/* This file is automatically generated, do not edit manually! */

/* eslint-disable max-len */

const DeviceType = require('../src/constants').deviceType;

exports.PROFILES = {
  'http://go.acer.com/?id=17884': ['Acer', 'All-in-One DA223HQL', 'Android'],
  'http://support.acer.com/uaprofile/Acer_E110_profile.xml': ['Acer', 'beTouch E110', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAprofile/Acer_E130_profile_no_3rd_drm_no_java.xml': [
    'Acer',
    'beTouch E130',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_E400_Profile.xml': ['Acer', 'beTouch E400', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAprofile/Acer_Acer_A9_Profile.xml': [
    'Acer',
    'CloudMobile',
    'Aliyun OS',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_S500_IML74K_Profile.xml': [
    'Acer',
    'CloudMobile',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_S500_IMM76D_Profile.xml': [
    'Acer',
    'CloudMobile',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_S500_IMM76I_Profile.xml': [
    'Acer',
    'CloudMobile',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_S500_JRO03L_Profile.xml': [
    'Acer',
    'CloudMobile',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_S500_JZO54K_Profile.xml': [
    'Acer',
    'CloudMobile',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_E100_Profile.XML': ['Acer', 'E100', 'Windows Mobile', DeviceType.MOBILE],
  'http://global-download.acer.com/SupportFiles/Files/UAProfile/XML/Acer_A1-810_JDQ39_Profile.xml': [
    'Acer',
    'Iconia A1-810',
    'Android',
    DeviceType.TABLET,
  ],
  'http://global-download.acer.com/SupportFiles/Files/UAProfile/XML/Acer_A1-811_JDQ39_Profile.xml': [
    'Acer',
    'Iconia A1-811',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://global-download.acer.com/SupportFiles/Files/UAProfile/XML/Acer_A1-812_JDQ39_Profile.xml': [
    'Acer',
    'Iconia A1-812',
    'Android',
    DeviceType.TABLET,
  ],
  'http://go.acer.com/?id=5566': ['Acer', 'Iconia A1-820', 'Android', DeviceType.TABLET],
  'http://go.acer.com/?id=17979': ['Acer', 'Iconia A1-830', 'Android', DeviceType.TABLET],
  'http://go.acer.com/?id=17995': ['Acer', 'Iconia One 7 B1-730 HD', 'Android', DeviceType.TABLET],
  'http://support.acer.com/UAprofile/Acer_S300_Profile.xml': ['Acer', 'Iconia Smart', 'Android', DeviceType.MOBILE],
  'http://global-download.acer.com/SupportFiles/Files/UAProfile/XML/Acer_A1-713_JDQ39_Profile.xml': [
    'Acer',
    'Iconia Tab 7 A1-713',
    'Android',
    DeviceType.TABLET,
  ],
  'http://global-download.acer.com/SupportFiles/Files/UAProfile/XML/Acer_A1-713_KOT49H_Profile.xml': [
    'Acer',
    'Iconia Tab 7 A1-713',
    'Android',
    DeviceType.TABLET,
  ],
  'http://global-download.acer.com/SupportFiles/Files/UAProfile/XML/Acer_A1-713HD_KOT49H_Profile.xml': [
    'Acer',
    'Iconia Tab 7 A1-713 HD',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A100_IML74K_Profile.xml': [
    'Acer',
    'Iconia Tab A100',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A100_Profile.xml': [
    'Acer',
    'Iconia Tab A100',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.zte.com.cn/mobile/uaprof/A100.xml': ['Acer', 'Iconia Tab A100', 'Android', DeviceType.TABLET],
  'http://support.acer.com/UAprofile/Acer_A101_IML74K_Profile.xml': [
    'Acer',
    'Iconia Tab A101',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A101_Profile.xml': [
    'Acer',
    'Iconia Tab A101',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A200_Profile.xml': [
    'Acer',
    'Iconia Tab A200',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A210_IMM76D_Profile.xml': [
    'Acer',
    'Iconia Tab A210',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A210_JRO03H_Profile.xml': [
    'Acer',
    'Iconia Tab A210',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A210_JRO4HDb1_Profile.xml': [
    'Acer',
    'Iconia Tab A210',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A210_JRO4HDb3_Profile.xml': [
    'Acer',
    'Iconia Tab A210',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A210_JZO54K_Profile.xml': [
    'Acer',
    'Iconia Tab A210',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A211_IMM76D_Profile.xml': [
    'Acer',
    'Iconia Tab A211',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A211_JRO03H_Profile.xml': [
    'Acer',
    'Iconia Tab A211',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A500_IML74K_Profile.xml': [
    'Acer',
    'Iconia Tab A500',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A500_IMM76D_Profile.xml': [
    'Acer',
    'Iconia Tab A500',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A500_Profile.xml': [
    'Acer',
    'Iconia Tab A500',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A501_IML74K_Profile.xml': [
    'Acer',
    'Iconia Tab A501',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A501_Profile.xml': [
    'Acer',
    'Iconia Tab A501',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A510_JRO03H_Profile.xml': [
    'Acer',
    'Iconia Tab A510',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A510_JZO54K_Profile.xml': [
    'Acer',
    'Iconia Tab A510',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A510_Profile.xml': [
    'Acer',
    'Iconia Tab A510',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A511_IML74K_Profile.xml': [
    'Acer',
    'Iconia Tab A511',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A511_JZO54K_Profile.xml': [
    'Acer',
    'Iconia Tab A511',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A700_IMM76D_Profile.xml': [
    'Acer',
    'Iconia Tab A700',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A700_JRO03H_Profile.xml': [
    'Acer',
    'Iconia Tab A700',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A700_Profile.xml': [
    'Acer',
    'Iconia Tab A700',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A701_IMM76D_Profile.xml': [
    'Acer',
    'Iconia Tab A701',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_A701_JRO03H_Profile.xml': [
    'Acer',
    'Iconia Tab A701',
    'Android',
    DeviceType.TABLET,
  ],
  'http://support.acer.com/UAprofile/Acer_S100_Profile.xml': ['Acer', 'Liquid', 'Android', DeviceType.MOBILE],
  'http://go.acer.com?id=17494': ['Acer', 'Liquid E2', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=17895': ['Acer', 'Liquid E3', 'Android', DeviceType.MOBILE],
  'http://go.acer.com?id=17895': ['Acer', 'Liquid E3', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=17999': ['Acer', 'Liquid E700', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAprofile/Acer_E210_Profile.xml': [
    'Acer',
    'Liquid Express',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_E320_Profile.xml': [
    'Acer',
    'Liquid Express',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://go.acer.com/?id=18008': ['Acer', 'Liquid Jade', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=18009': ['Acer', 'Liquid Jade S', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=83843': ['Acer', 'Liquid Jade Z', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAprofile/Acer_E310_Profile.xml': ['Acer', 'Liquid mini', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAprofile/Acer_S120_Profile.xml': ['Acer', 'Liquid mt', 'Android', DeviceType.MOBILE],
  'http://global-download.acer.com/SupportFiles/Files/UAProfile/XML/Acer_S510_JDQ39_Profile.xml': [
    'Acer',
    'Liquid S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://go.acer.com/?id=17873': ['Acer', 'Liquid S ', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=17891': ['Acer', 'Liquid S2 ', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAprofile/Acer_S520_JDQ39_Profile.xml': [
    'Acer',
    'Liquid S2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_Z110_UAProfile.xml': ['Acer', 'Liquid Z', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAprofile/Acer_Z120_UAProfile.xml': ['Acer', 'Liquid Z2', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=18020': ['Acer', 'Liquid Z200', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=83844': ['Acer', 'Liquid Z205', 'Android', DeviceType.MOBILE],
  'http://global-download.acer.com/SupportFiles/Files/UAProfile/XML/Acer_Z130_JDQ39_Profile.xml': [
    'Acer',
    'Liquid Z3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://go.acer.com/?id=84411': ['Acer', 'Liquid Z330', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=17980': ['Acer', 'Liquid Z4', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=18083': ['Acer', 'Liquid Z410', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=17940': ['Acer', 'Liquid Z5', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=83841': ['Acer', 'Liquid Z520', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAProfile/Acer_P400_Profile.xml': [
    'Acer',
    'neoTouch P400',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_S200_Profile.xml': [
    'Acer',
    'neoTouch S200',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_S110_Profile.xml': ['Acer', 'Stream', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAprofile/Acer_TD600_profile.xml': ['Acer', 'TD600', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=17684': ['Acer', 'Touch and 3D Monitor DA245HQL', 'Android'],
  'http://www.fly-phone.ru/UAP/Flylife_Connect_3G_2.xml': [
    'AG Mobile',
    'Chrome Go-Tab 7.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_JR_TV_D140T.xml': [
    'AG Mobile',
    'Chrome Selfie',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO6_0HD.xml': ['Ainovo', 'Novo7 Aurora', 'Android', DeviceType.TABLET],
  'http://www.airnessmobile.com/uaprof/Airness-Air99.xml': ['Airness', 'Air99', null, DeviceType.MOBILE],
  'http://www.airnessmobile.com/uaprof/HT-1.xml': ['Airness', 'HT-1', null, DeviceType.MOBILE],
  'http://www.airnessmobile.com/uaprof/slide99.xml': ['Airness', 'Slide99', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/9021A.xml': ['Alcaltel', 'One Touch POP8', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Alcatel_A205G.rdf': ['Alcatel', 'A205G', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Alcatel_A205G-B.rdf': ['Alcatel', 'A205G-B', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_A206G.rdf': ['Alcatel', 'A206G', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Alcatel_A207BG.rdf': ['Alcatel', 'A207BG', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_A383G.rdf': ['Alcatel', 'A383G', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_A392G.rdf': ['Alcatel', 'A392G', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_A392T.rdf': ['Alcatel', 'A392T', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/A480G.xml': ['Alcatel', 'A480G', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/A621R.xml': ['Alcatel', 'A621R', 'Android', DeviceType.MOBILE],
  'http://www-ccpp-mpd.alcatel.com/files/ALCATEL-BF4_2.0.rdf': ['Alcatel', 'BF4', null, DeviceType.MOBILE],
  'http://www-ccpp-mpd.alcatel.com/files/ALCATEL-BF5_1.0.rdf': ['Alcatel', 'BF5', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/odm/ALCATEL_D6.rdf': ['Alcatel', 'D6', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/TCL/Alcatel4044T-Chameleon/4044TV02.RDF': [
    'Alcatel',
    'Go Flip',
    'KaiOS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/4044M.xml': ['Alcatel', 'Go Flip', 'KaiOS', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4044N.xml': ['Alcatel', 'Go Flip', 'KaiOS', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4044O.xml': ['Alcatel', 'Go Flip', 'KaiOS', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4044V.XML': ['Alcatel', 'Go Flip', 'KaiOS', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4044W.xml': ['Alcatel', 'Go Flip', 'KaiOS', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4060A.xml': ['Alcatel', 'IDEAL', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/alcatel/wsa622gl/wsa622gl.xml': [
    'Alcatel',
    'Jitterbug Smart',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/Mobile_Sosh.xml': ['Alcatel', 'Le mobile Sosh', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-MD01.rdf': ['Alcatel', 'MD01', null, DeviceType.MOBILE],
  'http://www-ccpp-mpd.alcatel.com/odm/OH1C_UAProf.rdf': ['Alcatel', 'OH1C', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_2067X.rdf': [
    'Alcatel',
    'One Touch 2067',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_385JA.rdf': [
    'Alcatel',
    'One Touch 385',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT510A.rdf': ['Alcatel', 'One Touch 510A', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_585F.rdf': [
    'Alcatel',
    'One Touch 585',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_602A.rdf': [
    'Alcatel',
    'One Touch 602',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_720.rdf': [
    'Alcatel',
    'One Touch 720',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_768T.rdf': [
    'Alcatel',
    'One Touch 768T',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-802.rdf': ['Alcatel', 'One Touch 802', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_803A.rdf': [
    'Alcatel',
    'One Touch 803',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-806.rdf': ['Alcatel', 'One Touch 806', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-807D.rdf': ['Alcatel', 'One Touch 807', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_810D.rdf': [
    'Alcatel',
    'One Touch 810D',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_813.rdf': [
    'Alcatel',
    'One Touch 813',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_813A.rdf': [
    'Alcatel',
    'One Touch 813',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_813D.rdf': [
    'Alcatel',
    'One Touch 813',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_813FA.rdf': [
    'Alcatel',
    'One Touch 813FA',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_815.rdf': [
    'Alcatel',
    'One Touch 815',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_818A.rdf': [
    'Alcatel',
    'One Touch 818',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_819.rdf': [
    'Alcatel',
    'One Touch 819',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp-mpd.alcatel.com/odm/OT835_UAProf.rdf': ['Alcatel', 'One Touch 835', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_838.rdf': [
    'Alcatel',
    'One Touch 838',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT871A.rdf': ['Alcatel', 'One Touch 871A', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_890.xml': [
    'Alcatel',
    'One Touch 890',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_890D.xml': [
    'Alcatel',
    'One Touch 890',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_900A.rdf': [
    'Alcatel',
    'One Touch 900',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_900M.rdf': [
    'Alcatel',
    'One Touch 900M',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_902A.rdf': [
    'Alcatel',
    'One Touch 902A',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_903.xml': [
    'Alcatel',
    'One Touch 903',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_903A.xml': [
    'Alcatel',
    'One Touch 903',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_903D.xml': [
    'Alcatel',
    'One Touch 903',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_905M.rdf': [
    'Alcatel',
    'One Touch 905',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_908.xml': [
    'Alcatel',
    'One Touch 908',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_908F.xml': [
    'Alcatel',
    'One Touch 908',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_908S.xml': [
    'Alcatel',
    'One Touch 908',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_909A.xml': [
    'Alcatel',
    'One Touch 909',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_916.xml': [
    'Alcatel',
    'One Touch 916',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_916A.xml': [
    'Alcatel',
    'One Touch 916',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_918.xml': [
    'Alcatel',
    'One Touch 918',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_918A.xml': [
    'Alcatel',
    'One Touch 918',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_918D.xml': [
    'Alcatel',
    'One Touch 918',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_918N.xml': [
    'Alcatel',
    'One Touch 918',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_918S.xml': [
    'Alcatel',
    'One Touch 918',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_918_Orange.xml': [
    'Alcatel',
    'One Touch 918',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-919.xml': ['Alcatel', 'One Touch 919', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_922.xml': [
    'Alcatel',
    'One Touch 922',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_928D.xml': [
    'Alcatel',
    'One Touch 928',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-980.xml': ['Alcatel', 'One Touch 980', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-980A.xml': ['Alcatel', 'One Touch 980', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-981A.xml': ['Alcatel', 'One Touch 981', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_One_touch_983.xml': [
    'Alcatel',
    'One Touch 983',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_One_touch_983A.xml': [
    'Alcatel',
    'One Touch 983',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_One_touch_983A_3G.xml': [
    'Alcatel',
    'One Touch 983',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_One_touch_983_3G.xml': [
    'Alcatel',
    'One Touch 983',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_985.xml': [
    'Alcatel',
    'One Touch 985',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_985A.xml': [
    'Alcatel',
    'One Touch 985',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_985D.xml': [
    'Alcatel',
    'One Touch 985',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_985N.xml': [
    'Alcatel',
    'One Touch 985',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.qma.com.tw/ALCATEL-one_touch_990C+.xml': ['Alcatel', 'One Touch 990', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/OT-990C.xml': ['Alcatel', 'One Touch 990', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_990.xml': [
    'Alcatel',
    'One Touch 990',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_990A.xml': [
    'Alcatel',
    'One Touch 990',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_990S.xml': [
    'Alcatel',
    'One Touch 990',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_OT_990M.xml': ['Alcatel', 'One Touch 990', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_991.xml': [
    'Alcatel',
    'One Touch 991',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_991A.xml': [
    'Alcatel',
    'One Touch 991',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_991D.xml': [
    'Alcatel',
    'One Touch 991',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_991T.xml': [
    'Alcatel',
    'One Touch 991',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_991_Orange.xml': [
    'Alcatel',
    'One Touch 991',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_992D.xml': [
    'Alcatel',
    'One Touch 992',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_993.xml': [
    'Alcatel',
    'One Touch 993',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_995.xml': [
    'Alcatel',
    'One Touch 995',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_995A.xml': [
    'Alcatel',
    'One Touch 995',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_996.xml': [
    'Alcatel',
    'One Touch 996',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_997.xml': [
    'Alcatel',
    'One Touch 997',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_one_touch_997D.xml': [
    'Alcatel',
    'One Touch 997',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_A392CC_CC.rdf': ['Alcatel', 'One Touch A392G', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_A392CC_TELUS.rdf': [
    'Alcatel',
    'One Touch A392G',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/5056O.xml': ['Alcatel', 'One Touch Allura', 'Android', DeviceType.MOBILE],
  'http://www-ccpp-mpd.alcatel.com/files/ALCATEL-CTH3_MMS11_1.0.rdf': [
    'Alcatel',
    'One Touch C651',
    null,
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-C700A.rdf': ['Alcatel', 'One Touch C700', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-C701.rdf': ['Alcatel', 'One Touch C701', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-C717.rdf': ['Alcatel', 'One Touch C717', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-C825.rdf': ['Alcatel', 'One Touch C825', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/onetouch_EVO7.xml': ['Alcatel', 'One Touch Evo 7', 'Android', DeviceType.TABLET],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_EVO7HD.xml': [
    'Alcatel',
    'One Touch Evo 7 HD',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_EVO8HD.xml': [
    'Alcatel',
    'One Touch Evo 8 HD',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7024N.xml': [
    'Alcatel',
    'One Touch Fierce',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7024R.xml': [
    'Alcatel',
    'One Touch Fierce',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7024W.xml': [
    'Alcatel',
    'One Touch Fierce',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/5054N.xml': ['Alcatel', 'One Touch Fierce XL', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATELOneTouch4012X.xml': [
    'Alcatel',
    'One Touch Fire',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4012A.xml': [
    'Alcatel',
    'One Touch Fire',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4012X.xml': [
    'Alcatel',
    'One Touch Fire',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/fils/ONE_TOUCH_4012A.xml': [
    'Alcatel',
    'One Touch Fire',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATELOneTouch4019A.xml': [
    'Alcatel',
    'One Touch Fire C',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATELOneTouch4019X.xml': [
    'Alcatel',
    'One Touch Fire C',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATELOneTouch4019X_V2.0.xml': [
    'Alcatel',
    'One Touch Fire C',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4020D.xml': [
    'Alcatel',
    'One Touch Fire C',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATELOneTouch6015X.xml': [
    'Alcatel',
    'One Touch Fire E',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATELOneTouch6015X_v2.0.xml': [
    'Alcatel',
    'One Touch Fire E',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONETOUCH_Flash_Plus.xml': [
    'Alcatel',
    'One Touch Flash Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/7048A.xml': ['Alcatel', 'One Touch Go Play', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/7048X.xml': ['Alcatel', 'One Touch Go Play', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_8020A.xml': [
    'Alcatel',
    'One Touch Hero',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_8020E.xml': [
    'Alcatel',
    'One Touch Hero',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/7055A.xml': ['Alcatel', 'One Touch Hero 2C', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6030A.xml': [
    'Alcatel',
    'One Touch Idol',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6030D.xml': [
    'Alcatel',
    'One Touch Idol',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6030N.xml': [
    'Alcatel',
    'One Touch Idol',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6030X.xml': [
    'Alcatel',
    'One Touch Idol',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6030X_Orange.xml': [
    'Alcatel',
    'One Touch Idol',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/6037Y.xml': ['Alcatel', 'One Touch Idol 2', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6037B.xml': ['Alcatel', 'One Touch Idol 2 Dual', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6037K.xml': ['Alcatel', 'One Touch Idol 2 Dual', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6016A.xml': ['Alcatel', 'One Touch Idol 2 Mini', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6016D.xml': ['Alcatel', 'One Touch Idol 2 Mini', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6016X.xml': ['Alcatel', 'One Touch Idol 2 Mini', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6036A.xml': ['Alcatel', 'One Touch Idol 2 Mini S', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6036X.xml': ['Alcatel', 'One Touch Idol 2 Mini S', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6036Y.xml': ['Alcatel', 'One Touch Idol 2 Mini S', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6036Y_KK.xml': [
    'Alcatel',
    'One Touch Idol 2 Mini S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONETOUCH_6036X.xml': [
    'Alcatel',
    'One Touch Idol 2 Mini S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6036X.xml': [
    'Alcatel',
    'One Touch Idol 2 Mini S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/6050A.xml': ['Alcatel', 'One Touch Idol 2S', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6050F.xml': ['Alcatel', 'One Touch Idol 2S', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6050Y.xml': ['Alcatel', 'One Touch Idol 2S', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6039A.xml': ['Alcatel', 'One Touch Idol 3 (4.7)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6039H.xml': ['Alcatel', 'One Touch Idol 3 (4.7)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6039J.xml': ['Alcatel', 'One Touch Idol 3 (4.7)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6039K.xml': ['Alcatel', 'One Touch Idol 3 (4.7)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6039S.xml': ['Alcatel', 'One Touch Idol 3 (4.7)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6039Y.xml': ['Alcatel', 'One Touch Idol 3 (4.7)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6039K.xml': [
    'Alcatel',
    'One Touch Idol 3 (4.7)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6039S.xml': [
    'Alcatel',
    'One Touch Idol 3 (4.7)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/6045F.xml': ['Alcatel', 'One Touch Idol 3 (5.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6045B.xml': [
    'Alcatel',
    'One Touch Idol 3 (5.5)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6045I.xml': [
    'Alcatel',
    'One Touch Idol 3 (5.5)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6045I_M.xml': [
    'Alcatel',
    'One Touch Idol 3 (5.5)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6045K.xml': [
    'Alcatel',
    'One Touch Idol 3 (5.5)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6045K_M.xml': [
    'Alcatel',
    'One Touch Idol 3 (5.5)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6045O.xml': [
    'Alcatel',
    'One Touch Idol 3 (5.5)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6045Y.xml': [
    'Alcatel',
    'One Touch Idol 3 (5.5)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH6045Y_M.xml': [
    'Alcatel',
    'One Touch Idol 3 (5.5)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/6055B.xml': ['Alcatel', 'One Touch Idol 4', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6055I.xml': ['Alcatel', 'One Touch Idol 4', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6055K.xml': ['Alcatel', 'One Touch Idol 4', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6055P.xml': ['Alcatel', 'One Touch Idol 4', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/6055U.xml': ['Alcatel', 'One Touch Idol 4', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6012D.xml': [
    'Alcatel',
    'One Touch Idol Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6014X.xml': [
    'Alcatel',
    'One Touch Idol Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_6012A.xml': [
    'Alcatel',
    'One Touch Idol Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_6012D.xml': [
    'Alcatel',
    'One Touch Idol Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_6012E.xml': [
    'Alcatel',
    'One Touch Idol Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_6012X.xml': [
    'Alcatel',
    'One Touch Idol Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6034M.xml': [
    'Alcatel',
    'One Touch Idol S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6034R.xml': [
    'Alcatel',
    'One Touch Idol S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6034Y.xml': [
    'Alcatel',
    'One Touch Idol S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6035R.xml': [
    'Alcatel',
    'One Touch Idol S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/6031X.xml': ['Alcatel', 'One Touch Idol Ultra', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6033A.xml': [
    'Alcatel',
    'One Touch Idol Ultra',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6033X.xml': [
    'Alcatel',
    'One Touch Idol Ultra',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6040A.xml': [
    'Alcatel',
    'One Touch Idol X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6040D.xml': [
    'Alcatel',
    'One Touch Idol X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6040X.xml': [
    'Alcatel',
    'One Touch Idol X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/6043D.xml': ['Alcatel', 'One Touch Idol X+', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6032.xml': [
    'Alcatel',
    'One Touch Idol α',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6032A.xml': [
    'Alcatel',
    'One Touch Idol α',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5020A.xml': [
    'Alcatel',
    'One Touch M\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5020D.xml': [
    'Alcatel',
    'One Touch M\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5020E.xml': [
    'Alcatel',
    'One Touch M\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5020N.xml': [
    'Alcatel',
    'One Touch M\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5020T.xml': [
    'Alcatel',
    'One Touch M\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5020W.xml': [
    'Alcatel',
    'One Touch M\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5020X.xml': [
    'Alcatel',
    'One Touch M\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/9005X.xml': [
    'Alcatel',
    'One Touch One Touch Pixi 3 (8)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4007A.xml': [
    'Alcatel',
    'One Touch Pixi',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4007D.xml': [
    'Alcatel',
    'One Touch Pixi',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4007X.xml': [
    'Alcatel',
    'One Touch Pixi',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATELOneTouch4022D.xml': [
    'Alcatel',
    'One Touch Pixi 3 (3.5)',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATELOneTouch4023A.xml': [
    'Alcatel',
    'One Touch Pixi 3 (3.5)',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATELOneTouch4023X.xml': [
    'Alcatel',
    'One Touch Pixi 3 (3.5)',
    'Firefox OS',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4014D.xml': [
    'Alcatel',
    'One Touch Pixi 3 (4)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/5065A.xml': ['Alcatel', 'One Touch Pixi 3 (5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5065D.xml': ['Alcatel', 'One Touch Pixi 3 (5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5065X.xml': ['Alcatel', 'One Touch Pixi 3 (5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5054D.xml': ['Alcatel', 'One Touch Pixi 3 (5.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5054O.xml': ['Alcatel', 'One Touch Pixi 3 (5.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5054S.xml': ['Alcatel', 'One Touch Pixi 3 (5.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5054T.xml': ['Alcatel', 'One Touch Pixi 3 (5.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5054X.xml': ['Alcatel', 'One Touch Pixi 3 (5.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/9007A.xml': ['Alcatel', 'One Touch Pixi 3 (7)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/9022X.xml': ['Alcatel', 'One Touch Pixi 3 (8)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Alcatel_9022S.xml': [
    'Alcatel',
    'One Touch Pixi 3 (8)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www-ccpp.tcl-ta.com/files/Alcatel_4060O.xml': [
    'Alcatel',
    'One Touch Pixi 4 (6)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/alcatel_5098O.xml': [
    'Alcatel',
    'One Touch Pixi 4 (6)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/alcatel/wsa571vl/wsa571vl.xml': [
    'Alcatel',
    'One Touch Pixi Avion',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/A570BL.xml': ['Alcatel', 'One Touch Pixi Avion', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/alcatel/oda573vc/oda573vc.xml': [
    'Alcatel',
    'One Touch Pixi Bond',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONETOUCH_4024D.xml': [
    'Alcatel',
    'One Touch Pixi First',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONETOUCH_4024X.xml': [
    'Alcatel',
    'One Touch Pixi First',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/4045A.xml': ['Alcatel', 'One Touch Pop 2 (4)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4045D.xml': ['Alcatel', 'One Touch Pop 2 (4)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4045L.xml': ['Alcatel', 'One Touch Pop 2 (4)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5042A.xml': ['Alcatel', 'One Touch Pop 2 (4.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5042D.xml': ['Alcatel', 'One Touch Pop 2 (4.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5042W.xml': ['Alcatel', 'One Touch Pop 2 (4.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5042X.xml': ['Alcatel', 'One Touch Pop 2 (4.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5042Y.xml': ['Alcatel', 'One Touch Pop 2 (4.5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONETOUCH_5042G.xml': [
    'Alcatel',
    'One Touch Pop 2 (4.5)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/7043K.xml': ['Alcatel', 'One Touch Pop 2 (5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/7043Y.xml': ['Alcatel', 'One Touch Pop 2 (5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/7044A.xml': [
    'Alcatel',
    'One Touch Pop 2 (5) Premium',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/7044X.xml': [
    'Alcatel',
    'One Touch Pop 2 (5) Premium',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/7051X.xml': ['Alcatel', 'One Touch Pop 3 (5)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5051J.xml': ['Alcatel', 'One Touch Pop 4 (5.0)', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4016A.xml': ['Alcatel', 'One Touch Pop C1', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4016X.xml': ['Alcatel', 'One Touch Pop C1', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_4015T.xml': [
    'Alcatel',
    'One Touch Pop C1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4015A.xml': [
    'Alcatel',
    'One Touch Pop C1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4015D.xml': [
    'Alcatel',
    'One Touch Pop C1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4015N.xml': [
    'Alcatel',
    'One Touch Pop C1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4015T.xml': [
    'Alcatel',
    'One Touch Pop C1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4015X.xml': [
    'Alcatel',
    'One Touch Pop C1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/one_touch_4016X.xml': [
    'Alcatel',
    'One Touch Pop C1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/4032A.xml': ['Alcatel', 'One Touch Pop C2', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4032D.xml': ['Alcatel', 'One Touch Pop C2', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/4032X.xml': ['Alcatel', 'One Touch Pop C2', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4033A.xml': [
    'Alcatel',
    'One Touch Pop C3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4033D.xml': [
    'Alcatel',
    'One Touch Pop C3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4033E.xml': [
    'Alcatel',
    'One Touch Pop C3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_4033X.xml': [
    'Alcatel',
    'One Touch Pop C3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5036A.xml': [
    'Alcatel',
    'One Touch Pop C5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5036D.xml': [
    'Alcatel',
    'One Touch Pop C5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5036X.xml': [
    'Alcatel',
    'One Touch Pop C5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5037A.xml': [
    'Alcatel',
    'One Touch Pop C5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5037E.xml': [
    'Alcatel',
    'One Touch Pop C5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5037X.xml': [
    'Alcatel',
    'One Touch Pop C5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7040A.xml': [
    'Alcatel',
    'One Touch Pop C7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7040D.xml': [
    'Alcatel',
    'One Touch Pop C7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7040E.xml': [
    'Alcatel',
    'One Touch Pop C7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7041D.xml': [
    'Alcatel',
    'One Touch Pop C7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7041X.xml': [
    'Alcatel',
    'One Touch Pop C7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7047A.xml': [
    'Alcatel',
    'One Touch Pop C9',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7047D.xml': [
    'Alcatel',
    'One Touch Pop C9',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7047E.xml': [
    'Alcatel',
    'One Touch Pop C9',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_A995L.xml': [
    'Alcatel',
    'One Touch Pop Mega',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/5050A.xml': ['Alcatel', 'One Touch Pop S3', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5050X.xml': ['Alcatel', 'One Touch Pop S3', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5050Y.xml': ['Alcatel', 'One Touch Pop S3', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/7050Y.xml': ['Alcatel', 'One Touch Pop S9', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7050Y.xml': [
    'Alcatel',
    'One Touch Pop S9',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_A845L.xml': [
    'Alcatel',
    'One Touch Pop Star',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/6044D.xml': ['Alcatel', 'One Touch Pop Up', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/P360X.xml': ['Alcatel', 'One Touch POP10', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/9015B.xml': ['Alcatel', 'One Touch POP7', 'Android', DeviceType.TABLET],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_P310A.xml': [
    'Alcatel',
    'One Touch POP7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_P310X.xml': [
    'Alcatel',
    'One Touch POP7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_P310X_KK.xml': [
    'Alcatel',
    'One Touch POP7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www-ccpp.tcl-ta.com/files/P330X.xml': ['Alcatel', 'One Touch POP7S', 'Android', DeviceType.TABLET],
  'http://www-ccpp.tcl-ta.com/files/P330X_orange.xml': ['Alcatel', 'One Touch POP7S', 'Android', DeviceType.TABLET],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_P320A_TELUS.xml': [
    'Alcatel',
    'One Touch POP8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_P320X.xml': [
    'Alcatel',
    'One Touch POP8',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_P321X.xml': [
    'Alcatel',
    'One Touch POP8',
    'Android',
    DeviceType.TABLET,
  ],
  'www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_P320A.xml': [
    'Alcatel',
    'One Touch POP8',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4030A.xml': [
    'Alcatel',
    'One Touch S\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4030D.xml': [
    'Alcatel',
    'One Touch S\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4030E.xml': [
    'Alcatel',
    'One Touch S\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4030X.xml': [
    'Alcatel',
    'One Touch S\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4030Y.xml': [
    'Alcatel',
    'One Touch S\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-S218.rdf': ['Alcatel', 'One Touch S218', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-S319.rdf': ['Alcatel', 'One Touch S319', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-S520.rdf': ['Alcatel', 'One Touch S520', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_8000A.xml': [
    'Alcatel',
    'One Touch Scribe Easy',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_8000D.xml': [
    'Alcatel',
    'One Touch Scribe Easy',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_8008D.xml': [
    'Alcatel',
    'One Touch Scribe HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_8008W.xml': [
    'Alcatel',
    'One Touch Scribe HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_8008X.xml': [
    'Alcatel',
    'One Touch Scribe HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_8020D.xml': [
    'Alcatel',
    'One Touch Scribe Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_8020D.xml': [
    'Alcatel',
    'One Touch Scribe Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_8020X.xml': [
    'Alcatel',
    'One Touch Scribe Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_7030L.xml': ['Alcatel', 'One Touch Snap', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7025D.xml': [
    'Alcatel',
    'One Touch Snap',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7025X.xml': [
    'Alcatel',
    'One Touch Snap',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7042A.xml': [
    'Alcatel',
    'One Touch Snap',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_7042D.xml': [
    'Alcatel',
    'One Touch Snap',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5021E.xml': [
    'Alcatel',
    'One Touch Soleil',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_A851L.xml': ['Alcatel', 'One Touch Sonic', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL ONE TOUCH 6010D.xml': [
    'Alcatel',
    'One Touch Star',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6010D.xml': [
    'Alcatel',
    'One Touch Star',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6010X.xml': [
    'Alcatel',
    'One Touch Star',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6010X_Orange.xml': [
    'Alcatel',
    'One Touch Star',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4010A.xml': [
    'Alcatel',
    'One Touch T\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4010D.xml': [
    'Alcatel',
    'One Touch T\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4010E.xml': [
    'Alcatel',
    'One Touch T\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4010X.xml': [
    'Alcatel',
    'One Touch T\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_4011X.xml': [
    'Alcatel',
    'One Touch T\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ONE_TOUCH_TAB_7.xml': [
    'Alcatel',
    'One Touch Tab 7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www-ccpp.tcl-ta.com/files/3075A.rdf': ['Alcatel', 'One Touch Tribe 3075A', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL-OT-V670.rdf': ['Alcatel', 'One Touch V670', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5035D.xml': [
    'Alcatel',
    'One Touch X\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5035E.xml': [
    'Alcatel',
    'One Touch X\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_5035X.xml': [
    'Alcatel',
    'One Touch X\'Pop',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/4044C.xml': ['Alcatel', 'QUICKFLIP', 'KaiOS', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_TRIBE_3075A.rdf': ['Alcatel', 'Tribe 3075A', null, DeviceType.MOBILE],
  'http://uaprof.vmobl.com/PCD/ADR2045-VMUB/1.0/UAProf.xml': ['Alcatel', 'Venture', 'Android', DeviceType.MOBILE],
  'http://pluto.alphacell.com/uaprof/m5p.xml': ['AlphaCell', 'M5', null, DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/Amoi-8512.xml': ['Amoi', '8512', null, DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/Amoi-8709.xml': ['Amoi', '8709', null, DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/Amoi-8710.xml': ['Amoi', '8710', null, DeviceType.MOBILE],
  'http://www.amoi.com.cn/ua/AMOI_A726T_JB3_UAprofile.xml': ['Amoi', 'A726T', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOAMOI A920W.xml': ['Amoi', 'A920W', 'Android', DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/c200.xml': ['Amoi', 'C200', null, DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/CA6.xml': ['Amoi', 'CA6', null, DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/E610.xml': ['Amoi', 'E610', null, DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/E72.xml': ['Amoi', 'E72', null, DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/F8.xml': ['Amoi', 'F8', null, DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/M636.xml': ['Amoi', 'M636', null, DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOAMOI_N828.xml': ['Amoi', 'N828', 'Android', DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/S6.xml': ['Amoi', 'S6', null, DeviceType.MOBILE],
  'https://servicios.iusacell.com.mx/amoi/v810/v810v1.xml': ['Amoi', 'V810', null, DeviceType.MOBILE],
  'http://www.apanda.com.cn/apanda-A60-ua-profile.xml': ['Apanda', 'A60', 'Android', DeviceType.MOBILE],
  'http://asmobile.ehosting.com.tw/uaprof/castor.xml': ['Asmobile', 'Castor', null, DeviceType.MOBILE],
  'http://asmobile.ehosting.com.tw/uaprof/PAVO.xml': ['Asmobile', 'PAVO', null, DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS1210-1.0.xml': ['Asus', '1210', null, DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-NAPA-1.0.xml': ['Asus', 'Eee Pc T10', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-NAPA-MINI-1.0.xml': ['Asus', 'Eee Pc T20', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ASUS-K00S.xml': ['Asus', 'Fonepad', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-ME371MG-1.0.xml': ['Asus', 'Fonepad', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-K00E.xml': ['Asus', 'Fonepad 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-K00Z.xml': ['Asus', 'Fonepad 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-ME175CG.xml': ['Asus', 'Fonepad 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-ME175CG_KK.xml': ['Asus', 'Fonepad 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-ME372CG.xml': ['Asus', 'Fonepad 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-ME372CL.xml': ['Asus', 'Fonepad 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-FE170CG.xml': ['Asus', 'Fonepad 7 2014', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-FE171CG.xml': ['Asus', 'Fonepad 7 2015', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-FE375CL.xml': ['Asus', 'Fonepad 7 2015', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-FE380CG.xml': ['Asus', 'Fonepad 8 2014', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-K00G.xml': ['Asus', 'Fonepad Note 6', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/K00G.xml': ['Asus', 'Fonepad Note 6', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-J501_UAProf.xml': ['Asus', 'J501', null, DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-M530w-1.0.xml': ['Asus', 'M530w', 'Windows Mobile', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-M930-1.0.xml': ['Asus', 'M930', 'Windows Mobile', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-K00F.xml': ['Asus', 'MemoPad 10', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-ME375CL.xml': ['Asus', 'MemoPad 7', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ME572CL.xml': ['Asus', 'MemoPad 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-K00L.xml': ['Asus', 'MemoPad 8', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-ME302C-1.0.xml': ['Asus', 'MemoPad FHD 10', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-grouper.xml': ['Asus', 'Nexus 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/grouper.xml': ['Asus', 'Nexus 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-GalaxyMini-1.0.xml': ['Asus', 'P320', 'Windows Mobile', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-Pegasus-1.0.xml': ['Asus', 'P526', 'Windows Mobile', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-P527-1.0.xml': ['Asus', 'P527', 'Windows Mobile', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-GalaxyII-1.0.xml': ['Asus', 'P535', 'Windows Mobile', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-P550-1.0.xml': ['Asus', 'P550', 'Windows Mobile', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-GalaxyMini2-1.0.xml': ['Asus', 'P552', 'Windows Mobile', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-P750-1.0.xml': ['Asus', 'P750', 'Windows Mobile', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-PadFone-1.0.xml': ['Asus', 'Padfone', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-PadFone.xml': ['Asus', 'Padfone', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-A68.xml': ['Asus', 'Padfone 2', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-PadFone 2.xml': ['Asus', 'Padfone 2', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-ASUS-T008.xml': ['Asus', 'Padfone E', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-A80.xml': ['Asus', 'Padfone Infinity', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-A86.xml': ['Asus', 'Padfone Infinity', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ASUS-A86.xml': ['Asus', 'Padfone Infinity', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-ASUS-T00C.xml': ['Asus', 'Padfone Mini', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ASUS_T00E.xml': ['Asus', 'Padfone Mini', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-PF451CL.xml': ['Asus', 'Padfone Mini', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-A91.xml': ['Asus', 'Padfone X', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-PF500KL.xml': ['Asus', 'Padfone X', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS_T00N.xml': ['Asus', 'Padfone X', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-PF450CL.xml': ['Asus', 'Padfone X Mini', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-TX201LA.xml': [
    'Asus',
    'Transformer Book Trio',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprofile.asus.com/uaprof/ASUS-TF300TG.xml': ['Asus', 'Transformer Pad 300', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-TF300TL.xml': ['Asus', 'Transformer Pad 300', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-K00C.xml': [
    'Asus',
    'Transformer Pad Infinity',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprofile.asus.com/uaprof/ASUS-TF700KL-1.0.xml': [
    'Asus',
    'Transformer Pad Infinity 700',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprofile.asus.com/uaprof/ASUS-TF700KL.xml': [
    'Asus',
    'Transformer Pad Infinity 700',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprofile.asus.com/uaprof/ASUS-V75_UAProf.xml': ['Asus', 'V75', null, DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ZE500CL.xml': ['Asus', 'ZenFone 2', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ZE550ML.xml': ['Asus', 'ZenFone 2', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ZE551ML.xml': ['Asus', 'ZenFone 2', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ZE500KG.xml': ['Asus', 'ZenFone 2 Laser', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ZE500KL.xml': ['Asus', 'ZenFone 2 Laser', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ZE550KL.xml': ['Asus', 'ZenFone 2 Laser', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ASUS_T00I.xml': ['Asus', 'ZenFone 4', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/AMAX-UAP.xml': ['Asus', 'ZenFone 5', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-A500CG.xml': ['Asus', 'ZenFone 5', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-A500KL.xml': ['Asus', 'ZenFone 5', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ASUS_T00F.xml': ['Asus', 'ZenFone 5', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ASUS_T00J.xml': ['Asus', 'ZenFone 5', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-T00J.xml': ['Asus', 'ZenFone 5', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-A600CG.xml': ['Asus', 'ZenFone 6', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ASUS_T00G.xml': ['Asus', 'ZenFone 6', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ZB551KL.xml': [
    'Asus',
    'ZenFone Go (ZB551KL)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprofile.asus.com/uaprof/ASUS-ZC500TG.xml': [
    'Asus',
    'ZenFone Go (ZC500TG)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprofile.asus.com/uaprof/ASUS-ZC550KL.xml': ['Asus', 'ZenFone Max', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-ZX551ML.xml': ['Asus', 'ZenFone Zoom', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/ASUS-Z300CL.xml': ['Asus', 'ZenPad 10', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-Z170C.xml': ['Asus', 'ZenPad 7', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-Z370KL.xml': ['Asus', 'ZenPad 7.0 (Z370KL)', 'Android', DeviceType.TABLET],
  'http://uaprofile.asus.com/uaprof/ASUS-Z380KL.xml': ['Asus', 'ZenPad 8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8652GPRS-ATT.xml': ['AT&T', 'Fusion', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8652WCDMA-ATT.xml': ['AT&T', 'Fusion', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/9020A.xml': ['AT&T', 'Trek HD', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y536A1.xml': ['AT&T', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Audiovox/CDM-8450SP/T060SP2T36.rdf': [
    'Audiovox',
    'CDM-8450',
    null,
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Audiovox/CDM-8450SP/T060SP2T37.rdf': [
    'Audiovox',
    'CDM-8450',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.bellmobilite.ca/BMC_Audiovox_CDM-8450_P08.rdf': ['Audiovox', 'CDM-8450', null, DeviceType.MOBILE],
  'http://www.pocket.com/phone_data/CDM8615.xml': ['Audiovox', 'CDM-8615', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/audiovox/cdm-8900.rdf': ['Audiovox', 'CDM-8900', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/audiovox/8910/8910.xml': ['Audiovox', 'CDM-8910', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Audiovox/CDM8912SP/T115SP0T13.rdf': ['Audiovox', 'CDM-8912', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/audiovox/cdm-8920.rdf': ['Audiovox', 'CDM-8920', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Audiovox/CDM9950SP/132037.rdf': ['Audiovox', 'CDM-9950', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Audiovox/PM8920KIT/T120SP0T19.rdf': ['Audiovox', 'PM-8920', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Q_Maxi.xml': [
    'Avea',
    'inTouch 3 Large',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/Avea_inTouch_4.xml': ['Avea', 'inTouch 4', 'Android', DeviceType.TABLET],
  'http://www.jeekomi.com/hw/Avvio489_WAP_BROWSER.xml': ['Avvio', '489', 'Android', DeviceType.MOBILE],
  'http://guardsys.museui.com/Avvio750_PEP_WAP_BROWSER.xml': ['Avvio', '750', 'Android', DeviceType.MOBILE],
  'http://guardsys.museui.com/Avvio750_WAP_BROWSER.xml': ['Avvio', '750', 'Android', DeviceType.MOBILE],
  'http://www.ilakia.com/uaprof/Avvio774.xml': ['Avvio', '774', 'Android', DeviceType.MOBILE],
  'http://www.kcmobile.net/UAProf/UAP_AVVIO_776.xml': ['Avvio', '776', 'Android', DeviceType.MOBILE],
  'http://config.51coolpad.com/UAProfile/Brightstar/Avvio_L500.xml': ['Avvio', 'L500', 'Android', DeviceType.MOBILE],
  'http://www.kcmobile.net/UAProf/WAP2_SEC_MMS_AvvioPAD10.1.xml': ['Avvio', 'Pad', 'Android', DeviceType.MOBILE],
  'http://www.jeekomi.com/hw/AvvioQ797_WAP_BROWSER.xml': ['Avvio', 'Q797', 'Android', DeviceType.MOBILE],
  'http://www.axiooworld.com': ['Axioo', 'Picopad', 'Android', DeviceType.TABLET],
  'http://www.axiooworld.com/uaprof/uaprof_picopad.xml': ['Axioo', 'Picopad', 'Android', DeviceType.TABLET],
  'http://www.axiooworld.com/uaprof/uaprof_VIGO350.xml': ['Axioo', 'Vigo 350', 'Android', DeviceType.MOBILE],
  'http://www.axiooworld.com/uaprof/uaprof_VIGO410.xml': ['Axioo', 'Vigo 410', 'Android', DeviceType.MOBILE],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A35C_Lite.xml': [
    'Azumi',
    'A35c Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A35S.xml': [
    'Azumi',
    'A35s',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A35S_Lite.xml': [
    'Azumi',
    'A35s Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A40Style_Lite.xml': [
    'Azumi',
    'A40 Style Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A40C.xml': [
    'Azumi',
    'A40c',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A45T.xml': [
    'Azumi',
    'A45c',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A45S.xml': [
    'Azumi',
    'A45s',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A50c.xml': [
    'Azumi',
    'A50c',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A50c+.xml': [
    'Azumi',
    'A50c+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_AT7.xml': ['Azumi', 'AT7', 'Android', DeviceType.TABLET],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_IRO_A5_Q.xml': [
    'Azumi',
    'Iro A5Q',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_IRO_A5_QL.xml': [
    'Azumi',
    'Iro A5QL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_KL32.xml': [
    'Azumi',
    'KL32',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_LT50.xml': [
    'Azumi',
    'LT50',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_LT50+.xml': [
    'Azumi',
    'LT50+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://343761.ctc-w228.dns.com.cn/UAProfile/EVE.xml': ['b-mobile', 'EVE', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/BASE_Tab.xml': ['BASE', 'Tab', 'Android', DeviceType.MOBILE],
  'http://www.bbk.com/uaprof/BBKi710.xml': ['BBK', 'i710', 'MRE', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Beeline_E400.xml': ['Beeline', 'E400', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Beeline_E600.xml': ['Beeline', 'E600', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/BeelineM2_22.xml': ['Beeline', 'M2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Beeline_Pro.xml': ['Beeline', 'Pro', 'Android', DeviceType.MOBILE],
  'http://staticfiles.technoserv.com/uap/BG1_TS.xml': ['Beeline', 'Pro 2', 'Android', DeviceType.MOBILE],
  'http://staticfiles.technoserv.com/uap/BeelineSmartDual.xml': [
    'Beeline',
    'Smart Dual',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/Beeline_Smart2.xml': ['Beeline', 'Smart2', 'Android', DeviceType.MOBILE],
  'http://staticfiles.technoserv.com/uap/Beeline_Smart_3.xml': ['Beeline', 'Smart3', 'Android', DeviceType.MOBILE],
  'http://tehnoligadevice.ru/uap/Beeline_Smart_4.xml': ['Beeline', 'Smart4', 'Android', DeviceType.MOBILE],
  'http://staticfiles.technoserv.com/uap/BEE703G02.xml': ['Beeline', 'Tab', 'Android', DeviceType.TABLET],
  'http://senseit.ru/UAProfile/beelinetab2.xml': ['Beeline', 'Tab 2', 'Android', DeviceType.TABLET],
  'http://www.bellwave.co.uk/uaprof/Neo100.xml': ['Bellwave', 'Neo100', null, DeviceType.MOBILE],
  'https://s3-eu-west-1.amazonaws.com/fotabucket/uaprof/uaprof_f4_benq.xml': [
    'BenQ',
    'A3s',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?device=C11C&v=11': [
    'BenQ',
    'C11C',
    null,
    DeviceType.MOBILE,
  ],
  'http://uap.benq.com/mb_c30/benq_c30_v1.xml': ['BenQ', 'C30', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?DeviceID=ELC1&v=36': [
    'BenQ',
    'ELC1',
    null,
    DeviceType.MOBILE,
  ],
  'http://market.benqmobile.com/portal/UAProf/UAP.aspx?DeviceID=ELC1&v=36': [
    'BenQ',
    'ELC1',
    null,
    DeviceType.MOBILE,
  ],
  'http://dpg.openwave.com/downloadfun/29756742/Vulcan.xml': ['BenQ', 'Vulcan', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?DeviceID=EF81': [
    'BenQ-Siemens',
    'EF81',
    null,
    DeviceType.MOBILE,
  ],
  'http://uap.benq.com/mb_ef91/benq_ef91_3g.xml': ['BenQ-Siemens', 'EF91', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?device=S68': [
    'BenQ-Siemens',
    'S68',
    null,
    DeviceType.MOBILE,
  ],
  'http://uap.benq.com/mb_s81/benq_s81_v1.xml': ['BenQ-Siemens', 'S81', null, DeviceType.MOBILE],
  'http://uap.benq.com/mb_s82/benq_S82_voda_2g.xml': ['BenQ-Siemens', 'S82', null, DeviceType.MOBILE],
  'http://uap.benq.com/mb_s88/benq_s88_v3_300k.xml': ['BenQ-Siemens', 'S88', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/BGH_Joy_Smart_A7G.xml': [
    'BGH',
    'Joy Smart A7G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bbk.com/uaprof/BBKV205.xml': ['BKK', 'V205', null, DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/ADVANCE_3.5.XML': ['BLU', 'Advance 3.5', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/ADVANCE4.0.xml': ['BLU', 'Advance 4.0', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/ADVANCE_4.0.XML': ['BLU', 'Advance 4.0', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/Advance 4.0 L.xml': ['BLU', 'Advance 4.0 L', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_U_V856_V3.xml': ['BLU', 'Dash', 'Android', DeviceType.MOBILE],
  'http://ctmexico.com.mx/UA_DASH.xml': ['BLU', 'Dash 3.5', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_3.5.XML': ['BLU', 'Dash 3.5', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_3.5_II.xml': ['BLU', 'Dash 3.5 II', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_4.0.XML': ['BLU', 'Dash 4.0', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/Dash4.0Ce.xml': ['BLU', 'Dash 4.0 CE', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/dash_4.5.XML': ['BLU', 'Dash 4.5', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_5.0.XML': ['BLU', 'Dash 5.0', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH5.5.xml': ['BLU', 'Dash 5.5', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_C_MUSIC_D390u.xml': [
    'BLU',
    'Dash C Music',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_J_D070.xml': ['BLU', 'Dash J', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/BLU_D140_UAP.xml': ['BLU', 'Dash Jr', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_JR_3G_blu.xml': ['BLU', 'Dash Jr', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/dashjr.4.0.xml': ['BLU', 'Dash Jr 4.0', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_JR_K.XML': ['BLU', 'Dash Jr K', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/BLU-D140S_UAP.xml': [
    'BLU',
    'Dash Jr Social',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_L_D050.xml': ['BLU', 'Dash L', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_MUSIC_4.0.XML': [
    'BLU',
    'Dash Music 4.0',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/Dash music 4.5.xml': [
    'Blu',
    'Dash Music 4.5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/DASHMUSICII.xml': ['BLU', 'Dash Music II', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/DASH_MUSIC_JR.xml': ['BLU', 'Dash Music Jr', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/BLU_ENERGY_X_PLUS.xml': [
    'BLU',
    'Energy X Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/Studio_Energey_5.5.xml': [
    'BLU',
    'Energy X Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/LIFE8.xml': ['BLU', 'Life 8', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/LifeOne.xml': ['BLU', 'Life One', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/Life_One_M.xml': ['BLU', 'Life One M', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/LIFE ONE X.XML': ['BLU', 'Life One X', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/LIFE PLAY.XML': ['BLU', 'Life Play', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/LIFE_PLAY_MINI.xml': [
    'BLU',
    'Life Play Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/LIFE_PLAY_S.xml': ['BLU', 'Life Play S', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/LifeView.xml': ['BLU', 'Life View', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/ADVANCE_JR.xml': ['Blu', 'Neo 3.5', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/Neo_3.5.xml': ['BLU', 'Neo 3.5', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO5.0.xml': ['BLU', 'Studio 5.0', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO5.0_2.xml': ['BLU', 'Studio 5.0 II', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/Tank4.5.XML': ['BLU', 'Studio 5.0c HD', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/LIFEPLAY.xml': ['BLU', 'Studio 5.0ce', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/studio5.0e.xml': ['BLU', 'Studio 5.0e', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO_5.0K.xml': ['BLU', 'Studio 5.0k', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/ STUDIO5.0SII.XML': [
    'BLU',
    'Studio 5.0s II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO5.5S.xml': ['BLU', 'Studio 5.5s', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/Studio_7.0_II.xml': ['BLU', 'Studio 7.0 II', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO_C.XML': ['BLU', 'Studio C', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO_G.xml': ['BLU', 'Studio G', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO_G_PLUS.xml': ['BLU', 'Studio G Plus', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO5.0S_HD.xml': ['BLU', 'Studio X', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/STUDIO_X.xml': ['BLU', 'Studio X', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/BLU_STUDIO_X_PLUS.xml': [
    'BLU',
    'Studio X Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bluhelp.com/upload/xmlfiles/Studio_X_Plus.xml': ['BLU', 'Studio X Plus', 'Android', DeviceType.MOBILE],
  'http://112.74.195.169/upload/xmlfiles/STUDIO_X8_HD.XML': ['BLU', 'Studio X8 HD', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/Touchbook_7.0_3G.xml': [
    'BLU',
    'Touch Book 7.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX1020.xml': ['Bmobile', 'AX1020', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX1030.xml': ['Bmobile', 'AX1030', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/UAProfile_BmobileAX1035.xml': [
    'Bmobile',
    'AX1035',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX1060.xml': ['Bmobile', 'AX1060', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX1065.xml': ['Bmobile', 'AX1065', 'Android', DeviceType.MOBILE],
  'http://bmobile.eu.com/uaprofile/UAProfile_BmobileAX512.xml': ['Bmobile', 'AX512', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/UAProfile_BmobileAX512.xml': [
    'Bmobile',
    'AX512',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX570.xml': ['Bmobile', 'AX570', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX600.xml': ['Bmobile', 'AX600', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/UAProfile_BmobileAX600.xml': [
    'Bmobile',
    'AX600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bmobile.eu.com/uaprofile/BmobileAX605.xml': ['Bmobile', 'AX605', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/UAProfile_BmobileAX620.xml': [
    'Bmobile',
    'AX620',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX670.xml': ['Bmobile', 'AX670', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX675.xml': ['Bmobile', 'AX675', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX680.xml': ['Bmobile', 'AX680', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX710.xml': ['Bmobile', 'AX710', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/BmobileAX745.xml': ['Bmobile', 'AX745', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/Bmobile_AX810.xml': ['Bmobile', 'AX810', 'Android', DeviceType.MOBILE],
  'http://www.bmobile.eu.com/uaprofile/UAprofile_BmobileQW125.xml': ['Bmobile', 'QW125', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Bouygues Telecom Bs 351.xml': [
    'Bouygues',
    'Bs 351',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/Bouygues_Telecom_Bs_402.xml': [
    'Bouygues',
    'Bs 402',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/BS471.xml': ['Bouygues', 'Bs 471', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Bouygues_Telecom_Ultym_5_2.xml': [
    'Bouygues',
    'Ultym 5.2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/Bouygues_Telecom_Ultym_5L.xml': [
    'Bouygues',
    'Ultym 5L',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://files.bq.com/uaprof/bq_aquaris_45_JB.xml': ['bq', 'Aquaris', 'Android', DeviceType.MOBILE],
  'http://files.bq.com/uaprof/bq_aquaris_E4_KK.xml': ['bq', 'Aquaris E4', 'Android', DeviceType.MOBILE],
  'http://files.bq.com/uaprof/bq_aquaris_E45_KK.xml': ['bq', 'Aquaris E4.5', 'Android', DeviceType.MOBILE],
  'http://files.bq.com/uaprof/bq_aquaris_5lte_KK.xml': ['bq', 'Aquaris E5', 'Android', DeviceType.MOBILE],
  'http://files.bq.com/uaprof/bq_aquaris_E5_FHD_KK.xml': ['bq', 'Aquaris E5 FHD', 'Android', DeviceType.MOBILE],
  'http://files.bq.com/uaprof/bq_aquaris_E5_HD_KK.xml': ['bq', 'Aquaris E5 HD', 'Android', DeviceType.MOBILE],
  'http://files.bq.com/uaprof/fnac_aquaris_E5_HD_KK.xml': ['bq', 'Aquaris E5 HD', 'Android', DeviceType.MOBILE],
  'http://files.bq.com/uaprof/bq_aquaris_E6_KK.xml': ['bq', 'Aquaris E6', 'Android', DeviceType.MOBILE],
  'http://files.bq.com/uaprof/bq_edison_3_KK.xml': ['bq', 'Edison 3', 'Android', DeviceType.TABLET],
  'http://uaprof.vtext.com/pcd/c771/c771.xml': ['Casio', 'Gz\'One Commando', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/vzw/vzw.xml': ['Casio', 'Gz\'One Commando 811', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/vietnam/vietnam.xml': ['Casio', 'GzOne CA201', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/c811/c811.xml': ['Casio', 'GzOne Commando 811', 'Android', DeviceType.MOBILE],
  'http://www.catphones.com/uaprof/Cat_B10-2_UAprofile.xml': ['Cat', 'B15', 'Android', DeviceType.MOBILE],
  'http://www.catphones.com/uaprof/b15q.xml': ['CAT', 'B15Q', 'Android', DeviceType.MOBILE],
  'http://www.catphones.com/uaprof/s50.xml': ['CAT', 'S50', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/celkon/A95Pro.xml': ['Celkon', 'A95 Pro', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/M8050QM.xml': ['Celkon', 'S1', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/C1038.xml': ['Cellon', 'C1038', null, DeviceType.MOBILE],
  'http://uap.cellon.com/C2573.xml': ['Cellon', 'C2573', null, DeviceType.MOBILE],
  'http://uap.cellon.com/C8660.xml': ['Cellon', 'C8660', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/UAP/C8660.xml': ['Cellon', 'C8660', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/M8047IU.xml': ['Cellon', 'M8047IU', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/M8047QM.xml': ['Cellon', 'M8047QM', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/M8140PT.xml': ['Cellon', 'M8140PT', 'Android', DeviceType.MOBILE],
  'http://www.fih.com/uaprof/FIH000/UAProf_FIH000_Froyo.xml': ['ChangHong', 'Z-me', 'Android', DeviceType.MOBILE],
  'http://221.176.65.117/uaprof/CMDC_M601.xml': ['China Mobile', 'M601', 'Android', DeviceType.TABLET],
  'http://phone.hisense.com/khfw/rjxz/201306/P020130627360412430072.xml': [
    'China Mobile',
    'M701',
    'Android',
    DeviceType.TABLET,
  ],
  'http://221.176.65.117/uaprof/CMCC-M812.xml': ['China Mobile Device', 'and M812', 'Android', DeviceType.MOBILE],
  'http://221.176.65.117/uaprof/M821.xml': ['China Mobile Device', 'and M821', 'Android', DeviceType.MOBILE],
  'http://221.176.65.117/uaprof/M823.xml': ['China Mobile Device', 'and M823', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/CHL/CHL-S800_1_20101228.xml': ['CHL', 'S800', 'Android', DeviceType.MOBILE],
  'http://www.commtiva.com/uaprof/HD700/UAProf_HD700_Gingerbread.xml': [
    'Commtiva',
    'HD700',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.commtiva.com/uaprof/UAProf_Froyo.xml': ['Commtiva', 'N700', 'Android', DeviceType.MOBILE],
  'http://mms.openmobilepr.com/uaprof/Coolpad-3700A.xml': ['Coolpad', '3700', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Coolpad/5560S/Coolpad-5560S-SP004.rdf': [
    'Coolpad',
    '5560S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.cgmobile.com.cn/8810G_UAProfile.xml': ['Coolpad', '8010', 'Android', DeviceType.MOBILE],
  'http://uaprofile.YuLong.com/uaprof/CoolPad8026-1.0.xml': ['Coolpad', '8026', 'Android', DeviceType.MOBILE],
  'http://ota.ragentek.com:8002/RgkOTA/UAprofile/Coolpad8122_UAprofile.xml': [
    'Coolpad',
    '8122',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.oppo.com/resource/UA-PROF/OPPOCoolpad 8730L.xml': ['Coolpad', '8730L', 'Android', DeviceType.MOBILE],
  'http://uaprofile.YuLong.com/uaprof/YuLong-CoolPad8809-1.0.xml': ['CoolPad', '8809', 'Android', DeviceType.MOBILE],
  'http://nmsc.vnet.com.cn/uaprof/YL/COOLPAD-E600.xml': ['Coolpad', 'D510', 'Brew', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/YL/YL_Coolpad_E230_2_20100520.xml': ['Coolpad', 'E230', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Coolpad/801ES/Coolpad-801ES-CP021.rdf': [
    'Coolpad',
    'Quattro II 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.oppo.com/resource/UA-PROF/OPPOCoolpad Y80D.xml': ['Coolpad', 'Y80', 'Android', DeviceType.MOBILE],
  'http://www.azumi-mobile.com/agenteprofile/equipos/Azumi_A50.xml': [
    'Cozco',
    'C1 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.oppo.com/resource/UA-PROF/OPPOCUBOT ONE.xml': ['Cubot', 'One', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOMC002.xml': ['Dakele', 'MC002', 'Android', DeviceType.MOBILE],
  'http://ftp.us.dell.com/Factor_Software_Updates/Grappa_UA_Profile.xml': [
    'Dell',
    'Grappa',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://122.200.68.229/docs/mini3ix.xml': ['Dell', 'Mini 3ix', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/XCD35.xml': ['Dell', 'XCD35', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/5056A.xml': ['Digicel', 'DL1 Plus', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/DL800.xml': ['Digicel', 'DL800', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Juno-1.0.xml': ['Dopod', 'C750', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Tachi-1.0.xml': ['Dopod', 'T5399', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Qilin-1.0.xml': ['Dopod', 'T8388', 'Windows Mobile', DeviceType.MOBILE],
  'http://ua.doro.com/ua/Doro810_UAProfile.xml': ['Doro', 'Liberto 810', 'Android', DeviceType.MOBILE],
  'http://ua.doro.com/ua/Doro820_UAProfile.xml': ['Doro', 'Liberto 820', 'Android', DeviceType.MOBILE],
  'http://ua.doro.com/ua/Doro820Mini_UAProfile.xml': ['Doro', 'Liberto 820 Mini', 'Android', DeviceType.MOBILE],
  'http://ua.doro.com/ua/Doro740_UAProfile.xml': ['Doro', 'PhoneEasy 745', 'Android', DeviceType.MOBILE],
  'http://www.elitemodellookmobile.com/uaprof/eml2.xml': ['Elite Model Look', 'EML2', null, DeviceType.MOBILE],
  'http://mobileinternet.ericsson.com/UAprof/R380e.xml': ['Ericsson', 'R380', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/R520.xml': ['Ericsson', 'R520', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/R600.xml': ['Ericsson', 'R600', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T39.xml': ['Ericsson', 'T39', null, DeviceType.MOBILE],
  'http://mobileinternet.ericsson.com/UAprof/T60d.xml': ['Ericsson', 'T60', null, DeviceType.MOBILE],
  'http://mobileinternet.ericsson.com/UAprof/T65.xml': ['Ericsson', 'T65', null, DeviceType.MOBILE],
  'http://mobileinternet.ericsson.com/UAprof/T68R1.xml': ['Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T68R201.xml': ['Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T68R301.xml': ['Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T68R401.xml': ['Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T68R402.xml': ['Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T68R501.xml': ['Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T68R502.xml': ['Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T68R503.xml': ['Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/V6500_Etisalat_EG.xml': [
    'Etisalat',
    'Smartphone',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.qma.com.tw/BenQ-A3c.xml': ['Ezcast', 'Dongle', 'Android'],
  'http://mobiwire.com/uaprofile/Telekom_Austria_Group_FP1.xml': ['Fairphone', '1', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/Flair%20P2.xml': ['Fairphone', '2', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/N26/FarEastone_Smart501.xml': [
    'Fareastone',
    'Smart 501',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.wizdevice.com/support/rise/uaprof.xml': ['Fareastone', 'Smart 701', 'Android', DeviceType.TABLET],
  'http://211.42.201.70/ua_profile/FLY-2040i.xml': ['Fly', '2040', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-2040L.xml': ['Fly', '2040', null, DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_E154.xml': ['Fly', 'E154', 'MTK', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_E190.xml': ['Fly', 'E190', 'MTK', DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/Fly-E300.xml': ['Fly', 'E300', null, DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Flylife_Connect_7_3G.xml': [
    'Fly',
    'Flylife Connect 7 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.fly-phone.ru/UAP/Flylife_Connect_7.85_3G_2.xml': [
    'Fly',
    'Flylife Connect 7.85 3G 2',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.fly-phone.ru/UAP/Flylife_Connect_7.85_3G_Slim.xml': [
    'Fly',
    'Flylife Connect 7.85 3G Slim',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.fly-phone.ru/UAP/Fly_FS403.xml': ['Fly', 'FS403 Cumulus 1', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_FS451.xml': ['Fly', 'FS451 Nimbus 1', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ237.xml': ['Fly', 'IQ237 Dynamic', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ238.xml': ['Fly', 'IQ238 Jazz', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ239.xml': ['Fly', 'IQ239 Era Nano 2', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ246.xml': ['Fly', 'IQ246 Power', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ430.xml': ['Fly', 'IQ430 Evoke', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ431.xml': ['Fly', 'IQ431 Glory', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ432.xml': ['Fly', 'IQ432 Era Nano 1', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ434.xml': ['Fly', 'IQ434 Era Nano 5', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ436.xml': ['Fly', 'IQ434 Era Nano 9', 'Android', DeviceType.MOBILE],
  'http://www.bluhelp.com/upload/xmlfiles/STAR_4.5.xml': ['Fly', 'IQ440 Energie', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_EVO_Chic_1.xml': ['Fly', 'IQ440 Energie', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ440.xml': ['Fly', 'IQ440 Energie', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4403.xml': ['Fly', 'IQ440 Energie', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4404.xml': ['Fly', 'IQ440 Energie', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4407.xml': ['Fly', 'IQ440 Energie', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4409_Quad.xml': ['Fly', 'IQ440 Energie', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4405_Quad.xml': ['Fly', 'IQ4405 Evo Chic', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4410_Quad.xml': ['Fly', 'IQ441 Radiance', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4411_Quad.xml': ['Fly', 'IQ441 Radiance', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4412_Quad.xml': ['Fly', 'IQ441 Radiance', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4414_Quad.xml': ['Fly', 'IQ441 Radiance', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4415_Ouad.xml': ['Fly', 'IQ441 Radiance', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4416.xml': ['Fly', 'IQ441 Radiance', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4410i.xml': ['Fly', 'IQ4410i Phoenix 2', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4413_Quad.xml': ['Fly', 'IQ4413 Evo Chic 3', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ442.xml': ['Fly', 'IQ442 Miracle', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ443.xml': ['Fly', 'IQ443 Trend', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ444.xml': ['Fly', 'IQ444 Diamond', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ444_Quattro.xml': ['Fly', 'IQ444 Diamond', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ445.xml': ['Fly', 'IQ445 Genius', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ446.xml': ['Fly', 'IQ446 Magic', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ447.xml': ['Fly', 'IQ447 Era Life 1', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ449.xml': ['Fly', 'IQ449 Pronto', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4490.xml': ['Fly', 'IQ449 Pronto', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4491_Quad.xml': ['Fly', 'IQ449 Pronto', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4503_Quad.xml': ['Fly', 'IQ450 Horizon', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ450_Quattro.xml': ['Fly', 'IQ450 Horizon', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ451.xml': ['Fly', 'IQ451 Vista', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4511_Octa.xml': ['Fly', 'IQ451 Vista', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4514_Quad.xml': ['Fly', 'IQ451 Vista', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4515_Quad.xml': ['Fly', 'IQ451 Vista', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOIQ451.xml': ['Fly', 'IQ451 Vista', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4512_Quad.xml': ['Fly', 'IQ4512 Evo Chic 4', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4516_Octa.xml': ['Fly', 'IQ4516 Tornado Slim', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ452_Quad.xml': ['Fly', 'IQ452 Ego Vision 1', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ453_Quad.xml': ['Fly', 'IQ453 Luminor', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ454.xml': ['Fly', 'IQ454 Evo Tech 1', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ455_Octa.xml': ['Fly', 'IQ455 Ego Art 1', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ456.xml': ['Fly', 'IQ456 Era Life 2', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ458_Quad.xml': ['Fly', 'IQ458 Quad', 'Android', DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/Fly-LX610.xml': ['Fly', 'LX610', null, DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_MC100.xml': ['Fly', 'MC100', null, DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_MC110.xml': ['Fly', 'MC110', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-MX200i.xml': ['Fly', 'MX200', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-MX230.xml': ['Fly', 'MX230', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-MX300.xml': ['Fly', 'MX300', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-MX330.xml': ['Fly', 'MX330', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-SL300m.xml': ['Fly', 'SL300', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/Fly-SL399E.xml': ['Fly', 'SL399', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/SL500i.xml': ['Fly', 'SL500i', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/SL500m.xml': ['Fly', 'SL500m', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/SL600.xml': ['Fly', 'SL600', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/Fly-SLT100.xml': ['Fly', 'SLT100', null, DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_SX200.xml': ['Fly', 'SX200', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-SX210.xml': ['Fly', 'SX210', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-SX300.xml': ['Fly', 'SX300', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-SX305.xml': ['Fly', 'SX305', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-SX310.xml': ['Fly', 'SX310', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/FLY-SX390.xml': ['Fly', 'SX390', null, DeviceType.MOBILE],
  'http://218.249.89.125/UAprof/FLY-V120.xml': ['Fly', 'V120', null, DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_X3.xml': ['Fly', 'X3', null, DeviceType.MOBILE],
  'http://spf.fmworld.net/fujitsu/c/data/UAProf/STYLISTIC/S01.xml': [
    'Fujitsu',
    'STYLISTIC S01',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.fujitsu-siemens.com/uaprof/PLT830.xml': [
    'Fujitsu Siemens',
    'Pocket LOOX T830',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://static.garmincdn.com/uaprof/A10_1_0.xml': ['Garmin-Asus', 'Nuvifone A10', 'Android', DeviceType.MOBILE],
  'http://static.garmincdn.com/uaprof/A50_1_0.xml': ['Garmin-Asus', 'Nuvifone A50', 'Android', DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/garmin-asus-Nuvifone-M10-1.0.xml': [
    'Garmin-Asus',
    'Nuvifone M10',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://support.acer.com/UAprofile/Acer_TPA60W_Profile.xml': ['Gateway', 'TPA60W', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/GM-FOXv100WCDMA.xml': ['General Mobile', 'Fox', 'Android', DeviceType.MOBILE],
  'http://eip2.gigabytecm.com/GIGABYTE-g-smart.xml': ['Gigabyte', 'GSmart', null, DeviceType.MOBILE],
  'http://eip2.gigabytecm.com/GSMART-G1310.xml': ['Gigabyte', 'GSmart G1310', 'Android', DeviceType.MOBILE],
  'http://eip2.gigabytecm.com/GSMART-G1315.xml': ['Gigabyte', 'GSmart G1315', 'Android', DeviceType.MOBILE],
  'http://eip2.gigabytecm.com/GSMART-G1317.xml': ['Gigabyte', 'GSmart G1317', 'Android', DeviceType.MOBILE],
  'http://eip2.gigabytecm.com/GIGABYTE-MS800.xml': ['Gigabyte', 'GSmart MS800', null, DeviceType.MOBILE],
  'http://eip2.gigabytecm.com/GIGABYTE-g-smart-vga.xml': ['Gigabyte', 'GSmart T600', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1GPRS-GM_Turkey.xml': [
    'GM',
    'Ultimate Slim',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://gsm.lge.com/html/gsm/Dsi6X_y8P_In4gbf/xel-M3-D1.xml': ['Google', 'Pixel', 'Android', DeviceType.MOBILE],
  'http://mobile.haier.com/UAProf/uapA62.xml': ['Haier', 'A62', null, DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOHT-I860.xml': ['Haier', 'I860', 'Android', DeviceType.MOBILE],
  'http://www.yeezonetech.com/wap/SMDK4x12_UAProfile.xml': ['Haier', 'I928', 'Android', DeviceType.MOBILE],
  'http://mobile.haier.com/UAProf/uapM1610.xml': ['Haier', 'M1610', null, DeviceType.MOBILE],
  'http://www.ehaier.com/download/mobile/uapHaier-HW-N86W.xml': ['Haier', 'N86W', 'Android', DeviceType.MOBILE],
  'http://www.ehaier.com/download/mobile/uapHaier-HW-N88W.xml': ['Haier', 'N88W', 'Android', DeviceType.MOBILE],
  'http://www.ehaier.com/download/mobile/uapHaier-HW-W718.xml': ['Haier', 'N88W', 'Android', DeviceType.MOBILE],
  'http://uaprof.uni-wise.com/uaprof/Haier/Haier-T10C.xml': ['Haier', 'T10C', null, DeviceType.MOBILE],
  'http://mobile.haier.com/UAProf/uapV7000.xml': ['Haier', 'V7000', null, DeviceType.MOBILE],
  'http://www.ehaier.com/download/mobile/uapHW-W617.xml': ['Haier', 'W617', 'Android', DeviceType.MOBILE],
  'http://www.ehaier.com/download/mobile/uapHaier-HW-W716.xml': ['Haier', 'W716', 'Android', DeviceType.MOBILE],
  'http://cdn09.ehaier.com/download/mobile/uapHaier-W867.xml': ['Haier', 'W867', 'Android', DeviceType.MOBILE],
  'http://www.ehaier.com/download/mobile/uapHW-W910.xml': ['Haier', 'W910', 'Android', DeviceType.MOBILE],
  'http://mobile.haier.com/UAProf/uapZ3000.xml': ['Haier', 'Z3000', null, DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOAlpha Ice.xml': [
    'Highscreen',
    'Alpha Ice',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Blade L370.xml': ['Highscreen', 'Zera S', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOHIKe 868.xml': ['HIKe', 'Z1 868', 'Android', DeviceType.MOBILE],
  'http://phone.hisense.com/khfw/rjxz/201310/P020131012478952694173.xml': [
    'Hisense',
    'E360M',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.hisensephone.com/Hisense_E51-M_ua_profile.xml': ['Hisense', 'E51-M', 'Android', DeviceType.MOBILE],
  'http://www.hisensephone.com/Hisense_F20T_ua_profile.xml': ['Hisense', 'F20T', 'Android', DeviceType.MOBILE],
  'http://www.hisensephone.com/Hisense_F21T_ua_profile.xml': ['Hisense', 'F21T', 'Android', DeviceType.MOBILE],
  'http://phone.hisense.com/khfw/rjxz/201303/P020130307299783065342.xml': [
    'Hisense',
    'T820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201208/P020120809608224982262.xml': [
    'Hisense',
    'T830',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201205/P020120521576380789573.xml': [
    'Hisense',
    'T860',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201301/P020130130568107298317.xml': [
    'Hisense',
    'T912',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201306/P020130626391746806303.xml': [
    'Hisense',
    'T928',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201301/P020130121342541959752.xml': [
    'Hisense',
    'T958',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201306/P020130626392019424761.xml': [
    'Hisense',
    'T959',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201309/P020130909487904900221.xml': [
    'Hisense',
    'T959',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201307/P020130710551710631695.xml': [
    'Hisense',
    'T959S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201306/P020130626585426555510.xml': [
    'Hisense',
    'T968',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201304/P020130425502003281721.xml': [
    'Hisense',
    'T970',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201308/P020130805555147328699.xml': [
    'Hisense',
    'T980',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://phone.hisense.com/khfw/rjxz/201405/P020140505487949781524.xml': [
    'Hisense',
    'U939',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://picture-us.hismarttv.com/txfile/Hisense_HS-U961_20150304.XML': [
    'Hisense',
    'U961',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Hitachi/SH-P300/S2A31.rdf': ['Hitachi', 'SH-P300', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Hitachi/SH-P300/S2A33.rdf': ['Hitachi', 'SH-P300', null, DeviceType.MOBILE],
  'http://www.hp.com/ipaqcarrier/hpipaq510v10.xml': ['HP', 'iPAQ 510', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.hp.com/ipaqcarrier/hpipaq610v10.xml': ['HP', 'iPAQ 610', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.hp.com/ipaqcarrier/hpipaq910v10.xml': ['HP', 'iPAQ 910', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.hp.com/ipaqcarrier/HPiPAQDataMessenger10.xml': [
    'HP',
    'iPAQ Data Messenger',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.hp.com/ipaqcarrier/hpipaqhw692xv10.xml': ['HP', 'iPAQ hw6920', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.hp.com/ipaqcarrier/hpipaqrw6815v10.xml': ['HP', 'iPAQ rw6815', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.hp.com/ipaqcarrier/HPiPAQVoiceMessenger10.xml': [
    'HP',
    'iPAQ Voice Messenger',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://js.redirect.hp.com/jumpstation?bd=all&c=none&locale=ww_ww&pf=all&s=hp_linkplus_uaprofile&tp=mobility': [
    'HP',
    'Slate 10 Plus',
    'Android',
    DeviceType.TABLET,
  ],
  'http://js.redirect.hp.com/jumpstation?bd=all&c=none&locale=ww_ww&pf=all&s=hp_vogue_uaprofile&tp=mobility': [
    'HP',
    'Slate 8 Plus',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/HTC/0PJA2-SPRINT/ViperOneM9 610.rdf': ['HTC', '10', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/NxVAjJl9Mq/ua-profile.xml': ['HTC', '10', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Strk-1.0.xml': ['HTC', '3100', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/SongShan/ua-profile.xml': ['HTC', 'A3360', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Tianshan/ua-profile.xml': ['HTC', 'A3380', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Athena-1.0.xml': ['HTC', 'Advantage X7500', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/HTC_Amaze_4G/ua-profile.xml': [
    'HTC',
    'Amaze 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PH85/ua-profile.xml': ['HTC', 'Amaze 4G', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PH851/ua-profile.xml': ['HTC', 'Amaze 4G', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telus/Ruby/ua-profile.xml': ['HTC', 'Amaze 4G', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Videotron/Ruby/ua-profile.xml': [
    'HTC',
    'Amaze 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/apache-2.0.xml': ['HTC', 'Apache', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Aria/ua-profile.xml': ['HTC', 'Aria', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Liberty/A6366-1.0.xml': ['HTC', 'Aria', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/eMobile/Liberty/ua-profile.xml': ['HTC', 'Aria', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM651/ua-profile.xml': [
    'HTC',
    'au Infobar A02',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/beacon-1.0.xml': ['HTC', 'Beacon', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/RLyrImabWh/ua-profile.xml': [
    'HTC',
    'Butterfly 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_909d_1_20130601.XML': ['HTC', 'Butterfly S', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_909d_2_20130801.XML': ['HTC', 'Butterfly S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PO68/ua-profile.xml': [
    'HTC',
    'Butterfly S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PO681/ua-profile.xml': [
    'HTC',
    'Butterfly S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PO682/ua-profile.xml': [
    'HTC',
    'Butterfly S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PO684/ua-profile.xml': [
    'HTC',
    'Butterfly S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PO685/ua-profile.xml': [
    'HTC',
    'Butterfly S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/ChaChaCha/ua-profile.xml': [
    'HTC',
    'ChaCha',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/HTC_ChaCha_A810e/ua-profile.xml': [
    'HTC',
    'ChaCha',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PH06/ua-profile.xml': ['HTC', 'ChaCha', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Orange/ChaChaCha/ua-profile.xml': [
    'HTC',
    'ChaCha',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Orange/PH06/ua-profile.xml': ['HTC', 'ChaCha', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PD11/ua-profile.xml': ['HTC', 'Cullinan', 'Android', DeviceType.MOBILE],
  'http://mms.cellcom.com/uaprofs/cellcom_htc_DLX.xml': ['HTC', 'Deluxe', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ACG/PL832/ua-profile_500K.xml': ['HTC', 'Deluxe', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Bravo/HTC_Desire.xml': ['HTC', 'Desire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Bravo/HTC_Desire_A8181.xml': [
    'HTC',
    'Desire',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/Desire/ua-profile.xml': ['HTC', 'Desire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/eris/ua-profile.xml': ['HTC', 'Desire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Orange/Desire-profile.xml': [
    'HTC',
    'Desire',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/SBM/SBM_X06HT-1.0.xml': ['HTC', 'Desire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telstra/Desire/ua-profile.xml': ['HTC', 'Desire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telus/Bravo/ua-profile.xml': ['HTC', 'Desire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/tmo/HTC_Desire-1.0.xml': ['HTC', 'Desire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/cvA1671TDt/ua-profile.xml': [
    'HTC',
    'Desire 10 Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PO601/ua-profile.xml': [
    'HTC',
    'Desire 200',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/vHfmvk5H3n/ua-profile.xml': [
    'HTC',
    'Desire 210',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/4WaXiSSfCP/ua-profile.xml': [
    'HTC',
    'Desire 300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telstra/4WaXiSSfCP/ua-profile.xml': [
    'HTC',
    'Desire 300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/AIO/nhYHJ3dbMv/ua-profile.xml': [
    'HTC',
    'Desire 310',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/l9kfHYvA01/ua-profile.xml': [
    'HTC',
    'Desire 310',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/nhYHJ3dbMv/ua-profile.xml': [
    'HTC',
    'Desire 310',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/vBSZ5hs37J/ua-profile.xml': [
    'HTC',
    'Desire 310',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/O2/l9kfHYvA01/ua-profile.xml': [
    'HTC',
    'Desire 310',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Orange/l9kfHYvA01/ua-profile.xml': [
    'HTC',
    'Desire 310',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/l9kfHYvA01/ua-profile.xml': [
    'HTC',
    'Desire 310',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Vodafone/l9kfHYvA01/ua-profile.xml': [
    'HTC',
    'Desire 310',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telcel/nhYHJ3dbMv/ua-profile.xml': [
    'HTC',
    'Desire 320',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TELUS/nhYHJ3dbMv/ua-profile.xml': [
    'HTC',
    'Desire 320',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Vodafone/nhYHJ3dbMv/ua-profile.xml': [
    'HTC',
    'Desire 320',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/nJwqkkNk4t/ua-profile.xml': [
    'HTC',
    'Desire 326G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/AMX/0P3Z11/ua-profile.xml': ['HTC', 'Desire 500', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/0P3Z1/ua-profile.xml': [
    'HTC',
    'Desire 500',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/0P3Z11/ua-profile.xml': [
    'HTC',
    'Desire 500',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telcel/0P3Z1/ua-profile.xml': [
    'HTC',
    'Desire 500',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TIM/0P3Z11/ua-profile.xml': ['HTC', 'Desire 500', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/0P3Z11/ua-profile.xml': ['HTC', 'Desire 500', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Vodafone/0P3Z11/ua-profile.xml': [
    'HTC',
    'Desire 500',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/jV8CnoJUaO/ua-profile.xml': [
    'HTC',
    'Desire 501',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/0P3Z2/ua-profile.xml': [
    'HTC',
    'Desire 5088',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/0PCV1-2012071301/1476521.rdf': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/0PCV1-2012071301/1486522.rdf': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/0PCV1-2012071301/1496523.rdf': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/0PCV1-BOOST/1426521.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-BOOST/1476521.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-BOOST/1486522.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-BOOST/1496523.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-Chameleon/1486522.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-SPRINT/1426521.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-SPRPRE/1486522.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-SPRPRE/1496523.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-VIRGIN/1426521.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-VIRGIN/1476521.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-VIRGIN/1486522.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PCV1-VIRGIN/1496523.rdf': ['HTC', 'Desire 510', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/7l3xFmWvDC/ua-profile.xml': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/BM/7l3xFmWvDC/ua-profile.xml': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/R183PSZ1oa/ua-profile.xml': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Cricket/EwxIAccCJC/ua-profile.xml': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telcel/7l3xFmWvDC/ua-profile.xml': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telstra/R183PSZ1oa/ua-profile.xml': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telus/7l3xFmWvDC/ua-profile.xml': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/R183PSZ1oa/ua-profile.xml': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Vodafone/R183PSZ1oa/ua-profile.xml': [
    'HTC',
    'Desire 510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/VTy7Pu6T6N/ua-profile.xml': [
    'HTC',
    'Desire 520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TELCEL/hkQ3fFqw1h/ua-profile.xml': [
    'HTC',
    'Desire 526G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/hkQ3fFqw1h/ua-profile.xml': [
    'HTC',
    'Desire 526G+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/hwX6V8P1Mn/ua-profile.xml': [
    'HTC',
    'Desire 526G+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PO49120/ua-profile.xml': [
    'HTC',
    'Desire 600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PO471/ua-profile.xml': [
    'HTC',
    'Desire 600c',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTC0P4E1-VIRGIN/1106526.rdf': ['HTC', 'Desire 601', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC0P4E1-VIRGIN/1106529.rdf': ['HTC', 'Desire 601', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC0P4E1-VIRGIN/2156523.rdf': ['HTC', 'Desire 601', 'Android', DeviceType.MOBILE],
  'http://mms.ntwls.net/uaprofs/ua-profile_1M.xml': ['HTC', 'Desire 601', 'Android', DeviceType.MOBILE],
  'http://uaprof.cccomm.csky.us/ua/ua-profile_500k.xml': ['HTC', 'Desire 601', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ACG/PqjMKRKt4Z/ua-profile_1M.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/ACG/PqjMKRKt4Z/ua-profile_500K.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/BM/CjnctPc6Sf/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/CBW/CjnctPc6Sf/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/CjnctPc6Sf/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/SLl2AjRgr3/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Orange/CjnctPc6Sf/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Rogers/CjnctPc6Sf/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telus/CjnctPc6Sf/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TIM/CjnctPc6Sf/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Videotron/CjnctPc6Sf/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/WIND/CjnctPc6Sf/ua-profile.xml': [
    'HTC',
    'Desire 601',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PO491/ua-profile.xml': [
    'HTC',
    'Desire 606w',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PO481/ua-profile.xml': [
    'HTC',
    'Desire 608t',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_609d_1_20130501.XML': ['HTC', 'Desire 609d', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/GcDNB3aMvX/ua-profile.xml': [
    'HTC',
    'Desire 610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/GcDNB3aMvX/ua-profile.xml': [
    'HTC',
    'Desire 610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/HQEJRedmsG/ua-profile.xml': [
    'HTC',
    'Desire 610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Orange/HQEJRedmsG/ua-profile.xml': [
    'HTC',
    'Desire 610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telstra/HQEJRedmsG/ua-profile.xml': [
    'HTC',
    'Desire 610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/HQEJRedmsG/ua-profile.xml': [
    'HTC',
    'Desire 610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Vodafone/HQEJRedmsG/ua-profile.xml': [
    'HTC',
    'Desire 610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/gwLkpXJlS0/ua-profile.xml': [
    'HTC',
    'Desire 616',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/LC7XQ0af2u/ua-profile.xml': [
    'HTC',
    'Desire 616',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_619d_1_20130815.XML': ['HTC', 'Desire 619d', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/e1NGCirnFB/ua-profile.xml': [
    'HTC',
    'Desire 620',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Orange/e1NGCirnFB/ua-profile.xml': [
    'HTC',
    'Desire 620',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/e1NGCirnFB/ua-profile.xml': [
    'HTC',
    'Desire 620',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/rdV77sS2Jt/ua-profile.xml': [
    'HTC',
    'Desire 620G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/CMCC/RT7rIequXv/ua-profile.xml': [
    'HTC',
    'Desire 626',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/jpsQ9TJbx4/ua-profile.xml': [
    'HTC',
    'Desire 626',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/RT7rIequXv/ua-profile.xml': [
    'HTC',
    'Desire 626',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/vas6Y725FU/ua-profile.xml': [
    'HTC',
    'Desire 626',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Europe/EKgo2FnRlG/ua-profile.xml': [
    'HTC',
    'Desire 626G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/EKgo2FnRlG/ua-profile.xml': [
    'HTC',
    'Desire 626G+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/0PM92-BOOST/1246512.rdf': ['HTC', 'Desire 626s', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PM92-VIRGIN/1246512.rdf': ['HTC', 'Desire 626s', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PM92-VIRGIN/2276516.rdf': ['HTC', 'Desire 626s', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/AMX/ASJJ0xGajy/ua-profile.xml': [
    'HTC',
    'Desire 626s',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/ATT/4GjJvIf3I5/ua-profile.xml': [
    'HTC',
    'Desire 626s',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/ASJJ0xGajy/ua-profile.xml': [
    'HTC',
    'Desire 626s',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Cricket/ASJJ0xGajy/ua-profile.xml': [
    'HTC',
    'Desire 626s',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/nn9cpSwLNa/ua-profile.xml': [
    'HTC',
    'Desire 7060',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/mmxr4Fc9EJ/ua-profile.xml': [
    'HTC',
    'Desire 7088',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/azxFLxeBCm/ua-profile.xml': [
    'HTC',
    'Desire 709d',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/710C-SPRPRE/2336525.rdf': ['HTC', 'Desire 816', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/710C-VIRGIN/1136521.rdf': ['HTC', 'Desire 816', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/710C-VIRGIN/1506523.rdf': ['HTC', 'Desire 816', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/710C-VIRGIN/2336522.rdf': ['HTC', 'Desire 816', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/710C-VIRGIN/2336525.rdf': ['HTC', 'Desire 816', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/710C-VIRGIN/InsertCoin 100.rdf': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.qma.com.tw/HTC_D816d.xml': ['HTC', 'Desire 816', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ACG/weCs1tpPUG/ua-profile_500K.xml': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/7QtMcMcyB2/ua-profile.xml': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/geUXhkfboO/ua-profile.xml': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/HRobRleNsO/ua-profile.xml': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/Khlg9cPNZP/ua-profile.xml': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/miKNCjjDHJ/ua-profile.xml': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/rLgUe79qmx/ua-profile.xml': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/rYMdtoVVAt/ua-profile.xml': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/yKVvh30qEM/ua-profile.xml': [
    'HTC',
    'Desire 816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/j4yjajckun/ua-profile.xml': [
    'HTC',
    'Desire 816G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/pPB1MJUnqf/ua-profile.xml': [
    'HTC',
    'Desire 816G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/x7cG56PcBk/ua-profile.xml': [
    'HTC',
    'Desire 816G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Bouygues/GC0znJc20B/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/CMCC/B3BRtglhHJ/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/CMCC/rTlnYuch0E/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/8y4niiluZ7/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/B3BRtglhHJ/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/EjHarhDDvK/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/GC0znJc20B/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/rTlnYuch0E/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/wLkc0BX3An/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Orange/GC0znJc20B/ua-profile.xml': [
    'HTC',
    'Desire 820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/CMCC/EjHarhDDvK/ua-profile.xml': [
    'HTC',
    'Desire 820G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/mJQD40NuOR/ua-profile.xml': [
    'HTC',
    'Desire 820G+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Europe/mJQD40NuOR/ua-profile.xml': [
    'HTC',
    'Desire 820G+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/aXk2CNmBRo/ua-profile.xml': [
    'HTC',
    'Desire 826',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/c8HDMjoq7Q/ua-profile.xml': [
    'HTC',
    'Desire 826',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/L7YHOLHUJE/ua-profile.xml': [
    'HTC',
    'Desire 826',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/6G97EEWjge/ua-profile.xml': [
    'HTC',
    'Desire 828',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/Liurl1pXZW/ua-profile.xml': [
    'HTC',
    'Desire 830',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://mms.mycricket.com/htc_h1000c.xml': ['HTC', 'Desire C', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bell/A320a/ua-profile.xml': ['HTC', 'Desire C', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/L01/ua-profile.xml': ['HTC', 'Desire C', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Orange/L01/ua-profile.xml': ['HTC', 'Desire C', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Rogers/A320a/ua-profile.xml': ['HTC', 'Desire C', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telstra/L01/ua-profile.xml': ['HTC', 'Desire C', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TIM/L01/ua-profile.xml': ['HTC', 'Desire C', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/L01/ua-profile.xml': ['HTC', 'Desire C', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Vodafone/L01/ua-profile.xml': ['HTC', 'Desire C', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/60qf87NvHb/ua-profile.xml': [
    'HTC',
    'Desire Eye',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/kuAD9zppzP/ua-profile.xml': [
    'HTC',
    'Desire Eye',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/R6vdFCdZmJ/ua-profile.xml': [
    'HTC',
    'Desire Eye',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/O2/R6vdFCdZmJ/ua-profile.xml': [
    'HTC',
    'Desire Eye',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/R6vdFCdZmJ/ua-profile.xml': [
    'HTC',
    'Desire Eye',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.sonymobile.com/Desire HDR402.xml': ['HTC', 'Desire HD', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Ace/A9192-1.0.xml': ['HTC', 'Desire HD', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/DesireHD/ua-profile.xml': [
    'HTC',
    'Desire HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/SBM/SBM_001HT-1.0.xml': ['HTC', 'Desire HD', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telus/DesireHD/ua-profile.xml': [
    'HTC',
    'Desire HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/Ace/ua-profile.xml': ['HTC', 'Desire HD', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM6014/ua-profile.xml': ['HTC', 'Desire L', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM862/ua-profile.xml': ['HTC', 'Desire P', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/DesireS/ua-profile.xml': [
    'HTC',
    'Desire S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PG88/ua-profile.xml': ['HTC', 'Desire S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telstra/S510b/ua-profile.xml': ['HTC', 'Desire S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TME/DesireS/ua-profile.xml': ['HTC', 'Desire S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/Saga/ua-profile.xml': ['HTC', 'Desire S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM861/ua-profile.xml': ['HTC', 'Desire SV', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PL112DS/ua-profile.xml': [
    'HTC',
    'Desire U',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PL113/ua-profile.xml': ['HTC', 'Desire U', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PL111/ua-profile.xml': ['HTC', 'Desire V', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_T328d_1_20120301.XML': ['HTC', 'Desire VC', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/HTC_Desire_VC_T328d.xml': ['HTC', 'Desire VC', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PK781/ua-profile.xml': ['HTC', 'Desire VC', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PK79/ua-profile.xml': ['HTC', 'Desire VT', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bouygues/PO73/ua-profile.xml': ['HTC', 'Desire X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM661/ua-profile.xml': ['HTC', 'Desire X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM661U/ua-profile.xml': ['HTC', 'Desire X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PO73/ua-profile.xml': ['HTC', 'Desire X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Orange/PO73/ua-profile.xml': ['HTC', 'Desire X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/PO73/ua-profile.xml': ['HTC', 'Desire X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bell/Vision/ua-profile.xml': ['HTC', 'Desire Z', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/DesireZ/ua-profile.xml': [
    'HTC',
    'Desire Z',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Orange/DreamX/ua-profile-htc-dream-Orange.xml': [
    'HTC',
    'Dream',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/htc/htc6435lvw/htc6435lvw.xml': ['HTC', 'Droid DNA', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/adr6435/adr6435.xml': ['HTC', 'Droid DNA', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PL832/ua-profile.xml': ['HTC', 'Droid DNA', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/adr62k/adr62k.xml': ['HTC', 'Droid Eris', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/adr63k/adr63k.xml': ['HTC', 'Droid Incredible', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/IncredibleC/ua-profile.xml': [
    'HTC',
    'Droid Incredible',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/pcd/adr6350/adr6350.xml': ['HTC', 'Droid Incredible 2', 'Android', DeviceType.MOBILE],
  'http://mms.openmobilepr.com/uaprof/fireball_1M.xml': ['HTC', 'Droid Incredible 4G', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PO091/ua-profile.xml': ['HTC', 'E1', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/%CDMA_ROM_VERSION%.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/1106510.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/1136511.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/1226513.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/2136511.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/31565116.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/3166513.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/3176514.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/3176515.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/3176519.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/4036511.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX325CKT/4136513.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/4066514.rdf': ['HTC', 'EVO', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX515CKT/1116512.rdf': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX515CKT/1116513.rdf': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX515CKT/1136517.rdf': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX515CKT/2086512.rdf': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX515CKT/2086513.rdf': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX515CKT/2176515.rdf': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX515CKT/2896512.rdf': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX515CKT/2956515.rdf': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APX515CKT/2956516.rdf': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_X515d_1_20110831.XML': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/HTC/X515C-VMUB/1.0/UAProf.xml': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PG863/ua-profile.xml': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/KDDI/ISW12HT/ua-profile.xml': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Rogers/PG863/ua-profile.xml': ['HTC', 'EVO 3D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/1326511.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/3266516.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/3296515.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/3306512.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/3306513.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/3706511.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/4126511.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/4226512.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/4246511.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/4536511.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/4546511.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/4676513.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/5076511.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/5076512.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA9292KT/5076516.rdf': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/KDDI/ISW11HT/ua-profile.xml': ['HTC', 'EVO 4G', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/KT/HTC_X515E/ua-profile.xml': ['HTC', 'EVO 4G+', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APC715CKT/2126515.rdf': ['HTC', 'EVO Design 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APC715CKT/2126518.rdf': ['HTC', 'EVO Design 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APC715CKT/3146510.rdf': ['HTC', 'EVO Design 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APC715CKT/4026512.rdf': ['HTC', 'EVO Design 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC715ABB/1056533.rdf': ['HTC', 'EVO Design 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC715ABB/1116530.rdf': ['HTC', 'EVO Design 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC715ABB/1146530.rdf': ['HTC', 'EVO Design 4G', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PH441/ua-profile.xml': [
    'HTC',
    'EVO Design 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/APA7373KT/1176511.rdf': ['HTC', 'EVO Shift 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA7373KT/2726512.rdf': ['HTC', 'EVO Shift 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA7373KT/2766515.rdf': ['HTC', 'EVO Shift 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA7373KT/2766516.rdf': ['HTC', 'EVO Shift 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA7373KT/2776513.rdf': ['HTC', 'EVO Shift 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA7373KT/2776518.rdf': ['HTC', 'EVO Shift 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/ATP515CKIT/2236511.rdf': ['HTC', 'EVO View 4G', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PJ03/ua-profile.xml': ['HTC', 'Explorer', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/adr6410/adr6410.xml': ['HTC', 'Fireball', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/PM331/ua-profile.xml': ['HTC', 'First', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PG411/ua-profile.xml': ['HTC', 'Flyer', 'Android', DeviceType.TABLET],
  'http://www.htcmms.com.tw/Brew/Aqua/F5151-1.0.xml': ['HTC', 'Freestyle', 'Brew', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/att/P4600-1.0.xml': ['HTC', 'Fuze', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Gratia/ua-profile.xml': ['HTC', 'Gratia', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_HD_mini_T5555-1.0.xml': ['HTC', 'HD mini', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_HD2_T8585-1.0.xml': ['HTC', 'HD2', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_HD2_T9193-1.0.xml': ['HTC', 'HD2', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Leo-1.5.xml': ['HTC', 'HD2', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/voda/HTC_HD2-1.0.xml': ['HTC', 'HD2', 'Windows Mobile', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA6277KT/1566512.rdf': ['HTC', 'Hero', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA6277KT/2276516.rdf': ['HTC', 'Hero', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA6277KT/2316517.rdf': ['HTC', 'Hero', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/APA6277KT/2326512.rdf': ['HTC', 'Hero', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Hero/ua-profile.xml': ['HTC', 'Hero', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telus/Hero/ua-profile.xml': ['HTC', 'Hero', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/PH39100/ua-profile.xml': ['HTC', 'Holiday', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Alltel/Desire/ua-profile.xml': [
    'HTC',
    'HTC Desire',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/WhitestoneW-1.0.xml': ['HTC', 'Imagio', 'Windows Mobile', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_S710d_2_20110301.XML': ['HTC', 'Incredible S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bell/Vivo/ua-profile.xml': ['HTC', 'Incredible S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PG32/ua-profile.xml': [
    'HTC',
    'Incredible S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/KT/HTC_S710E/ua-profile.xml': [
    'HTC',
    'Incredible S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PK071/ua-profile.xml': ['HTC', 'J', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/KDDI/ISW13HT/ua-profile.xml': ['HTC', 'J', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PL9911/ua-profile.xml': [
    'HTC',
    'J Butterfly',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PL993/ua-profile.xml': [
    'HTC',
    'J Butterfly',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/KDDI/HTL21/ua-profile.xml': ['HTC', 'J Butterfly', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/2Q6jdXut9s/ua-profile.xml': [
    'HTC',
    'J Butterfly (HTL23)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/KDDI/HTL22/ua-profile.xml': ['HTC', 'J One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bell/Legend/ua-profile.xml': ['HTC', 'Legend', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Legend/ua-profile.xml': ['HTC', 'Legend', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/nTelos/Merge/ua-profile.xml': ['HTC', 'Lexikon', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/love-1.0.xml': ['HTC', 'Love', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/HTC_Magic/ua-profile.xml': ['HTC', 'Magic', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/HTC_Magic/ua-profile_mr.xml': [
    'HTC',
    'Magic',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/tmo/Mail-1.0.xml': ['HTC', 'Mail', null, DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/quartz-1.0.xml': ['HTC', 'Max 4G', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/Merge/ua-profile.xml': ['HTC', 'Merge', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/PPC6800/3566510.rdf': ['HTC', 'Mogul', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Breeze-2.0.xml': ['HTC', 'MTeoR', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/common/NexusOne/ua-profile.xml': [
    'HTC',
    'Nexus One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTC0P3P7-Chameleon/3026515.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-11/3056516.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-2011011301/3046512.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-2011011301/62365110.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-2011011301/6236516.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/12965110.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/1296517.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/1316512.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/3046512.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/3056516.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/4066519.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/5036513.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/5056512.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/6166512.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/62365110.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-Chameleon/6236516.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/12965110.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/1296517.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/1316512.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/3046512.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/3056515.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/3056516.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/4066514.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/4066519.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/42ONE Inverted ROM v12.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/5036513.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/5056512.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/6166512.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/62365110.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/6236516.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/6236517.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/Ava-OneV1//ALPHA1.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/Bad Boyz Sprint ONE M7 Lollipop v20.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/Bad Boyz Sprint ONE M7 Lollipop v30.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/Bad Boyz Sprint ONE Sense 6 v10.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/benny\'s 43.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/BSC Tranquil One RLS42.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/InsertCoin 711.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/RageOne CDMA v100.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/RageOne v151.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/Stock 12965110 Odex by -viperboy-.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/Stock w Goodies One 115.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/Stock w Goodies One 201.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/Stock.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/TrickDroid 551.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/ViperOne 350.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/ViperOne 701.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTCPN702-SPRINT/viperROM One v102.rdf': [
    'HTC',
    'One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/PN071/ua-SPRINT/ViperOne 800.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/PN071/ua-SPRINT/ViperOne 900.rdf': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://mms.cellcom.com/uaprofs/htc_M7_8M.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_802d_1_20130301.XML': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_One_1_20130301.XML': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://pix.cspire.com/UA/profile/htc/PN072/PN072.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/HTC_802d.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/htc/htc6500lvw/htc6500lvw.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ACG/PN072/ua-profile_1M.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/AMX/PN0711/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/BM/801a/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/CBW/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/82ZtOKlRiO/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PN0711/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PN072/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PN07310/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PN077U/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PN078T/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PN078U/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PN078W/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/LRA/PN07310/ua-profile_500K.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Nextel/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/O2/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Orange/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Rogers/801a/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telcel/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telstra/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telus/801a/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TIM/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMOUS/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TNZ/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Vodafone/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/WIND/PN071/ua-profile.xml': ['HTC', 'One', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/2PQ93-SPRINT/1106511.rdf': ['HTC', 'One (A9)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/2PQ93-SPRINT/1576511.rdf': ['HTC', 'One (A9)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/2PQ93-SPRINT/1606514.rdf': ['HTC', 'One (A9)', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/fJ1ZSlse0F/ua-profile.xml': [
    'HTC',
    'One (A9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/rjXLBq21RC/ua-profile.xml': [
    'HTC',
    'One (A9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/0PAJ5-Chameleon/1116512.rdf': ['HTC', 'One (E8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PAJ5-Chameleon/1226511.rdf': ['HTC', 'One (E8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PAJ5-Chameleon/23265111.rdf': ['HTC', 'One (E8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PAJ5-MVNO/2326517.rdf': ['HTC', 'One (E8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PAJ5-SPRINT/1076511.rdf': ['HTC', 'One (E8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PAJ5-SPRINT/1226511.rdf': ['HTC', 'One (E8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PAJ5-SPRINT/23265111.rdf': ['HTC', 'One (E8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PAJ5-SPRINT/2326517.rdf': ['HTC', 'One (E8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PAJ5-SPRINT/3106516.rdf': ['HTC', 'One (E8)', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/3vpxk6Z5ZS/ua-profile.xml': [
    'HTC',
    'One (E8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/q5lv3bcp7D/ua-profile.xml': [
    'HTC',
    'One (E8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/Uriwn0DyqH/ua-profile.xml': [
    'HTC',
    'One (E8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/zlxtuCDKgt/ua-profile.xml': [
    'HTC',
    'One (E8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/CMCC/mifaCnXW7o/ua-profile.xml': [
    'HTC',
    'One (E9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/mifaCnXW7o/ua-profile.xml': [
    'HTC',
    'One (E9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/mK8zhMmjOr/ua-profile.xml': [
    'HTC',
    'One (E9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/CMCC/cIIxkEojnw/ua-profile.xml': [
    'HTC',
    'One (M8 Eye)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/cIIxkEojnw/ua-profile.xml': [
    'HTC',
    'One (M8 Eye)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/RIGWqFpTj2/ua-profile.xml': [
    'HTC',
    'One (M8 Eye)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/11265117.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/15465110.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/1546518.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/2166514.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/3306512.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/42065110.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/4209065110.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/42565114.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/42565118.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-Chameleon/6206513.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-MVNO/2166514.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-MVNO/42065110.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-MVNO/42565114.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/15465110.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/1546518.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/2166514.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/3306512.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/3316512.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/42065110.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/42565114.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/42565118.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/42565418.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/6206513.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/6206543.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/Bad Boyz Sprint ONE M8 Harman v21 ART.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/Bad Boyz Sprint ONE M8 L Sense 7 v10.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/Bad Boyz Sprint ONE M8 Lollipop v30.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/Bad Boyz Sprint ONE M8 Lollipop v32.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/InsertCoin 716.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/InsertCoin 719.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/831C-SPRINT/ViperOneM8 430.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/831CH-Chameleon/15465413.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831CH-Chameleon/42065410.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831CH-Chameleon/42565414.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/831CH-Chameleon/6206543.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/1546518.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/15465413.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/15465415.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/1546549.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/2166544.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/3306512.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/3306542.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/3316542.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/42065410.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/42565114.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/42565414.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/42565418.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/6206513.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/6206543.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/Bad Boyz Sprint ONE M8 L Sense 7 v10.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/AP831CHK/Bad Boyz Sprint ONE M8 Lollipop v30.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/AP831CHK/Bad Boyz Sprint ONE M8 Lollipop v32 HK.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/AP831CHK/SkyDragon M8 v 100 Sprint Sense 7.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/AP831CHK/SkyDragon M8 v 80 Sprint Sense 7.rdf': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/AP831CHK/ViperOneM8 430.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/AP831CHK/ViperOneM8 502.rdf': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://mms.cellcom.com/uaprofs/htc_M8_8M.xml': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/htc/htc6525lvw/htc6525lvw.xml': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/AMX/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/ATT/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/BM/fL0fd1AcEY/ua-profile.xml': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/0YC9TSsPzu/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/3EdRGieOMj/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/3f2Kak1ivc/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/5iCu8aRdPo/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/ABUe39rODk/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/JLnzRx2IlE/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/MaGxKOfxPJ/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/LRA/82ZtOKlRiO/ua-profile_500K.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/O2/fL0fd1AcEY/ua-profile.xml': ['HTC', 'One (M8)', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Orange/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Rogers/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/SFR/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telcel/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telstra/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telus/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TIM/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMOUS/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TNZ/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Vodafone/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/WIND/fL0fd1AcEY/ua-profile.xml': [
    'HTC',
    'One (M8)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PPzlrbleWf/ua-profile.xml': [
    'HTC',
    'One (M8s)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/PPzlrbleWf/ua-profile.xml': [
    'HTC',
    'One (M8s)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Vodafone/PPzlrbleWf/ua-profile.xml': [
    'HTC',
    'One (M8s)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/RBuZib3xtL/ua-profile.xml': [
    'HTC',
    'One (M9 Plus)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/0PJA2-Chameleon/3416514.rdf': ['HTC', 'One (M9)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PJA2-SPRINT/13265130.rdf': ['HTC', 'One (M9)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PJA2-SPRINT/21165119.rdf': ['HTC', 'One (M9)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PJA2-SPRINT/2665111.rdf': ['HTC', 'One (M9)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PJA2-SPRINT/3416514.rdf': ['HTC', 'One (M9)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/0PJA2-SPRINT/Bad Boyz Sprint ONE M9 v20.rdf': [
    'HTC',
    'One (M9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/ATT/xbKGNh1DoH/ua-profile.xml': [
    'HTC',
    'One (M9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/CMCC/c8HDMjoq7Q/ua-profile.xml': [
    'HTC',
    'One (M9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/15Y7tWDPNn/ua-profile.xml': [
    'HTC',
    'One (M9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/uej4ao2E9J/ua-profile.xml': [
    'HTC',
    'One (M9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/WDfCkeuHE6/ua-profile.xml': [
    'HTC',
    'One (M9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/WOCIeZasGc/ua-profile.xml': [
    'HTC',
    'One (M9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/xbKGNh1DoH/ua-profile.xml': [
    'HTC',
    'One (M9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/bDZc52YZeG/ua-profile.xml': [
    'HTC',
    'One (X9)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTC0P3P7-Chameleon/%CDMA_ROM_VERSION%.rdf': [
    'HTC',
    'One Max',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/HTC0P3P7-Chameleon/0576512.rdf': ['HTC', 'One Max', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC0P3P7-Chameleon/3036513.rdf': ['HTC', 'One Max', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC0P3P7-SPRINT/1166514.rdf': ['HTC', 'One Max', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC0P3P7-SPRINT/2096511.rdf': ['HTC', 'One Max', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC0P3P7-SPRINT/3026515.rdf': ['HTC', 'One Max', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/HTC0P3P7-SPRINT/SkyDragon Max v 20 Sprint.rdf': [
    'HTC',
    'One Max',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/0O5MHN0Mig/ua-profile.xml': [
    'HTC',
    'One Max',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/arYPBWMPCx/ua-profile.xml': [
    'HTC',
    'One Max',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/LDdI1qcVhL/ua-profile.xml': [
    'HTC',
    'One Max',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/V79ccMv3KO/ua-profile.xml': [
    'HTC',
    'One Max',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/w778dYholc/ua-profile.xml': [
    'HTC',
    'One Max',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/O2/w778dYholc/ua-profile.xml': ['HTC', 'One Max', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/w778dYholc/ua-profile.xml': ['HTC', 'One Max', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Vodafone/w778dYholc/ua-profile.xml': [
    'HTC',
    'One Max',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/CMCC/15Y7tWDPNn/ua-profile.xml': ['HTC', 'One ME', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/PO582/ua-profile.xml': ['HTC', 'One Mini', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PO581/ua-profile.xml': ['HTC', 'One Mini', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PO582/ua-profile.xml': ['HTC', 'One Mini', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/O2/PO582/ua-profile.xml': ['HTC', 'One Mini', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Orange/PO582/ua-profile.xml': ['HTC', 'One Mini', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Rogers/PO582/ua-profile.xml': ['HTC', 'One Mini', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telstra/PO582//ua-profile.xml': [
    'HTC',
    'One Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TIM/PO582/ua-profile.xml': ['HTC', 'One Mini', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/PO582/ua-profile.xml': ['HTC', 'One mini', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/UlrIAz8JY9/ua-profile.xml': [
    'HTC',
    'One Mini 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telstra/UlrIAz8JY9/ua-profile.xml': [
    'HTC',
    'One Mini 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/UlrIAz8JY9/ua-profile.xml': [
    'HTC',
    'One Mini 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Vodafone/UlrIAz8JY9/ua-profile.xml': [
    'HTC',
    'One Mini 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Bell/Z520m/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bouygues/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Canada/Z520m/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/CBW/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PJ402/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/TX408/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Mobilicity/Z520m/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Nextel/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/O2/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Orange/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Rogers/Z520m/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telcel/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telstra/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telus/Z520m/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TIM/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMOUS/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Videotron/Z520m/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Vodafone/PJ401/ua-profile.xml': ['HTC', 'One S', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_T528d_1_20120801.XML': ['HTC', 'One SC', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/HTC_One_SC_T528d.xml': ['HTC', 'One SC', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM6010/ua-profile.xml': ['HTC', 'One SC', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM6011/ua-profile.xml': ['HTC', 'One ST', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM6012/ua-profile.xml': ['HTC', 'One SU', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/C525c-BOOST/1116531.rdf': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/C525c-BOOST/2066535.rdf': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/C525c-BOOST/2066536.rdf': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/C525c-BOOST/3056533.rdf': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/C525c-BOOST/3056534.rdf': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://mms.mycricket.com/htc_h3000c.xml': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bouygues/PL801/ua-profile.xml': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PL801/ua-profile.xml': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PL8011/ua-profile.xml': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Orange/PL801/ua-profile.xml': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TIM/PL8011/ua-profile.xml': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/PL801/ua-profile.xml': ['HTC', 'One SV', 'Android', DeviceType.MOBILE],
  'http://mms.mycricket.com/htc_h2000c.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/HTC/T120C-VMUB/1.0/UAProf.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bell/T320a/ua-profile.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PJ835/ua-profile.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PK76/ua-profile.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PK7631/ua-profile.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telcel/PK76/ua-profile.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telstra/PJ831/ua-profile.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telus/T320a/ua-profile.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/PK76/ua-profile.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TNZ/PK76/ua-profile.xml': ['HTC', 'One V', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/PM361/ua-profile.xml': ['HTC', 'One VX', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/PJ831/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PJ461/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PJ831/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM3511/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/O2/PJ461/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/O2/PJ831/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/O2/PM3511/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Orange/PJ461/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Rogers/X325a/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telcel/PJ461/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telus/X325a/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/PJ461/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/PJ831/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TNZ/PJ461/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Vodafone/PJ461/ua-profile.xml': ['HTC', 'One X', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/PM631/ua-profile.xml': ['HTC', 'One X+', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PM631/ua-profile.xml': ['HTC', 'One X+', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telus/X525a/ua-profile.xml': ['HTC', 'One X+', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_X720d_1_20120401.XML': ['HTC', 'One XC', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Vodafone/PJ831/ua-profile.xml': ['HTC', 'One XL', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PJ462/ua-profile.xml': ['HTC', 'One XT', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Oxygen-1.0.xml': ['HTC', 'Oxygen', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/CedarW-1.0.xml': ['HTC', 'Ozone', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/wave-1.0.xml': ['HTC', 'P3000', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/artemis-1.0.xml': ['HTC', 'P3300', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/elf-1.0.xml': ['HTC', 'P3450', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Trinity-1.0.xml': ['HTC', 'P3600', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Herald-1.0.xml': ['HTC', 'P4350', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/sedna-1.0.xml': ['HTC', 'P6500', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Panda-1.0.xml': ['HTC', 'Panda', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Pharos-1.0.xml': ['HTC', 'Pharos', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Prophet-2.0.xml': ['HTC', 'Prophet', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/pu10-2.0.xml': ['HTC', 'PU10', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bell/Holiday/ua-profile.xml': ['HTC', 'Raider', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Rogers/Holiday/ua-profile.xml': ['HTC', 'Raider', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PH39/ua-profile.xml': ['HTC', 'Raider 4G', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/adr6425/adr6425.xml': ['HTC', 'Rezound', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/adr6330/adr6330.xml': ['HTC', 'Rhyme', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PI4610/ua-profile.xml': ['HTC', 'Rhyme', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PD421/ua-profile.xml': ['HTC', 'S610d', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Cavalier-1.0.xml': ['HTC', 'S630', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Vox-1.0.xml': ['HTC', 'S710', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Volans-1.0.xml': ['HTC', 'S730', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_S740-1.0.xml': ['HTC', 'S740', null, DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PH11/ua-profile.xml': ['HTC', 'Salsa', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bell/Pyramid/ua-profile.xml': ['HTC', 'Sensation', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/HTC_Sensation_4G/ua-profile.xml': [
    'HTC',
    'Sensation',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PG58/ua-profile.xml': ['HTC', 'Sensation', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PG5814/ua-profile.xml': [
    'HTC',
    'Sensation',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Orange/PG58/ua-profile.xml': ['HTC', 'Sensation', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Telstra/Z710a/ua-profile.xml': [
    'HTC',
    'Sensation',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/Pyramid/ua-profile.xml': ['HTC', 'Sensation', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PG5813/ua-profile.xml': [
    'HTC',
    'Sensation XE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/SensationXE/ua-profile.xml': [
    'HTC',
    'Sensation XE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PI39/ua-profile.xml': [
    'HTC',
    'Sensation XL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/KT/HTC-X315E/ua-profile.xml': [
    'HTC',
    'Sensation XL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/Runnymede/ua-profile.xml': [
    'HTC',
    'Sensation XL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/tme/HTC_Snap_S521-1.0.xml': ['HTC', 'Snap', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/st20-1.0.xml': ['HTC', 'ST20', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/ATT/PH06130/ua-profile.xml': ['HTC', 'Status', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PK793/ua-profile.xml': ['HTC', 'T327t', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_T329d_1_20120901.XML': ['HTC', 'T329d', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_T9199_2_20100902.xml': ['HTC', 'T9199', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/HTC_TATTOO_A3288/ua-profile.xml': [
    'HTC',
    'Tattoo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/Tattoo/ua-profile.xml': ['HTC', 'Tattoo', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/UTSTARCOM/PG051/ua-profile.xml': [
    'HTC',
    'ThunderBolt',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/pcd/adr6325/adr6325.xml': ['HTC', 'Thunderbolt 4G', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Titan-1.0.xml': ['HTC', 'Titan', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/tornado-2.0.xml': ['HTC', 'Tornado', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/brightstar/ELFIN-1.0.xml': ['HTC', 'Touch', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Elfin_Opera-1.0.xml': ['HTC', 'Touch', 'Windows', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_Touch_Viva_T2223-1.0.xml': ['HTC', 'Touch', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_Touch2_T3333-1.0.xml': ['HTC', 'Touch 2', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/mega-1.0.xml': ['HTC', 'Touch 2', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_Touch_3G_T3232-1.0.xml': [
    'HTC',
    'Touch 3G',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/voda/Jade-1.0.xml': ['HTC', 'Touch 3G', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Polaris-1.0.xml': ['HTC', 'Touch Cruise', 'Windows Mobile', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/MP6950SP/1096515.rdf': [
    'HTC',
    'Touch Diamond',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/diamond-1.0.xml': ['HTC', 'Touch Diamond', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/victor-1.0.xml': ['HTC', 'Touch Diamond', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/VictorC-1.0.xml': ['HTC', 'Touch Diamond', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/VictorCT-1.0.xml': ['HTC', 'Touch Diamond', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/voda/diamond-1.0.xml': ['HTC', 'Touch Diamond', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_Touch_Diamond2_T5353-1.0.xml': [
    'HTC',
    'Touch Diamond 2',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/HTC_Touch_Diamond2_T5360-1.0.xml': [
    'HTC',
    'Touch Diamond 2',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/neon-1.0.xml': ['HTC', 'Touch Dual', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/NeonC_BM-1.0.xml': ['HTC', 'Touch Dual', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/nike-1.0.xml': ['HTC', 'Touch Dual', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_Touch_HD_T8282-1.0.xml': [
    'HTC',
    'Touch HD',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/voda/HTC_Touch_HD_T8282-1.0.xml': [
    'HTC',
    'Touch HD',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/PPC6850SP/1036513.rdf': ['HTC', 'Touch Pro', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HermannC_BM-1.0.xml': ['HTC', 'Touch Pro', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/HTC_Touch_Pro_T7272-1.0.xml': [
    'HTC',
    'Touch Pro',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/Raphael-1.0.xml': ['HTC', 'Touch Pro', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/swisscom/HTC_Touch_Pro-1.0.xml': ['HTC', 'Touch Pro', 'Windows Mobile'],
  'http://www.htcmms.com.tw/voda/HTC_Touch_Pro-1.0.xml': ['HTC', 'Touch Pro', 'Windows Mobile', DeviceType.MOBILE],
  'http://device.sprintpcs.com/HTC/PPCT7380SP/1216514.rdf': [
    'HTC',
    'Touch Pro 2',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HTC/PPCT7380SP/2046514.rdf': [
    'HTC',
    'Touch Pro 2',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/HTC_Touch_Pro2_T7373-1.0.xml': [
    'HTC',
    'Touch Pro 2',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/RhodiumW-1.0.xml': ['HTC', 'Touch Pro 2', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Hermes-1.0.xml': ['HTC', 'TyTN', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Hermes-2.0.xml': ['HTC', 'TyTN', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/kaiser-1.0.xml': ['HTC', 'TyTN II', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/LaQXqvY3I3/ua-profile.xml': [
    'HTC',
    'U Ultra',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/rlIC3c716z/ua-profile.xml': ['HTC', 'U11', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/KMKeMMeWHK/ua-profile.xml': [
    'HTC',
    'U11 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/Wildfire/ua-profile.xml': [
    'HTC',
    'Wildfire',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telstra/A3335/ua-profile.xml': ['HTC', 'Wildfire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TME/Wildfire/ua-profile.xml': ['HTC', 'Wildfire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/Buzz/ua-profile.xml': ['HTC', 'Wildfire', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Alltel/Bee/ua-profile.xml': [
    'HTC',
    'Wildfire 6225',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://mmsc1.uscc.net/mmsc/MMS': ['HTC', 'Wildfire S', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_A510c_1_20110425.XML': ['HTC', 'Wildfire S', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/HTC-PG762.xml': ['HTC', 'Wildfire S', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/HTC/A510c-VMUB/1.0/UAProf.xml': ['HTC', 'Wildfire S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Bell/Marvel/ua-profile.xml': ['HTC', 'Wildfire S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/PG76/ua-profile.xml': ['HTC', 'Wildfire S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/WildfireS/ua-profile.xml': [
    'HTC',
    'Wildfire S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Telstra/A510b/ua-profile.xml': [
    'HTC',
    'Wildfire S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/TMO/Marvel/ua-profile.xml': ['HTC', 'Wildfire S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/TME/WildfireS/ua-profile.xml': ['HTC', 'Wildfire S', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/Wizard-2.0.xml': ['HTC', 'Wizard', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/X1i-1.0.xml': ['HTC', 'X1i', 'Windows Mobile', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HTC/HTC_Z510d_1_20110831.XML': ['HTC', 'Z510d', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_A199_1_20130121.xml': ['Huawei', 'A199', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/Huawei-M920.xml': ['Huawei', 'Activa 4G', 'Android', DeviceType.MOBILE],
  'http://mms.mycricket.com/Huawei-M860.xml': ['Huawei', 'Ascend', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Huawei_M860_Normal.xml': ['Huawei', 'Ascend', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiC8812CDMA-NORMAL.xml': [
    'Huawei',
    'Ascend C8812',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiC8812CDMA2000-NORMAL.xml': [
    'Huawei',
    'Ascend C8812',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiC8812WCDMA-NORMAL.xml': [
    'Huawei',
    'Ascend C8812',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8812E_1_20120713.xml': [
    'Huawei',
    'Ascend C8812',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8812E_1_20121018.xml': [
    'Huawei',
    'Ascend C8812',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8812_1_20120228.xml': [
    'Huawei',
    'Ascend C8812',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8813D_1_20121018.xml': [
    'Huawei',
    'Ascend C8813',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8813Q_1_20130108.xml': [
    'Huawei',
    'Ascend C8813',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8813Q_1_20130425.xml': [
    'Huawei',
    'Ascend C8813',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8813_1_20121018.xml': [
    'Huawei',
    'Ascend C8813',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8813Q_1_20121018.xml': [
    'Huawei',
    'Ascend C8815',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8816D_1_20131107.xml': [
    'Huawei',
    'Ascend C8816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8816_1_20131106.xml': [
    'Huawei',
    'Ascend C8816',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9501L_UAProfile.xml': [
    'Huawei',
    'Ascend D LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9510E_UAProfile.xml': [
    'Huawei',
    'Ascend D quad',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9510_UAProfile.xml': [
    'Huawei',
    'Ascend D quad',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9500_UAProfile.xml': ['Huawei', 'Ascend D1', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_T9510E_UAProfile.xml': [
    'Huawei',
    'Ascend D1 Quad XL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9500E_UAProfile.xml': [
    'Huawei',
    'Ascend D1 XL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_D2-0082_Global_UAProfile.XML': [
    'Huawei',
    'Ascend D2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_D2_6114_UAProfile.xml': [
    'Huawei',
    'Ascend D2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_D2-0082_1_20121221_UAProfile.XML': [
    'Huawei',
    'Ascend D2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_D2-2010_1_20121026_UAProfile.XML': [
    'Huawei',
    'Ascend D2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_D2-2010_2_20130106_UAProfile.XML': [
    'Huawei',
    'Ascend D2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_D2-5000_2_20121218_UAProfile.XML': [
    'Huawei',
    'Ascend D2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8815GPRS-NORMAL-ICS.xml': [
    'Huawei',
    'Ascend G300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8815GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend G300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8815NWCDMA-NORMAL.xml': [
    'Huawei',
    'Ascend G300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8815WCDMA-NORMAL.xml': [
    'Huawei',
    'Ascend G300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8818GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend G300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8818WCDMA-NORMAL.xml': [
    'Huawei',
    'Ascend G300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_c8800_2_20111116.xml': [
    'Huawei',
    'Ascend G300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8810_2_20111116.xml': [
    'Huawei',
    'Ascend G300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8816WCDMA-NORMAL.xml': [
    'Huawei',
    'Ascend G301',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprofile.huawei.com/uaprof/HUAWEI_T8828-1.0.xml': [
    'Huawei',
    'Ascend G305T',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_T8830_UAProfile.xml': [
    'Huawei',
    'Ascend G309T',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_T8830Pro_UAProfile.xml': [
    'Huawei',
    'Ascend G309T Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8681GPRS-VTR.xml': ['Huawei', 'Ascend G312', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8681GPRS-WIND.xml': ['Huawei', 'Ascend G312', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG330-0100GPRS.xml': ['Huawei', 'Ascend G330', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8825-1GPRS.xml': ['Huawei', 'Ascend G330', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8825DGPRS-Unicom.xml': [
    'Huawei',
    'Ascend G330',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8825D_1_20120530.xml': [
    'Huawei',
    'Ascend G330C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_U8825D_1_20121018.xml': [
    'Huawei',
    'Ascend G330D',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8836Dv100CHNC00WCDMA.xml': [
    'Huawei',
    'Ascend G500',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8826D_1_20120926.xml': [
    'Huawei',
    'Ascend G500C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0010GPRS-Normal.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0010GPRS-Russia.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0010GPRS-UNICOM.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0010GPRS.xml': ['Huawei', 'Ascend G510', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0100GPRS-FL.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0100GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0100GPRS-Vodafone.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0100GPRS.xml': ['Huawei', 'Ascend G510', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0100WCDMA-FL.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0200GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0200GPRS-Yoigo.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0200GPRS.xml': ['Huawei', 'Ascend G510', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0251GPRS-DRM.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0251GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_T8951_UAProfile.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_U8951_1_20121018.xml': [
    'Huawei',
    'Ascend G510',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG520-0000GPRS-UNICOM.xml': [
    'Huawei',
    'Ascend G520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G520-5000_UAProfile.xml': [
    'Huawei',
    'Ascend G520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G520-T10_UAProfile.xml': [
    'Huawei',
    'Ascend G520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G520-U00_1_20121018.xml': [
    'Huawei',
    'Ascend G520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG525-U00GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend G525',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG525-U00GPRS-UNICOM.xml': [
    'Huawei',
    'Ascend G525',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG525-U00GPRS.xml': ['Huawei', 'Ascend G525', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G525-UOO_1_20130425.xml': [
    'Huawei',
    'Ascend G525',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HUAWEI/PLTFH882KT/H882LV100R001C378B145.rdf': [
    'Huawei',
    'Ascend G526',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG526-L11LTE-Normal.xml': [
    'Huawei',
    'Ascend G526',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG526-L22LTE-Normal.xml': [
    'Huawei',
    'Ascend G526',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG526-L33LTE-Normal.xml': [
    'Huawei',
    'Ascend G526',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG527-U081-Normal.xml': [
    'Huawei',
    'Ascend G527',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG535.xml': ['Huawei', 'Ascend G535', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG6L11-3G.xml': ['Huawei', 'Ascend G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG6L11_KK_EU.xml': ['Huawei', 'Ascend G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG6L22.xml': ['Huawei', 'Ascend G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG6L33.xml': ['Huawei', 'Ascend G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6-T00_EMUI3_UAProfile.xml': [
    'Huawei',
    'Ascend G6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6-T00_UAProfile.xml': ['Huawei', 'Ascend G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6-U10_KK_UAProfile.xml': [
    'Huawei',
    'Ascend G6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6-U10_UAProfile-DRM.xml': [
    'Huawei',
    'Ascend G6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6-U10_UAProfile.xml': ['Huawei', 'Ascend G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6-U251_UAProfile.xml': [
    'Huawei',
    'Ascend G6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6_C00_KK.xml': ['Huawei', 'Ascend G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6_U00.xml': ['Huawei', 'Ascend G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6_U00_KK.xml': ['Huawei', 'Ascend G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8950-1GPRS-Normal.xml': [
    'Huawei',
    'Ascend G600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8950-51GPRS-Normal.xml': [
    'Huawei',
    'Ascend G600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8950DGPRS-UNICOM.xml': [
    'Huawei',
    'Ascend G600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8950N-1GPRS-Normal.xml': [
    'Huawei',
    'Ascend G600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8950N-51GPRS-Normal.xml': [
    'Huawei',
    'Ascend G600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8950N-51WCDMA-Normal.xml': [
    'Huawei',
    'Ascend G600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_T8950_UAProfile.xml': [
    'Huawei',
    'Ascend G600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G610-T00_UAProfile.xml': [
    'Huawei',
    'Ascend G610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G610-T11_UAProfile.xml': [
    'Huawei',
    'Ascend G610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G610-U00_UAProfile.xml': [
    'Huawei',
    'Ascend G610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G610-U15_UAProfile.xml': [
    'Huawei',
    'Ascend G610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G610-U20_UAProfile.xml': [
    'Huawei',
    'Ascend G610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G610-U30_UAProfile.xml': [
    'Huawei',
    'Ascend G610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G610-C00_1_20130108.xml': [
    'Huawei',
    'Ascend G610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G615_U10.xml': ['Huawei', 'Ascend G615', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G616-T00_UAProfile.xml': [
    'Huawei',
    'Ascend G616',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620-A2.xml': ['Huawei', 'Ascend G620', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620-A2_CC.xml': ['Huawei', 'Ascend G620', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620-L72.xml': ['Huawei', 'Ascend G620', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620-L75.xml': ['Huawei', 'Ascend G620', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620S-L03.xml': ['Huawei', 'Ascend G620', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620_1_20130917.xml': [
    'Huawei',
    'Ascend G620',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620S-L01.xml': ['Huawei', 'Ascend G620S', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620S-L02.xml': ['Huawei', 'Ascend G620S', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620S-L03_PERU.xml': [
    'Huawei',
    'Ascend G620S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/G621-TL00.xml': ['Huawei', 'Ascend G621', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G621-TL00.xml': ['Huawei', 'Ascend G621', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/G628-TL00_LTE_UAProfile.xml': [
    'Huawei',
    'Ascend G628',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/G629_LTE_UAProfile.xml': ['Huawei', 'Ascend G629', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG630-U20-DRM.xml': ['Huawei', 'Ascend G630', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG630-U20-Normal-WCDMA.xml': [
    'Huawei',
    'Ascend G630',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG630-U20-Normal.xml': ['Huawei', 'Ascend G630', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG630-U251-Normal.xml': [
    'Huawei',
    'Ascend G630',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G630_U00.xml': ['Huawei', 'Ascend G630', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G630_U10.xml': ['Huawei', 'Ascend G630', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHC-U03_NLA_UAProfile.xml': [
    'Huawei',
    'Ascend G650',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHC-U03_UAProfile.xml': [
    'Huawei',
    'Ascend G650',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G660-L075.xml': ['Huawei', 'Ascend G660', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_%s_lollipop_UAProfile.xml': [
    'Huawei',
    'Ascend G7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_%s_UAProfile.xml': ['Huawei', 'Ascend G7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G7-L01_OrangeUAProfile.xml': [
    'Huawei',
    'Ascend G7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G7-L01_UAProfile.xml': ['Huawei', 'Ascend G7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G7-L02_UAProfile.xml': ['Huawei', 'Ascend G7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G7-L03_DRMFL_UAProfile.xml': [
    'Huawei',
    'Ascend G7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G7-L03_UAProfile.xml': ['Huawei', 'Ascend G7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G7-L11_UAProfile.xml': ['Huawei', 'Ascend G7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G7-TL00_UAProfile.xml': [
    'Huawei',
    'Ascend G7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G7-UL20_UAProfile.xml': [
    'Huawei',
    'Ascend G7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Rock-L01_UAProfile.xml': [
    'Huawei',
    'Ascend G7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Rock-L01_UAProfile_DRM.xml': [
    'Huawei',
    'Ascend G7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Rock-L03_UAProfile.xml': [
    'Huawei',
    'Ascend G7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G760-L01-TME.xml': ['Huawei', 'Ascend G7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_Rock-L01_DT_UAProfile.xml': [
    'Huawei',
    'Ascend G7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G700-T00_UAProfile.xml': [
    'Huawei',
    'Ascend G700',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G700-U00_UAProfile.xml': [
    'Huawei',
    'Ascend G700',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G700-U10_UAProfile.xml': [
    'Huawei',
    'Ascend G700',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G700-U20_UAProfile.xml': [
    'Huawei',
    'Ascend G700',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.oppo.com/resource/UA-PROF/OPPOHuawei G700-U00.xml': [
    'Huawei',
    'Ascend G700',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG716-L070LTE.xml': ['Huawei', 'Ascend G716', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G718_1_20130805.xml': [
    'Huawei',
    'Ascend G718',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G730-T00_UAProfile.xml': [
    'Huawei',
    'Ascend G730',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G730-U00_UAProfile.xml': [
    'Huawei',
    'Ascend G730',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G730-U10_UAProfile.xml': [
    'Huawei',
    'Ascend G730',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G730-U251_UAProfile.xml': [
    'Huawei',
    'Ascend G730',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G730-U27_UAProfile.xml': [
    'Huawei',
    'Ascend G730',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G730-U30_UAProfile.xml': [
    'Huawei',
    'Ascend G730',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G730-C00_20130826.xml': [
    'Huawei',
    'Ascend G730',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G730-C10_1_20130828.xml': [
    'Huawei',
    'Ascend G730',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G730-L075.xml': ['Huawei', 'Ascend G730', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G735-L03_UAProfile.xml': [
    'Huawei',
    'Ascend G735',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G735-L03__NLA_UAProfile.xml': [
    'Huawei',
    'Ascend G735',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G735-L23_UAProfile.xml': [
    'Huawei',
    'Ascend G735',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG740-L00LTE-DRM.xml': ['Huawei', 'Ascend G740', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG740-L00LTE-Normal.xml': [
    'Huawei',
    'Ascend G740',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G750-T01_UAProfile.xml': [
    'Huawei',
    'Ascend G750',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G750-T20_UAProfile.xml': [
    'Huawei',
    'Ascend G750',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G750-U10_UAProfile.xml': [
    'Huawei',
    'Ascend G750',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_G760-TL00_UAProfile.xml': [
    'Huawei',
    'Ascend G760',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G620S-UL00.xml': ['Huawei', 'Ascend G760', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G760-L01.xml': ['Huawei', 'Ascend G760', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G760-L01_Europe_DRM-UAProfile.xml': [
    'Huawei',
    'Ascend G760',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_G760-L071.xml': ['Huawei', 'Ascend G760', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-AL00_UAProfile.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-CL00_UAProfile.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/Huawei_RIO-L01_DT_UAProfile.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L01_UAProfile.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L01_UAProfile_DRM.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L01_UAProfile_DRM_FL.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L01_UAProfile_Orange_DRM.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L02_UAProfile.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L02_UAProfile_DRM.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L03_UAProfile.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L03_UAProfile_DRM.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L03_UAProfile_DRMALL.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-L03_UAProfile_DRMALL_1MB.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-TL00_UAProfile.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIO-UL00_UAProfile.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_RIOL03_UAProfile.xml': ['Huawei', 'Ascend G8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_Rock-CL00_UAProfile.xml': [
    'Huawei',
    'Ascend G8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/SC-UL10_LTE_UAProfile.xml': ['Huawei', 'Ascend GX1', 'Android', DeviceType.MOBILE],
  'http://mms.mycricket.com/Huawei-M865.xml': ['Huawei', 'Ascend II', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/Huawei/ADR3310/ADR3310v1.xml': ['Huawei', 'Ascend II', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/OEM/ADR3305/ADR3305v1.xml': ['Huawei', 'Ascend II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Huawei-M865C.xml': ['Huawei', 'Ascend II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_MATE_T00_UAProfile.xml': [
    'Huawei',
    'Ascend Mate',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_MATE_UAProfile.XML': ['Huawei', 'Ascend Mate', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_MATE_Wind_UAProfile.XML': [
    'Huawei',
    'Ascend Mate',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/Huawei_MT2-L02_UAProfile.xml': [
    'Huawei',
    'Ascend Mate 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/Huawei_MT2-L05_UAProfile.xml': [
    'Huawei',
    'Ascend Mate 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_MT2_L05_UAProfile.xml': [
    'Huawei',
    'Ascend Mate 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Mate2.xml': ['Huawei', 'Ascend Mate 2', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_MT2-C00_1_20130425.xml': [
    'Huawei',
    'Ascend Mate 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_MT2-C00_1_20131227.xml': [
    'Huawei',
    'Ascend Mate 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_MT7-TL00_UAProfile.xml': [
    'Huawei',
    'Ascend Mate 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_MT7-TL10_UAProfile.xml': [
    'Huawei',
    'Ascend Mate 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_MT7-UL00_UAProfile.xml': [
    'Huawei',
    'Ascend Mate 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_MT7_L09_UAProfile.xml': [
    'Huawei',
    'Ascend Mate 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Z100-TL00_UAProfile.xml': [
    'Huawei',
    'Ascend Mate 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Z100_L09_UAProfile.xml': [
    'Huawei',
    'Ascend Mate 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_MT7-CL00_2_20140903.xml': [
    'Huawei',
    'Ascend Mate 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Z100-CL00_1_20140709.xml': [
    'Huawei',
    'Ascend Mate 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_GS03_UAProfile.xml': ['Huawei', 'Ascend P1', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_T9200_UAProfile.xml': ['Huawei', 'Ascend P1', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9200_UAProfile.xml': ['Huawei', 'Ascend P1', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9201L_UAProfile.xml': ['Huawei', 'Ascend P1', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9202L-1_UAProfile.xml': [
    'Huawei',
    'Ascend P1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9202L-3_UAProfile.xml': [
    'Huawei',
    'Ascend P1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_P2_NewZealand_UAProfile.xml': [
    'Huawei',
    'Ascend P2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_P2_UAProfile.xml': ['Huawei', 'Ascend P2', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9700L_UAProfile.xml': ['Huawei', 'Ascend P2', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_P6_S_U00_UAProfile.xml': [
    'Huawei',
    'Ascend P6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_P6_T00_UAProfile.xml': ['Huawei', 'Ascend P6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_P6_U06_MTN_UAProfile.xml': [
    'Huawei',
    'Ascend P6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_P6_U06_UAProfile.xml': ['Huawei', 'Ascend P6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_P6_U06_Wind_UAProfile.xml': [
    'Huawei',
    'Ascend P6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_P6-C00_1_20130425.xml': [
    'Huawei',
    'Ascend P6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_MT2_T00_UAProfile.xml': [
    'Huawei',
    'Ascend P7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_MT2_U071_UAProfile.xml': [
    'Huawei',
    'Ascend P7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_SOPHIA_L07_UAProfile.xml': [
    'Huawei',
    'Ascend P7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_SOPHIA_L10_UAProfile.xml': [
    'Huawei',
    'Ascend P7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_SOPHIA_L10_UAProfile_3G.xml': [
    'Huawei',
    'Ascend P7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_SOPHIA_L11_UAProfile.xml': [
    'Huawei',
    'Ascend P7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_SOPHIA_L12_UAProfile.xml': [
    'Huawei',
    'Ascend P7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_P7-L09_1_20140327.xml': [
    'Huawei',
    'Ascend P7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_GRA-TL00_UAProfile.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_GRA-UL00_UAProfile.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_GRA-UL10_UAProfile.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_GRA_L09_DRM_UAProfile.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_GRA_L09_UAProfile.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_GRA_L09_VDF_UAProfile_3G.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_GRA_TL00_UAProfile.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_X100-UL00_UAProfile.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_GRA-CL00_1_20150105.xml': ['Huawei', 'Ascend P8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_GRA-CL00_1_20150317.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_GRA-CL10_1_20150317.xml': [
    'Huawei',
    'Ascend P8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_M100-CL00_1_20150120.xml': ['Huawei', 'Ascend P8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L02_NLA_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L02_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L04_5.1_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L21_DRM_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L21_FT_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L21_PL_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L21_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L23_NLA_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L23_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-TL00_6.0_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-TL00_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-UL00_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALEL04_UAProfile.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_ALE-CL00_1_20141217.xml': [
    'Huawei',
    'Ascend P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/huawei/h881c/h881c.xml': ['Huawei', 'Ascend Plus', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiM660-Cricket.xml': ['Huawei', 'Ascend Q', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU9000v100WCDMA.xml': ['Huawei', 'Ascend X', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/huawei/h866c/h866c.xml': ['Huawei', 'Ascend Y H866C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8185GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend Y100',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8185WCDMA-NORMAL.xml': [
    'Huawei',
    'Ascend Y100',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8186GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend Y101',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8186WCDMA-NORMAL.xml': [
    'Huawei',
    'Ascend Y101',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8655GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend Y200',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8655WCDMA-NORMAL.xml': [
    'Huawei',
    'Ascend Y200',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_T8620_UAProfile.xml': [
    'Huawei',
    'Ascend Y200T',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8666E-1GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend Y201',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8666E-51GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend Y201',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8666EGPRS-NORMAL-ICS.xml': [
    'Huawei',
    'Ascend Y201',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8666EGPRS-NORMAL.xml': [
    'Huawei',
    'Ascend Y201',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8666GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend Y201',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8666N-1GPRS-2Degrees.xml': [
    'Huawei',
    'Ascend Y201',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8666N-1GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend Y201',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8666WCDMA-NORMAL.xml': [
    'Huawei',
    'Ascend Y201',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8655_20120206.xml': [
    'Huawei',
    'Ascend Y201C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY210-C10CDMA-Orinoquia.xml': [
    'Huawei',
    'Ascend Y210',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y210-2010_1_20120206.xml': [
    'Huawei',
    'Ascend Y210',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y210S_1_20121105.xml': [
    'Huawei',
    'Ascend Y210',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/Y210-0010GPRS-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0010WCDMA-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0100GPRS-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0100WCDMA-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0151GPRS-DRM.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0151GPRS-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0151WCDMA-DRM.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0151WCDMA-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0151WCDMA-TELUS.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0200GPRS-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0200WCDMA-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0251GPRS-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y210-0251WCDMA-NORMAL.xml': ['Huawei', 'Ascend Y210', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY220-U00_UAProfile.xml': [
    'Huawei',
    'Ascend Y220',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY220-U05_UAProfile.xml': [
    'Huawei',
    'Ascend Y220',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY220-U10_UAProfile.xml': [
    'Huawei',
    'Ascend Y220',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY221-U03_UAProfile.xml': [
    'Huawei',
    'Ascend Y221',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY221-U12_UAProfile.xml': [
    'Huawei',
    'Ascend Y221',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY221-U22_UAProfile.xml': [
    'Huawei',
    'Ascend Y221',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY221-U53_UAProfile.xml': [
    'Huawei',
    'Ascend Y221',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/OrinoquiaAuyantepui+Y221-U03_UAProfile.xml': [
    'Huawei',
    'Ascend Y221',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0000GPRS-UNICOM.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0000GPRS.xml': ['Huawei', 'Ascend Y300', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0100GPRS-FL.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0100GPRS-MTN.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0100GPRS-NORMAL.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0100GPRS.xml': ['Huawei', 'Ascend Y300', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0100WCDMA-Yoigo.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0151GPRS-DRM.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0151GPRS-FL.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0151GPRS-Telefonica.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0151GPRS-Telstra.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0151GPRS.xml': ['Huawei', 'Ascend Y300', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0151WCDMA.xml': ['Huawei', 'Ascend Y300', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY300-0159GPRS.xml': ['Huawei', 'Ascend Y300', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_T8833_UAProfile.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y300C_1_20121018.xml': [
    'Huawei',
    'Ascend Y300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/HUAWEI/PLTFH882KT/H882LV100R001C378B170SP02.rdf': [
    'Huawei',
    'Ascend Y301',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY301-A1-Normal.xml': ['Huawei', 'Ascend Y301', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY301-A2-Normal.xml': ['Huawei', 'Ascend Y301', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Beeline_Smart-v100WCDMA.xml': [
    'Huawei',
    'Ascend Y320',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY320-U01v100WCDMA.xml': [
    'Huawei',
    'Ascend Y320',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY320-U10v100WCDMA.xml': [
    'Huawei',
    'Ascend Y320',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY320-U151v100WCDMA.xml': [
    'Huawei',
    'Ascend Y320',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY320-U30v100WCDMA.xml': [
    'Huawei',
    'Ascend Y320',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY320-U351v100WCDMA.xml': [
    'Huawei',
    'Ascend Y320',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY321-U051v100WCDMA.xml': [
    'Huawei',
    'Ascend Y321',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y330-U01_UAProfile.xml': [
    'Huawei',
    'Ascend Y330',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y330-U05_UAProfile.xml': [
    'Huawei',
    'Ascend Y330',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y330-U07_UAProfile.xml': [
    'Huawei',
    'Ascend Y330',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y330-U11_Normal_UAProfile.xml': [
    'Huawei',
    'Ascend Y330',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y330-U15_UAProfile.xml': [
    'Huawei',
    'Ascend Y330',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y330-C00_1_20140418.xml': [
    'Huawei',
    'Ascend Y330',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y336-U02_UAProfile.xml': [
    'Huawei',
    'Ascend Y336',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y336-A1.xml': ['Huawei', 'Ascend Y336', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY340-U081-Normal.xml': [
    'Huawei',
    'Ascend Y340',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/Y360-U03_UAProfile.xml': ['Huawei', 'Ascend Y360', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y360-U23_UAProfile.xml': ['Huawei', 'Ascend Y360', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y360-U31_UAProfile.xml': ['Huawei', 'Ascend Y360', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y360-U61_UAProfile.xml': ['Huawei', 'Ascend Y360', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y360-U72_UAProfile.xml': ['Huawei', 'Ascend Y360', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y360-U82_UAProfile.xml': ['Huawei', 'Ascend Y360', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y360-U93_UAProfile.xml': ['Huawei', 'Ascend Y360', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y511-U00.xml': ['Huawei', 'Ascend Y511', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y511-U10.xml': ['Huawei', 'Ascend Y511', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y511-U251.xml': ['Huawei', 'Ascend Y511', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y511-U30.xml': ['Huawei', 'Ascend Y511', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y511_TD_UAProfile.xml': ['Huawei', 'Ascend Y516', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y516_TD_UAProfile.xml': ['Huawei', 'Ascend Y516', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Y518_TD_UAProfile.xml': ['Huawei', 'Ascend Y518', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY520-U03v100WCDMA.xml': [
    'Huawei',
    'Ascend Y520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY520-U12v100WCDMA.xml': [
    'Huawei',
    'Ascend Y520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY520-U22v100WCDMA.xml': [
    'Huawei',
    'Ascend Y520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY520-U33v100WCDMA.xml': [
    'Huawei',
    'Ascend Y520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/Y523_LTE_UAProfile.xml': ['Huawei', 'Ascend Y523', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY530-U00-DT.xml': ['Huawei', 'Ascend Y530', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY530-U00-Normal.xml': ['Huawei', 'Ascend Y530', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY530-U051-Normal-DRM.xml': [
    'Huawei',
    'Ascend Y530',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY530-U051-Normal-MMS.xml': [
    'Huawei',
    'Ascend Y530',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY530-U051-Normal.xml': [
    'Huawei',
    'Ascend Y530',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY530-U051-Telecom-NZ.xml': [
    'Huawei',
    'Ascend Y530',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY530-U051-Telstra-MMS.xml': [
    'Huawei',
    'Ascend Y530',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y536-A1.xml': ['Huawei', 'Ascend Y536', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY540-U01v100WCDMA.xml': [
    'Huawei',
    'Ascend Y540',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y541-U02_UAProfile.xml': [
    'Huawei',
    'Ascend Y541',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/Y541-U02_UAProfile.xml': ['Huawei', 'Ascend Y541', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y550-L01.xml': ['Huawei', 'Ascend Y550', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y550-L01_EE.xml': ['Huawei', 'Ascend Y550', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y550-L02-VHA-AU.xml': [
    'Huawei',
    'Ascend Y550',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y550-L03.xml': ['Huawei', 'Ascend Y550', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y550-L03_PERU.xml': [
    'Huawei',
    'Ascend Y550',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y560-L01_DT_GR_UAProfile.xml': [
    'Huawei',
    'Ascend Y560',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y560-U02_UAProfile.xml': [
    'Huawei',
    'Ascend Y560',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y560_L02_Telstra_UAProfile.xml': [
    'Huawei',
    'Ascend Y560',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y560_L_UAProfile.xml': [
    'Huawei',
    'Ascend Y560',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y560_U_UAProfile.xml': [
    'Huawei',
    'Ascend Y560',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY600-U00_UAProfile.xml': [
    'Huawei',
    'Ascend Y600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY600-U151_UAProfile.xml': [
    'Huawei',
    'Ascend Y600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY600-U20_UAProfile.xml': [
    'Huawei',
    'Ascend Y600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY600-U351_UAProfile.xml': [
    'Huawei',
    'Ascend Y600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY600-U40_UAProfile.xml': [
    'Huawei',
    'Ascend Y600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiY610-U00_UAProfile.xml': [
    'Huawei',
    'Ascend Y610',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y625_U13_UAProfile.xml': [
    'Huawei',
    'Ascend Y625',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y625_U21_UAProfile.xml': [
    'Huawei',
    'Ascend Y625',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y625_U32_UAProfile.xml': [
    'Huawei',
    'Ascend Y625',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y625_U43_UAProfile.xml': [
    'Huawei',
    'Ascend Y625',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y625_U51_UAProfile.xml': [
    'Huawei',
    'Ascend Y625',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L01_UAProfile.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L01_UAProfile_EUROPE.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L01_UAProfile_TME.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L02_UAProfile.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L02_UAProfile_DRM.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L02_UAProfile_DRM_MMS.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L03_UAProfile.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L03_UAProfile_DRM.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L03_UAProfile_DRM_FL.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L03_UAProfile_MMS_FL_DRM.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L21_UAProfile.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-L21_UAProfile_EUROPE.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Y635-TL00_UAProfile.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Y635-CL00_1_20140930.xml': [
    'Huawei',
    'Ascend Y635',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_B199.xml': ['Huawei', 'B199', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_B199_1_20130806.xml': ['Huawei', 'B199', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_B199_1_20131113.xml': ['Huawei', 'B199', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8350v100GPRS.xml': ['Huawei', 'Boulder', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8350v100WCDMA.xml': ['Huawei', 'Boulder', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C199.xml': ['Huawei', 'C199', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_C199s_UAProfile.xml': ['Huawei', 'C199s', 'Android', DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiC5720CDMA1X.xml': ['Huawei', 'C5720', null, DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HW/HW_HUAWEI_C5735_1_20110406.xml': ['Huawei', 'C5735', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_C8500_1_20100127.xml': ['Huawei', 'C8500', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8500S_1_20110511.xml': ['Huawei', 'C8500', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8511_1_20110511.xml': ['Huawei', 'C8511', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8512_20110817.xml': ['Huawei', 'C8512', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8550_1_20111103.xml': ['Huawei', 'C8550', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_C8600_1_20100127.xml': ['Huawei', 'C8600', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8650PLUS_1_20111025.xml': [
    'Huawei',
    'C8650',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8650_1_20110512.xml': ['Huawei', 'C8650', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_c8650_2_20111116.xml': ['Huawei', 'C8650', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8815_1_20130425.xml': ['Huawei', 'C8815', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8817D.xml': ['Huawei', 'C8817', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8817E.xml': ['Huawei', 'C8817', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8817L.xml': ['Huawei', 'C8817', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8818_1_20141217.xml': ['Huawei', 'C8818', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiC8850v100CDMA.xml': ['Huawei', 'C8850', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8687-Normal.xml': ['Huawei', 'Chronos', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_TIT-AL00_Oversea_UAProfile.xml': [
    'Huawei',
    'Enjoy 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_TIT-AL00_UAProfile .xml': [
    'Huawei',
    'Enjoy 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_TIT-CL10_UAProfile.xml': ['Huawei', 'Enjoy 5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_TIT-L01_UAProfile .xml': ['Huawei', 'Enjoy 5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_TIT-L01_UAProfile.xml': ['Huawei', 'Enjoy 5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_TIT-TL00_UAProfile.xml': ['Huawei', 'Enjoy 5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_TIT-U02_UAProfile .xml': ['Huawei', 'Enjoy 5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/TIT-AL00C583_UAProfile.xml': ['Huawei', 'Enjoy 5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_TANGO_UAProfile.xml': ['Huawei', 'Enjoy 5S', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_NCE-AL00_UAProfile.xml': ['Huawei', 'Enjoy 6', 'Windows', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_NCE-TL10_UAProfile.xml': ['Huawei', 'Enjoy 6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_SLA-TL10_UAProfile.xml': ['Huawei', 'Enjoy 7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_TRT-TL10A_UAProfile.xml': [
    'Huawei',
    'Enjoy 7 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_TRT-TL10_UAProfile.xml': [
    'Huawei',
    'Enjoy 7 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_CM990_1_20130108.xml': [
    'Huawei',
    'Evolución 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiUM840v100GPRS.xml': ['Huawei', 'Evolution', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiUM840v100WCDMA.xml': ['Huawei', 'Evolution', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_CM980.xml': ['Huawei', 'Evolution II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8665GPRS-ATT.xml': ['Huawei', 'Fusion 2', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8665WCDMA-ATT.xml': ['Huawei', 'Fusion 2', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHC-U01_UAProfile.xml': [
    'Huawei',
    'G Play Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHC-U23_UAProfile.xml': [
    'Huawei',
    'G Play Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiG6L11.xml': ['Huawei', 'G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G6_C00.xml': ['Huawei', 'G6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/G6609UAprofileV1.1.xml': ['Huawei', 'G6609', 'MTK', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/G7300UAprofileV1.1.xml': ['Huawei', 'G7300', 'MTK', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_G750-T00_UAProfile.xml': ['Huawei', 'G750', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/G7500_UAProfile.xml': ['Huawei', 'G7500', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/huawei/h868c/h868c.xml': ['Huawei', 'Glory', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KII-L03_UAProfile.xml': ['Huawei', 'GR5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KII-L05_UAProfile_1mb.xml': ['Huawei', 'GR5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KII-L21_UAProfile.xml': ['Huawei', 'GR5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KII-L22_UAProfile.xml': ['Huawei', 'GR5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KII-L23_DRM_UAProfile.xml': ['Huawei', 'GR5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KII-L23_UAProfile.xml': ['Huawei', 'GR5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KII-L23_UAProfile_FL_Only.xml': ['Huawei', 'GR5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KII-L23_UA_DRM_FL_Profile.xml': ['Huawei', 'GR5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_H870C.xml': ['Huawei', 'H870C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8860-51GPRS-Normal.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8860-51WCDMA-Normal.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8860-92GPRS-EAccess.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8860-92WCDMA-EAccess.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8860GPRS-NORMAL-ICS.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8860GPRS-NORMAL.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8860WCDMA-NORMAL-ICS.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8860WCDMA-NORMAL.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8860E_1_20111103.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8860_1_20110704.xml': ['Huawei', 'Honor', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9508_U06_UAProfile.xml': [
    'Huawei',
    'Honor 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_U9508_UAProfile.xml': ['Huawei', 'Honor 2', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_HN3_U01_UAProfile.xml': ['Huawei', 'Honor 3', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Hol-U19_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Hol_T00_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Hol_U10_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HONOR_H30-L01M_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HONOR_H30-L01_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HONOR_H30-L02_Global_UAProfile.xml': [
    'Huawei',
    'Honor 3C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_H30-L02_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H30-T00_Global_UAProfile.xml': [
    'Huawei',
    'Honor 3C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_H30-T00_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H30-T10_Global_UAProfile.xml': [
    'Huawei',
    'Honor 3C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_H30-T10_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H30-U00_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H30-U10_Global_UAProfile.xml': [
    'Huawei',
    'Honor 3C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_H30-U10_UAProfile.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HONOR_H30-C00_20140420.xml': [
    'Huawei',
    'Honor 3C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_H30-C00_20140420.xml': [
    'Huawei',
    'Honor 3C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/Hol-T00.xml': ['Huawei', 'Honor 3C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_SCL-U31_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-AL00_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-CL00_1_20150420.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-L01_DT_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-L01_Europe_DRM-UAProfile.xml': [
    'Huawei',
    'Honor 4A',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_SCL-L01_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-L01_UAProfile_OrangeDive70.xml': [
    'Huawei',
    'Honor 4A',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_SCL-L02_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-L03_DRMFL_TIGO_UAProfile.xml': [
    'Huawei',
    'Honor 4A',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_SCL-L03_DRMFL_UAProfile.xml': [
    'Huawei',
    'Honor 4A',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_SCL-L03_UAProfile-DRM.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-L03_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-L03_UAProfile_DRM_FL_Only.xml': [
    'Huawei',
    'Honor 4A',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_SCL-L04_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-L04_UAProfile_1MB.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-L21_Europe_DRM-UAProfile.xml': [
    'Huawei',
    'Honor 4A',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_SCL-L21_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-TL00H_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-TL00_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-U23_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCL-U31_UAProfile.xml': ['Huawei', 'Honor 4A', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHM-TL00H_UAProfile.xml': [
    'Huawei',
    'Honor 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHM-U01_UAProfile.xml': ['Huawei', 'Honor 4C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHM-UL00_UAProfile.xml': [
    'Huawei',
    'Honor 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_CHM-CL00_1_20141217.xml': ['Huawei', 'Honor 4C', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/huawei/wsh892l/wsh892l.xml': ['Huawei', 'Honor 4X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HONOR_CHE-TL00H_6.0_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_CHE-TL00_6.0_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che1-CL10_6_0_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che1-CL20_6_0_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che1-L04_UAProfile.xml': ['Huawei', 'Honor 4X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-L11_Russia_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-L11_UAProfile.xml': ['Huawei', 'Honor 4X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-L12_5.1_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-L12_UAProfile.xml': ['Huawei', 'Honor 4X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-L23_UAProfile.xml': ['Huawei', 'Honor 4X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-TL00H_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-TL00M_5.1_UAProfile.xml': ['Huawei', 'Honor 4X', 'Android'],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-TL00M_6.0_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-TL00M_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-TL00_6.0_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-TL00_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-UL00_6.0_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_Che2-UL00_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHE-TL00H_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHE-TL00_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Che1-CL10_5.1_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Che1-CL20_5.1_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Che2-L23_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_Che2-UL00_UAProfile.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Che1-CL10_1_20140801.xml': [
    'Huawei',
    'Honor 4X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_Che1-CL20.xml': ['Huawei', 'Honor 4X', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOChe1-CL20.xml': ['Huawei', 'Honor 4X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_UAProfile.xml': ['Huawei', 'Honor 5C', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KIW-AL10_6.0_UAProfile.xml': [
    'Huawei',
    'Honor 5X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_KIW-AL10_UAProfile.xml': ['Huawei', 'Honor 5X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KIW-CL00_1_20150425.xml': ['Huawei', 'Honor 5X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KIW-CL00_6.0_UAProfile.xml': [
    'Huawei',
    'Honor 5X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_KIW-L21_UAProfile.xml': ['Huawei', 'Honor 5X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KIW-L21_UAProfile_DRM.xml': ['Huawei', 'Honor 5X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KIW-L22_UAProfile.xml': ['Huawei', 'Honor 5X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KIW-TL00H_6.0_UAProfile.xml': [
    'Huawei',
    'Honor 5X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_KIW-TL00H_UAProfile.xml': ['Huawei', 'Honor 5X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KIW-TL00_6.0_UAProfile.xml': [
    'Huawei',
    'Honor 5X',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_KIW-TL00_UAProfile.xml': ['Huawei', 'Honor 5X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KIW-UL00_UAProfile.xml': ['Huawei', 'Honor 5X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_KIWL24_UAProfile.xml': ['Huawei', 'Honor 5X', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H60_J1_UAProfile.xml': ['Huawei', 'Honor 6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H60_L01_UAProfile.xml': ['Huawei', 'Honor 6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H60_L02_UAProfile.xml': ['Huawei', 'Honor 6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H60_L03_UAProfile.xml': ['Huawei', 'Honor 6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H60_L04_UAProfile.xml': ['Huawei', 'Honor 6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H60_L11_UAProfile.xml': ['Huawei', 'Honor 6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_H60_L12_UAProfile.xml': ['Huawei', 'Honor 6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_E100-TL10_UAProfile.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_E100-TL20_UAProfile.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_E100-UL00_UAProfile.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_E100_TL00M_UAProfile.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_PE-TL10_UAProfile.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_PE-TL20_UAProfile.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_PE-UL00_UAProfile.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_PE_TL00M_UAProfile.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_E100-CL00_1_20141103.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_PE-CL00_1_20141225.xml': [
    'Huawei',
    'Honor 6 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_PLK-AL10-Uaprofile.xml': ['Huawei', 'Honor 7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_PLK-L01-Uaprofile.xml': ['Huawei', 'Honor 7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_PLK-L01_UAProfile.xml': ['Huawei', 'Honor 7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_PLK-TL00-Uaprofile.xml': ['Huawei', 'Honor 7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_PLK-TL01H-Uaprofile.xml': [
    'Huawei',
    'Honor 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_PLK-UL00-Uaprofile.xml': ['Huawei', 'Honor 7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_C9746_1_20150319.xml': ['Huawei', 'Honor 7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_ATH-AL00_Uaprofile.xml': [
    'Huawei',
    'Honor 7i',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ATH-CL00_Uaprofile.xml': [
    'Huawei',
    'Honor 7i',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ATH-TL00H_Uaprofile.xml': [
    'Huawei',
    'Honor 7i',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ATH-TL00_Uaprofile.xml': [
    'Huawei',
    'Honor 7i',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ATH-UL00_Uaprofile.xml': [
    'Huawei',
    'Honor 7i',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_CHM-TL00H_6.0_UAProfile.xml': [
    'Huawei',
    'Honor Play 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_CHM-TL00_5.1_UAProfile.xml': [
    'Huawei',
    'Honor Play 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_CHM-TL00_6.0_UAProfile.xml': [
    'Huawei',
    'Honor Play 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_CHM-U01_UAProfile.xml': [
    'Huawei',
    'Honor Play 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HONOR_CHM-UL00_6.0_UAProfile.xml': [
    'Huawei',
    'Honor Play 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHM-TL00_UAProfile.xml': [
    'Huawei',
    'Honor Play 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CHM-U01_Russia_UAProfile.xml': [
    'Huawei',
    'Honor Play 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_CHM-CL00_6_0_UAProfile.xml': [
    'Huawei',
    'Honor Play 4C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ATH-UL01_DRM_Uaprofile.xml': [
    'Huawei',
    'Honor ShotX',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ATH-UL01_Uaprofile.xml': [
    'Huawei',
    'Honor ShotX',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ATH-UL06_Uaprofile.xml': [
    'Huawei',
    'Honor ShotX',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_HDN-L09_UAProfile.xml': [
    'Huawei',
    'Honor WaterPlay',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8950D_1_20120704.xml': [
    'Huawei',
    'Honor+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8150v100WCDMA.xml': ['Huawei', 'IDEOS', 'Android', DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/Huawei-S7.xml': ['Huawei', 'IDEOS S7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiS7v100EVDONormal.xml': ['Huawei', 'IDEOS S7', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HuaweiS7v100GPRSNormal.xml': ['Huawei', 'IDEOS S7', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HuaweiS7v100WCDMA.xml': ['Huawei', 'IDEOS S7', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HuaweiS7v100WCDMANormal.xml': ['Huawei', 'IDEOS S7', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiS7Slimv100WCDMA.xml': [
    'Huawei',
    'IDEOS S7 Slim',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8180GPRS.xml': ['Huawei', 'IDEOS X1', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8180WCDMA.xml': ['Huawei', 'IDEOS X1', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8500v100GPRSNormal.xml': [
    'Huawei',
    'IDEOS X2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8500v100WCDMANormal.xml': [
    'Huawei',
    'IDEOS X2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1GPRS-2degrees.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1GPRS-o2-Tchibo.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1GPRS-o2.xml': ['Huawei', 'IDEOS X3', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1GPRS-VDF_HU.xml': ['Huawei', 'IDEOS X3', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1GPRS-VDF_PT.xml': ['Huawei', 'IDEOS X3', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1GPRS-Wind_GR.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1WCDMA-2degrees.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1WCDMA-o2-Tchibo.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1WCDMA-o2.xml': ['Huawei', 'IDEOS X3', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1WCDMA-TAM_ID.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1WCDMA-VDF_HU.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-1WCDMA-VDF_PT.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-5WCDMA-Iusacell_MX.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-5WCDMA-Iusacell_MX236.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510-92WCDMA-EAccess.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510GPRS-NORMAL235.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510GPRS-NORMAL236.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8510WCDMA-NORMAL.xml': ['Huawei', 'IDEOS X3', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8510WCDMA-NORMAL235.xml': [
    'Huawei',
    'IDEOS X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8800-51v100GPRS.xml': ['Huawei', 'IDEOS X5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8800-51v100WCDMA-ATT.xml': [
    'Huawei',
    'IDEOS X5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8800-51v100WCDMA.xml': ['Huawei', 'IDEOS X5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8800iGPRS-NORMAL.xml': ['Huawei', 'IDEOS X5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8800v100C2WCDMA.xml': ['Huawei', 'IDEOS X5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8800v100GPRS.xml': ['Huawei', 'IDEOS X5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8800v100WCDMA.xml': ['Huawei', 'IDEOS X5', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_C8800_1_20110222.xml': [
    'Huawei',
    'IDEOS X5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8800proGPRS-NORMAL.xml': [
    'Huawei',
    'IDEOS X5 Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8800PROiGPRS-NORMAL.xml': [
    'Huawei',
    'IDEOS X5 Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8800prov100GPRS.xml': [
    'Huawei',
    'IDEOS X5 Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8800prov100WCDMA.xml': [
    'Huawei',
    'IDEOS X5 Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8800proWCDMA-NORMAL.xml': [
    'Huawei',
    'IDEOS X5 Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiH867GGPRS-Normal.xml': ['Huawei', 'Inspira', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/Huawei-M328.xml': ['Huawei', 'M328', null, DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/HUAWEI-M570.xml': ['Huawei', 'M570', null, DeviceType.MOBILE],
  'http://mms.mycricket.com/HUAWEI-M615.xml': ['Huawei', 'M615', null, DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/Huawei-M635.xml': ['Huawei', 'M635', null, DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/Huawei-M735.xml': ['Huawei', 'M735', null, DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/Huawei-M835.xml': ['Huawei', 'M835', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_M835_1_20110720.xml': ['Huawei', 'M835', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/Huawei-M860.xml': ['Huawei', 'M860', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/Huawei-M860F.xml': ['Huawei', 'M860', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_H871G.xml': ['Huawei', 'Magna', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CRR_L09_UAProfile.xml': ['Huawei', 'Mate 8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_M200_L09_UAProfile.xml': ['Huawei', 'Mate 8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_NXT-AL10_UAProfile.xml': ['Huawei', 'Mate 8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_NXT-TL00_UAProfile.xml': ['Huawei', 'Mate 8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_NXT-UL00_UAProfile.xml': ['Huawei', 'Mate 8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_NXT-CL00_1_20151102.xml': ['Huawei', 'Mate 8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CRR-UL00_UAProfile.xml': ['Huawei', 'Mate S', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CRR-UL20_UAProfile.xml': ['Huawei', 'Mate S', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CRR_L09_UAProfile_3G.xml': [
    'Huawei',
    'Mate S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_CRR-CL00_1_20150310.xml': ['Huawei', 'Mate S', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_CRR-CL20_1_20150310.xml': ['Huawei', 'Mate S', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPadEVDODataOnly.xml': [
    'Huawei',
    'MediaPad',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPadWCDMADataOnly.xml': [
    'Huawei',
    'MediaPad',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPadWCDMA_ICS.xml': ['Huawei', 'MediaPad', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPadWIFIOnly.xml': ['Huawei', 'MediaPad', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPadWIFIOnly_ICS.xml': [
    'Huawei',
    'MediaPad',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_201u.xml': [
    'Huawei',
    'MediaPad 10 Link',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_201wa.xml': [
    'Huawei',
    'MediaPad 10 Link',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S10-231L.xml': [
    'Huawei',
    'MediaPad 10 Link',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S10-231u.xml': [
    'Huawei',
    'MediaPad 10 Link',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S10-231w.xml': [
    'Huawei',
    'MediaPad 10 Link',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/MediaPad7LiteWCDMA_ICS.xml': [
    'Huawei',
    'MediaPad 7 Lite',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/MediaPad7LiteWIFIOnly_ICS.xml': [
    'Huawei',
    'MediaPad 7 Lite',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad71111WCDMA.xml': [
    'Huawei',
    'MediaPad 7 Vivid',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad7611WCDMA.xml': [
    'Huawei',
    'MediaPad 7 Vivid',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad7601WCDMA.xml': [
    'Huawei',
    'MediaPad 7 Vogue',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad7601WIFIOnly.xml': [
    'Huawei',
    'MediaPad 7 Vogue',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S7-601c.xml': [
    'Huawei',
    'MediaPad 7 Vogue',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad7701WIFIOnly.xml': [
    'Huawei',
    'MediaPad 7 Youth',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad770XWCDMA.xml': [
    'Huawei',
    'MediaPad 7 Youth',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad721XWCDMA.xml': [
    'Huawei',
    'MediaPad 7 Youth 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S7-721g.xml': [
    'Huawei',
    'MediaPad 7 Youth 2',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S7-721w.xml': [
    'Huawei',
    'MediaPad 7 Youth 2',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S7-72Xu.xml': [
    'Huawei',
    'MediaPad 7 Youth 2',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S8-301L.xml': [
    'Huawei',
    'MediaPad 8 Vogue',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S8-301u.xml': [
    'Huawei',
    'MediaPad M1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S8-301u_4_4.xml': [
    'Huawei',
    'MediaPad M1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S8-301w.xml': [
    'Huawei',
    'MediaPad M1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S8-301L_4_4.xml': [
    'Huawei',
    'MediaPad M1 403HW',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/LST.xml': ['Huawei', 'MediaPad M2', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HUAWEI_BAH-AL00_UAProfile.xml': ['Huawei', 'MediaPad M3 Lite', 'Windows'],
  'http://wap1.huawei.com/uaprof/HUAWEI_BAH-W09_UAProfile.xml': [
    'Huawei',
    'MediaPad M3 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CPN-AL00_UAProfile.xml': [
    'Huawei',
    'MediaPad M3 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CPN-W09_UAProfile.xml': [
    'Huawei',
    'MediaPad M3 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/7D-501w.xml': ['Huawei', 'MediaPad T1', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad701XWCDMA.xml': [
    'Huawei',
    'MediaPad T1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_S8-701w.xml': [
    'Huawei',
    'MediaPad T1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediapad_S8-70Xu.xml': [
    'Huawei',
    'MediaPad T1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediapad_T1-701g.xml': [
    'Huawei',
    'MediaPad T1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediapad_T1-701u.xml': [
    'Huawei',
    'Mediapad T1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediapad_T1-701ua.xml': [
    'Huawei',
    'MediaPad T1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediapad_T1-701w.xml': [
    'Huawei',
    'MediaPad T1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediapad_T1-702u.xml': [
    'Huawei',
    'MediaPad T1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_T1-821L.xml': [
    'Huawei',
    'MediaPad T1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_T1-A21L.xml': [
    'Huawei',
    'MediaPad T1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/T1-701u.xml': ['Huawei', 'MediaPad T1', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_PLE-703L.xml': [
    'Huawei',
    'MediaPad T2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_T2-10.xml': ['Huawei', 'MediaPad T2', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/HUAWEI_KOB-L09_UAProfile.xml': [
    'Huawei',
    'MediaPad T3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_KOB-W09_UAProfile.xml': [
    'Huawei',
    'MediaPad T3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/7D-501L.xml': ['Huawei', 'MediaPad X1', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/7D-501L_4_4.xml': ['Huawei', 'MediaPad X1', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/7D-501u.xml': ['Huawei', 'MediaPad X1', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/7D-501u_4_4.xml': ['Huawei', 'MediaPad X1', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_7D-501L.xml': [
    'Huawei',
    'MediaPad X1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_7D-501u.xml': [
    'Huawei',
    'MediaPad X1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap1.huawei.com/uaprof/X1S-703L.xml': ['Huawei', 'MediaPad X1 S', 'Android', DeviceType.MOBILE],
  'http://mms.openmobilepr.com/uaprof/HuaweiM886.xml': ['Huawei', 'Mercury', 'Android', DeviceType.MOBILE],
  'http://provantage.cleartalk.csky.us/ua/huawei_M886.xml': ['Huawei', 'Mercury', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiM886-Cricket.xml': ['Huawei', 'Mercury', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CAZ-TL10_UAProfile.xml': ['Huawei', 'Nova', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CAZ-TL20_UAProfile.xml': ['Huawei', 'Nova', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_BAC-TL00_UAProfile.xml': [
    'Huawei',
    'Nova 2 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_VTR-TL00_UAProfile.xml': ['Huawei', 'P10', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_WAS-TL10_UAProfile.xml': [
    'Huawei',
    'P10 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_VKY-TL00_UAProfile.xml': [
    'Huawei',
    'P10 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_GRA-CL10_1_20150105.xml': ['Huawei', 'P8', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-L21_5.1_UAProfile.xml': [
    'Huawei',
    'P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_ALE-UL00_6.0_UAProfile.xml': [
    'Huawei',
    'P8 Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HW_ALE-CL00_6_0_UAProfile.xml': ['Huawei', 'P8 Lite', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_A168-AL10_UAProfile.xml': ['Huawei', 'P9', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_EVA-AL00_UAProfile.xml': ['Huawei', 'P9', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_EVA-AL10_UAProfile.xml': ['Huawei', 'P9', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_EVA-DL00_UAProfile.xml': ['Huawei', 'P9', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_EVA-TL00_UAProfile.xml': ['Huawei', 'P9', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_EVA-CL00_3_20160226.xml': ['Huawei', 'P9', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_VNS-TL00_UAProfile.xml': ['Huawei', 'P9 Lite', 'Windows', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_VNS_AL00_UAProfile.xml': ['Huawei', 'P9 Lite', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_VNS_DL00_UAProfile.xml': ['Huawei', 'P9 Lite', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_VIE-AL10_UAProfile.xml': ['Huawei', 'P9 Plus', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/Huawei-M931.xml': ['Huawei', 'Premia 4G', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_HUAWEI_H891L.xml': ['Huawei', 'Pronto', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad_FDR-A04L.xml': [
    'Huawei',
    'Qua tab 02 HWT31',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/HW/HW_HUAWEI_S8520_1_20110819.xml': ['Huawei', 'S8520', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/HW/HW_HUAWEI_S8600_1_20110825.xml': ['Huawei', 'S8600', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650GPRS-Normal.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650GPRS-Normal236.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650GPRS-UNICOM.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650GPRS-Vodafone-It.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650GPRS-Yoigo.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-Normal.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-Normal236.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-Taiwan.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-Tele2-HR.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-Tele2-LT.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-Tele2-SE.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-UNICOM.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-Vodafone-It.xml': [
    'Huawei',
    'Sonic',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-Yoigo.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8660GPRS-Normal.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8660WCDMA-Normal.xml': ['Huawei', 'Sonic', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8661GPRS.xml': ['Huawei', 'Sonic+', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8661WCDMA.xml': ['Huawei', 'Sonic+', 'Android', DeviceType.MOBILE],
  'http://uaprofile.huawei.com/uaprof/HUAWEI-T8300-1.0.xml': ['Huawei', 'T8300', 'Android', DeviceType.MOBILE],
  'http://uaprofile.huawei.com/uaprof/HUAWEI-T8600-1.0.xml': ['Huawei', 'T8600', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_T8950N_UAProfile.xml': ['Huawei', 'T8950N', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8651WCDMA-VTR.xml': ['Huawei', 'Talon', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8651WCDMA-WIND.xml': ['Huawei', 'Talon', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8820GPRS-NII.xml': ['Huawei', 'Titan', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8820WCDMA-NII.xml': ['Huawei', 'Titan', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU120v100.xml': ['Huawei', 'U120', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U2800A_UAProfile.xml': ['Huawei', 'U2800', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U2801_UAProfile.xml': ['Huawei', 'U2801', 'Brew', DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiU3100v100UNIWCDMA.xml': ['Huawei', 'U3100', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiU3205v100WCDMA.xml': ['Huawei', 'U3205', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiU3300v100GPRS.xml': ['Huawei', 'U3300', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U3900_ATTNormal.xml': ['Huawei', 'U3900', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U5120_UAProfile.xml': ['Huawei', 'U5120', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U5200_UAProfile.xml': ['Huawei', 'U5200', 'Brew', DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiU526v100.xml': ['Huawei', 'U526', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiU528v100.xml': ['Huawei', 'U528', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U5300_UAProfile.xml': ['Huawei', 'U5300', 'Brew', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U5310_UAProfile.xml': ['Huawei', 'U5310', 'Brew', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU535v100GPRS.xml': ['Huawei', 'U535', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U6150_UAProfile.xml': ['Huawei', 'U6150', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_U6150_WIND_UAProfile.xml': ['Huawei', 'U6150', 'Brew', DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiU626v100.xml': ['Huawei', 'U626', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiV715v100WCDMA.xml': ['Huawei', 'U715', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiV716v100WCDMA.xml': ['Huawei', 'U716', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiV720v100WCDMA.xml': ['Huawei', 'U720', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiV725v100GPRS.xml': ['Huawei', 'U725', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiV725v100WCDMA.xml': ['Huawei', 'U725', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiU7510v100WCDMA.xml': ['Huawei', 'U7510', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiV810v100GPRS.xml': ['Huawei', 'U810', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiV810v100WCDMA.xml': ['Huawei', 'U810', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8100-9v100WCDMA.xml': ['Huawei', 'U8100', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8100v100GPRSNormal.xml': ['Huawei', 'U8100', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8100v100WCDMANormal.xml': ['Huawei', 'U8100', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8109GPRS.xml': ['Huawei', 'U8109', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8109v100WCDMA.xml': ['Huawei', 'U8109', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8110v100GPRS.xml': ['Huawei', 'U8110', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8110v100GPRSNormal.xml': ['Huawei', 'U8110', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8110v100WCDMA.xml': ['Huawei', 'U8110', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8110v100WCDMANormal.xml': ['Huawei', 'U8110', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8160WCDMA-MTS.xml': ['Huawei', 'U8160', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8230v100GPRS.xml': ['Huawei', 'U8230', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8230v100WCDMAEclair.xml': ['Huawei', 'U8230', 'Android', DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiV830v100WCDMA.xml': ['Huawei', 'U830', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8300v100GPRSNormal.xml': ['Huawei', 'U8300', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8300v100WCDMANormal.xml': ['Huawei', 'U8300', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8652-51WCDMA-Normal236.xml': [
    'Huawei',
    'U8652',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8652WCDMA-Normal.xml': ['Huawei', 'U8652', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8667GPRS-NII.xml': ['Huawei', 'U8667', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8667WCDMA-NII.xml': ['Huawei', 'U8667', 'Android', DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiU9130v100GPRS.xml': ['Huawei', 'U9130', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Huawei/Y538-2012071301/Y538C237B128.rdf': [
    'Huawei',
    'Union',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Huawei/Y538-BOOST/Y538C237B128.rdf': [
    'Huawei',
    'Union',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Huawei/Y538-BOOST/Y538C237B138.rdf': [
    'Huawei',
    'Union',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Huawei/Y538-VIRGIN/Y538C237B150.rdf': [
    'Huawei',
    'Union',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8850v100WCDMA.xml': ['Huawei', 'Vision', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_LUNA_UAProfile.xml': ['Huawei', 'Y3 II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/LUA-U03_UAProfile.xml': ['Huawei', 'Y3 II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/LUA-U22_UAProfile.xml': ['Huawei', 'Y3 II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/LUA-U23_UAProfile.xml': ['Huawei', 'Y3 II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CANCUN_UAProfile.xml,http://wap1.huawei.com/uaprof/HUAWEI_CUN_L_UAProfile.xml': [
    'Huawei',
    'Y5 II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_CUN_L_UAProfile.xml': ['Huawei', 'Y5 II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CUN_U_UAProfile.xml': ['Huawei', 'Y5 II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HW_SCC-U21_UAProfile.xml': ['Huawei', 'Y6', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HUAWEI_CAM_TL00H_UAProfile.xml': ['Huawei', 'Y6 II', 'Android', DeviceType.MOBILE],
  'http://imatemms.imate.com/gen/UAProf_8502_v1.xml': ['i-mate', '8502', null, DeviceType.MOBILE],
  'http://imatemms.imate.com/gen/UAProf_9502_v1.xml': ['i-mate', '9502', null, DeviceType.MOBILE],
  'http://www.htcmms.com.tw/tmo/i-mate K-JAM PPC-1.3.xml': ['i-mate', 'K-JAM', 'Windows Mobile', DeviceType.MOBILE],
  'http://imatemms.imate.com/gen/UAProf_Pebble_v1.xml': ['i-mate', 'Pebble', null, DeviceType.MOBILE],
  'http://asmobile.ehosting.com.tw/uaprof/i-mobile607.xml': ['i-mobile', '607', null, DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/i-mobile/i-STYLE2.9.xml': [
    'i-Mobile',
    'i-Style 2.9',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/i-mobile/i-STYLE7.6.xml': [
    'i-Mobile',
    'i-Style 7.6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uap.cellon.com/i-mobile IQ X.xml': ['i-Mobile', 'iQ X', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/i-mobile IQ X2.xml': ['i-Mobile', 'iQ X2', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/i-mobile IQ XA.xml': ['i-mobile', 'iQ XA', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/BS/Brightstar_Avvio_760.xml': ['Ilium', 'Avvio 760', 'Android', DeviceType.MOBILE],
  'http://xmlsite3.webs.com/Brightstar_Avvio_760.xml': ['Ilium', 'Avvio 760', 'Android', DeviceType.MOBILE],
  'http://ua.tinno.com/profile/latinamerica/brightstar/Avvio765_UAProf.xml': [
    'Ilium',
    'AVVIO 765',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://ua.tinno.com/profile/latinamerica/brightstar/Avvio785_UAProf.xml': [
    'Ilium',
    'AVVIO 785',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/Brightstar/Avvio_790.xml': ['Ilium', 'Avvio 790', 'Android', DeviceType.MOBILE],
  'http://guardsys.museui.com/Avvio793_WAP_BROWSER.xml': ['Ilium', 'AVVIO 793', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/N26/IN260.xml': ['InFocus', 'IN260', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/IVM/IN330.xml': ['InFocus', 'IN330', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/MG2/IN610.xml': ['InFocus', 'IN610', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/VKY/IN810.xml': ['InFocus', 'IN810', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/VKY/IN810.xml': ['InFocus', 'IN810', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/LSO/M2.xml': ['InFocus', 'M2', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/LSO/M2.xml': ['InFocus', 'M2', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/H1M/M210.xml': ['InFocus', 'M210', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/H1M/M210.xml': ['InFocus', 'M210', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/H1W/M310.xml': ['InFocus', 'M310', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/D70/M320m.xml': ['InFocus', 'M320', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/D70/M320u.xml': ['InFocus', 'M320', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/D70/M320u.xml': ['InFocus', 'M320', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/TID/InFocus M510t.xml': ['InFocus', 'M510', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/TID/PZ_InFocus_M510t.xml': ['InFocus', 'M510', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/TID_CHT/M510.xml': ['InFocus', 'M510', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/TID_TWN/InFocus M511.xml': ['InFocus', 'M511', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/MC2_CN/M512.xml': ['InFocus', 'M512', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/VNA/M810u.xml': ['InFocus', 'M810', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/VNA/PZ_M810t.xml': ['Infocus', 'M810', 'Android', DeviceType.MOBILE],
  'http://wap.innostream.com/uaprof/INNO30.xml': ['Innostream', 'INNO 30', null, DeviceType.MOBILE],
  'http://wap.innostream.com/uaprof/INNO55.xml': ['Innostream', 'INNO 55', null, DeviceType.MOBILE],
  'http://wap.innostream.com/uaprof/INNO89.xml': ['Innostream', 'INNO 89', null, DeviceType.MOBILE],
  'http://wap.innostream.com/uaprof/INNO90.xml': ['Innostream', 'INNO 90', null, DeviceType.MOBILE],
  'http://wap.innostream.com/uaprof/INNO98.xml': ['Innostream', 'INNO 98', null, DeviceType.MOBILE],
  'http://wap.innostream.com/uaprof/INNOA10.xml': ['Innostream', 'INNO A10', null, DeviceType.MOBILE],
  'http://wap.innostream.com/uaprof/INNOA10_W2.xml': ['Innostream', 'INNO A10', null, DeviceType.MOBILE],
  'http://www.inqmobile.com/ua/inq1.xml': ['INQ', 'INQ1', null, DeviceType.MOBILE],
  'http://50.18.182.85/profile/AZ210_UA_Profile.xml': ['Intel', 'AZ210', 'Android', DeviceType.MOBILE],
  'http://50.18.182.85/profile/AZ210A_UA_Profile.xml': ['Intel', 'AZ210A', 'Android', DeviceType.MOBILE],
  'http://downloadmirror.intel.com/20932/eng/AZ210A_UA_Profile.xml': [
    'Intel',
    'AZ210A',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://downloadmirror.intel.com/20932/eng/AZ210B_UA_Profile.xml': [
    'Intel',
    'AZ210B',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.ibbprof.com/uaprof/AZ210B_UA_Profile.xml': ['Intel', 'AZ210B', 'Android', DeviceType.MOBILE],
  'http://50.18.182.85/profile/AZ510_UA_Profile.xml': ['Intel', 'AZ510', 'Android', DeviceType.MOBILE],
  'http://downloadmirror.intel.com/20932/eng/AZ510_UA_Profile.xml': ['Intel', 'AZ510', 'Android', DeviceType.MOBILE],
  'http://www.ibbprof.com/uaprof/AZ510_UA_Profile.xml': ['Intel', 'AZ510', 'Android', DeviceType.MOBILE],
  'http://downloadmirror.intel.com/20932/eng/BT210_UA_Profile.xml': ['Intel', 'BT210', 'Android', DeviceType.MOBILE],
  'http://downloadmirror.intel.com/20932/eng/BT230_UA_Profile.xml': ['Intel', 'BT230', 'Android', DeviceType.MOBILE],
  'http://downloadmirror.intel.com/20932/eng/BT510_UA_Profile.xml': ['Intel', 'BT510', 'Android', DeviceType.MOBILE],
  'http://intextechnologies.com/wap/intex_Cloud-X3.xml': ['Intex', 'Cloud X3', 'Android', DeviceType.MOBILE],
  'http://www.intextechnologies.com/wap/intex_Cloud-Y1.xml': ['Intex', 'Cloud Y1', 'Android', DeviceType.MOBILE],
  'http://intextechnologies.com/wap/intex_Cloud-y2.xml': ['Intex', 'Cloud Y2', 'Android', DeviceType.MOBILE],
  'http://mobile.itelcospa.it/useragent/ITELCO-IT2500.xml': ['Itelco', 'IT2500', null, DeviceType.MOBILE],
  'http://uaprofs.scm.ixi.com:8080/UAProfs/ct-25m-scm-q0108.xml': ['IXI', 'CT 25m', null, DeviceType.MOBILE],
  'http://www.nyxmobile.com/UAProfile/zeuzhd/NYX_ZEUZ_HD.xml': ['Jiayu', 'G4C', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Jiayu_G4S.xml': ['Jiayu', 'G4S', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOJY-G5.xml': ['Jiayu', 'G5', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/TY/TY_E619+_1_20121123.xml': ['K-Touch', 'E619', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/TY/TY_K-Touch_E619+_1_20121203.xml': [
    'K-Touch',
    'E619',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.qma.com.tw/ktouch-e620.xml': ['K-Touch', 'E620', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/ktouch-e650.xml': ['K-Touch', 'E650', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/ktouch-e780.xml': ['K-Touch', 'E780', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/ktouch-e815.xml': ['K-Touch', 'E815', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S898t+_KK_UAprofile.xml': [
    'K-Touch',
    'Niburu Mars One H1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.ontim.com.cn/ua/K-Touch_T580_uaprofile.xml': ['K-Touch', 'T580', 'Android', DeviceType.MOBILE],
  'http://114.251.81.153/t660/K-Touch_T660_profile_3G.xml': ['K-Touch', 'T660', 'Android', DeviceType.MOBILE],
  'http://114.251.81.153/UAProfile/U81t/K-Touch_U81t_UAProfile.xml': [
    'K-Touch',
    'U81t',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://218.206.177.209:8080/waptest/browser15/TC3.html': ['KATA', 'i3s', 'Android', DeviceType.MOBILE],
  'http://tsprdev.com/kazam/ua/spain/movistar/KAZAM_Trooper_450_UAprofile.xml': [
    'KAZAM',
    'Trooper 450',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.fly-phone.ru/UAP/Fly_IQ4505_Quad.xml': ['KAZAM', 'Trooper 451', 'Android', DeviceType.MOBILE],
  'http://asmobile.ehosting.com.tw/uaprof/KingcomInjoyMS02.xml': ['Kingcom', 'Injoy MS02', null, DeviceType.MOBILE],
  'http://guardsys.museui.com/KIOTO793_WAP_BROWSER.xml': ['KIOTO', '793', 'Android', DeviceType.MOBILE],
  'http://www.mobilesoft.com.cn/UAProfile/CMSMMS2003.xml': ['Konka', 'C908', null, DeviceType.MOBILE],
  'http://www.konkamobile.com/profile/konka_k3.xml': ['Konka', 'K3', 'Android', DeviceType.MOBILE],
  'http://www.konkamobile.com/uploadfile/KONKA_V926_UAProfile.xml': ['Konka', 'V926', 'Android', DeviceType.MOBILE],
  'http://www.kkcool.com/hw/KONKA_V936.xml': ['Konka', 'V936', 'Android', DeviceType.MOBILE],
  'http://www.kkcool.com/hw/KONKA_V980.xml': ['Konka', 'V980', 'Android', DeviceType.MOBILE],
  'http://www.konkamobile.com/Profile/KONKA_V985.xml': ['Konka', 'V985', 'Android', DeviceType.MOBILE],
  'http://www.konkamobile.com/profile/KONKA_V987.xml': ['Konka', 'V987', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/KPN_Smart_300.xml': ['KPN', 'Smart 300', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/KPN_Smart_400.xml': ['KPN', 'Smart 400', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Kyivstar Spark.xml': ['Kyivstar', 'Spark', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/S2151-BST/1.001BT.rdf': [
    'Kyocera',
    'Coast S2151',
    'Brew MP',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/S2151-PLB/1.001VM.rdf': ['Kyocera', 'Coast S2151', 'Brew', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/Kyocera/vmk325/VMU_Thunder_UAProf.xml': ['Kyocera', 'Cyclops', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Kyocera/E4233/1400SP.rdf': ['Kyocera', 'E4233', 'Brew MP', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Kyocera/E4277/1308SP.rdf': ['Kyocera', 'E4277', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Kyocera/M9300/1100SP.rdf': ['Kyocera', 'Echo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Kyocera/M9300/2002SP.rdf': ['Kyocera', 'Echo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Kyocera/M9300/2006SP.rdf': ['Kyocera', 'Echo', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/JC/JC_KSP8000_3_20111228.xml': ['Kyocera', 'Echo', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/JC/JC_KSP8000_3_20120209.xml': ['Kyocera', 'Echo', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/JC/JC_KSP8000_4_20120308.xml': ['Kyocera', 'Echo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5133-2012102201/1.020VM.rdf': [
    'Kyocera',
    'Event',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5133-823/1.020VM.rdf': ['Kyocera', 'Event', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5133-Chameleon/latest': ['Kyocera', 'Event', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5133-VIRGIN/1.005VM.rdf': ['Kyocera', 'Event', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5133-VIRGIN/1.010VM.rdf': ['Kyocera', 'Event', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5133-VIRGIN/1.020VM.rdf': ['Kyocera', 'Event', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5170-2011050301/1.200BT.rdf': [
    'Kyocera',
    'Hydro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5170-2012051001/1.001BT.rdf': [
    'Kyocera',
    'Hydro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5170-2012102201/1.200BT.rdf': [
    'Kyocera',
    'Hydro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5170-BOOST/1.000BT.rdf': ['Kyocera', 'Hydro', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5170-BOOST/1.001BT.rdf': ['Kyocera', 'Hydro', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5170-BOOST/1.006BT.rdf': ['Kyocera', 'Hydro', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5170-BOOST/1.010BT.rdf': ['Kyocera', 'Hydro', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5170-BOOST/1.200BT.rdf': ['Kyocera', 'Hydro', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5170-BOOST/1.201BT.rdf': ['Kyocera', 'Hydro', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Kyocera/C5170-BST/0510BT.rdf': ['Kyocera', 'Hydro', 'Android', DeviceType.MOBILE],
  'http://wapuaprof.mycricket.com/kyo_c5171.xml': ['Kyocera', 'Hydro', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5215-BOOST/1.001.rdf': [
    'Kyocera',
    'Hydro Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5215-BOOST/1.002.rdf': [
    'Kyocera',
    'Hydro Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5215-BOOST/1.010.rdf': [
    'Kyocera',
    'Hydro Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5215-BOOST/1.020.rdf': [
    'Kyocera',
    'Hydro Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5215-Chameleon/latest': [
    'Kyocera',
    'Hydro Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5215-SPRINT/1.020.rdf': [
    'Kyocera',
    'Hydro Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.publicmobile.ca/Kyocera/Hydro_C5216_0.200NP.rdf': [
    'Kyocera',
    'Hydro Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.publicmobile.ca/Kyocera/Hydro_C5216_0.300NP.rdf': [
    'Kyocera',
    'Hydro Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.publicmobile.ca/Kyocera/Hydro_C5216_0.350NP.rdf': [
    'Kyocera',
    'Hydro Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C6730-BOOST/1.003.rdf': [
    'Kyocera',
    'Hydro Icon',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C6730-BOOST/1.010.rdf': [
    'Kyocera',
    'Hydro Icon',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C6730-Chameleon/latest': [
    'Kyocera',
    'Hydro Icon',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.kyocera-wireless.com/UAProf/C6530/C6530N_TM002.xml': [
    'Kyocera',
    'Hydro Life',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C6725-SPRINT/1.003.rdf': [
    'Kyocera',
    'Hydro Vibe',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C6725-VIRGIN/1.003.rdf': [
    'Kyocera',
    'Hydro Vibe',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.metropcs.net/UAProf/kyocera-C6721.xml': ['Kyocera', 'Hydro XTRM', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/KYOCERA/C6721/0.920US.xml': ['Kyocera', 'Hydro XTRM', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/KYOCERA/C6721/0.990US.xml': ['Kyocera', 'Hydro XTRM', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/KYOCERA/C6721/1.000US.xml': ['Kyocera', 'Hydro XTRM', 'Android', DeviceType.MOBILE],
  'http://www.kyocera-wireless.com/UAProf/C6522/C6522N_TM001.xml': [
    'Kyocera',
    'Hydro XTRM',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.kyocera-wireless.com/UAProf/C6522/C6522N_TM002.xml': [
    'Kyocera',
    'Hydro XTRM',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.kyocera-wireless.com/UAProf/C6522/C6522_TM001.xml': [
    'Kyocera',
    'Hydro XTRM',
    'Android',
    DeviceType.MOBILE,
  ],
  'https://servicios.iusacell.com.mx/kyo/KX18.xml': ['Kyocera', 'KX18', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Kyocera/C5120-BST/1.100BT.rdf': ['Kyocera', 'Milano', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Kyocera/C5120/1007SP.rdf': ['Kyocera', 'Milano', 'Android', DeviceType.MOBILE],
  'http://mms.revol.us/uaprofs/Oblique_C5121.xml': ['Kyocera', 'Milano', 'Android', DeviceType.MOBILE],
  'http://www.kyoceramobile.com/UAProf/S1370/S1370_TB001.xml': ['Kyocera', 'Rally', 'Brew MP', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5155-2011011301/1.011SP.rdf': [
    'Kyocera',
    'Rise',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/C5155-SPRINT/1.003SP.rdf': ['Kyocera', 'Rise', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5155-SPRINT/1.005SP.rdf': ['Kyocera', 'Rise', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/C5155-SPRINT/1.011SP.rdf': ['Kyocera', 'Rise', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Kyocera/C5155/0401SP.rdf': ['Kyocera', 'Rise', 'Android', DeviceType.MOBILE],
  'http://profile.kyocera-wireless.com/uaprof/Rise_C5156_1.002PM.rdf': [
    'Kyocera',
    'Rise',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://profile.kyocera-wireless.com/uaprof/Rise_C5156_1.101PM.rdf': [
    'Kyocera',
    'Rise',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.publicmobile.ca/Kyocera/Rise_C5156_1.101PM.rdf': ['Kyocera', 'Rise', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/Kyocera/C5155-VMUB/1.0/UAProf.xml': ['Kyocera', 'Rise', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/KYOCERA/K10-Royale/VMU_Royale_UAProf.xml': ['Kyocera', 'Royale', null, DeviceType.MOBILE],
  'http://uaprof.vmobl.com/kyocera/S2000i/VMU_S2000i_UAProf.xml': ['Kyocera', 'S2000i', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/S3015-PLB/1.001VM.rdf': [
    'Kyocera',
    'S3015-PLB',
    'Brew MP',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vmobl.com/KYOCERA/K612/VMU_Switch_Back_UAProf.xml': ['Kyocera', 'Strobe', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/E6710-Chameleon/latest': ['Kyocera', 'Torque', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/E6710-SPRINT/1.005SP.rdf': [
    'Kyocera',
    'Torque',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/E6710-SPRINT/1.006SP.rdf': [
    'Kyocera',
    'Torque',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/E6710-SPRINT/1.007SP.rdf': [
    'Kyocera',
    'Torque',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/E6710-SPRINT/2.002SP.rdf': [
    'Kyocera',
    'Torque',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/E6710-SPRINT/2.300SP.rdf': [
    'Kyocera',
    'Torque',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/E6710-SPRINT/2.602SP.rdf': [
    'Kyocera',
    'Torque',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/KYOCERA/E6710-SPRINT/3.000SP.rdf': [
    'Kyocera',
    'Torque',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Sanyo/PL8600/1004PL.rdf': ['Kyocera', 'Zio', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/PL8600/2103PL.rdf': ['Kyocera', 'Zio', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP8600/2200SP.rdf': ['Kyocera', 'Zio', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_Ilium_L1100.xml': [
    'Lanix',
    'Ilium L1100',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lanixmobile.com/profiles/LANIX_IliumL1200_Chrome.xml': [
    'Lanix',
    'Ilium L1200',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lanixmobile.com/profiles/Lanix_IliumL400.xml': ['Lanix', 'Ilium L400', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_ILIUM_L820.xml': ['Lanix', 'Ilium L820', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_IliumL950_LP.xml': [
    'Lanix',
    'Ilium L950',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lanixmobile.com/profiles/Lanix_IliumLT500.xml': ['Lanix', 'Ilium LT500', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_ILIUM_S106.xml': ['Lanix', 'Ilium S106', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_IliumS115.xml': ['Lanix', 'Ilium S115', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_IliumS120.xml': ['Lanix', 'Ilium S120', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_ILIUM_S130.xml': ['Lanix', 'Ilium S130', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_iliumS200.xml': ['Lanix', 'Ilium S200', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_IliumS210.xml': ['Lanix', 'Ilium S210', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_iliumS400.xml': ['Lanix', 'Ilium S400', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_IliumS410.xml': ['Lanix', 'Ilium S410', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_iliumS420.xml': ['Lanix', 'Ilium S420', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_iliumS50.xml': ['Lanix', 'Ilium S50', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_IliumS500.xml': ['Lanix', 'Ilium S500', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_IliumS520.xml': ['Lanix', 'Ilium S520', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_ILIUM_S520.xml': ['Lanix', 'Ilium S520', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/Profiles/Lanix_IliumS700.xml': ['Lanix', 'Ilium S700', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_IliumX110.xml': ['Lanix', 'Ilium X110', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_IliumX200.xml': ['Lanix', 'Ilium X200', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_IliumX210.xml': ['Lanix', 'Ilium X210', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_IliumX400.xml': ['Lanix', 'Ilium X400', 'Android', DeviceType.MOBILE],
  'http://www.lanixmobile.com/profiles/Lanix_IliumX500B.xml': ['Lanix', 'Ilium X500B', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/LAVA_IRIS349_UAP.xml': ['Lava', 'Flair E3', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/Flair%20P8.xml': ['Lava', 'Flair P8', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/lava/LAVA_IRIS_355.xml': ['Lava', 'Iris 355', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/lava/LAVA_IRIS356.xml': ['Lava', 'Iris 356', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/LAVA_IRIS_360m_style.xml': ['Lava', 'Iris 360M', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/IRIS_400C.XML': ['Lava', 'Iris 400 Colour', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/Lava%20Iris%20401.xml': ['Lava', 'Iris 401', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/lava/LAVA_IRIS402.xml': ['Lava', 'Iris 402', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/LAVA_IRIS412.xml': ['Lava', 'Iris 412', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/LAVA_IRIS415.xml': ['Lava', 'Iris 415', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/LAVA_iris_460.xml': ['Lava', 'Iris 460', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/lava_iris500.xml': ['Lava', 'Iris 500', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/lava/LAVA_IRIS_501.xml': ['Lava', 'Iris 501', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/lava/LAVA_IRIS504Q.xml': ['Lava', 'Iris 504Q', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/LAVA_IRIS504Q+.xml': ['Lava', 'Iris 504QP', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/lava/LAVA_IRIS506Q.xml': ['Lava', 'Iris 506Q', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/iris_alfa.xml': ['Lava', 'Iris Alfa', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/Iris_Alfa_L.xml': ['Lava', 'Iris Alfa L', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/iris_fuel_10.xml': ['Lava', 'Iris fuel10', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/iris_Fuel20.xml': ['Lava', 'Iris fuel20', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_A107.xml': ['Lava', 'Iris fuel50', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/Iris%20Fuel60.xml': ['Lava', 'Iris fuel60', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/lava/LAVA_N320.xml': ['Lava', 'Iris N320', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/M8047LAL.xml': ['Lava', 'Iris Pro 20', 'Android', DeviceType.MOBILE],
  'http://uap.cellon.com/M8047LA.xml': ['Lava', 'Iris Pro 30', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/Lava_Iris_X1_Grand.xml': ['Lava', 'Iris X1 Grand', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/iris_X1_Selfie.xml': ['Lava', 'Iris X1 Selfie', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/Lava_Iris_X5.xml': ['Lava', 'Iris X5', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/LAVA_IRISX8.xml': ['Lava', 'Iris X8', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/Lava/X9.xml': ['Lava', 'Iris X9', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/XOLO/XOLO_A500L.xml': ['Lava', 'XOLO A500L', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/XOLO/XOLO_A500sLite.xml': ['Lava', 'XOLO A500S Lite', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/XOLO/BLACK.xml': ['Lava', 'XOLO Black', 'Android', DeviceType.MOBILE],
  'http://msai.in/uaprof/XOLO/Play%20100.xml': ['Lava', 'XOLO Play 6X-1000', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/XOLO/Play%208X-1100.xml': ['Lava', 'XOLO Play 8X-1100', 'Android', DeviceType.MOBILE],
  'http://wap.msaiuap.in/xolo/Q1000S.xml': ['Lava', 'XOLO Q1000S', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/XOLO/XOLO_Q1010i.xml': ['Lava', 'XOLO Q1010i', 'Android', DeviceType.MOBILE],
  'http://msai.in/uaprof/XOLO/Q1011.xml': ['Lava', 'XOLO Q1011', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/XOLO/Q2100.xml': ['Lava', 'XOLO Q2100', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/XOLO/Q3000.xml': ['Lava', 'XOLO Q3000', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/XOLO/XOLO_Q900T.xml': ['Lava', 'XOLO Q900T', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/lava/Q700.xml': ['Lava', 'XOLO X900', 'Android', DeviceType.MOBILE],
  'http://www.lemonmobiles.com/UAP/LemonP105.xml': ['Lemon', 'P105', 'Android', DeviceType.MOBILE],
  'http://www.lemonmobiles.com/UAP/LemonP3.xml': ['Lemon', 'P3', 'Android', DeviceType.MOBILE],
  'http://www.lemonmobiles.com/UAP/LemonP5.xml': ['Lemon', 'P5', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A300_UAProfile.xml': [
    'Lenovo',
    'A300',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://10.125.33.169:8080/LNV_Lenovo_A305e_2_20130627.xml': ['Lenovo', 'A305', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A319_AMX_UAProfile.xml': [
    'Lenovo',
    'A319',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A326_UAProfile.xml': [
    'Lenovo',
    'A326',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A360_UAProfile.xml': [
    'Lenovo',
    'A360',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/downfile/LNV_Lenovo_A360e_1_20130925.xml': [
    'Lenovo',
    'A360',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A366t_UAProfile.xml': [
    'Lenovo',
    'A366',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A378t_UAProfile.xml': [
    'Lenovo',
    'A378',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A500_UAProfile.xml': [
    'Lenovo',
    'A500',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A516_ROW_UAProfile.xml': [
    'Lenovo',
    'A516',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A516_UAProfile.xml': [
    'Lenovo',
    'A516',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A520_UAProfile.xml': [
    'Lenovo',
    'A520',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo%20A526_ROW_UAProfile_0120.xml': [
    'Lenovo',
    'A526',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S650_KK_ROW_UAprofile.xml': [
    'Lenovo',
    'A536',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/TYZ/LNV_Lenovo_A560e_1_20111220.xml': [
    'Lenovo',
    'A560',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A588t_UAProfile.xml': [
    'Lenovo',
    'A588',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A60_UAProfile.xml': [
    'Lenovo',
    'A60',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A630e_UAProfile.xml': [
    'Lenovo',
    'A630',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A630t_UAProfile.xml': [
    'Lenovo',
    'A630',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A65_UAProfile.xml': [
    'Lenovo',
    'A65',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A656_UAProfile.xml': [
    'Lenovo',
    'A656',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A66t_profile_3G.xml': [
    'Lenovo',
    'A66',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/A660_UAprofile.xml': [
    'Lenovo',
    'A660',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A678t_UAProfile.xml': [
    'Lenovo',
    'A678',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/LNV/LNV_Lenovo_A68e_1_20110715.xml': ['Lenovo', 'A68', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A698t_UAProfile.xml': [
    'Lenovo',
    'A698',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A700e_UAProfile.xml': [
    'Lenovo',
    'A700',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A750_UAProfile.xml': [
    'Lenovo',
    'A750',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A7600-m_UAprofile.xml': [
    'Lenovo',
    'A760',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A7600_UAprofile.xml': [
    'Lenovo',
    'A7600',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A766_UAProfile.xml': [
    'Lenovo',
    'A766',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A789_UAProfile.xml': [
    'Lenovo',
    'A789',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/LNV/LNV_AE760_1_20111024.xml': ['Lenovo', 'A790', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A798t_UAProfile.xml': [
    'Lenovo',
    'A798',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A800_UAProfile.xml': [
    'Lenovo',
    'A800',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A806_UAprofile.xml': [
    'Lenovo',
    'A806',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A808t-i_UAprofile.xml': [
    'Lenovo',
    'A808',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A808t_UAprofile.xml': [
    'Lenovo',
    'A808',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.Lenovo.com.cn/mobile/uaprof/Lenovo_A820t.xml': ['Lenovo', 'A820', 'Android', DeviceType.MOBILE],
  'http://www.Lenovo.com.cn/mobile/uaprof/ZTE_V967S.xml': ['Lenovo', 'A820', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A820t_UAProfile.xml': [
    'Lenovo',
    'A820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A820_UAProfile.xml': [
    'Lenovo',
    'A820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.oppo.com/resource/UA-PROF/OPPOLenovo A820.xml': ['Lenovo', 'A820', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A830_UAProfile.xml': [
    'Lenovo',
    'A830',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A850+_UAprofile.xml': [
    'Lenovo',
    'A850',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A850plus_UAprofile.xml': [
    'Lenovo',
    'A850',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A850_ROW_UAProfile.xml': [
    'Lenovo',
    'A850',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A850_UAProfile.xml': [
    'Lenovo',
    'A850',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A859_ROW_UAprofile.xml': [
    'Lenovo',
    'A859',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A936_UAprofile.xml': [
    'Lenovo',
    'A936',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_A938t_UAprofile.xml': [
    'Lenovo',
    'A938',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_B6000-HV_UAProfile.xml': [
    'Lenovo',
    'B6000 Yoga Tablet 8',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_B6000-H_UAProfile.xml': [
    'Lenovo',
    'B6000 Yoga Tablet 8',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_20071165379380.xml': [
    'Lenovo',
    'E303',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/i325wg_Profile.xml': [
    'Lenovo',
    'i325wg',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_2006815893438.xml': [
    'Lenovo',
    'I720',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_2007736634847.xml': [
    'Lenovo',
    'I906',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_20075225142784.xml': [
    'Lenovo',
    'I908',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_B8000-H_UAProfile.xml': [
    'Lenovo',
    'IdeaTab B8000',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S5000-H_UAProfile.xml': [
    'Lenovo',
    'IdeaTab S5000',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.oppo.com/resource/UA-PROF/OPPOLenovo K31-t3.xml': ['Lenovo', 'K3', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_K50-T5_UAprofile.xml': [
    'Lenovo',
    'K50',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_P70-A.xml': [
    'Lenovo',
    'P70',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_P70_UAProfile.xml': [
    'Lenovo',
    'P70',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_20071236069306.xml': [
    'Lenovo',
    'P768',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_P770_ROW_UAProfile.xml': [
    'Lenovo',
    'P770',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_P770_UAProfile.xml': [
    'Lenovo',
    'P770',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_20067105107369.xml': [
    'Lenovo',
    'P780',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_P780_KK_UAProfile.xml': [
    'Lenovo',
    'P780',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_P780_ROW_UAProfile.xml': [
    'Lenovo',
    'P780',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_P780_UAProfile.xml': [
    'Lenovo',
    'P780',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.oppo.com/resource/UA-PROF/OPPOLenovo P780.xml': ['Lenovo', 'P780', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S650_KK_UAprofile.xml': [
    'Lenovo',
    'S650',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S650_ROW_UAprofile.xml': [
    'Lenovo',
    'S650',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S650_UAprofile.xml': [
    'Lenovo',
    'S650',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S658t_KK_UAprofile.xml': [
    'Lenovo',
    'S658',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S658t_UAprofile.xml': [
    'Lenovo',
    'S658',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_2008423595403.xml': [
    'Lenovo',
    'S707',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S720i_UAProfile.xml': [
    'Lenovo',
    'S720',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S720_ROW_UAProfile.xml': [
    'Lenovo',
    'S720',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S820_KK_UAprofile.xml': [
    'Lenovo',
    'S820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S820_ROW_UAProfile.xml': [
    'Lenovo',
    'S820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S820_UAProfile.xml': [
    'Lenovo',
    'S820',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HUAWEI_S850t_UAProfile.xml': ['Lenovo', 'S850', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S850T_UAprofile.xml': [
    'Lenovo',
    'S850',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S850_KK_UAprofile.xml': [
    'Lenovo',
    'S850',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S850_ROW_UAprofile.xml': [
    'Lenovo',
    'S850',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S850_UAprofile.xml': [
    'Lenovo',
    'S850',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S860t_UAprofile.xml': [
    'Lenovo',
    'S860',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S860_KK_UAprofile.xml': [
    'Lenovo',
    'S860',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S860_ROW_UAprofile.xml': [
    'Lenovo',
    'S860',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S860_UAprofile.xml': [
    'Lenovo',
    'S860',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S890i_UAProfile.xml': [
    'Lenovo',
    'S890',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S890_ROW_UAProfile.xml': [
    'Lenovo',
    'S890',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S898t+_UAProfile.xml': [
    'Lenovo',
    'S898',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S898t_UAProfile.xml': [
    'Lenovo',
    'S898',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S968t_KK_UAprofile.xml': [
    'Lenovo',
    'S898',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_20075256251113.xml': [
    'Lenovo',
    'S9',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/Lenovo S90-A.xml': ['Lenovo', 'S90', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S920_KK_UAProfile.xml': [
    'Lenovo',
    'S920',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S920_ROW_UAProfile.xml': [
    'Lenovo',
    'S920',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S920_UAProfile.xml': [
    'Lenovo',
    'S920',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S930_KK_UAprofile.xml': [
    'Lenovo',
    'S930',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S930_ROW_UAprofile.xml': [
    'Lenovo',
    'S930',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S930_UAprofile.xml': [
    'Lenovo',
    'S930',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S938t_UAprofile.xml': [
    'Lenovo',
    'S938t',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S939_KK_UAprofile.xml': [
    'Lenovo',
    'S939',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S939_UAprofile.xml': [
    'Lenovo',
    'S939',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S960_KK_UAprofile.xml': [
    'Lenovo',
    'S960',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S960_ROW_UAProfile.xml': [
    'Lenovo',
    'S960',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S960_UAprofile.xml': [
    'Lenovo',
    'S960',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_S968t_UAProfile.xml': [
    'Lenovo',
    'S968t',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_20069185728203.xml': [
    'Lenovo',
    'V800',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_X2-CU_UAprofile.xml': [
    'Lenovo',
    'Vibe X2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_X2-TO_UAprofile.xml': [
    'Lenovo',
    'Vibe X2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Lenovo_X2-TR_UAprofile.xml': [
    'Lenovo',
    'Vibe X2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.lenovomobile.com/admin/module/product/DownFile/download_200710186443397.xml': [
    'Lenovo',
    'X1',
    null,
    DeviceType.MOBILE,
  ],
  'http://gsm.lge.com/html/gsm/LG-LG306G.xml': ['LG', '306G', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-LG441G.xml': ['LG', '441G', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-A165-M3-D1.xml': ['LG', 'A165', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-A350-M3-D1.xml': ['LG', 'A350', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-A380.xml': ['LG', 'A380', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-A447.xml': ['LG', 'A447', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/n0xwBQ5qwfIlsJPX/H788SG-M3-D1.xml': ['LG', 'AKA', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/oOTiaX1x1bTXYvdu/H788-M3-D1.xml': ['LG', 'AKA', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/oOTiaX1x1bTXYvdu/H788n-M3-D1.xml': ['LG', 'AKA', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C710h-M6-D1-GB.xml': ['LG', 'Aloha', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C710h-M6-D1.xml': ['LG', 'Aloha', 'Android', DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/lg/ax245/ax245.xml': ['LG', 'AX245', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/lg/ax260/ax260.xml': ['LG', 'AX260 Scoop', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/lg/ax355/ax355.xml': ['LG', 'AX355', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/lg/ax380/ax380.xml': ['LG', 'AX380 Wave', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/lg/ax4750/ax4750.xml': ['LG', 'AX4750', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/lg/ax490/ax490.xml': ['LG', 'AX490', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/lg/ax830/ax830.xml': ['LG', 'AX830 Glimmer', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/lg/ax8600/ax8600.xml': ['LG', 'AX8600', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-B2070.xml': ['LG', 'B2070', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-B450.xml': ['LG', 'B450', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/4r8SiMuCXFiuV_W9/LG-B470.xml': ['LG', 'B470', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/BL40-M6-D2CL.xml': ['LG', 'BL40', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C130.xml': ['LG', 'C130', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C1300.xml': ['LG', 'C1300', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C1500.xml': ['LG', 'C1500', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C195-M3-D1.xml': ['LG', 'C195', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C195N-M3-D1.xml': ['LG', 'C195N', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C199-M3-D1.xml': ['LG', 'C199', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C2000.xml': ['LG', 'C2000', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C205-M3-D1.xml': ['LG', 'C205', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C207-M3-D1.xml': ['LG', 'C207', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C2500.xml': ['LG', 'C2500', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C330-M3-D1.xml': ['LG', 'C330', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C360-M3-D1.xml': ['LG', 'C360', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C365-M3-D1.xml': ['LG', 'C365', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C395.xml': ['LG', 'C395', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C397-M3-D1.xml': ['LG', 'C397', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-C410.xml': ['LG', 'C410', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-CB630.xml': ['LG', 'CB630 Invision', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-CE110.xml': ['LG', 'CE110', null, DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/LG-MS840.xml': ['LG', 'Connect 4G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T300-M3-D1-NS.xml': ['LG', 'Cookie Light T300', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-CT810.xml': ['LG', 'CT810 Incite', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-CU320.xml': ['LG', 'CU320', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-CU920.xml': ['LG', 'CU920 Vu', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/_ogUJjFY_IgTaMCN/LGL21G-M10-D1.xml': ['LG', 'Destiny', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C729-M10-D1.xml': ['LG', 'DoublePlay', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-E300-M3-D1.xml': ['LG', 'E300', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C800G-M10-D1.xml': ['LG', 'Eclypse', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS696/LS696ZVF.rdf': ['LG', 'Elite', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/lge/vs700/vs700.xml': ['LG', 'Enlighten', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx11000/vx11000.xml': ['LG', 'Env Touch', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx9200/vx9200.xml': ['LG', 'Env3', 'Brew', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P870-M10-D1.xml': ['LG', 'Escape', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P870-M6-D2.xml': ['LG', 'Escape', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H445-M10-D1.xml': ['LG', 'Escape2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/ojFJqSe94jShCXCN/H443-M3-D1.xml': ['LG', 'Escape2', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/LG-MS910.xml': ['LG', 'Esteem', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-F2200.xml': ['LG', 'F2200', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-F3000.xml': ['LG', 'F3000', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/a_ygkA6q45TBK1IF/D393-M10-D1.xml': ['LG', 'F60', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D392-M3-D1.xml': ['LG', 'F60', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGMS395-M10-D0.xml': ['LG', 'F60', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D315-M3-D1.xml': ['LG', 'F70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D315-M6-D1.xml': ['LG', 'F70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D315s-M6-D1.xml': ['LG', 'F70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F370L-M3-D1.xml': ['LG', 'F70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/L31L-M10-D1.xml': ['LG', 'F70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-F7250.xml': ['LG', 'F7250', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LGLS740-Chameleon/latest': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-2012071301/LS740ZV5.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-BOOST/LS740ZV3.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-BOOST/LS740ZV4.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-BOOST/LS740ZV5.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-BOOST/LS740ZV6.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-Chameleon/latest': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-SPRPRE/LS740ZV5.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-VIRGIN/LS740ZV3.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-VIRGIN/LS740ZV4.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-VIRGIN/LS740ZV5.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-VIRGIN/LS740ZV6.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.comLS740.rdf': ['LG', 'F90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-F9100.xml': ['LG', 'F9100', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-F9200.xml': ['LG', 'F9200', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS995-Chameleon/latest': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS995-SPRINT/LS995ZV3.rdf': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS995-SPRINT/LS995ZV6.rdf': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS995-SPRINT/LS995ZV7.rdf': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS995-SPRINT/LS995ZVA.rdf': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS995-SPRINT/LS995ZVB.rdf': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS995-SPRPRE/LS995ZVA.rdf': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS995-SPRPRE/LS995ZVB.rdf': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D950-M10-D1-KK.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D950-M10-D1.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D950-M3-D1.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D950G-M10-D1-KK.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D955-M10-D1.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D955-M3-D1-KK.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D955-M3-D1.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D955-M6-D1-KK.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D955-M6-D1.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D956-M3-D1.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D958-M10-D1.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D958-M3-D1-KK.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D958-M3-D1.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D959-M10-D1-KK.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D959-M10-D1.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F340L-M3-D1-KK.xml': ['LG', 'G Flex', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS991-SPRINT/LS996ZV8.rdf': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS996-BOOST/LS996ZV9.rdf': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS996-Chameleon/latest': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS996-SPRINT/LS996ZV5.rdf': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS996-SPRINT/LS996ZV6.rdf': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS996-SPRINT/LS996ZV7.rdf': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS996-SPRINT/LS996ZV8.rdf': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS996-SPRINT/LS996ZV9.rdf': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS996-SPRINT/LS996ZVB.rdf': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS996-SPRINT/LS996ZVC.rdf': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/2D_2BD_BlBeXhXq5/H955-M3-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/2D_2BD_BlBeXhXq5/H955-M5-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/2D_2BD_BlBeXhXq5/H955-M6-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LS996-M10-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MbAHlRXTX34T2a8f/H950-M10-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MbAHlRXTX34T2a8f/H950-M3-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MbAHlRXTX34T2a8f/H955-M10-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MbAHlRXTX34T2a8f/H955-M20-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MbAHlRXTX34T2a8f/H955-M3-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MbAHlRXTX34T2a8f/H955-M5-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MbAHlRXTX34T2a8f/H955-M6-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MbAHlRXTX34T2a8f/H959-M3-D1.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://pix.cspire.com/UA/profile/lg/as995/as995.xml': ['LG', 'G Flex 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/V410-D1.xml': ['LG', 'G Pad 7.0', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/V410-M10-D1.xml': ['LG', 'G Pad 7.0', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/V410-M3-D1.xml': ['LG', 'G Pad 7.0', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/V410GO-D1.xml': ['LG', 'G Pad 7.0', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/V490-M3-D1.xml': ['LG', 'G Pad 7.0', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/LG/LK430-Chameleon/latest': ['LG', 'G Pad F 7.0', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/LG/LK430-SPRINT/LK430ZV3.rdf': ['LG', 'G Pad F 7.0', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/LG/LK430-SPRINT/LK430ZV4.rdf': ['LG', 'G Pad F 7.0', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/LG/LK430-SPRINT/LK430ZV5.rdf': ['LG', 'G Pad F 7.0', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/LG/LK430-SPRINT/LK430ZV6.rdf': ['LG', 'G Pad F 7.0', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/LG/LK430-SPRINT/LK430ZV7.rdf': ['LG', 'G Pad F 7.0', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/iBpgg_0u_ASxAV_F/V495-D1.xml': ['LG', 'G Pad F 7.0', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/iBpgg_0u_ASxAV_F/V499-D1.xml': ['LG', 'G Pad F 8.0', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/rGTs_Yxuw5wT0ZyW/V495-D1.xml': ['LG', 'G Pad F 8.0', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/TksSP_-GkCHZ7K__/V930-D1.xml': ['LG', 'G Pad X 10.1', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/_-0_bP_4P_s73ov-/V930-D1.xml': ['LG', 'G Pad X 10.1', 'Android', DeviceType.TABLET],
  'http://gsm.lge.com/html/gsm/D830-M3-D1.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D838-M3-D1-KK.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D838-M3-D1.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D838-M9-D1-KK.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F350K-M3-D1-KK.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F350K-M3-D1.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F350L-M3-D1.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F350L-M9-D1.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F350S-M10-D1.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F350S-M3-D1.xml': ['LG', 'G Pro 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D680-M10-D1-KK.xml': ['LG', 'G Pro Lite', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D680-M10-D1.xml': ['LG', 'G Pro Lite', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D680-M3-D1-KK.xml': ['LG', 'G Pro Lite', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D680-M3-D1.xml': ['LG', 'G Pro Lite', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D681-M3-D1-KK.xml': ['LG', 'G Pro Lite', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D681-M3-D1.xml': ['LG', 'G Pro Lite', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D682-M3-D1.xml': ['LG', 'G Pro Lite', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D682TR-M3-D1.xml': ['LG', 'G Pro Lite', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D682TR-M5-D1.xml': ['LG', 'G Pro Lite', 'Android', DeviceType.MOBILE],
  'http://tool.xcdn.gdms.lge.com/html/uap/BZGZ3OH0HR/D682TR-M3-D1.xml': [
    'LG',
    'G Pro Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://gsm.lge.com/html/gsm/D685-M3-D1-KK.xml': ['LG', 'G Pro Lite Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D685-M3-D1.xml': ['LG', 'G Pro Lite Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D686-M3-D1-KK.xml': ['LG', 'G Pro Lite Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D686-M3-D1.xml': ['LG', 'G Pro Lite Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D686-M5-D1-KK.xml': ['LG', 'G Pro Lite Dual', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-BOOST/LS770ZV3.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-BOOST/LS770ZV4.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-BOOST/LS770ZV5.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-BOOST/LS770ZV7.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-BOOST/LS770ZV8.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-BOOST/LS770ZV9.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-BOOST/LS770ZVA.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-BOOST/LS770ZVB.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-BOOST/LS770ZVE.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-Chameleon/latest': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-SPRINT/LS770ZV4.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-SPRINT/LS770ZV5.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-SPRINT/LS770ZV7.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-SPRINT/LS770ZVB.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-SPRPRE/LS770ZV3.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-SPRPRE/LS770ZV4.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-VIRGIN/LS770ZV7.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-VIRGIN/LS770ZV9.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-VIRGIN/LS770ZVA.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS770-VIRGIN/LS770ZVB.rdf': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/5uyruBAm__1ZuYMa/H631-M10-D1.xml': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/b7_gceeg_u9fMBZq/H635-M10-D1.xml': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/b7_gceeg_u9fMBZq/H635-M5-D1.xml': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/b7_gceeg_u9fMBZq/H635-M6-D1.xml': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/b7_gceeg_u9fMBZq/H636-M10-D1.xml': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/b7_gceeg_u9fMBZq/H636-M3-D1.xml': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/uIJXil7N_tpYFHo7/LGMS631-M10-D1.xml': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/uIJXil7N_tpYFHo7/LGMS631-M3-D1.xml': ['LG', 'G Stylo', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/m9a8_OJx_S_kt06K/H740-M10-D1.xml': ['LG', 'G Vista 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-G1610.xml': ['LG', 'G1610', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-BOOST/LS980ZVC.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-BOOST/LS980ZVD.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-BOOST/LS980ZVG.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-BOOST/LS980ZVH.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-Chameleon/latest': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZV6.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZV7.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZV8.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZVA.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZVC.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZVD.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZVE.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZVG.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZVH.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/LS980ZVI.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS980-SPRINT/OpTimuS.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.comLS980ZV8.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.comLS980ZVG.rdf': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/01F-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/01F-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/01F-M9-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/980 4G-M12-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D800-M10-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D800-M10-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D800-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D800-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D801-M10-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D801-M10-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D801-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D801-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M1-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M1-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M10-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M10-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M2-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M20-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M20-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M4-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M5-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M5-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M6-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M6-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802-M9-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802T-M20-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802T-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802T-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802T-M5-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802TR-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802TR-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802TR-M5-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D802TR-M5-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D803-M10-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D803-M10-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D803-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D803-M6-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D803-M6-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D805-M10-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D805-M10-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D805-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D805-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D805-M5-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D806-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D806-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320K-M10-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320K-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320K-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320K-M9-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320L-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320L-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320L-M9-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320L-M9-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320S-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320S-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F320S-M9-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/G2-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/l01f-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/L01F-M9-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/L22-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/L22-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LS980-M10-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LS980-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LS980-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LS980-M9-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/M-PrVgyxvfGD20R_/D802-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/VS980-M3-D1-KK.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://tool.xcdn.gdms.lge.com/html/uap/C957NUJHUE/D802TR-M3-D1.xml': ['LG', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/618-M3-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/8-M3-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D610-M3-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D610AR-M3-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D610TR-M3-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D610TR-M5-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D618-M3-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D618-M4-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D620-M10-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D620-M3-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D620-M6-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D620r-M3-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D625-M10-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D625-M3-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D625-M5-D1.xml': ['LG', 'G2 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-G282.xml': ['LG', 'G282', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-BOOST/LS990ZVC.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-BOOST/LS990ZVF.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-Chameleon/latest': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZV4.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZV6.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZV8.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZVA.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZVB.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZVC.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZVE.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZVF.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZVG.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS990-SPRINT/LS990ZVI.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS995-SPRINT/LS990ZVA.rdf': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/%H:%M:%S/D855-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/%s/%s/%s/D855-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/985 4G-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D850-M10-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D850-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D851-M10-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D851-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D852-M10-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D852-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D852-M6-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D852-parrot-M10-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D852G-M10-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D852G-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D855-M1-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D855-M10-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D855-M20-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D855-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D855-M4-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D855-M5-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D855-M6-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D855A-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D855K-M20-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D856-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D858-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D858HK-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F400K-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F400L-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F400S-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/G3-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LS990-M10-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LS990-M3-D1.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/LG/LG_LG-D859_3_20140707.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://pix.cspire.com/UA/profile/lg/as990/as990.xml': ['LG', 'G3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D727-M10-D1.xml': ['LG', 'G3 Beat', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D728-M3-D1.xml': ['LG', 'G3 Beat', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F470S-M3-D1.xml': ['LG', 'G3 Beat', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/HD_8T0W9FihEqY5S/D727-M10-D1.xml': ['LG', 'G3 Beat', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/LG/LG_LG-D729_2_20140627.xml': ['LG', 'G3 Beat', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F460K-M10-D1.xml': ['LG', 'G3 Cat.6', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F460L-M9-D1.xml': ['LG', 'G3 Cat.6', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F460S-M10-D1.xml': ['LG', 'G3 Cat.6', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS885-Chameleon/latest': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS885-SPRINT/LS885ZV4.rdf': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS885-SPRINT/LS885ZV5.rdf': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D722-M3-D1.xml': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D722-M5-D1.xml': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D722-M6-D1.xml': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D722v-M3-D1.xml': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D723-M3-D1.xml': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D723-M5-D1.xml': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D724-M3-D1.xml': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D725-M10-D1.xml': ['LG', 'G3 mini', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F460K-M3-D1.xml': ['LG', 'G3 Prime', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F460L-M3-D1.xml': ['LG', 'G3 Prime', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F460S-M3-D1.xml': ['LG', 'G3 Prime', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D722-M10-D1.xml': ['LG', 'G3 S', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D722AR-M3-D1.xml': ['LG', 'G3 S', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D690-M3-D1.xml': ['LG', 'G3 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D690n-M3-D1.xml': ['LG', 'G3 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D693-M3-D1.xml': ['LG', 'G3 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D693n-M10-D1.xml': ['LG', 'G3 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D693n-M3-D1.xml': ['LG', 'G3 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D693TR-M3-D1.xml': ['LG', 'G3 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D693TR-M5-D1.xml': ['LG', 'G3 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/RNTp_ElEPgL_QrBQ/D690-M3-D1.xml': ['LG', 'G3 Stylus', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS885-SPRINT/LS885ZV6.rdf': ['LG', 'G3 Vigor', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D631-M10-D1.xml': ['LG', 'G3 Vista', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS991-Chameleon/latest': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/H815-M3-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/H818P-M3-D1-KK.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Qf23_I29ZbHl2AuA/H815-M5-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Qf23_I29ZbHl2AuA/H815-M6-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Qf23_I29ZbHl2AuA/H818-M3-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H810-M10-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H810-M3-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H811-M10-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H811-M3-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H812-M10-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H815-M10-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H815-M20-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H815-M3-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H815-M4-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H815-M5-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H815-M6-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H815K-M20-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H815P-M3-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H818-M3-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H818-M4-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H818-M5-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/H819-M3-D1.xml': ['LG', 'G4', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/eNsCGw_apwMhnXPM/H900-M10-D1.xml': ['LG', 'G4 Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/_W4s8Utf_eec5qYV/H900-M10-D1.xml': ['LG', 'G4 Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/-pBWguyi4C2qxxHn/H540-M3-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/-pBWguyi4C2qxxHn/H540-M4-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/-pBWguyi4C2qxxHn/H540-M5-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/-pBWguyi4C2qxxHn/H542-M10-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/-pBWguyi4C2qxxHn/H542-M3-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/-pBWguyi4C2qxxHn/H542-M5-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/b7_gceeg_u9fMBZq/H630-M3-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/b7_gceeg_u9fMBZq/H630D-M3-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/b7_gceeg_u9fMBZq/H635-M3-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/b7_gceeg_u9fMBZq/H635A-M3-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/H540-M3-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/H542-M10-D1.xml': ['LG', 'G4 Stylus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MX_LG_G4015.xml': ['LG', 'G4015', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-G4020.xml': ['LG', 'G4020', null, DeviceType.MOBILE],
  'http://fr.lge.com/gsm/LG-G4050.xml': ['LG', 'G4050', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/1XolXoCnSn7_dGTS/H525n-M10-D1.xml': ['LG', 'G4c', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/1XolXoCnSn7_dGTS/H525n-M6-D1.xml': ['LG', 'G4c', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/3p7OIw-_p_OSTTKo/H734-M3-D1.xml': ['LG', 'G4s', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/3p7OIw-_p_OSTTKo/H735-M10-D1.xml': ['LG', 'G4s', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/3p7OIw-_p_OSTTKo/H735-M20-D1.xml': ['LG', 'G4s', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/3p7OIw-_p_OSTTKo/H735-M3-D1.xml': ['LG', 'G4s', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/3p7OIw-_p_OSTTKo/H735-M5-D1.xml': ['LG', 'G4s', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/3p7OIw-_p_OSTTKo/H735-M6-D1.xml': ['LG', 'G4s', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/3p7OIw-_p_OSTTKo/H736-M3-D1.xml': ['LG', 'G4s', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H735-M3-D1.xml': ['LG', 'G4s', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H736-M3-D1.xml': ['LG', 'G4s', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-G5400.xml': ['LG', 'G5400', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-G650.xml': ['LG', 'G650', null, DeviceType.MOBILE],
  'http://fr.lge.com/gsm/LG-G7050.xml': ['LG', 'G7050', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-G7200.xml': ['LG', 'G7200', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-G912.xml': ['LG', 'G912', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-UAP-GB270-v0.1.xml': ['LG', 'GB270', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GD510.xml': ['LG', 'GD510 Pop', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GD880-3G-M6-D2CL.xml': ['LG', 'GD880', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GD880-M3-D1.xml': ['LG', 'GD880', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GD880-M6-D1.xml': ['LG', 'GD880', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GD880-M6-D2CL.xml': ['LG', 'GD880', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GM200.xml': ['LG', 'GM200 Brio', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GM360-NS.xml': ['LG', 'GM360 Viewty Snap', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GM360.xml': ['LG', 'GM360 Viewty Snap', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GM630.xml': ['LG', 'GM630', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GM730.xml': ['LG', 'GM730', 'Windows Mobile', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GM750Q.xml': ['LG', 'GM750 Smart', 'Windows Mobile', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GR500.xml': ['LG', 'GR500 Xenon', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GS290.xml': ['LG', 'GS290 Cookie Fresh', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GS390.xml': ['LG', 'GS390 Prime', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT400-M6-D2CL.xml': ['LG', 'GT400', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GT500-TMO.xml': ['LG', 'GT500 Puccini', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GT505-ORG.xml': ['LG', 'GT505', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GT505.xml': ['LG', 'GT505', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GW300.xml': ['LG', 'GW300', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GW550.xml': ['LG', 'GW550', 'Windows Mobile', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GW620-M6-D1.xml': ['LG', 'GW620 Eve', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F310L-M3-D1-KK.xml': ['LG', 'GX', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F310L-M3-D1.xml': ['LG', 'GX', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F310L-M9-D1-KK.xml': ['LG', 'GX', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F310LR-M3-D1-KK.xml': ['LG', 'GX', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F310LR-M9-D1-KK.xml': ['LG', 'GX', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-GX500.xml': ['LG', 'GX500', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-HB620T.xml': ['LG', 'HB620T', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lge/vs950/vs950.xml': ['LG', 'Intuition', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGL22C-M12-D1.xml': ['LG', 'isai', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/L24-M3-D1.xml': ['LG', 'isai FL', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/YSdHbanpHC5h2R_E/V32-M3-D1.xml': [
    'LG',
    'isai vivid LGV32',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://gsm.lge.com/html/gsm/H220-M5-D1.xml': ['LG', 'Joy', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/H221AR-M3-D1.xml': ['LG', 'Joy', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/JMVnyLlmw2NR0pk1/H220-M3-D1.xml': ['LG', 'Joy', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/JMVnyLlmw2NR0pk1/H220-M5-D1.xml': ['LG', 'Joy', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/JMVnyLlmw2NR0pk1/H221-M10-D1.xml': ['LG', 'Joy', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/JMVnyLlmw2NR0pk1/H221AR-M3-D1.xml': ['LG', 'Joy', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/JMVnyLlmw2NR0pk1/H222-M3-D1.xml': ['LG', 'Joy', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KB770-VDF3G.xml': ['LG', 'KB770', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KC550.xml': ['LG', 'KC550', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KC780.xml': ['LG', 'KC780', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KC910-VDF.xml': ['LG', 'KC910', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KC910-VDF3G.xml': ['LG', 'KC910 Renoir', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KC910.xml': ['LG', 'KC910 Renoir', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KC910i.xml': ['LG', 'KC910i Renoir', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KE260-V08f.xml': ['LG', 'KE260', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KE500.xml': ['LG', 'KE500', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KE600E.xml': ['LG', 'KE600', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KE770.xml': ['LG', 'KE770 Shine', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KE820.xml': ['LG', 'KE820', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KE850.xml': ['LG', 'KE850 Prada', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KE970.xml': ['LG', 'KE970 Shine', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KE990.xml': ['LG', 'KE990 Viewty', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF240.xml': ['LG', 'KF240', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF245.xml': ['LG', 'KF245', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF300.xml': ['LG', 'KF300', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF310-H3G.xml': ['LG', 'KF310', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF310-VDF3G.xml': ['LG', 'KF310', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF311-DRM-2.xml': ['LG', 'KF311', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF390.xml': ['LG', 'KF390', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF510.xml': ['LG', 'KF510', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF600.xml': ['LG', 'KF600', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF700.xml': ['LG', 'KF700', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF750-OPEN1.xml': ['LG', 'KF750 Secret', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF750-VDF3G.xml': ['LG', 'KF750 Secret', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF755.xml': ['LG', 'KF755', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KF900.xml': ['LG', 'KF900 Prada II', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG119.xml': ['LG', 'KG119', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG190.xml': ['LG', 'KG190', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG200.xml': ['LG', 'KG200', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG200j.xml': ['LG', 'KG200', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG208.xml': ['LG', 'KG208', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG280.xml': ['LG', 'KG280', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG290UAE.xml': ['LG', 'KG290', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG296.xml': ['LG', 'KG296', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG300j.xml': ['LG', 'KG300', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG70.xml': ['LG', 'KG70 Shine', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG77.xml': ['LG', 'KG77 Shine', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG90.xml': ['LG', 'KG90', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG920.xml': ['LG', 'KG920', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KG98.xml': ['LG', 'KG98', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KM380.xml': ['LG', 'KM380', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KM500.xml': ['LG', 'KM500', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KM501.xml': ['LG', 'KM501', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KM553.xml': ['LG', 'KM553', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KM900N.xml': ['LG', 'KM900', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KM900.xml': ['LG', 'KM900 Arena', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP110.xml': ['LG', 'KP110', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP130.xml': ['LG', 'KP130', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP135.xml': ['LG', 'KP135', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-UAP-KP199-v0.1.xml': ['LG', 'KP199', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP202.xml': ['LG', 'KP202', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP210.xml': ['LG', 'KP210', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP215.xml': ['LG', 'KP215', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-UAP-KP220-v0.1.xml': ['LG', 'KP220', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP230.xml': ['LG', 'KP230', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP233.xml': ['LG', 'KP233', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP260.xml': ['LG', 'KP260', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP265.xml': ['LG', 'KP265', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP270-3G.xml': ['LG', 'KP270', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP275.xml': ['LG', 'KP275', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP320.xml': ['LG', 'KP320', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP500.xml': ['LG', 'KP500 Cookie', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP501.xml': ['LG', 'KP500 Cookie', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KP570.xml': ['LG', 'KP570 Cookie', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/KS10.xml': ['LG', 'KS10 JOY', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KS20.xml': ['LG', 'KS360', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KS360-V10d.xml': ['LG', 'KS360', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KS360.xml': ['LG', 'KS360', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KS500-VDF3G.xml': ['LG', 'KS500', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KT520-OPEN1.xml': ['LG', 'KT520', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU250.xml': ['LG', 'KU250', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU380-v10a.xml': ['LG', 'KU380', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU380-v10b.xml': ['LG', 'KU380', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU580-CA.xml': ['LG', 'KU580', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU970-CA.xml': ['LG', 'KU970 Shine', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU970.xml': ['LG', 'KU970 Shine', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU990-3G.xml': ['LG', 'KU990', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU990-VDF3G.xml': ['LG', 'KU990 Viewty', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU990.xml': ['LG', 'KU990 Viewty', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-KU990i.xml': ['LG', 'KU990 Viewty', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D331-M6-D1.xml': ['LG', 'L Bello', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D335-M3-D1.xml': ['LG', 'L Bello', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D337-M3-D1.xml': ['LG', 'L Bello', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/RNTp_ElEPgL_QrBQ/D335-M3-D1.xml': ['LG', 'L Bello', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/RNTp_ElEPgL_QrBQ/D335-M5-D1.xml': ['LG', 'L Bello', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/U_EOJw1JxwmQJceD/31-M10-D1.xml': ['LG', 'L Bello', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/U_EOJw1JxwmQJceD/D331-M5-D1.xml': ['LG', 'L Bello', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/U_EOJw1JxwmQJceD/D335-M3-D1.xml': ['LG', 'L Bello', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/U_EOJw1JxwmQJceD/D335E-M3-D1.xml': ['LG', 'L Bello', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D290-M10-D1.xml': ['LG', 'L Fino', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D290-M3-D1.xml': ['LG', 'L Fino', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D290-M5-D1.xml': ['LG', 'L Fino', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D295-M3-D1.xml': ['LG', 'L Fino', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/U_EOJw1JxwmQJceD/D337-M3-D1.xml': ['LG', 'L Prime', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-L1100.xml': ['LG', 'L1100', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MX_LG_L1150.xml': ['LG', 'L1150', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-L1200.xml': ['LG', 'L1200', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG_L1400.xml': ['LG', 'L1400', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D100-M10-D1.xml': ['LG', 'L20', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D100-M3-D1.xml': ['LG', 'L20', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D100AR-M3-D1.xml': ['LG', 'L20', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D105-M3-D1.xml': ['LG', 'L20', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D107-M3-D1.xml': ['LG', 'L20', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D120-M10-D1.xml': ['LG', 'L30', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D120-M3-D1.xml': ['LG', 'L30', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D123-M3-D1.xml': ['LG', 'L30', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D125-M3-D1.xml': ['LG', 'L30', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D125f-M3-D1.xml': ['LG', 'L30', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D127-M3-D1.xml': ['LG', 'L30', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D120AR-M3-D1.xml': ['LG', 'L30 Sporty', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D150-M5-D1.xml': ['LG', 'L35', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D157f-M3-D1.xml': ['LG', 'L35', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGL35G-M6-D1.xml': ['LG', 'L35G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/34C-M11-D1.xml': ['LG', 'L40', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D160-M10-D1.xml': ['LG', 'L40', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D160-M20-D1.xml': ['LG', 'L40', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D160-M3-D1.xml': ['LG', 'L40', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D160-M6-D1.xml': ['LG', 'L40', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D170-M3-D1.xml': ['LG', 'L40', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D175f-M3-D1.xml': ['LG', 'L40', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/L34C-M12-D1.xml': ['LG', 'L40', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/X130g-M10-D1.xml': ['LG', 'L40', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D227-M3-D1.xml': ['LG', 'L50', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D213-M10-D1.xml': ['LG', 'L50 Sporty', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D213-M3-D1.xml': ['LG', 'L50 Sporty', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-L5100.xml': ['LG', 'L5100', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/X135-M10-D1.xml': ['LG', 'L60', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/X140-M10-D1.xml': ['LG', 'L60', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/X145-M10-D1.xml': ['LG', 'L60', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/X147-M10-D1.xml': ['LG', 'L60', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-L600V.xml': ['LG', 'L600v', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/X137-M10-D1.xml': ['LG', 'L60i', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D280-M10-D1.xml': ['LG', 'L65', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D280-M3-D1.xml': ['LG', 'L65', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D280-M5-D1.xml': ['LG', 'L65', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D285-M3-D1.xml': ['LG', 'L65', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/321-M10-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D320-M10-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D320-M2-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D320-M3-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D320-M5-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D320-M6-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D320AR-M3-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D320n-M3-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D321-M10-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D325-M3-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D325-M4-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D325f-M3-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGAS323-M10-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGL41C-M12-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGMS323-M10-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGMS323-M3-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MS323-M10-D1.xml': ['LG', 'L70', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D340f8-M3-D1.xml': ['LG', 'L70 Tri', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D373-M10-D1.xml': ['LG', 'L80', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D373-M3-D1.xml': ['LG', 'L80', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D380-M3-D1.xml': ['LG', 'L80', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D385-M3-D1.xml': ['LG', 'L80', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D331-M3-D1.xml': ['LG', 'L80+', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/U_EOJw1JxwmQJceD/D331-M10-D1.xml': ['LG', 'L80+', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/U_EOJw1JxwmQJceD/D331-M3-D1.xml': ['LG', 'L80+', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D400-M10-D1.xml': ['LG', 'L90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D400-M3-D1.xml': ['LG', 'L90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D405-M10-D1.xml': ['LG', 'L90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D405-M3-D1.xml': ['LG', 'L90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D405-M5-D1.xml': ['LG', 'L90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D405-M6-D1.xml': ['LG', 'L90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D410-M3-D1.xml': ['LG', 'L90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D415-M10-D1.xml': ['LG', 'L90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D415-M3-D1.xml': ['LG', 'L90', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGL996L-M10-D1.xml': ['LG', 'L996L', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/0W_43_22MIQ_HNMe/H340-M10-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/0W_43_22MIQ_HNMe/H340-M3-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/0W_43_22MIQ_HNMe/H340AR-M3-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/0W_43_22MIQ_HNMe/H340n-M10-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/0W_43_22MIQ_HNMe/H340n-M3-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/0W_43_22MIQ_HNMe/H340n-M5-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/0W_43_22MIQ_HNMe/H340n-M6-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/0W_43_22MIQ_HNMe/H342-M3-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/RNTp_ElEPgL_QrBQ/H320-M10-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/RNTp_ElEPgL_QrBQ/H320-M3-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/RNTp_ElEPgL_QrBQ/H320-M5-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/RNTp_ElEPgL_QrBQ/H326-M3-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/yObOcsVFUyAgTj5W/H345-M10-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/yObOcsVFUyAgTj5W/LGMS345-M10-D1.xml': ['LG', 'Leon', 'Android', DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/LGE_LG160P.rdf': ['LG', 'LG160', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/LGE_LG160V.rdf': ['LG', 'LG160', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG200.rdf': ['LG', 'LG200', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG245-0.rdf': ['LG', 'LG245', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/LGE_LG260.rdf': ['LG', 'LG260', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/LGE_LG280.rdf': ['LG', 'LG280', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG285-1.rdf': ['LG', 'LG285', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/LGE_LG385.rdf': ['LG', 'LG385', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-LG440G.xml': ['LG', 'LG440G', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/lg4600.rdf': ['LG', 'LG4600', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG490-0.rdf': ['LG', 'LG490', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-LG530G.xml': ['LG', 'LG530G', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_LG_LG5400_LG540V05.rdf': ['LG', 'LG5400', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/lg5450.rdf': ['LG', 'LG5450', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_LGE_LG550_CX55BL10.rdf': ['LG', 'LG550', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/LGE_LG570V.rdf': ['LG', 'LG570', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/LGE_LG600.rdf': ['LG', 'LG600', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/lg6070.rdf': ['LG', 'LG6070', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/lg6190.rdf': ['LG', 'LG6190', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_LG_LG6200_CX62BE07.rdf': ['LG', 'LG6200', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/LGE_LG830.rdf': ['LG', 'LG830', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-LG840G.xml': ['LG', 'LG840G', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG8500-0.rdf': ['LG', 'LG8500 Chocolate', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG8600-1.rdf': ['LG', 'LG8600 Chocolate Flip', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_LGE_LG8700_CX87BL04.rdf': ['LG', 'LG8700', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG8800-0.rdf': ['LG', 'LG8800 Venus', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG9100-0.rdf': ['LG', 'LG9100 Keybo', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG9700-0.rdf': ['LG', 'LG9700 Dare', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LN280-PLB/LN280ZV3.rdf': ['LG', 'LN280', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LX600/LX600V07.rdf': ['LG', 'Lotus LX600', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LX600/LX600V08.rdf': ['LG', 'Lotus LX600', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lge/vs840/vs840.xml': ['LG', 'Lucid', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Z9L2LsF6CK0ZCabE/LGL16C-M12-D1.xml': ['LG', 'Lucky', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/LG/LX-140/VMU_lx140_UAProf.xml': ['LG', 'LX140 Aloha', null, DeviceType.MOBILE],
  'http://uaprof.vmobl.com/LG/lx165/VMU_lx165_UAProf.xml': ['LG', 'LX165 Flare', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LX400/LX400V13.rdf': ['LG', 'LX400', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/5350/LX5350_11.rdf': ['LG', 'LX5350', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LX610/LX610V05.rdf': ['LG', 'LX610', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS860-2011011301/LS860ZV7.rdf': ['LG', 'Mach', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS860-BOOST/LS860ZV8.rdf': ['LG', 'Mach', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS860-Chameleon/latest': ['LG', 'Mach', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS860-SPRINT/LS860ZV7.rdf': ['LG', 'Mach', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS860-SPRINT/LS860ZV8.rdf': ['LG', 'Mach', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/1XolXoCnSn7_dGTS/H520-M10-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/1XolXoCnSn7_dGTS/H520-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/1XolXoCnSn7_dGTS/H522-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/1XolXoCnSn7_dGTS/H525-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/1XolXoCnSn7_dGTS/H525-M5-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/1XolXoCnSn7_dGTS/H525n-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/1XolXoCnSn7_dGTS/H525n-M5-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Dsi6X_y8P_In4gbf/H500-M10-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Dsi6X_y8P_In4gbf/H500-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Dsi6X_y8P_In4gbf/H500-M6-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Dsi6X_y8P_In4gbf/H502-M10-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Dsi6X_y8P_In4gbf/H502-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/H500-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/H522-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/H522F-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/RNTp_ElEPgL_QrBQ/H502-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/RNTp_ElEPgL_QrBQ/H522-M3-D1.xml': ['LG', 'Magna', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG855ABC/LG855ZV3.rdf': ['LG', 'Marquee', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG855ABC/LG855ZV4.rdf': ['LG', 'Marquee', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS855/LS855ZV1.rdf': ['LG', 'Marquee', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS855/LS855ZV9.rdf': ['LG', 'Marquee', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS855/LS855ZVC.rdf': ['LG', 'Marquee', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-ME591D.xml': ['LG', 'ME591', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-ME770.xml': ['LG', 'ME770 Shine', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-MG101.xml': ['LG', 'MG101', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-MG150.xml': ['LG', 'MG150', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-MG170.xml': ['LG', 'MG170', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-MG200.xml': ['LG', 'MG200', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-MG220.xml': ['LG', 'MG220', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-MG225d.xml': ['LG', 'MG225', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-MG235.xml': ['LG', 'MG235', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-MG280.xml': ['LG', 'MG280', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-MG800c.xml': ['LG', 'MG800 Chocolate', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/MM535/MM535V24.rdf': ['LG', 'MM-535', null, DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/LG-MS770.xml': ['LG', 'Motion 4G', 'Android', DeviceType.MOBILE],
  'https://servicios.iusacell.com.mx/lg/mx200v1.xml': ['LG', 'MX200', null, DeviceType.MOBILE],
  'https://servicios.iusacell.com.mx/lg/MX210/MX210v1.xml': ['LG', 'MX210', null, DeviceType.MOBILE],
  'https://servicios.iusacell.com.mx/lg/MX275/mx275v1.xml': ['LG', 'MX275', null, DeviceType.MOBILE],
  'https://servicios.iusacell.com.mx/lg/mx500v1.xml': ['LG', 'MX500', null, DeviceType.MOBILE],
  'https://servicios.iusacell.com.mx/lg/MX8500/mx8500v1.xml': ['LG', 'MX8500', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P930-M6-D1-ICS.xml': ['LG', 'Nitro HD', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P930-M6-D1.xml': ['LG', 'Nitro HD', 'Android', DeviceType.MOBILE],
  'http://mobileuaprof.xtra.co.nz/NX550.rdf': ['LG', 'NX550', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540_M6_D2_CL.xml': ['LG', 'Optimus', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-P990h-M10-D1.xml': ['LG', 'Optimus 2X Speed', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P990-M3-D2.xml': ['LG', 'Optimus 2X Speed', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P990-M6-D1-ICS.xml': ['LG', 'Optimus 2X Speed', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P990-M6-D2.xml': ['LG', 'Optimus 2X Speed', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P990h-M10-D1.xml': ['LG', 'Optimus 2X Speed', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P990hN-M6-D1-ICS.xml': ['LG', 'Optimus 2X Speed', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P990hN-M6-D1.xml': ['LG', 'Optimus 2X Speed', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P920-M3-D2-ICS.xml': ['LG', 'Optimus 3D', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P920-M3-D2.xml': ['LG', 'Optimus 3D', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P920-M6-D2.xml': ['LG', 'Optimus 3D', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P920h-M3-D2.xml': ['LG', 'Optimus 3D', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P725-M3-D2.xml': ['LG', 'Optimus 3D Max', 'Android', DeviceType.MOBILE],
  'http://device.telusmobility.com/lg/LG-CX670-0.rdf': ['LG', 'Optimus 3G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P880-M10-D1.xml': ['LG', 'Optimus 4X HD', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P880-M3-D1.xml': ['LG', 'Optimus 4X HD', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P880-M3-D2.xml': ['LG', 'Optimus 4X HD', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P880-M6-D2.xml': ['LG', 'Optimus 4X HD', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P880g-M10-D1.xml': ['LG', 'Optimus 4X HD', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P880g-M3-D1.xml': ['LG', 'Optimus 4X HD', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/L85C/LGL85CV1.rdf': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-P970-M3-D2.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-P970-M6-D2.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-P970h-M10-D1.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-P970h-M3-D1.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-P970h-M6-D1.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P970-M10-D2.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P970-M3-D2.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P970-M6-D2.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P970g-M10-D1.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P970h-M3-D2.xml': ['LG', 'Optimus Black', 'Android', DeviceType.MOBILE],
  'http://mms.cleartalk.co/sam-r720.xml?source=web': ['LG', 'Optimus C', 'Android', DeviceType.MOBILE],
  'http://wapuaprof.wap.mycricket.com/lg/LW690.xml': ['LG', 'Optimus C', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C550-M6-D2.xml': ['LG', 'Optimus Chat', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C555-M10-D1.xml': ['LG', 'Optimus Chat', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-E720-M6-D2.xml': ['LG', 'Optimus Chic', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-E720b-M6-D1.xml': ['LG', 'Optimus Chic', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P720-M3-D2.xml': ['LG', 'Optimus Chic', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P720h-M3-D2.xml': ['LG', 'Optimus Chic', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGL38C-M12-D1.xml': ['LG', 'Optimus Dynamic', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/L39C-M12-D1.xml': ['LG', 'Optimus Dynamic II', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/LG/VM696-VMUB/1.0/UAProf.xml': ['LG', 'Optimus Elite', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/L40g-M6-D1.xml': ['LG', 'Optimus Extreme', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-2011011301/LS720ZV8.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-2012083001/LS720ZV8.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-BOOST//LG/LS720-BOOST/LS720ZV8.rdf': [
    'LG',
    'Optimus F3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/LG/LS720-BOOST/LS720ZV6.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-BOOST/LS720ZV8.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-Chameleon/latest': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-SPRINT/LS720Z06.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-SPRINT/LS720ZV7.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-SPRINT/LS720ZV8.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-VIRGIN//LG/LS720-VIRGIN/LS720ZV8.rdf': [
    'LG',
    'Optimus F3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/LG/LS720-VIRGIN/LS720ZV5.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-VIRGIN/LS720ZV6.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-VIRGIN/LS720ZV7.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS720-VIRGIN/LS720ZV8.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MS659-M10-D1.xml': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P655H-M3-D1.xml': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P659-M10-D1.xml': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/LG/LS720-VIRGIN/LS720ZV6.rdf': ['LG', 'Optimus F3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D520-M10-D1.xml': ['LG', 'Optimus F3Q', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P875-M10-D1.xml': ['LG', 'Optimus F5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P875-M3-D1.xml': ['LG', 'Optimus F5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P875h-M3-D1.xml': ['LG', 'Optimus F5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D500-M10-D1.xml': ['LG', 'Optimus F6', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D500-M3-D1-KK.xml': ['LG', 'Optimus F6', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D505-M3-D1-KK.xml': ['LG', 'Optimus F6', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D505-M3-D1.xml': ['LG', 'Optimus F6', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D505-M6-D1-KK.xml': ['LG', 'Optimus F6', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MS500-M10-D1-KK.xml': ['LG', 'Optimus F6', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MS500-M10-D1.xml': ['LG', 'Optimus F6', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG870-BOOST/LG870ZV1.rdf': ['LG', 'Optimus F7', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG870-BOOST/LG870ZV4.rdf': ['LG', 'Optimus F7', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG870-BOOST/LG870ZV5.rdf': ['LG', 'Optimus F7', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG870-Chameleon/latest': ['LG', 'Optimus F7', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG870-SPRINT/LG870ZV4.rdf': ['LG', 'Optimus F7', 'Android', DeviceType.MOBILE],
  'http://mms.ntwls.net/uaprofs/AS780.xml': ['LG', 'Optimus F7', 'Android', DeviceType.MOBILE],
  'http://pix.cspire.com/UA/profile/lg/as780/as780.xml': ['LG', 'Optimus F7', 'Android', DeviceType.MOBILE],
  'http://uaprof.ntelospcs.net/AS780.xml': ['LG', 'Optimus F7', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS970-2011011301/LS970ZVC.rdf': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS970-Chameleon/latest': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS970-SPRINT/LS970ZV7.rdf': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS970-SPRINT/LS970ZV9.rdf': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS970-SPRINT/LS970ZVA.rdf': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS970-SPRINT/LS970ZVB.rdf': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS970-SPRINT/LS970ZVC.rdf': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/ Optimus G-M3-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E970-M3-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E970-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E970-M6-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E971-M10-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E973-M10-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E973-M6-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E973-parrot-M10-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E975-M10-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E975-M3-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E975-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E975-M5-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E975-M6-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E975K-M20-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E975K-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E975T-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E975w-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E976-M10-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E976-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E977-M3-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E977-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E987-M3-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E987-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F180-M3-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F180K-M10-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F180K-M3-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F180K-M9-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F180L-M3-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F180L-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F180S-M3-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F180S-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F180S-M9-D1-KK.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LS970-M3-D1.xml': ['LG', 'Optimus G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/980 4G-M12-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/980 4G-M3-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/980 4G-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E980-M10-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E980-M10-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E980-M3-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E980-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E980-M9-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E980h-M10-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E980h-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E981h-M3-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E981h-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E985-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E985T-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E986-M3-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E986-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E986-M5-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E988-M3-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E988-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E988-M5-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E988-M9-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E989-M3-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E989-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F240K-M3-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F240L-M10-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F240L-M3-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F240L-M3-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F240L-M9-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F240S-M3-D1-KK.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/VS980-M10-D1.xml': ['LG', 'Optimus G Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F220K-M3-D1-KK.xml': ['LG', 'Optimus GK', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F220K-M9-D1-KK.xml': ['LG', 'Optimus GK', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540f_M3_D1_J.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540f_MR_M3_D1_J.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540_M3_D2_CL.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540_M6_D1_J.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540_M6_D2_CL_J.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540_M6_D2_CL_J_Y.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540_MR_M3_D2_CL.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540_MR_M3_D2_CL_J.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540_MR_M6_D1_J.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/GT540_MR_M6_D2_CL_J.xml': ['LG', 'Optimus GT540', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E510-M6-D2.xml': ['LG', 'Optimus Hub', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E510f-M6-D2.xml': ['LG', 'Optimus Hub', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E510g-M6-D2.xml': ['LG', 'Optimus Hub', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E410-M3-D1.xml': ['LG', 'Optimus L1 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E410B-M6-D1.xml': ['LG', 'Optimus L1 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E410f-M3-D1.xml': ['LG', 'Optimus L1 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E410g-M10-D1.xml': ['LG', 'Optimus L1 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E410g-M3-D1.xml': ['LG', 'Optimus L1 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E410i-M3-D1.xml': ['LG', 'Optimus L1 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E411g-M3-D1.xml': ['LG', 'Optimus L1 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E415f-M3-D1.xml': ['LG', 'Optimus L1 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E420-M3-D1.xml': ['LG', 'Optimus L1 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E475f-M3-D1.xml': ['LG', 'Optimus L1 II Tri', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E400-M6-D2.xml': ['LG', 'Optimus L3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E400b-M10-D1.xml': ['LG', 'Optimus L3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E400R-M6-D1.xml': ['LG', 'Optimus L3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E405-M6-D2.xml': ['LG', 'Optimus L3 Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E425-M3-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E425f-M10-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E425f-M20-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E425f-M3-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E425g-M3-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E430-M10-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E430-M3-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E430-M5-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E430-M6-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E431g-M3-D1.xml': ['LG', 'Optimus L3 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E435-M3-D1.xml': ['LG', 'Optimus L3 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E435f-M3-D1.xml': ['LG', 'Optimus L3 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E435g-M3-D1.xml': ['LG', 'Optimus L3 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E435k-M3-D1.xml': ['LG', 'Optimus L3 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E440-M3-D1.xml': ['LG', 'Optimus L4 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E440g-M10-D1.xml': ['LG', 'Optimus L4 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E465f-M3-D1.xml': ['LG', 'Optimus L4 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E465g-M3-D1.xml': ['LG', 'Optimus L4 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E445-M3-D1.xml': ['LG', 'Optimus L4 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E467f-M3-D1.xml': ['LG', 'Optimus L4 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E470f-M3-D1.xml': ['LG', 'Optimus L4 II Triple', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E610-M10-D1.xml': ['LG', 'Optimus L5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E610-M3-D1.xml': ['LG', 'Optimus L5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E610-M5-D1.xml': ['LG', 'Optimus L5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E610v-M3-D1.xml': ['LG', 'Optimus L5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E612f-M10-D1.xml': ['LG', 'Optimus L5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E612f-M3-D1.xml': ['LG', 'Optimus L5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E612g-M3-D1.xml': ['LG', 'Optimus L5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E617G-M6-D1.xml': ['LG', 'Optimus L5', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E615-M3-D1.xml': ['LG', 'Optimus L5 Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E615f-M3-D1.xml': ['LG', 'Optimus L5 Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E450-M3-D1.xml': ['LG', 'Optimus L5 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E450B-M6-D1.xml': ['LG', 'Optimus L5 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E450f-M10-D1.xml': ['LG', 'Optimus L5 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E450f-M3-D1.xml': ['LG', 'Optimus L5 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E460-M10-D1.xml': ['LG', 'Optimus L5 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E460-M3-D1.xml': ['LG', 'Optimus L5 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E460-M5-D1.xml': ['LG', 'Optimus L5 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E460-M6-D1.xml': ['LG', 'Optimus L5 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E460f-M3-D1.xml': ['LG', 'Optimus L5 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E455-M3-D1-KK.xml': ['LG', 'Optimus L5 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E455-M3-D1.xml': ['LG', 'Optimus L5 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E455f-M3-D1.xml': ['LG', 'Optimus L5 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P700-M3-D1.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P700-M6-D2.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P705-M3-D1.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P705-M6-D2.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P705f-M3-D1.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P705g-M10-D1.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P705g-M3-D1.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P705g-M6-D1.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P708g-M10-D1.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P708g-M3-D1.xml': ['LG', 'Optimus L7', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P710-M10-D1.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P710-M3-D1-KK.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P710-M3-D1.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P710-M5-D1.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P710-M6-D1.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P712-M3-D1.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P713-M3-D1-KK.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P713-M3-D1.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P713GO-M3-D1.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P713TR-M5-D1-KK.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P714-M10-D1-KK.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P714-M10-D1.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P714-M3-D1-KK.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P714-M3-D1.xml': ['LG', 'Optimus L7 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P715-M3-D1-KK.xml': ['LG', 'Optimus L7 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P715-M3-D1.xml': ['LG', 'Optimus L7 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P716-M3-D1-KK.xml': ['LG', 'Optimus L7 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P716-M3-D1.xml': ['LG', 'Optimus L7 II Dual', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D700-M6-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/MS769-M10-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P760-M6-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P765-M6-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P768-M10-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P768-M3-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P768-M6-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P769-M10-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P769-M3-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P778-M3-D1.xml': ['LG', 'Optimus L9', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D605-M3-D1-KK.xml': ['LG', 'Optimus L9 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D605-M3-D1.xml': ['LG', 'Optimus L9 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D605-M5-D1-KK.xml': ['LG', 'Optimus L9 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D605-M6-D1-KK.xml': ['LG', 'Optimus L9 II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P935-M10-D1-ICS.xml': ['LG', 'Optimus LTE', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P935-M10-D1.xml': ['LG', 'Optimus LTE', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P936-M3-D1.xml': ['LG', 'Optimus LTE', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F260S-M3-D1-KK.xml': ['LG', 'Optimus LTE III', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F260S-M9-D1-KK.xml': ['LG', 'Optimus LTE III', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/a_ygkA6q45TBK1IF/LGMS395-M10-D1.xml': [
    'LG',
    'Optimus M',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.metropcs.net/UAProf/LG-MS690.xml': ['LG', 'Optimus M', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/LG-MS695.xml': ['LG', 'Optimus M+', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P350-M6-D1.xml': ['LG', 'Optimus Me', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P350-M6-D2.xml': ['LG', 'Optimus Me', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P350f-M6-D1.xml': ['LG', 'Optimus Me', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P350g-M6-D1.xml': ['LG', 'Optimus Me', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/L45C/latest': ['LG', 'Optimus Net', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/L45C/LGL45CT1.rdf': ['LG', 'Optimus Net', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/L45C/LGL45CT2.rdf': ['LG', 'Optimus Net', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P690-M6-D2.xml': ['LG', 'Optimus Net', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P690b-M6-D1.xml': ['LG', 'Optimus Net', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P690f-M6-D1.xml': ['LG', 'Optimus Net', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P692-M6-D2.xml': ['LG', 'Optimus Net', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P698-M6-D2.xml': ['LG', 'Optimus Net', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P698f-M6-D2.xml': ['LG', 'Optimus Net', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P500-M6-D1.xml': ['LG', 'Optimus One', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P500h-M6-D1.xml': ['LG', 'Optimus One', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P500h_iw-M6-D1.xml': ['LG', 'Optimus One', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P500_iw-M6-D1.xml': ['LG', 'Optimus One', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P503-M6-D1.xml': ['LG', 'Optimus One', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P504-M10-D1.xml': ['LG', 'Optimus One', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C660-M6-D1.xml': ['LG', 'Optimus Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C660h-M6-D1-TCL.xml': ['LG', 'Optimus Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C660h-M6-D1-USC.xml': ['LG', 'Optimus Pro', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/C660h-M6-D1.xml': ['LG', 'Optimus Pro', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/L55C/LGL55CV1.rdf': ['LG', 'Optimus Q', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/L55C/LGL55CV3.rdf': ['LG', 'Optimus Q', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS670/LS670ZV8.rdf': ['LG', 'Optimus S', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS670/LS670ZV9.rdf': ['LG', 'Optimus S', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS670/LS670ZVD.rdf': ['LG', 'Optimus S', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS670/LS670ZVH.rdf': ['LG', 'Optimus S', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS670/LS670ZVJ.rdf': ['LG', 'Optimus S', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/LGE/VM701-VMUB/1.0/UAProf.xml': ['LG', 'Optimus Slider', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E730-M6-D2.xml': ['LG', 'Optimus Sol', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/E730f-M6-D2.xml': ['LG', 'Optimus Sol', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P509-M10-D1.xml': ['LG', 'Optimus T', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/lg/vm670/1.0/VMU_VM670_UAProf.xml': ['LG', 'Optimus V', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P895-M6-D2.xml': ['LG', 'Optimus Vu', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P895qb-M10-D1.xml': ['LG', 'Optimus Vu', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P895qb-M6-D2.xml': ['LG', 'Optimus Vu', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F200L-M3-D1-KK.xml': ['LG', 'Optimus Vu II', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P505-M6-D1.xml': ['LG', 'Phoenix', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P505R-M6-D1.xml': ['LG', 'Phoenix', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/PLS225/WL225V04.rdf': ['LG', 'PLS225', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/PLS350/LX35VN02.rdf': ['LG', 'PLS350', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/PM225/PM225V02.rdf': ['LG', 'PM-225', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/PM325/PM325V16.rdf': ['LG', 'PM-325', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P940-M6-D2.xml': ['LG', 'PRADA 3.0', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P940h-M6-D2.xml': ['LG', 'PRADA 3.0', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/qfss6rfI__J51f2o/LGL61AL-M10-D1.xml': ['LG', 'Premier', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LGLS620-Chameleon/latest': ['LG', 'Realm', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS620-BOOST/LS620ZV3.rdf': ['LG', 'Realm', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS620-BOOST/LS620ZV4.rdf': ['LG', 'Realm', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/xDR2-7TjP_4JVIDb/LGL43AL-M10-D1.xml': ['LG', 'Rebel', 'Android', DeviceType.MOBILE],
  'http://wapuaprof.wap.mycricket.com/lg/LG-LW770.xml': ['LG', 'Regard', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LX260/LX260V09.rdf': ['LG', 'Rumor LX260', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LX260/LX260V0a.rdf': ['LG', 'Rumor LX260', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG272/LG272ZV8.rdf': ['LG', 'Rumor Reflex', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LN272/LN272ZV4.rdf': ['LG', 'Rumor Reflex', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LN272/LN272ZV7.rdf': ['LG', 'Rumor Reflex', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LN272/LN272ZV8.rdf': ['LG', 'Rumor Reflex', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LN272S/LN272SV2.rdf': ['LG', 'Rumor Reflex S', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LN510/LN510ZVD.rdf': ['LG', 'Rumor Touch', 'Brew', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/lg/vm510/1.0/VMU_VM510_UAProf.xml': ['LG', 'Rumor Touch', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-S5300.xml': ['LG', 'S5300', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lge/vs920/vs920.xml': ['LG', 'Spectrum', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/lge/vs930/vs930.xml': ['LG', 'Spectrum 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H440-M3-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H440AR-M3-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H440n-M10-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H440n-M20-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H440n-M3-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H440n-M5-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H440n-M6-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/AK1bQ_G8_-S9ccPj/H442-M3-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/H440n-M3-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/ojFJqSe94jShCXCN/H443-M10-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/ojFJqSe94jShCXCN/H445-M3-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/yZxLjC9A3ey4GDAw/H420-M10-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/yZxLjC9A3ey4GDAw/H420-M3-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/yZxLjC9A3ey4GDAw/H420-M6-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/yZxLjC9A3ey4GDAw/H422-M3-D1.xml': ['LG', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/LG-MS870.xml': ['LG', 'Spirit 4G', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/_2YOMy__ZoqF7__g/LGL81AL-M10-D1.xml': ['LG', 'Stylo 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/L15G-M10-D1.xml': ['LG', 'Sunrise', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LGL15G-M10-D1.xml': ['LG', 'Sunrise', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/Q9h6lw8rC-nijrc6/LGL15G-M10-D1.xml': ['LG', 'Sunrise', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/yObOcsVFUyAgTj5W/LGL33L-M10-D1.xml': ['LG', 'Sunset', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T310i-M3-D1-NS.xml': ['LG', 'T310i', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T325-M3-D1.xml': ['LG', 'T325', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T370-M3-D1.xml': ['LG', 'T370', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T375-M3-D1.xml': ['LG', 'T375', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T375.xml': ['LG', 'T375', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T385.xml': ['LG', 'T385', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T385b-M3-D1.xml': ['LG', 'T385b', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T395.xml': ['LG', 'T395', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T500-M3-D1.xml': ['LG', 'T500', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T505-M3-D1.xml': ['LG', 'T505', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T510-M3-D1.xml': ['LG', 'T510', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T5100N.xml': ['LG', 'T5100', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T5100V.xml': ['LG', 'T5100', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T515-M3-D1.xml': ['LG', 'T515', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T565-M3-D1.xml': ['LG', 'T565', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T565b-M3-D1.xml': ['LG', 'T565b', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T580-M3-D1.xml': ['LG', 'T580', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T585-M3-D1.xml': ['LG', 'T585', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-T595-M3-D1.xml': ['LG', 'T595', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-TB200.xml': ['LG', 'TB200', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P925-M6-D1-ICS.xml': ['LG', 'Thrill', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P925-M6-D1.xml': ['LG', 'Thrill', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P925g-M6-D1-ICS.xml': ['LG', 'Thrill', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P925g-M6-D1.xml': ['LG', 'Thrill', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/D857-M3-D1.xml': ['LG', 'Titan', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/60XyU11_CW-MsU_c/LGL51AL-M10-D1.xml': [
    'LG',
    'Treasure',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://gsm.lge.com/html/gsm/LG-C333-M3-D1.xml': ['LG', 'Tri Chip C333', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-2012071301/LS660ZV5.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-2012071301/LS660ZV6.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-BOOST/LS660ZV4.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-BOOST/LS660ZV5.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-BOOST/LS660ZV6.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-Chameleon/latest': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-SPRPRE/LS660ZV3.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-SPRPRE/LS660ZV4.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-SPRPRE/LS660ZV5.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-VIRGIN/LS660ZV3.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-VIRGIN/LS660ZV4.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-VIRGIN/LS660ZV5.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS660-VIRGIN/LS660ZV6.rdf': ['LG', 'Tribute', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-TU575.xml': ['LG', 'TU575', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-TU720.xml': ['LG', 'TU720 Shine', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-TU915.xml': ['LG', 'TU915 Vu', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-U300.xml': ['LG', 'U300', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-U400.xml': ['LG', 'U400', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-U830.xml': ['LG', 'U830 Chocolate', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-U900.xml': ['LG', 'U900', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-U970.xml': ['LG', 'U970 Shine', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/eNsCGw_apwMhnXPM/H901-M3-D1.xml': ['LG', 'V10', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/eNsCGw_apwMhnXPM/H960-M10-D1.xml': ['LG', 'V10', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/eNsCGw_apwMhnXPM/H960-M3-D1.xml': ['LG', 'V10', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/eNsCGw_apwMhnXPM/H961N-M3-D1.xml': ['LG', 'V10', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/eNsCGw_apwMhnXPM/H968-M3-D1.xml': ['LG', 'V10', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/_W4s8Utf_eec5qYV/H900-M3-D1.xml': ['LG', 'V10', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG730-6100000231/LG730ZV5.rdf': ['LG', 'Venice', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG730-BOOST/LG730ZV5.rdf': ['LG', 'Venice', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG730-BOOST/LG730ZV6.rdf': ['LG', 'Venice', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG730-BOOST/LG730ZV8.rdf': ['LG', 'Venice', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LG730-Chameleon/latest': ['LG', 'Venice', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/VI125/VI125V10.rdf': ['LG', 'VI-125', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/VI5225/LX540V08.rdf': ['LG', 'VI-5225', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS840/LS840ZVC.rdf': ['LG', 'Viper', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS840/LS840ZVD.rdf': ['LG', 'Viper', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS840/LS840ZVI.rdf': ['LG', 'Viper', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS840/LS840ZVK.rdf': ['LG', 'Viper', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-2012071301/LS740ZV6.rdf': ['LG', 'Volt', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS740-SPRPRE/LS740ZV4.rdf': ['LG', 'Volt', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/LG/LS751-Chameleon/latest': ['LG', 'Volt 2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/F300L-M3-D1.xml': ['LG', 'Vu 3', 'Android', DeviceType.MOBILE],
  'http://mms.cellcom.com/uaprofs/lg-vx5000.xml': ['LG', 'VX5000', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx8350/vx8350.xml': ['LG', 'VX8350', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx8550/vx8550.xml': ['LG', 'VX8550 Chocolate', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx8600/vx8600.xml': ['LG', 'VX8600', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx8610/vx8610.xml': ['LG', 'VX8610 Decoy', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx8700/vx8700.xml': ['LG', 'VX8700', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx8800/vx8800.xml': ['LG', 'VX8800 Venus', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx9100/vx9100.xml': ['LG', 'VX9100 enV2', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx9400/vx9400.xml': ['LG', 'VX9400', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx9700/vx9700.xml': ['LG', 'VX9700 Dare', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/lg/vx9900/vx9900.xml': ['LG', 'VX9900 enV', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/sMGZI_CVcpnY_oHi/H410-M10-D1.xml': ['LG', 'Wine Smart', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/sMGZI_CVcpnY_oHi/H410-M3-D1.xml': ['LG', 'Wine Smart', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/sMGZI_CVcpnY_oHi/H410-M6-D1.xml': ['LG', 'Wine Smart', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/_aYtYmwT_LRbNYO_/LGL53BL-M10-D1.xml': ['LG', 'X Style', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/31L-M10-D1.xml': ['LG', 'X3', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-UAP-X330-v0.1.xml': ['LG', 'X330T', null, DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-X350.xml': ['LG', 'X350', 'MTK', DeviceType.MOBILE],
  'http://www.m4tel.com/product/profiles/uaprof/M4TEL_SS990GPRS.xml': [
    'M4Tel',
    'E-Motion',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4TEL_SS550GPRS.xml': [
    'M4Tel',
    'Genius',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS1060GPRS.xml': [
    'M4Tel',
    'M4Live',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS1080GPRS.xml': [
    'M4Tel',
    'Max One',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS1090GPRS.xml': [
    'M4Tel',
    'Max Ultra',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4TEL_SS880GPRS.xml': [
    'M4Tel',
    'Mirage',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS1070GPRS.xml': ['M4Tel', 'Sense', 'Android', DeviceType.MOBILE],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS1050GPRS.xml': [
    'M4Tel',
    'SS1050',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS4040GPRS.xml': [
    'M4Tel',
    'SS4040',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS4041GPRS.xml': [
    'M4Tel',
    'SS4041',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS4045GPRS.xml': [
    'M4Tel',
    'SS4045',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS4350GPRS.xml': [
    'M4Tel',
    'SS4350',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS4450GPRS.xml': [
    'M4Tel',
    'SS4450',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS4451GPRS.xml': [
    'M4Tel',
    'SS4451',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS4452GPRS.xml': [
    'M4Tel',
    'SS4452',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.m4tel.com/product/profiles/uaprof/M4_SS4456GPRS.xml': [
    'M4Tel',
    'SS4456',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-SKATE.xml, http://www.zte.com.cn/mobile/uaprof/ZTE-SKATE.xml': [
    'Medion',
    'Life P4310',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/MT7A.xml': ['MegaFon', 'Login', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/MegaFon_V9+.xml': ['MegaFon', 'V9+', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/smart_a17.xml': ['MEO', 'Smart A17', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/MEO Smart A40.xml': ['MEO', 'Smart A40', 'Android', DeviceType.MOBILE],
  'http://mobileupdate.sdt.pt/meo/WBW5518-UAProfile.xml': ['MEO', 'Smart A66', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_A104.xml': [
    'Micromax',
    'A104 Canvas Fire',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.oppo.com/resource/UA-PROF/OPPOA110Q.xml': ['Micromax', 'A110 Canvas 2', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_A177.xml': [
    'Micromax',
    'A177 Canvas Juice',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_A190.xml': [
    'Micromax',
    'A190 Canvas HD Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_A315.xml': [
    'Micromax',
    'A315 Canvas 4 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_A316.xml': [
    'Micromax',
    'A316 Canvas Hue 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://ibu.joy3g.org/ibu/MCX_A54_20121119_ua.xml': ['Micromax', 'A54 Ninja', 'Android', DeviceType.MOBILE],
  'http://ibu.joy3g.org/ibu/MCX_A56_20120522_ua.xml': ['Micromax', 'A56 Ninja 2', 'Android', DeviceType.MOBILE],
  'http://ibu.joy3g.org/ibu/MCX_A57_20120725_ua.xml': ['Micromax', 'A57 Ninja 3', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_A064.xml': [
    'Micromax',
    'A64 Bolt',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_A065.xml': [
    'Micromax',
    'A65 Smarty',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://ibu.joy3g.org/ibu/MCX_A87_20120725_ua.xml': ['Micromax', 'A87 Ninja 4', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_A093.xml': [
    'Micromax',
    'A93 Canvas Elanza',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_AQ5001.xml': [
    'Micromax',
    'AQ5001 Canvas Juice 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://202.58.121.191/MTK_Phone_KK_UAprofile.xml': ['Micromax', 'Canvas Tab P470', 'Android', DeviceType.TABLET],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_Q380.xml': [
    'Micromax',
    'Q380 Canvas Spark',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax Q391.xml': [
    'Micromax',
    'Q391 Canvas Doodle 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_Q394.xml': [
    'Micromax',
    'Q394 Canvas Juice 3+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.uniscope.com.cn/Micromax_Q415_UAprofile.xml': [
    'Micromax',
    'Q415 Spark Vdeo',
    'Android',
    DeviceType.MOBILE,
  ],
  'Micromax X450': ['Micromax', 'X450', null, DeviceType.MOBILE],
  'http://go.microsoft.com/fwlink/?LinkId=164226': ['Microsoft', 'Kin ONE', 'Kin OS', DeviceType.MOBILE],
  'http://zune.net/uaprof/ZuneHD.xml': ['Microsoft', 'Zune HD', null],
  'http://www.mio-tech.com.tw/download/smartphone/Mio8390r101.xml': ['Mio', '8390', null, DeviceType.MOBILE],
  'http://www.mio-tech.com.tw/download/smartphone/MioA700.xml': ['Mio', 'A700', null, DeviceType.MOBILE],
  'http://www.mio-tech.com.tw/download/smartphone/MioA701.xml': ['Mio', 'A701', null, DeviceType.MOBILE],
  'http://www.mitsubishi-telecom.com/profiles/eclipse.ua': ['Mitsubishi', 'Trium Eclipse', null, DeviceType.MOBILE],
  'http://www.mitsubishi-telecom.com/profiles/eclipse_mserv.ua': [
    'Mitsubishi',
    'Trium Eclipse',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.mitsubishi-telecom.com/profiles/mt560.ua': ['Mitsubishi', 'Trium M 320', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/M9000.xml': ['MobiFone', 'M9000', 'Android', DeviceType.MOBILE],
  'http://imatemms.imate.com/gen/UAProf_JAMA_v1.xml': ['MobileXP', 'JAMA', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/MOCHE SMART A16.xml': ['Moche', 'Smart A16', 'Android', DeviceType.MOBILE],
  'http://asmobile.ehosting.com.tw/uaprof/Virgin_1.xml': ['Modelabs', 'Virgin', null, DeviceType.MOBILE],
  'http://www.modumobile.com/ua/modu-t_1_browser.xml': ['Modu', 'T', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/moii_E598.xml': ['moii', 'E598', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Momodesign_MD_Droid.xml': [
    'Momodesign',
    'MD Droid',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/a1000/Profile/a1000.rdf': [
    'Motorola',
    'A1000',
    'UIQ',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/MOT/MOT_A3300c_4_20091029.xml': [
    'Motorola',
    'A3300',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/a780/Profile/a780.rdf': ['Motorola', 'A780', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/a840/a840v1.xml': ['Motorola', 'A840', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/MOT603KIT/551Q117PAX33.rdf': [
    'Motorola',
    'ADMIRAL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/MOT603KIT/551Q117PAX63.rdf': [
    'Motorola',
    'ADMIRAL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/MOT603KIT/551Q117PAX69.rdf': [
    'Motorola',
    'ADMIRAL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/MOT603KIT/551Q117PAX79.rdf': [
    'Motorola',
    'ADMIRAL',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb860/Profile/motomb860.rdf': [
    'Motorola',
    'ATRIX',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb860/Profile/motomb860emara.rdf': [
    'Motorola',
    'ATRIX',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb861/Profile/motomb861.rdf': [
    'Motorola',
    'ATRIX',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoME860/profile/MotoME860.rdf': [
    'Motorola',
    'ATRIX',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb865/Profile/motomb865.rdf': [
    'Motorola',
    'ATRIX 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt687/Profile/xt687.rdf': [
    'Motorola',
    'ATRIX TV',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoMB300/profile/MotoMB300.rdf': [
    'Motorola',
    'BACKFLIP',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb300/Profile/MotoMB300Eclair.rdf': [
    'Motorola',
    'BACKFLIP',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb300/Profile/motomb300la.rdf': [
    'Motorola',
    'BACKFLIP',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb520/Profile/MotoMB520.rdf': [
    'Motorola',
    'BRAVO',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb520/Profile/MotoMB520FroYo.rdf': [
    'Motorola',
    'BRAVO',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/ex118/Profile/EX118.rdf': [
    'Motorola',
    'Brea EX119',
    'MTK',
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/C168/Profile/c168.rdf': ['Motorola', 'C168', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/C168i/Profile/C168i-cingular.rdf': [
    'Motorola',
    'C168i',
    null,
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/C290/2440.rdf': ['Motorola', 'C290', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/c357/Profile/c357.rdf': ['Motorola', 'C357', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motomb502/Profile/MotoMB502.rdf': [
    'Motorola',
    'CHARM',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoMB200/profile/MotoMB200.rdf': [
    'Motorola',
    'CLIQ',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoMB501/profile/MotoMB501.rdf': [
    'Motorola',
    'CLIQ XT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/cn620/profile/cn620.rdf': ['Motorola', 'CN620', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/MotoMB525+/profile/MotoMB525+.rdf': [
    'Motorola',
    'DEFY',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoMB525/profile/MotoMB525.rdf': [
    'Motorola',
    'DEFY',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoMB525/profile/MotoMB525Telstra.rdf': [
    'Motorola',
    'DEFY',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt535/Profile/XT535.rdf': [
    'Motorola',
    'DEFY',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt535/Profile/xt535I.rdf': [
    'Motorola',
    'DEFY',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt535/Profile/xt535_TNZ.rdf': [
    'Motorola',
    'DEFY',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt536/Profile/xt536.rdf': [
    'Motorola',
    'DEFY Diana',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt536/Profile/xt536I.rdf': [
    'Motorola',
    'DEFY Diana',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt320/Profile/xt320.rdf': [
    'Motorola',
    'DEFY Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt321/Profile/xt321.rdf': [
    'Motorola',
    'DEFY Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt560/Profile/xt560.rdf': [
    'Motorola',
    'DEFY Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt555c/Profile/xt555c.rdf': [
    'Motorola',
    'DEFY XT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt556/Profile/xt556.rdf': [
    'Motorola',
    'DEFY XT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt557/Profile/xt557.rdf': [
    'Motorola',
    'DEFY XT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.ntelospcs.net/xt556.xml': ['Motorola', 'DEFY XT', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/MotoMB525/profile/MotoMB526.rdf': [
    'Motorola',
    'DEFY+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb526/Profile/motomb526.rdf': [
    'Motorola',
    'DEFY+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb886/Profile/motomb886.rdf': [
    'Motorola',
    'DINARA',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/mot/a955/a955.xml': ['Motorola', 'Droid 2', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/a956/a956.xml': ['Motorola', 'Droid 2', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/xt682/Profile/xt682.rdf': [
    'Motorola',
    'Droid 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/mot/xt862/xt862.xml': ['Motorola', 'Droid 3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/XT897-2011011301/771Q6SPR125ASA14.rdf': [
    'Motorola',
    'Droid 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/mot/xt894/xt894.xml': ['Motorola', 'Droid 4', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/xt875/xt875.xml': ['Motorola', 'Droid Bionic', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motoxt610/Profile/motoxt610.rdf': [
    'Motorola',
    'Droid Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/mot/xt610/xt610.xml': ['Motorola', 'Droid Pro', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motoxt912/Profile/motoxt912.rdf': [
    'Motorola',
    'Droid RAZR',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/mot/xt912/xt912.xml': ['Motorola', 'Droid RAZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motoxt925/Profile/motoxt925.rdf': [
    'Motorola',
    'Droid RAZR HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/mot/xt926/xt926.xml': ['Motorola', 'Droid RAZR HD', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/xt907/xt907.xml': ['Motorola', 'Droid RAZR M', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/mb810/mb810.xml': ['Motorola', 'Droid X', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/mb870/mb870.xml': ['Motorola', 'Droid X2', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/mz617/mz617.xml': ['Motorola', 'Droid XYBOARD 10.1', 'Android', DeviceType.TABLET],
  'http://uaprof.vtext.com/mot/mz609/mz609.xml': ['Motorola', 'Droid XYBOARD 8.2', 'Android', DeviceType.TABLET],
  'http://motorola.handango.com/phoneconfig/e365/Profile/e365.rdf': ['Motorola', 'E365', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/e680i/Profile/e680i.rdf': ['Motorola', 'E680i', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/E770v/Profile/E770v.rdf': ['Motorola', 'E770v', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/e790/Profile/e790.rdf': ['Motorola', 'E790', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/e815/Profile/e815.rdf': ['Motorola', 'E815', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_Motorola_E815_BMX171P.rdf': ['Motorola', 'E815', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motomb853/Profile/motomb853.rdf': [
    'Motorola',
    'Electrify',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/em25/Profile/em25.rdf': ['Motorola', 'EM25', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/em30/Profile/em30.rdf': ['Motorola', 'EM30', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/em325/Profile/em325.rdf': ['Motorola', 'EM325', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/es405b/Profile/es405b.rdf': [
    'Motorola',
    'ES405B',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/ex116/Profile/ex116.rdf': ['Motorola', 'EX116', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/ex128/Profile/EX128_27390a3c7426da5686f20302b82926e1.rdf': [
    'Motorola',
    'EX128',
    null,
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/MOT/MOT_EX200_3_20100728.xml': ['Motorola', 'EX200', 'Brew', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/ex226/Profile/ex226.rdf': ['Motorola', 'EX226', 'MTK', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/xt311/Profile/xt311.rdf': [
    'Motorola',
    'FIRE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt530/Profile/xt530.rdf': [
    'Motorola',
    'FIRE XT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/XT531/Profile/XT531.rdf': [
    'Motorola',
    'FIRE XT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoMB511/profile/MotoMB511.rdf': [
    'Motorola',
    'FLIPOUT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb508/Profile/MotoMB508FroYo.rdf': [
    'Motorola',
    'FLIPSIDE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/wx308/Profile/wx308.rdf': [
    'Motorola',
    'GLEAM+ WX308',
    'MTK',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/ic402/1280.rdf': ['Motorola', 'ic402 Blend', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/ic502/1292.rdf': ['Motorola', 'ic502 Buzz', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/ic602/1500.rdf': ['Motorola', 'ic602 Buzz+', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/ic902/2610.rdf': ['Motorola', 'ic902 Deluxe', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motoxt627/Profile/Motoxt627.rdf': [
    'Motorola',
    'Kairos XT627',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/k1/Profile/k1.rdf': ['Motorola', 'KRZR K1', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/moto/k1c/k1c.xml': ['Motorola', 'KRZR K1c', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/K3/Profile/K3.rdf': ['Motorola', 'KRZR K3', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/l6/Profile/l6.rdf': ['Motorola', 'L6', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/l6i/Profile/l6i.rdf': ['Motorola', 'L6i', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/MOTOXT603/': ['Motorola', 'Master XT605', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/MotoXT605/profile/MotoXT605.rdf': [
    'Motorola',
    'Master XT605',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/mc65/Profile/mc65.rdf': [
    'Motorola',
    'MC65 Wireless Rugged Mobile Computer',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/milestonext720/Profile/milestonext720.rdf': [
    'Motorola',
    'Milestone',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoA953/profile/MotoA953.rdf': [
    'Motorola',
    'Milestone 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoA953/profile/MotoA953GB.rdf': [
    'Motorola',
    'Milestone 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motoxt860/Profile/motoxt860.rdf': [
    'Motorola',
    'Milestone 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/A1200e/profile/A1200e.rdf': [
    'Motorola',
    'Ming A1200e',
    null,
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/A1200i/profile/A1200i.rdf': [
    'Motorola',
    'Ming A1200i',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/em330/Profile/em330.rdf': [
    'Motorola',
    'MOTO EM330',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motome525+/Profile/motome525+.rdf': [
    'Motorola',
    'MOTO ME525',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprofile.motorola.com/uaprof/MOT_MT620-1.0.xml': ['Motorola', 'MOTO MT620', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/MotoMt870/profile/MotoMt870.rdf': [
    'Motorola',
    'MOTO MT870',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/SLV-L7c/0350.rdf': ['Motorola', 'MOTO SLVR L7c', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motoxt316/Profile/motoxt316.rdf': [
    'Motorola',
    'MOTO XT316',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt316/Profile/xt316.rdf': [
    'Motorola',
    'MOTO XT316',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt615/Profile/motoxt615.rdf': [
    'Motorola',
    'MOTO XT615',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt615/Profile/xt615.rdf': [
    'Motorola',
    'MOTO XT615',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motoxt626/Profile/Motoxt626.rdf': [
    'Motorola',
    'MOTO XT626',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/MOT/MOT_XT681_1_20110930.XML': [
    'Motorola',
    'MOTO XT681',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/MOT/MOT_XT681_1_20111012.XML': [
    'Motorola',
    'MOTO XT681',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.qma.com.tw/Motorola-XT681.xml': ['Motorola', 'MOTO XT681', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/xt685/Profile/xt685.rdf': [
    'Motorola',
    'MOTO XT685',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb860/Profile/motoxt882.rdf': [
    'Motorola',
    'MOTO XT882',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/w450/profile/w450.rdf': [
    'Motorola',
    'MOTOACTV W450',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/ex430/Profile/ex430.rdf': [
    'Motorola',
    'MotoGO EX430',
    'MTK',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/ex108/Profile/ex108.rdf': [
    'Motorola',
    'MOTOKEY Mini EX108',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/ex225/Profile/ex225.rdf': [
    'Motorola',
    'MOTOKEY Social EX225',
    'MTK',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/mt680/Profile/mt680.rdf': [
    'Motorola',
    'MOTOLUXE MT680',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt611/Profile/xt611.rdf': [
    'Motorola',
    'MOTOSMART Flip',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/MOT/MOT_XT553_1_20120309.XML': [
    'Motorola',
    'MOTOSMART MIX',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt550/Profile/xt550.rdf': [
    'Motorola',
    'MOTOSMART MIX',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt303/Profile/xt303.rdf': [
    'Motorola',
    'MOTOSMART XT303',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt305/Profile/xt305.rdf': [
    'Motorola',
    'MOTOSMART XT305',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt389/Profile/xt389.rdf': [
    'Motorola',
    'MOTOSMART XT389',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt389/Profile/xt389_we.rdf': [
    'Motorola',
    'MOTOSMART XT389',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt390/Profile/xt390.rdf': [
    'Motorola',
    'MOTOSMART XT390',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/q-gsm/Profile/mot-a3100.rdf': [
    'Motorola',
    'MOTOSURF A3100',
    'Windows',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/zn5/Profile/zn5.rdf': [
    'Motorola',
    'MOTOZINE ZN5',
    null,
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/mpx/Profile/mpx.rdf': ['Motorola', 'MPx', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/mpx200/Profile/mpx200.rdf': [
    'Motorola',
    'MPx200',
    null,
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/mpx220/Profile/mpx220.rdf': [
    'Motorola',
    'MPx220',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomt917/profile/motomt917.rdf': [
    'Motorola',
    'MT917',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/u6/Profile/u6.rdf': ['Motorola', 'PEBL U6', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/MotoMB200/profile/MotoMB200.rdf451A1.rdf': [
    'Motorola',
    'PHOTON',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/MOTOMB855/': ['Motorola', 'PHOTON 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/MOTOMB855/451A1.rdf': [
    'Motorola',
    'PHOTON 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomb855/Profile/motomb855.rdf': [
    'Motorola',
    'PHOTON 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/XT897-SPRINT/771Q6SPR125ASA10.rdf': [
    'Motorola',
    'PHOTON Q',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/XT897-SPRINT/771Q6SPR125ASA14.rdf': [
    'Motorola',
    'PHOTON Q',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/XT897-SPRINT/771Q6SPR89ASA36.rdf': [
    'Motorola',
    'PHOTON Q',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/XT897/latest': ['Motorola', 'PHOTON Q', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/MotoXT621/profile/MotoXT621.rdf': [
    'Motorola',
    'Primus XT621',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaporf.motorola.com/phoneconfig/MotoME632/profile/MotoME632.rdf': [
    'Motorola',
    'PRO+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MotoMB632/profile/MotoMB632.rdf': [
    'Motorola',
    'PRO+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/q-umts/Profile/mot-q-umts.rdf': [
    'Motorola',
    'Q',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/q-gsm/Profile/mot-q-gsm.rdf': ['Motorola', 'Q', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/q-umts/Profile/mot-q-umts.rdf': ['Motorola', 'Q', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/q-umts/Profile/mot-q9h.rdf': ['Motorola', 'Q9h', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motoxt910/Profile/motoxt910.rdf': [
    'Motorola',
    'RAZR',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motoxt910k/Profile/motoxt910k.rdf': [
    'Motorola',
    'RAZR',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motoxt890/Profile/motoxt890.rdf': [
    'Motorola',
    'RAZR i',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motoxt890/Profile/motoxt890_jb.rdf': [
    'Motorola',
    'RAZR i',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/mt781/Profile/mt781.rdf': [
    'Motorola',
    'RAZR i',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.ntelospcs.net/motoxt908.xml': ['Motorola', 'RAZR MAXX', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/MOT/MOT_XT889_1_20120217.XML': ['Motorola', 'RAZR V', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/mt887/Profile/mt887.rdf': [
    'Motorola',
    'RAZR V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt885/Profile/xt885.rdf': [
    'Motorola',
    'RAZR V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt885/Profile/xt885_ca.rdf': [
    'Motorola',
    'RAZR V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt885/Profile/xt885_ird.rdf': [
    'Motorola',
    'RAZR V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt886/Profile/xt886.rdf': [
    'Motorola',
    'RAZR V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/razrv3x/Profile/razrv3x.rdf': [
    'Motorola',
    'RAZR V3',
    null,
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/razrv3xx/Profile/RAZRV3xx.rdf': [
    'Motorola',
    'RAZR V3',
    null,
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/v3/Profile/v3.rdf': ['Motorola', 'RAZR V3', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_Motorola_V3c_070301P.rdf': ['Motorola', 'RAZR V3c', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/v3i/Profile/v3i.rdf': ['Motorola', 'RAZR V3i', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/v3r/Profile/v3r.rdf': ['Motorola', 'RAZR V3r', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/razrv6/Profile/RAZRv6.rdf': [
    'Motorola',
    'RAZR V6',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/MOTORAZRv9x/profile/MOTORAZRv9x.rdf': [
    'Motorola',
    'RAZR V9',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/v9/profile/v9.rdf': ['Motorola', 'RAZR V9', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/VE20/0570.rdf': ['Motorola', 'RAZR VE20', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/motorazrV8/Profile/motorazrv8.rdf': [
    'Motorola',
    'RAZR2 V8',
    null,
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/V9m/2680.rdf': ['Motorola', 'RAZR2 V9m', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/motorola/V9m-1.rdf': ['Motorola', 'RAZR2 V9m', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/V950/0591.rdf': ['Motorola', 'Renegade V950', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motorizrz10/Profile/motorizrz10.xml': [
    'Motorola',
    'RIZR Z10',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motorizrz8/profile/motorizrz8.rdf': [
    'Motorola',
    'RIZR Z8',
    null,
    DeviceType.MOBILE,
  ],
  'http://motorola.handango.com/phoneconfig/e1/Profile/e1.rdf': ['Motorola', 'ROKR E1', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/motorokre6/Profile/motorokre6.rdf': [
    'Motorola',
    'ROKR E6',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/motorokre6/Profile/motorokre6.rdf': [
    'Motorola',
    'ROKR E6',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/e8/Profile/e8.rdf': ['Motorola', 'ROKR E8', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/W5/Profile/W5.rdf': ['Motorola', 'ROKR W5', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/w6/Profile/w6.rdf': ['Motorola', 'ROKR W6', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/motorokrz6/Profile/motorokrz6.rdf': [
    'Motorola',
    'ROKR Z6',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.alltel.net/uaprof/moto/z6m/z6m.xml': ['Motorola', 'ROKR Z6m', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/motoxt300/Profile/motoxt300.rdf': [
    'Motorola',
    'SPICE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/VA76r/Profile/VA76r.rdf': [
    'Motorola',
    'Tundra VA76r',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/u9/Profile/u9.rdf': ['Motorola', 'U9', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/v175/Profile/v175.rdf': ['Motorola', 'V175', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/v177/profile/v177.rdf': ['Motorola', 'V177', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/v190/Profile/v190.rdf': ['Motorola', 'V190', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/v191/Profile/v191.rdf': ['Motorola', 'V191', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/v197/Profile/v197.rdf': ['Motorola', 'V197', null, DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/Motorola-V323i.xml': ['Motorola', 'V323i', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/v325/v325v1.xml': ['Motorola', 'V325', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/v360i/Profile/v360i.rdf': ['Motorola', 'V360', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/motorola/v710.rdf': ['Motorola', 'V710', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/v860/v860.xml': ['Motorola', 'V860', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/ve/vev1.xml': ['Motorola', 'Ve', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/ve538/Profile/ve538.rdf': ['Motorola', 'VE538', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/W213/Profile/W213.rdf': ['Motorola', 'W213', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/w230/Profile/w230.rdf': ['Motorola', 'W230', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/W270/Profile/W270.rdf': ['Motorola', 'W270', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/w360/Profile/w360.rdf': ['Motorola', 'W360', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/w370/Profile/w370.rdf': ['Motorola', 'W370', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/W375/Profile/W375.rdf': ['Motorola', 'W375', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/w385m/Profile/w385m.rdf': ['Motorola', 'W385', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/W396/Profile/W396.rdf': ['Motorola', 'W396', null, DeviceType.MOBILE],
  'http://motorola.handango.com/phoneconfig/w510/Profile/w510.rdf': ['Motorola', 'W510', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/mot/w755/w755v1.xml': ['Motorola', 'W755', null, DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/MotoMZ616/Profile/MotoMZ616.rdf': [
    'Motorola',
    'XOOM 2',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprof.motorola.com/phoneconfig/Xoom2/Profile/xoom2.rdf': [
    'Motorola',
    'XOOM 2',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprof.motorola.com/phoneconfig/Xoom2me/Profile/xoom2me.rdf': [
    'Motorola',
    'XOOM 2',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprof.motorola.com/phoneconfig/motomz601/Profile/motomz601.rdf': [
    'Motorola',
    'XOOM 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Motorola/MOTB612ABB/BST20.rdf': ['Motorola', 'XPRT', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Motorola/MOTOMB612/451110KNS17.rdf': [
    'Motorola',
    'XPRT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/MOTOMB612/451110KNS46.rdf': [
    'Motorola',
    'XPRT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Motorola/MOTOMB612/KRNSX41110.rdf': [
    'Motorola',
    'XPRT',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.motorola.com/phoneconfig/xt788/Profile/xt788.rdf': [
    'Motorola',
    'XT788',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/MOT/MOT_XT928_1_20110914.XML': ['Motorola', 'XT928', 'Android', DeviceType.MOBILE],
  'http://uaprof.motorola.com/phoneconfig/ZN200/Profile/ZN200.rdf': ['Motorola', 'ZN200', null, DeviceType.MOBILE],
  'http://wap.nexustelco.com/uaprofile/MovistarD5.xml': ['Movistar', 'Dual D5', 'Android', DeviceType.MOBILE],
  'http://wap.nexustelco.com/uaprofile/GO1001.xml': ['Movistar', 'Go Mobile 1001', 'Android', DeviceType.MOBILE],
  'wap.nexustelco.com/uaprofile/GO984.xml': ['Movistar', 'Go Mobile 504', 'Android', DeviceType.MOBILE],
  'http://wap.nexustelco.com/uaprofile/GO775.xml': ['Movistar', 'Go Mobile 775', 'Android', DeviceType.MOBILE],
  'http://wap.nexustelco.com/uaprofile/GO778.xml': ['Movistar', 'Go Mobile 778', 'Android', DeviceType.MOBILE],
  'http://wap.nexustelco.com/uaprofile/GO950.xml': ['Movistar', 'Go Mobile 950', 'Android', DeviceType.MOBILE],
  'http://wap.nexustelco.com/wap/uaprofile/GO963.xml': ['Movistar', 'Go Mobile 963', 'Android', DeviceType.MOBILE],
  'http://wap.nexustelco.com/uaprofile/GO980.xml': ['Movistar', 'Go Mobile 980', 'Android', DeviceType.MOBILE],
  'http://wap.nexustelco.com/uaprofile/GO984.xml': ['Movistar', 'Go Mobile 984', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Movistar-Link.xml': ['Movistar', 'Link', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Movistar-Motion.xml': ['Movistar', 'Motion', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Movistar-One.xml': ['Movistar', 'One', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/MTC_1055.xml': ['MTC', '1055', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC_1078.xml': ['MTC', '1078', 'Android', DeviceType.TABLET],
  'http://wap1.huawei.com/uaprof/MTC_752.xml': ['MTC', '752', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/MTC_916.xml': ['MTC', '916', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650GPRS-MTS.xml': ['MTC', '955', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-MTS.xml': ['MTC', '955', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC_960.xml': ['MTC', '960', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC-962.xml': ['MTC', '962', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC-962_3G.xml': ['MTC', '962', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC_968.xml': ['MTC', '968', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC_970.xml': ['MTC', '970', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC_970H.xml': ['MTC', '970H', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC_972.xml': ['MTC', '972', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC_975.xml': ['MTC', '975', 'Android', DeviceType.MOBILE],
  'http://tpsolution.ru/uaprof/MTC980.xml': ['MTC', '980', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MTC_982T.xml': ['MTC', '982', 'Android', DeviceType.MOBILE],
  'http://tpsolution.ru/uaprof/MTC982O.xml': ['MTC', '982O', 'Android', DeviceType.MOBILE],
  'http://tpsolution.ru/uaprof/mtc982o442.xml': ['MTC', '982O', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/MTC_SMART_Run_4G.xml': ['MTC', 'Smart Run', 'Android', DeviceType.MOBILE],
  'http://tpsolution.ru/uaprof/SS.xml': ['MTC', 'Smart Sprint', 'Android', DeviceType.MOBILE],
  'http://www.jeekomi.com/hw/MTC_SMART_Sprint_4G.xml': ['MTC', 'Smart Sprint', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/SMART_Start.xml': ['MTC', 'Smart Start', 'Android', DeviceType.MOBILE],
  'http://staticfiles.technoserv.com/uap/MTS_Smart_Surf2_4G.xml': [
    'MTC',
    'Smart Surf 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8160GPRS-MTS.xml': ['MTS', 'Mini', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/NATCOM_N8302GPRS-NORMAL.xml': ['NATCOM', 'N8302', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/NATCOM_N8302WCDMA-NORMAL.xml': ['Natcom', 'N8302', 'Android', DeviceType.MOBILE],
  'http://www.nechdm.com/profiles/232/a232.rdf': ['NEC', 'A232', null, DeviceType.MOBILE],
  'http://www.nechdm.com/profiles/525/a525.rdf': ['NEC', 'A525', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/e121V01.xml': ['NEC', 'e121', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/232V01.xml': ['NEC', 'e232', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/e238V01.xml': ['NEC', 'e238', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/e242V01.xml': ['NEC', 'e242', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/e353V01.xml': ['NEC', 'e353', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/530V01.xml': ['NEC', 'e530', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/UAPMargay.xml': ['NEC', 'N110', null, DeviceType.MOBILE],
  'http://nechdm.com/profiles/535/a535.xml': ['NEC', 'N535', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/N6206V01.xml': ['NEC', 'N6206', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/N700V01.xml': ['NEC', 'N700', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/N710V01.xml': ['NEC', 'N710', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/N820V01.xml': ['NEC', 'N820', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/N840HKV01.xml': ['NEC', 'N840', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/N900V01.xml': ['NEC', 'N900', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/N908V01.xml': ['NEC', 'N908', null, DeviceType.MOBILE],
  'http://www.ehaier.com/download/mobile/HaierN80Wv100WCDMA.xml': ['NEC', 'RPSPG3501', 'Android', DeviceType.MOBILE],
  'http://www.n-keitai.com/uap/NE-201A1A_UAProf_v1.2.xml': ['NEC', 'Terrain', 'Android', DeviceType.MOBILE],
  'http://vfwap.jn.neic.ne.jp/profile/V802N.xml': ['NEC', 'V802N', null, DeviceType.MOBILE],
  'http://www.nexian-apps.com/UAProf/NX-G869/G869UAProf.xml': [
    'Nexian',
    'NX-G869 Cappuccino',
    'MTK',
    DeviceType.MOBILE,
  ],
  'http://www.nexian-apps.com/UAProf/NX-G965/G965UAProf.xml': [
    'Nexian',
    'NX-G965 Champion',
    'MTK',
    DeviceType.MOBILE,
  ],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmatlantis.xml': ['NGM', 'Atlantis', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmfun.xml': ['NGM', 'Dynamic Fun', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmjump.xml': ['NGM', 'Dynamic Jump', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmracing3.xml': [
    'NGM',
    'Dynamic Jump',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmmilo.xml': ['NGM', 'Dynamic Milo', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmstar.xml': ['NGM', 'Dynamic Star', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmstylo.xml': ['NGM', 'Dynamic Stylo', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngm5_5.xml': ['NGM', 'Forward 5.5', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmendurance.xml': [
    'NGM',
    'Forward Endurance',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmprime.xml': ['NGM', 'Forward Prime', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmruby.xml': ['NGM', 'Forward Ruby', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmproductname.xml': [
    'NGM',
    'Forward Young',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmyoung.xml': ['NGM', 'Forward Young', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmlegend2.xml': ['NGM', 'Legend 2', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmmiracle.xml': ['NGM', 'Miracle', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmpolaris.xml': ['NGM', 'Polaris', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmjumpl.xml': ['NGM', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmspirit.xml': ['NGM', 'Spirit', 'Android', DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmwilco.xml': ['NGM', 'WeMove Wilco', 'Android', DeviceType.MOBILE],
  'http://www.ddmbrands.com/uaprof/niu/tek4D2.xml': ['NIU', 'Tek 4D2', 'Android', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia109r100.xml': ['Nokia', '109', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia110r100.xml': ['Nokia', '110', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia1100r100.xml': ['Nokia', '1100', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N1101r100.xml': ['Nokia', '1101', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia111.1r100.xml': ['Nokia', '111', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia111r100.xml': ['Nokia', '111', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia112r100.xml': ['Nokia', '112', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia1120r100.xml': ['Nokia', '1120', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia113r100.xml': ['Nokia', '113', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia114r100.xml': ['Nokia', '114', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N1680c-2r100.xml': ['Nokia', '1680 classic', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia2030r100.xml': ['Nokia', '2030', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia2052r100.xml': ['Nokia', '2052', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia2055r100.xml': ['Nokia', '2055', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia2060r100.xml': ['Nokia', '2060', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia208.1r100.xml': ['Nokia', '208', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia208.2r100.xml': ['Nokia', '208', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia208.3r100.xml': ['Nokia', '208', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia208.4r100.xml': ['Nokia', '208', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia208r100.xml': ['Nokia', '208', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia210.2r100.xml': ['Nokia', '210', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia220r100.xml': ['Nokia', '220', 'Series30', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia225r100.xml': ['Nokia', '225', 'Series30', DeviceType.MOBILE],
  'http://useragentprofile.microsoft.com/uaprof/Nokia230r100.xml': ['Nokia', '230', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2322cr100.xml': ['Nokia', '2322 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2600c-2r100.xml': ['Nokia', '2600 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2600cr100.xml': ['Nokia', '2600 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N2610r100.xml': ['Nokia', '2610', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2610r100.xml': ['Nokia', '2610', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N2626r100.xml': ['Nokia', '2626', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2626r100.xml': ['Nokia', '2626', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N2630r100.xml': ['Nokia', '2630', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2630r100.xml': ['Nokia', '2630', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N2650r100.xml': ['Nokia', '2650', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N2650r200.xml': ['Nokia', '2650', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N2650r300.xml': ['Nokia', '2650', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N2660r100.xml': ['Nokia', '2660', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2680s-2r100.xml': ['Nokia', '2680 slide', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2690r100.xml': ['Nokia', '2690', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2692r100.xml': ['Nokia', '2692', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2700c-2r100.xml': ['Nokia', '2700 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2700cr100.xml': ['Nokia', '2700 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2710c-2r100.xml': ['Nokia', '2710', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2720ar100.xml': ['Nokia', '2720 fold', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2730c-1br100.xml': ['Nokia', '2730 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2730c-1r100.xml': ['Nokia', '2730 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N2730cr100.xml': ['Nokia', '2730 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N2760r100.xml': ['Nokia', '2760', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/3000r100.xml': ['Nokia', '3000', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia301.1r100.xml': ['Nokia', '301', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia301r100.xml': ['Nokia', '301', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia3020r100.xml': ['Nokia', '3020', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia3030r100.xml': ['Nokia', '3030', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia3050r200.xml': ['Nokia', '3050', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia307r100.xml': ['Nokia', '307', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia3090r100.xml': ['Nokia', '3090', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3100br100.xml': ['Nokia', '3100', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3100r100.xml': ['Nokia', '3100', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3105tlsr100.xml': ['Nokia', '3105', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3108r100.xml': ['Nokia', '3108', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3109cr100.xml': ['Nokia', '3109 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3109cr100.xml': ['Nokia', '3109 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3110cr100.xml': ['Nokia', '3110 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3110cr100.xml': ['Nokia', '3110 Evolve', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3120br100.xml': ['Nokia', '3120', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3120r100.xml': ['Nokia', '3120', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3120cr100.xml': ['Nokia', '3120 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3128r100.xml': ['Nokia', '3128', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3129r100.xml': ['Nokia', '3129', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3155x5Ar002.xml': ['Nokia', '3155', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3155x5Cr002.xml': ['Nokia', '3155', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3155x7Ar004.xml': ['Nokia', '3155', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3155x7Cr004.xml': ['Nokia', '3155', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3200r100.xml': ['Nokia', '3200', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3200r200.xml': ['Nokia', '3200', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3205tlsr100.xml': ['Nokia', '3205', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3208cr100.xml': ['Nokia', '3208 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3220r100.xml': ['Nokia', '3220', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3220r200.xml': ['Nokia', '3220', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3220r100.xml': ['Nokia', '3220', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3220r200.xml': ['Nokia', '3220', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3230r100.xml': ['Nokia', '3230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3230r100.xml': ['Nokia', '3230', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3250r100.xml': ['Nokia', '3250', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3250r200.xml': ['Nokia', '3250', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3250r100.xml': ['Nokia', '3250', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3300r100.xml': ['Nokia', '3300', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3300r200.xml': ['Nokia', '3300', 'Series40', DeviceType.MOBILE],
  'http://useragentprofile.hmdglobal.com/uaprof/Nokia3310r100.xml': [
    'Nokia',
    '3310 (2017)',
    null,
    DeviceType.MOBILE,
  ],
  'http://useragentprofile.hmdglobal.com/uaprof/Nokia33103Gr100.xml': [
    'Nokia',
    '3310 3G',
    'KaiOS',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N3330r100.xml': ['Nokia', '3330', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3350r100.xml': ['Nokia', '3350', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3360r100.xml': ['Nokia', '3360', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3410r100.xml': ['Nokia', '3410', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3500cr100.xml': ['Nokia', '3500 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3500cr100.xml': ['Nokia', '3500 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3510ir100.xml': ['Nokia', '3510i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3510r100.xml': ['Nokia', '3510i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3520r100.xml': ['Nokia', '3520', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3520_N3560r100.xml': ['Nokia', '3520', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3555cr100_3G.xml': ['Nokia', '3555', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3555cr100.xml': ['Nokia', '3555 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3555cr100_3G.xml': ['Nokia', '3555 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3560r100.xml': ['Nokia', '3560', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3590r100.xml': ['Nokia', '3590', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3595r100.xml': ['Nokia', '3595', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3600r100.xml': ['Nokia', '3600', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3600slider100.xml': ['Nokia', '3600 slide', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3610r100.xml': ['Nokia', '3610', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3610ar100.xml': ['Nokia', '3610 fold', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3620r100.xml': ['Nokia', '3620', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3620r200.xml': ['Nokia', '3620', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3650r100.xml': ['Nokia', '3650', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3650r200.xml': ['Nokia', '3650', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N3660r100.xml': ['Nokia', '3660', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3710foldr100.xml': ['Nokia', '3710 fold', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N3720cr100.xml': ['Nokia', '3720 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N500r100-VF2G.xml': ['Nokia', '500', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N500r100-VF3G.xml': ['Nokia', '500', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N500r100.xml': ['Nokia', '500', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N500r200.xml': ['Nokia', '500', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N500r210.xml': ['Nokia', '500', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5000d-2r100.xml': ['Nokia', '5000', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5000r100.xml': ['Nokia', '5000', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5070nmr100.xml': ['Nokia', '5070', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5070r100.xml': ['Nokia', '5070', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5070r100.xml': ['Nokia', '5070b', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5100r100.xml': ['Nokia', '5100', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5100r200.xml': ['Nokia', '5100', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5130c-2r100.xml': ['Nokia', '5130 XpressMusic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5130r100.xml': ['Nokia', '5130 XpressMusic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5140r100.xml': ['Nokia', '5140', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5140ir100.xml': ['Nokia', '5140i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5140ir200.xml': ['Nokia', '5140i', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia515.2r100.xml': ['Nokia', '515', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia515r100.xml': ['Nokia', '515', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5200r100.xml': ['Nokia', '5200', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5200ir200.xml': ['Nokia', '5200', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5200r100.xml': ['Nokia', '5200', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5210r100.xml': ['Nokia', '5210', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5220XpressMusicr100.xml': [
    'Nokia',
    '5220 XpressMusic',
    'Series40',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5228r100-2G.xml ': ['Nokia', '5228', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5228r100-3G.xml ': ['Nokia', '5228', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5233r100-2G.xml ': ['Nokia', '5228', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5233r100-3G.xml': ['Nokia', '5228', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/n-5230-vf3g.xml': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230-1br100-3G.xml': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230-1cr100-2G.xml ': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230-1cr100-3G.xml': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230-1dr100-3G.xml ': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230-cr100-2G.xml ': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230-cr100-3G.xml': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230r100-2G.xml ': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230r100-3G.xml': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230r100-VF2G.xml': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5230r100-VF3G.xml': ['Nokia', '5230', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5235-1br100-3G.xml ': [
    'Nokia',
    '5235 Ovi Music Unlimited',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5235-1dr100-3G.xml ': [
    'Nokia',
    '5235 Ovi Music Unlimited',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5235r100-2G.xml ': [
    'Nokia',
    '5235 Ovi Music Unlimited',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5235r100-3G.xml ': [
    'Nokia',
    '5235 Ovi Music Unlimited',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5236r100-2G.xml ': ['Nokia', '5236', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5238r100-3G.xml ': ['Nokia', '5238', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5250r100.xml': ['Nokia', '5250', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5300r100.xml': ['Nokia', '5300 XpressMusic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5300r100.xml': ['Nokia', '5300 XpressMusic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5310r100.xml': ['Nokia', '5310 XpressMusic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5310XpressMusicr100.xml': [
    'Nokia',
    '5310 XpressMusic',
    'Series40',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/N5310r100.xml': ['Nokia', '5310 XpressMusic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5310XpressMusicr100.xml': [
    'Nokia',
    '5310 XpressMusic',
    'Series40',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/N5310XpressMusicVFr100.xml': [
    'Nokia',
    '5310 XpressMusic',
    'Series40',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/N5320c-1r100-3G.xml': [
    'Nokia',
    '5320 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/N5320d-1br100.xml': ['Nokia', '5320 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5320d-1r100-2G.xml': [
    'Nokia',
    '5320 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/N5320d-1r100-3G.xml': [
    'Nokia',
    '5320 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/N5320r100-2G.xml': ['Nokia', '5320 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5330-1dr100.xml': [
    'Nokia',
    '5330 Mobile TV Edition',
    'Series40',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N5500dr100.xml': ['Nokia', '5500 Sport', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5510r100.xml': ['Nokia', '5510', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5530c-2r100-2G.xml': [
    'Nokia',
    '5530 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5530r100.xml': ['Nokia', '5530 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5610r100.xml': ['Nokia', '5610 XpressMusic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia5630d-1r100-2G.xml': [
    'Nokia',
    '5630 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5630d-1r100-3G.xml': [
    'Nokia',
    '5630 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N5700r100-2G.xml': ['Nokia', '5700 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5700r100-3G.xml': ['Nokia', '5700 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N5700r100.xml': ['Nokia', '5700 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5700r100-2G.xml': ['Nokia', '5700 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5700r100-3G.xml': ['Nokia', '5700 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5700r100.xml': ['Nokia', '5700 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5730s-1r100.xml': ['Nokia', '5730 XpressMusic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N5800XpressMusicr100-2G.xml': [
    'Nokia',
    '5800 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5800d-1r100-2G.xml ': [
    'Nokia',
    '5800 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5800d-1r100-3G.xml': [
    'Nokia',
    '5800 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5800d-1r100.xml': [
    'Nokia',
    '5800 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5800i-1r100-2G.xml ': [
    'Nokia',
    '5800 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5800i-1r100-3G.xml': [
    'Nokia',
    '5800 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5800r100-2G.xml ': [
    'Nokia',
    '5800 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5800w-1r100-2G.xml': [
    'Nokia',
    '5800 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia5800w-1r100-3G.xml': [
    'Nokia',
    '5800 XpressMusic',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N6020r100.xml': ['Nokia', '6020', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6020r200.xml': ['Nokia', '6020', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6020r200.xml': ['Nokia', '6020', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6021r100.xml': ['Nokia', '6021', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N603r100.xml': ['Nokia', '603', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N603r200-3G.xml': ['Nokia', '603', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N603r200.xml': ['Nokia', '603', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N603r300.xml': ['Nokia', '603', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6030r100.xml': ['Nokia', '6030', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6030br100.xml': ['Nokia', '6030', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6030r100.xml': ['Nokia', '6030', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6030br100.xml': ['Nokia', '6030b', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6060r100.xml': ['Nokia', '6060', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6060vr100.xml': ['Nokia', '6060v', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6061r100.xml': ['Nokia', '6061', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6070r100.xml': ['Nokia', '6070', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6070r100.xml': ['Nokia', '6070', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6080r100.xml': ['Nokia', '6080', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6085r100.xml': ['Nokia', '6085', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6085r100.xml': ['Nokia', '6085', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6086r100.xml': ['Nokia', '6086', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6086r100.xml': ['Nokia', '6086', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6100r100.xml': ['Nokia', '6100', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6101r100.xml': ['Nokia', '6101', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6101r100.xml': ['Nokia', '6101', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6102r100.xml': ['Nokia', '6102', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6102ir100.xml': ['Nokia', '6102i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6103r100.xml': ['Nokia', '6103', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6108r100.xml': ['Nokia', '6108', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6110r100.xml': ['Nokia', '6110', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6110cr100.xml': ['Nokia', '6110 classic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6110Navigatorr100-2G.xml': [
    'Nokia',
    '6110 Navigator',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N6110Navigatorr100-3G.xml': [
    'Nokia',
    '6110 Navigator',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N6110Navigatorr100.xml': ['Nokia', '6110 Navigator', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6110Navigatorr100-2G.xml': [
    'Nokia',
    '6110 Navigator',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/N6110Navigatorr100-3G.xml': [
    'Nokia',
    '6110 Navigator',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N6111r100.xml': ['Nokia', '6111', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6111r200.xml': ['Nokia', '6111', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6111r201.xml': ['Nokia', '6111', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6111r300.xml': ['Nokia', '6111', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6111r301.xml': ['Nokia', '6111', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6111r200.xml': ['Nokia', '6111', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6120c-1r100-2G.xml': ['Nokia', '6120 classic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6120c-1r100-3G.xml': ['Nokia', '6120 classic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6120c-1r100-CV2G.xml': ['Nokia', '6120 classic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6120c-1r100-CV3G.xml': ['Nokia', '6120 classic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6120cr100.xml': ['Nokia', '6120 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6120c-1r100-2G.xml': ['Nokia', '6120 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6120c-1r100-3G.xml': ['Nokia', '6120 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6120c-1r100-CV2G.xml': ['Nokia', '6120 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6120cr100.xml': ['Nokia', '6120 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6122cr100.xml': ['Nokia', '6122 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6124cr100-2G.xml': ['Nokia', '6124 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6124cr100-3G.xml': ['Nokia', '6124 classic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6125r100.xml': ['Nokia', '6125', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6126r100.xml': ['Nokia', '6126', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6126r101.xml': ['Nokia', '6126', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6131r100.xml': ['Nokia', '6131', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6131r101.xml': ['Nokia', '6131', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6131r100.xml': ['Nokia', '6131', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6133r100.xml': ['Nokia', '6133', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6133r101.xml': ['Nokia', '6133', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6136r100.xml': ['Nokia', '6136', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r100.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r100_3G.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r101.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r101_3G.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r200.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r200_3G.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r201.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r201_3G.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r300.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r300_3G.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r301.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r301_3G.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r400.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r400_3G.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r401.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6151r401_3G.xml': ['Nokia', '6151', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6170r100.xml': ['Nokia', '6170', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6200r100.xml': ['Nokia', '6200', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6210r100.xml': ['Nokia', '6210 Navigator', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6210s-1r100-2G.xml': ['Nokia', '6210 Navigator', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6210s-1r100-3G.xml': ['Nokia', '6210 Navigator', 'Series60', DeviceType.MOBILE],
  'http://uaprof.vtext.com/nokia/nokia6215i/nokia6215i.xml': ['Nokia', '6215i', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6220r100.xml': ['Nokia', '6220 classic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6220r200.xml': ['Nokia', '6220 classic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6220r300.xml': ['Nokia', '6220 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6220c-1r100-2G.xml': ['Nokia', '6220 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6220c-1r100-3G.xml': ['Nokia', '6220 classic', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6225tlsr100.xml': ['Nokia', '6225', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230r100.xml': ['Nokia', '6230', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230r200.xml': ['Nokia', '6230', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230r300.xml': ['Nokia', '6230', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230r400.xml': ['Nokia', '6230', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230ir100.xml': ['Nokia', '6230i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230ir200.xml': ['Nokia', '6230i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230ir201.xml': ['Nokia', '6230i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230ir300.xml': ['Nokia', '6230i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230ir301.xml': ['Nokia', '6230i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230ir400.xml': ['Nokia', '6230i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6230ir401.xml': ['Nokia', '6230i', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6230ir401.xml': ['Nokia', '6230i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r100.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r100_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r101.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r101_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r200.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r200_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r201.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r201_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r300.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r300_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r301.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r301_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r400.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r400_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r401.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r401_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r500.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r500_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r501.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6233r501_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6233r200.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6233r400.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6233r500.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6233r500_3G.xml': ['Nokia', '6233', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r100.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r100_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r101.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r101_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r200.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r200_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r201.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r201_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r300.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r300_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r301.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r301_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r400.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r400_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r401.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r401_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r500.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r500_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r501.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6234r501_3G.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6234r500.xml': ['Nokia', '6234', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6235x4Ar001.xml': ['Nokia', '6235i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6250r100.xml': ['Nokia', '6250', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6255x3Ar001.xml': ['Nokia', '6255i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6260r100.xml': ['Nokia', '6260', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6260s-1r100.xml': ['Nokia', '6260 slide', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6263r100.xml': ['Nokia', '6263', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6263r100_3G.xml': ['Nokia', '6263', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6263r101.xml': ['Nokia', '6263', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6263r101_3G.xml': ['Nokia', '6263', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6267r100.xml': ['Nokia', '6267', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6267r100_3G.xml': ['Nokia', '6267', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6267r101.xml': ['Nokia', '6267', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6267r101_3G.xml': ['Nokia', '6267', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6270r100.xml': ['Nokia', '6270', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r100.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r1000.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r1000_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r1001.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r1001_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r1100.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r1100_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r1101.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r1101_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r200.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r201.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r300.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r301.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r400.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r400_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r401.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r401_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r500.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r500_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r501.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r501_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r600.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r600_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r601.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r601_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r700.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r700_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r701.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r701_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r800.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r800_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r801.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r801_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r900.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r900_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r901.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6280r901_3G.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6280r1100.xml': ['Nokia', '6280', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6282r100.xml': ['Nokia', '6282', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6282r100_3G.xml': ['Nokia', '6282', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6282r200.xml': ['Nokia', '6282', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6282r200_3G.xml': ['Nokia', '6282', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6282r300.xml': ['Nokia', '6282', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6282r300_3G.xml': ['Nokia', '6282', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r100.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r100_3G.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r101.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r101_3G.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r200.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r200_3G.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r201.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r201_3G.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r300.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r300_3G.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r301.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6288r301_3G.xml': ['Nokia', '6288', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6288r300.xml': ['Nokia', '6288', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6290r100-2G.xml': ['Nokia', '6290', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6290r100-3G.xml': ['Nokia', '6290', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6290r100.xml': ['Nokia', '6290', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NokiaMMS13r100.xml': ['Nokia', '6290', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6300r100.xml': ['Nokia', '6300', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6300r100.xml': ['Nokia', '6300', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6300ir100.xml': ['Nokia', '6300i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6301r100.xml': ['Nokia', '6301', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6301r100.xml': ['Nokia', '6301', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6303classicr100.xml': ['Nokia', '6303 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6303cr100.xml': ['Nokia', '6303 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6303cir100.xml': ['Nokia', '6303i classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6303iclassicr100.xml': [
    'Nokia',
    '6303i classic',
    'Series40',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/nokia/6305/6305v1.xml': ['Nokia', '6305i', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6310r100.xml': ['Nokia', '6310', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/nokia/nokia6315i/nokia6315i.xml': ['Nokia', '6315i', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6340r100.xml': ['Nokia', '6340', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6500cr100.xml': ['Nokia', '6500 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6500cr101.xml': ['Nokia', '6500 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6500cVFr100.xml': ['Nokia', '6500 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6500cVFr100_3G.xml': ['Nokia', '6500 classic', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6500sr100.xml': ['Nokia', '6500 slide', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6500sr101.xml': ['Nokia', '6500 slide', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6500sVFr100.xml': ['Nokia', '6500 slide', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6500sVFr100_3G.xml': ['Nokia', '6500 slide', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6500s2Gr100.xml': ['Nokia', '6500 slide', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6500sr100.xml': ['Nokia', '6500 slide', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6500cr100.xml': ['Nokia', '6500c', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6510R100.xml': ['Nokia', '6510', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6555r100.xml': ['Nokia', '6555', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6555r100_3G.xml': ['Nokia', '6555', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6555r100_3G.xml': ['Nokia', '6555', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6555br100.xml': ['Nokia', '6555b', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6555br100_3G.xml': ['Nokia', '6555b', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6555cr100.xml': ['Nokia', '6555c', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6555cr100_3G.xml': ['Nokia', '6555c', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6560R100.xml': ['Nokia', '6560', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6590R100.xml': ['Nokia', '6590', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6590r200.xml': ['Nokia', '6590', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6600r100.xml': ['Nokia', '6600', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6600r100.xml': ['Nokia', '6600', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6600fr100.xml': ['Nokia', '6600 fold', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6600sr100.xml': ['Nokia', '6600 slide', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6600ir100.xml': ['Nokia', '6600i slide', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6610r100.xml': ['Nokia', '6610', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6610r200.xml': ['Nokia', '6610', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6610ir100.xml': ['Nokia', '6610i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6620r100.xml': ['Nokia', '6620', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6620r200.xml': ['Nokia', '6620', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6620r200.xml': ['Nokia', '6620', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6630r100-VF2G.xml': ['Nokia', '6630', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6630r100-VF3G.xml': ['Nokia', '6630', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6630r100-VFKK2G.xml': ['Nokia', '6630', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6630r100-VFKK3G.xml': ['Nokia', '6630', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6630r100.xml': ['Nokia', '6630', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6650r100.xml': ['Nokia', '6650', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6650r200.xml': ['Nokia', '6650', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6650r300.xml': ['Nokia', '6650', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6651r100.xml': ['Nokia', '6651', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6670r100.xml': ['Nokia', '6670', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6680r100-VF2G.xml': ['Nokia', '6680', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6680r100-VF3G.xml': ['Nokia', '6680', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6680r100-VFKK2G.xml': ['Nokia', '6680', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6680r100-VFKK3G.xml': ['Nokia', '6680', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6680r100.xml': ['Nokia', '6680', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6681r100.xml': ['Nokia', '6681', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6681r100.xml': ['Nokia', '6681', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6682r100.xml': ['Nokia', '6682', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6682r200.xml': ['Nokia', '6682', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6700c-1r100.xml': ['Nokia', '6700 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6700cr100.xml': ['Nokia', '6700 classic', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6700s-1cr100.xml': ['Nokia', '6700 slide', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6700sr100-VF3G.xml': ['Nokia', '6700 slide', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6700sr100.xml': ['Nokia', '6700 slide', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6708r100.xml': ['Nokia', '6708', 'UIQ', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia6710sr100-2G.xml': [
    'Nokia',
    '6710 Navigator',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia6710sr100-3G.xml': [
    'Nokia',
    '6710 Navigator',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia6720c-1br100.xml': ['Nokia', '6720 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia6720cr100.xml': ['Nokia', '6720 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6730cr100.xml': ['Nokia', '6730 classic', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6760s-1r100-2G.xml': ['Nokia', '6760 slide', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N6760s-1r100-3G.xml': ['Nokia', '6760 slide', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6800r100.xml': ['Nokia', '6800', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6800r200.xml': ['Nokia', '6800', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6810r100.xml': ['Nokia', '6810', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6820r100.xml': ['Nokia', '6820', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N6822r100.xml': ['Nokia', '6822', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N700r100-VF2G.xml': ['Nokia', '700', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N700r100-VF3G.xml': ['Nokia', '700', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N700r100.xml': ['Nokia', '700', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N700r200.xml': ['Nokia', '700', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N700r300.xml': ['Nokia', '700', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N701r100.xml': ['Nokia', '701', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N701r200.xml': ['Nokia', '701', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N701r300.xml': ['Nokia', '701', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N701r310-3G.xml': ['Nokia', '701', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7020r100.xml': ['Nokia', '7020', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N702Tr100.xml': ['Nokia', '702T', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7070d-2r100.xml': ['Nokia', '7070 Prism', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7110r100.xml': ['Nokia', '7110', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7160r100.xml': ['Nokia', '7160', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7190r100.xml': ['Nokia', '7190', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7200r100.xml': ['Nokia', '7200', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7210r100.xml': ['Nokia', '7210 Supernova', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7210r200.xml': ['Nokia', '7210 Supernova', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7210Supernovar100.xml': [
    'Nokia',
    '7210 Supernova',
    'Series40',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/N7230-1cr100.xml': ['Nokia', '7230', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7230r100.xml': ['Nokia', '7230', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7250r100.xml': ['Nokia', '7250', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7250ir100.xml': ['Nokia', '7250i', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7260r100.xml': ['Nokia', '7260', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7260r200.xml': ['Nokia', '7260', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7262r100.xml': ['Nokia', '7262', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7270r100.xml': ['Nokia', '7270', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7270r300.xml': ['Nokia', '7270', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7280r100.xml': ['Nokia', '7280', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7280r200.xml': ['Nokia', '7280', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7280r300.xml': ['Nokia', '7280', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7310r100.xml': ['Nokia', '7310', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7310cr100.xml': ['Nokia', '7310 Supernova', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7360r100.xml': ['Nokia', '7360', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7370r100.xml': ['Nokia', '7370', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7373r100.xml': ['Nokia', '7373', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7380r100.xml': ['Nokia', '7380', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7380r101.xml': ['Nokia', '7380', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r100.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r100_3G.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r101.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r101_3G.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r200.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r200_3G.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r201.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r201_3G.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r300.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r300_3G.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r301.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7390r301_3G.xml': ['Nokia', '7390', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7500r100.xml': ['Nokia', '7500 Prism', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7500r100.xml': ['Nokia', '7500 Prism', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7510ar100.xml': ['Nokia', '7510', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7510Supernovar100.xml': [
    'Nokia',
    '7510 Supernova',
    'Series40',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N7600r100.xml': ['Nokia', '7600', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7600r200.xml': ['Nokia', '7600', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7610r100.xml': ['Nokia', '7610', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7610r100.xml': ['Nokia', '7610 Supernova', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7610Supernovar100.xml': [
    'Nokia',
    '7610 Supernova',
    'Series40',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N7650r100.xml': ['Nokia', '7650', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7650r200.xml': ['Nokia', '7650', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N7710r100.xml': ['Nokia', '7710', 'Series90', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N7900r100.xml': ['Nokia', '7900 Prism', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N801Tr100.xml': ['Nokia', '801T', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N808PureViewr100.xml': ['Nokia', '808 PureView', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N808PureViewr200.xml': ['Nokia', '808 PureView', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N808r100.xml': ['Nokia', '808 PureView', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N808r200.xml': ['Nokia', '808 PureView', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8310r100.xml': ['Nokia', '8310', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8600dr100.xml': ['Nokia', '8600 Luna', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800r100.xml': ['Nokia', '8800', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800r101.xml': ['Nokia', '8800', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800r200.xml': ['Nokia', '8800', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800r201.xml': ['Nokia', '8800', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800r300.xml': ['Nokia', '8800', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800r301.xml': ['Nokia', '8800', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800SIr100.xml': ['Nokia', '8800 Sirocco', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800SIr101.xml': ['Nokia', '8800 Sirocco', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800SIr200.xml': ['Nokia', '8800 Sirocco', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8800SIr201.xml': ['Nokia', '8800 Sirocco', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8801r100.xml': ['Nokia', '8801', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8801r101.xml': ['Nokia', '8801', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8801r200.xml': ['Nokia', '8801', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8801r201.xml': ['Nokia', '8801', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8801r300.xml': ['Nokia', '8801', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8801r301.xml': ['Nokia', '8801', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8801r400.xml': ['Nokia', '8801', 'Series40', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8801r401.xml': ['Nokia', '8801', 'Series40', DeviceType.MOBILE],
  'http://useragentprofile.hmdglobal.com/uaprof/Nokia88104Gr100.xml': [
    'Nokia',
    '8810 4G',
    'KaiOS',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/N8910r100.xml': ['Nokia', '8910', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N8910ir100.xml': ['Nokia', '8910i', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N9110r100.xml': ['Nokia', '9110 Communicator', 'GOES', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N9210r100.xml': ['Nokia', '9210 Communicator', 'Series80', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N9300r100.xml': ['Nokia', '9300', 'Series80', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N9300r100.xml': ['Nokia', '9300', 'Series80', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N9300ir100.xml': ['Nokia', '9300i', 'Series80', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N93kir100.xml': ['Nokia', '9300i', 'Series80', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N9300ir100.xml': ['Nokia', '9300i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/N9500r100.xml': ['Nokia', '9500 Communicator', 'Series90', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia200r100.xml': ['Nokia', 'Asha 200', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia201r100.xml': ['Nokia', 'Asha 201', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/202r100.xml': ['Nokia', 'Asha 202', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/203r100.xml': ['Nokia', 'Asha 203', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia205.1r100.xml': ['Nokia', 'Asha 205', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia205.3r100.xml': ['Nokia', 'Asha 205', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia205r100.xml': ['Nokia', 'Asha 205', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia206.1r100.xml': ['Nokia', 'Asha 206', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia206r100.xml': ['Nokia', 'Asha 206', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia210.3r100.xml': ['Nokia', 'Asha 210', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia210.4r100.xml': ['Nokia', 'Asha 210', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia210.5r100.xml': ['Nokia', 'Asha 210', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia210r100.xml': ['Nokia', 'Asha 210', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaAsha230DSr100.xml': [
    'Nokia',
    'Asha 230',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/NokiaAsha230SSr100.xml': [
    'Nokia',
    'Asha 230',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/300r100.xml': ['Nokia', 'Asha 300', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia302r100.xml': ['Nokia', 'Asha 302', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia303r100.xml': ['Nokia', 'Asha 303', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/305r100.xml': ['Nokia', 'Asha 305', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/305r200.xml': ['Nokia', 'Asha 305', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/306r100.xml': ['Nokia', 'Asha 306', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/308r100.xml': ['Nokia', 'Asha 308', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/309r100.xml': ['Nokia', 'Asha 309', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/Nokia310r100.xml': ['Nokia', 'Asha 310', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/311r100.xml': ['Nokia', 'Asha 311', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaAsha500DSr100.xml': [
    'Nokia',
    'Asha 500',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia501.1r100.xml': [
    'Nokia',
    'Asha 501',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia501.2r100.xml': [
    'Nokia',
    'Asha 501',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia501r100.xml': [
    'Nokia',
    'Asha 501',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia501sr100.xml': [
    'Nokia',
    'Asha 501',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia502r100.xml': [
    'Nokia',
    'Asha 502',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia503r100.xml': [
    'Nokia',
    'Asha 503',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/Nokia503sr100.xml': [
    'Nokia',
    'Asha 503',
    'Nokia Asha Platform',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/NokiaC1-01.1r100.xml': ['Nokia', 'C1-01', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC1-01r100.xml': ['Nokia', 'C1-01', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC1-02ir100.xml': ['Nokia', 'C1-02', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC1-02r100.xml': ['Nokia', 'C1-02', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC1-03r100.xml': ['Nokia', 'C1-03', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC2-00r100.xml': ['Nokia', 'C2-00', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC2-01r100.xml': ['Nokia', 'C2-01', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC2-02.1r100.xml': ['Nokia', 'C2-02', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC2-02r100.xml': ['Nokia', 'C2-02', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC2-03r100.xml': ['Nokia', 'C2-03', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC2-05.1r100.xml': ['Nokia', 'C2-05', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC2-05r100.xml': ['Nokia', 'C2-05', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC2-06r100.xml': ['Nokia', 'C2-06', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC3-00.1r100.xml': ['Nokia', 'C3-00', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC3-00r100.xml': ['Nokia', 'C3-00', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC3-01.5r100.xml': ['Nokia', 'C3-01', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC3-01r100.xml': ['Nokia', 'C3-01', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC5-00.2r100.xml': ['Nokia', 'C5-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC5-00r100.xml': ['Nokia', 'C5-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC5-03r100-3G.xml ': ['Nokia', 'C5-03', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC5-03r100-VF2G.xml': ['Nokia', 'C5-03', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC5-03r100-VF3G.xml': ['Nokia', 'C5-03', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC5-03r200-3G.xml': ['Nokia', 'C5-03', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC5-05r100-2G.xml ': ['Nokia', 'C5-05', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC5-06r100-2G.xml ': ['Nokia', 'C5-06', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC6-00.1r100.xml': ['Nokia', 'C6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC6-00r100-VF2G.xml': ['Nokia', 'C6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC6-00r100-VF3G.xml': ['Nokia', 'C6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaC6-00r100.xml': ['Nokia', 'C6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC6-01.3r100.xml': ['Nokia', 'C6-01', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC6-01.3r200.xml': ['Nokia', 'C6-01', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC6-01.3r300.xml': ['Nokia', 'C6-01', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC6-01r100.xml': ['Nokia', 'C6-01', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC6-01r200.xml': ['Nokia', 'C6-01', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC6-01r300.xml': ['Nokia', 'C6-01', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC6-01r310.xml': ['Nokia', 'C6-01', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00.1r100.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00r100-VF2G.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00r100-VF3G.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00r100.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00r200.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00r300-3G.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00r300.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00r310.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00sr100.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NC7-00sr210.xml': ['Nokia', 'C7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE5-00.2r100.xml': ['Nokia', 'E5-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE5-00r100-VF2G.xml': ['Nokia', 'E5-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE5-00r100-VF3G.xml': ['Nokia', 'E5-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE5-00r100.xml': ['Nokia', 'E5-00', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE50-1r100.xml': ['Nokia', 'E50', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE50-2r100-VF2G.xml': ['Nokia', 'E50', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE50-2r100.xml': ['Nokia', 'E50', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE51-1r100-VF3G.xml': ['Nokia', 'E51', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE51-1r100.xml': ['Nokia', 'E51', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE51-2r100.xml': ['Nokia', 'E51', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE52-1r100-vf3g.xml': ['Nokia', 'E52', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE52-1r100.xml': ['Nokia', 'E52', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE55-1r100.xml': ['Nokia', 'E55', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE6-00r100-VF2G.xml': ['Nokia', 'E6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE6-00r100-VF3G.xml': ['Nokia', 'E6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE6-00r100.xml': ['Nokia', 'E6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE6-00r210.xml': ['Nokia', 'E6-00', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE60-1r100-VF2G.xml': ['Nokia', 'E60', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE60-1r100-VF3G.xml': ['Nokia', 'E60', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE60-1r100-VFKK2G.xml': ['Nokia', 'E60', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE60-1r100-VFKK3G.xml': ['Nokia', 'E60', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE60-1r100.xml': ['Nokia', 'E60', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61-1r100-VF2G.xml': ['Nokia', 'E61', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61-1r100-VF3G.xml': ['Nokia', 'E61', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61-1r100-VFKK2G.xml': ['Nokia', 'E61', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61-1r100-VFKK3G.xml': ['Nokia', 'E61', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61-1r100.xml': ['Nokia', 'E61', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61i-1r100-VF2G.xml': ['Nokia', 'E61i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61i-1r100-VF2Gdrm10.xml': ['Nokia', 'E61i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61i-1r100-VF3G.xml': ['Nokia', 'E61i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61i-1r100-VF3Gdrm10.xml': ['Nokia', 'E61i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61i-1r100.xml': ['Nokia', 'E61i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61i-1r101.xml': ['Nokia', 'E61i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE61i-2r100.xml': ['Nokia', 'E61i', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE61i-1r100.xml': ['Nokia', 'E61i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE62-1r100.xml': ['Nokia', 'E62', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE63-1r100.xml': ['Nokia', 'E63', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE63-2r100.xml': ['Nokia', 'E63', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE63-3r100.xml': ['Nokia', 'E63', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE63r100.xml': ['Nokia', 'E63', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE65-1r100-VF2G.xml': ['Nokia', 'E65', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE65-1r100-VF2Gdrm10.xml': ['Nokia', 'E65', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE65-1r100-VF3G.xml': ['Nokia', 'E65', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE65-1r100-VF3Gdrm10.xml': ['Nokia', 'E65', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE65-1r100.xml': ['Nokia', 'E65', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE65-1r101.xml': ['Nokia', 'E65', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE65-2r100.xml': ['Nokia', 'E65', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE66-1r100-vf3g.xml': ['Nokia', 'E66', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE66-1r100.xml': ['Nokia', 'E66', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE66-2r100.xml': ['Nokia', 'E66', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE66r100.xml': ['Nokia', 'E66', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE7-00r100-VF2G.xml': ['Nokia', 'E7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE7-00r100-VF3G.xml': ['Nokia', 'E7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE7-00r100.xml': ['Nokia', 'E7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE7-00r200.xml': ['Nokia', 'E7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE7-00r300.xml': ['Nokia', 'E7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE7-00r310.xml': ['Nokia', 'E7-00', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE70-1r100-VF2G.xml': ['Nokia', 'E70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE70-1r100-VF3G.xml': ['Nokia', 'E70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE70-1r100-VFKK2G.xml': ['Nokia', 'E70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE70-1r100-VFKK3G.xml': ['Nokia', 'E70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE70-1r100.xml': ['Nokia', 'E70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE70-2r100.xml': ['Nokia', 'E70', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/ne71-1r100-vf2g.xml': ['Nokia', 'E71', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/ne71-1r100-vf3g.xml': ['Nokia', 'E71', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE71-1r100.xml': ['Nokia', 'E71', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE71-2r100.xml': ['Nokia', 'E71', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE71-3r100.xml': ['Nokia', 'E71', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE71r100.xml': ['Nokia', 'E71', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE71xr100-2G.xml': ['Nokia', 'E71x', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE71xr100-3G.xml': ['Nokia', 'E71x', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE72-1r100-vf2g.xml': ['Nokia', 'E72', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE72-1r100-vf3g.xml': ['Nokia', 'E72', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE72-1r100.xml': ['Nokia', 'E72', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE72-2r100.xml': ['Nokia', 'E72', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE72r100.xml': ['Nokia', 'E72', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE73r100.xml': ['Nokia', 'E73 Mode', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE75-1r100.xml': ['Nokia', 'E75 ', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE90-1r100-VF2G.xml': ['Nokia', 'E90', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE90-1r100-VF3G.xml': ['Nokia', 'E90', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NE90-1r100.xml': ['Nokia', 'E90', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NE90-1r100.xml': ['Nokia', 'E90 Communicator ', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NNGager100.xml': ['Nokia', 'N-Gage', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NNGageQDr100.xml': ['Nokia', 'N-Gage QD', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NNGageQDr200.xml': ['Nokia', 'N-Gage QD', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NNGQDr100.xml': ['Nokia', 'N-Gage QD', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NNGQDr200.xml': ['Nokia', 'N-Gage QD', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN70-1r100-VF2G.xml': ['Nokia', 'N70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN70-1r100-VF2GMIP.xml': ['Nokia', 'N70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN70-1r100-VF3G.xml': ['Nokia', 'N70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN70-1r100-VF3GMIP.xml': ['Nokia', 'N70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN70-1r100-VFKK2G.xml': ['Nokia', 'N70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN70-1r100-VFKK3G.xml': ['Nokia', 'N70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN70-1r100.xml': ['Nokia', 'N70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN70-5r100.xml': ['Nokia', 'N70', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN70-1r100.xml': ['Nokia', 'N70', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN71-1r100-VFKK2G.xml': ['Nokia', 'N71', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN71-1r100-VFKK3G.xml': ['Nokia', 'N71', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN71-1r100.xml': ['Nokia', 'N71', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN71-1r101.xml': ['Nokia', 'N71', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN72r100.xml': ['Nokia', 'N72', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN72r100.xml': ['Nokia', 'N72', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-1r100-SB2G.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-1r100-SB3G.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-1r100-VF2G.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-1r100-VF2GMIP.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-1r100-VF3G.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-1r100-VF3GMIP.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-1r100.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-2r100.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-5r100.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73-6r100.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN73r100.xml': ['Nokia', 'N73', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN75-3r100.xml': ['Nokia', 'N75', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN75-3r200.xml': ['Nokia', 'N75', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN75-3r300.xml': ['Nokia', 'N75', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN76-1r100.xml': ['Nokia', 'N76', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN76-1r100.xml': ['Nokia', 'N76', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN77-1r100.xml': ['Nokia', 'N77', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN77r100.xml': ['Nokia', 'N77', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN78-1r100-VF2G.xml': ['Nokia', 'N78', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN78-1r100-VF3G.xml': ['Nokia', 'N78', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN78-1r100.xml': ['Nokia', 'N78', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN79-1r100.xml': ['Nokia', 'N79', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N8r200.xml': ['Nokia', 'N8', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NC7-00r100.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN8-00.1r100-3G.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN8-00.1r200-3G.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN8-00.1r300-3G.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN8-00r100-3G.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN8-00r100-VF2G.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN8-00r100-VF3G.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN8-00r200-3G.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN8-00r300-3G.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN8-00r310-3G.xml': ['Nokia', 'N8-00', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN80-1r100-VF2G.xml': ['Nokia', 'N80', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN80-1r100-VF3G.xml': ['Nokia', 'N80', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN80-1r100.xml': ['Nokia', 'N80', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN80-3r100.xml': ['Nokia', 'N80', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN81-1r100.xml': ['Nokia', 'N81', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/N81r100.xml': ['Nokia', 'N81', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN81-1r100-VF2G.xml': ['Nokia', 'N81', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN81-1r100.xml': ['Nokia', 'N81', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN81-3r100.xml': ['Nokia', 'N81', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN82-1r100.xml': ['Nokia', 'N82', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN85-1r100-VF2G.xml': ['Nokia', 'N85', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN85-1r100-VF3G.xml': ['Nokia', 'N85', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN85-1r100.xml': ['Nokia', 'N85', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN85-3r100.xml': ['Nokia', 'N85', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN85r100.xml': ['Nokia', 'N85', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN86-1r100.xml': ['Nokia', 'N86 8MP', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN86-3r100.xml': ['Nokia', 'N86 8MP', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN90-1r100-VF2G.xml': ['Nokia', 'N90', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN90-1r100-VF3G.xml': ['Nokia', 'N90', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN90-1r100-VFKK2G.xml': ['Nokia', 'N90', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN90-1r100-VFKK3G.xml': ['Nokia', 'N90', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN90-1r100.xml': ['Nokia', 'N90', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN91-1r100-VF2G.xml': ['Nokia', 'N91', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN91-1r100-VF3G.xml': ['Nokia', 'N91', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN91-1r100.xml': ['Nokia', 'N91', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN91-2r100.xml': ['Nokia', 'N91', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN91-5r100.xml': ['Nokia', 'N91', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN91-6r100.xml': ['Nokia', 'N91', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN91r100.xml': ['Nokia', 'N91', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN92-1r100.xml': ['Nokia', 'N92', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN92-2r100.xml': ['Nokia', 'N92', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN93-1r100-VF2G.xml': ['Nokia', 'N93', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN93-1r100-VF3G.xml': ['Nokia', 'N93', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN93-1r100.xml': ['Nokia', 'N93', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN93r100.xml': ['Nokia', 'N93', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN93i-1r100-VF2G.xml': ['Nokia', 'N93i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN93i-1r100-VF3G.xml': ['Nokia', 'N93i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN93i-1r100.xml': ['Nokia', 'N93i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN93ir100.xml': ['Nokia', 'N93i', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN95-1r100-VF2G.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN95-1r100-VF2GMIP.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN95-1r100-VF3G.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN95-1r100-VF3GMIP.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN95-1r100.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN95-3r100.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN95-5r100.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NN95_8GB-1r100.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN95-1r100-VF2G.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN95-1r100.xml': ['Nokia', 'N95', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN95_8GB-1r100-VF3G.xml': ['Nokia', 'N95 8GB', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN95_8GB-1r100.xml': ['Nokia', 'N95 8GB', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN95_8GB-3r100.xml': ['Nokia', 'N95 8GB', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN95-3r100.xml': ['Nokia', 'N95-3 NAM', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN96-1r100.xml': ['Nokia', 'N96', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN96-3r100.xml': ['Nokia', 'N96', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN96r100.xml': ['Nokia', 'N96', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-1r100-2G.xml': ['Nokia', 'N97', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-1r100-3G.xml': ['Nokia', 'N97', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-3r100-2G.xml': ['Nokia', 'N97', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-3r100-3G.xml': ['Nokia', 'N97', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97ir100-2G.xml': ['Nokia', 'N97', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97r100-2G.xml': ['Nokia', 'N97', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaN97-1r100-3G.xml ': ['Nokia', 'N97', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaN97-4r100-3G.xml ': ['Nokia', 'N97', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN9-00r100-R.xml': ['Nokia', 'N97 Mini', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-4r100-2G.xml': ['Nokia', 'N97 Mini', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-4r100-3G-VF2G.xml': ['Nokia', 'N97 Mini', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-4r100-3G-VF3G.xml': ['Nokia', 'N97 Mini', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-4r100-3G.xml': ['Nokia', 'N97 Mini', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-5r100-2G.xml': ['Nokia', 'N97 Mini', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97-5r100-3G.xml': ['Nokia', 'N97 Mini', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97minir100-2G.xml': ['Nokia', 'N97 Mini', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NN97minir100-3G.xml': ['Nokia', 'N97 Mini', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NSU7r100.xml': ['Nokia', 'SU-7', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NT7-00r100.xml': ['Nokia', 'T7-00', 'Series60', DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NTHR880ir100.xml': ['Nokia', 'THR880i', null, DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX2-00r100.xml': ['Nokia', 'X2-00', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX2-01.1r100.xml': ['Nokia', 'X2-01', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX2-01r100.xml': ['Nokia', 'X2-01', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX2-02r100.xml': ['Nokia', 'X2-02', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX2-03r100.xml': ['Nokia', 'X2-03', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX2-05r100.xml': ['Nokia', 'X2-05', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX3-00r100.xml': ['Nokia', 'X3-00', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX3-02.5r100.xml': ['Nokia', 'X3-02', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX3-02r100.xml': ['Nokia', 'X3-02', 'Series40', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX5-00r100.xml': ['Nokia', 'X5-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX5-01r100.xml': ['Nokia', 'X5-01', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX6-00.1r100-3G.xml ': ['Nokia', 'X6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX6-00mr100-2G.xml': ['Nokia', 'X6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX6-00r100-2G.xml ': ['Nokia', 'X6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX6-00r100-3G.xml': ['Nokia', 'X6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NokiaX6-00r100-VF2G.xml': ['Nokia', 'X6-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX7-00.1r100-3G.xml': ['Nokia', 'X7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX7-00r100-3G.xml': ['Nokia', 'X7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX7-00r100-VF3G.xml': ['Nokia', 'X7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX7-00r200-3G.xml': ['Nokia', 'X7-00', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NX7-00r210-3G.xml': ['Nokia', 'X7-00', 'Series60', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/nubia_NX501_Z54.xml': ['Nubia', 'Z5', 'Android', DeviceType.MOBILE],
  'http://nyxmobile.com/UAProfile/fly/NYX_FLY.xml': ['Nyx', 'Fly', 'Android', DeviceType.MOBILE],
  'http://www.nyxmobile.com/UAProfile/flyii/NYX_FLY_II.xml': ['NYX Mobile', 'Fly II', 'Android', DeviceType.MOBILE],
  'http://www.nyxmobile.com/UAProfile/join/NYX_JOIN.xml': ['NYX Mobile', 'Join', 'Android', DeviceType.MOBILE],
  'http://www.nyxmobile.com/UAProfile/nobaii/NYX_NOBA_II.xml': [
    'NYX Mobile',
    'Noba II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.nyxmobile.com/UAProfile/orbis/NYX_ORBIS_LL.xml': ['NYX Mobile', 'Orbis', 'Android', DeviceType.MOBILE],
  'http://www.seeo2.com/uaprofile/uaprof-atomlife.xml': ['O2', 'Comet', null, DeviceType.MOBILE],
  'http://www.seeo2.com/uaprofile/uaprof-atomexec.xml': ['O2', 'Xda Exec', null, DeviceType.MOBILE],
  'http://www.seeo2.com/uaprofile/uaprof-stealth.xml': ['O2', 'XDA Stealth', null, DeviceType.MOBILE],
  'http://www.obimobiles.com/UAP/S500.xml': ['Obi', 'Yeti S500', 'Android', DeviceType.MOBILE],
  'http://www.okwap.com.cn/uaprof/d88/d88profile.xml': ['Okwap', 'D88', null, DeviceType.MOBILE],
  'http://www.okwap.com.cn/uaprof/km63/km63profile.xml': ['Okwap', 'KM63', null, DeviceType.MOBILE],
  'http://www.okwap.com.cn/uaprof/km65/km65profile.xml': ['Okwap', 'KM65', null, DeviceType.MOBILE],
  'http://www.ondacommunication.com/ua/N1010.xml': ['Onda', 'N1010', null, DeviceType.MOBILE],
  'http://www.ondacommunication.com/ua/N5010.xml': ['Onda', 'N5010', null, DeviceType.MOBILE],
  'http://www.ondacommunication.com/ua/TT101.xml': ['Onda', 'TT101', 'Android', DeviceType.TABLET],
  'http://www.ondacommunication.com/ua/TT102.xml': ['Onda', 'TT102', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOA0001.xml': ['OnePlus', 'One', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/ONEPLUSA0001.xml': ['OnePlus', 'One', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOA0001.xml': ['OnePlus', 'One', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-ONIDA F970.xml': ['Onida', 'F970', null, DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPO1100.xml': ['Oppo', '1100', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPO1105.xml': ['Oppo', '1105', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPO1107.xml': ['Oppo', '1107', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPO3005.xml': ['Oppo', '3005', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A30.xml': ['Oppo', 'A30', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOA31.xml': ['Oppo', 'A31', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOA31c.xml': ['Oppo', 'A31c', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOA31t.xml': ['Oppo', 'A31t', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A31t.xml': ['Oppo', 'A31t', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOA31u.xml': ['Oppo', 'A31u', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A33.xml': ['Oppo', 'A33', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A33m.xml': ['Oppo', 'A33m', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A37m.xml': ['Oppo', 'A37m', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A53.xml': ['Oppo', 'A53', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A53m.xml': ['Oppo', 'A53m', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A57.xml': ['Oppo', 'A57', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A57t.xml': ['Oppo', 'A57t', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A59m.xml': ['Oppo', 'A59m', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A59s.xml': ['Oppo', 'A59s', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A59st.xml': ['Oppo', 'A59st', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A77.xml': ['Oppo', 'A77', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO A77t.xml': ['Oppo', 'A77t', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR827.xml': ['Oppo', 'Find 5 mini R827', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR2001.xml': ['Oppo', 'Find 5 mini R827T', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR827T.xml': ['Oppo', 'Find 5 mini R827T', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOX909T.xml': ['Oppo', 'Find 5 X909', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOR6006.xml': [
    'Oppo',
    'Find 7 mini R6006',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOFIND7.xml': ['Oppo', 'Find 7 X9070', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOX9070.xml': ['Oppo', 'Find 7 X9070', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOX9076.xml': ['Oppo', 'Find 7 X9076', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOX9077.xml': ['Oppo', 'Find 7 X9077', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOX9000.xml': ['Oppo', 'Find 7a X9000', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOX9006.xml': ['Oppo', 'Find 7a X9006', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOX9007.xml': ['Oppo', 'Find 7a X9007', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR815.xml': ['Oppo', 'Find Clover R815', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR815T.xml': ['Oppo', 'Find Clover R815', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR821T.xml': ['Oppo', 'Find Muse R821T', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOU707.xml': ['Oppo', 'Find Way S U707', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPON1.xml': ['Oppo', 'N1', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPON5111.xml': ['Oppo', 'N1 mini', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPON5116.xml': ['Oppo', 'N1 mini', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPON5110.xml': ['Oppo', 'N1 mini', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPON5117.xml': ['Oppo', 'N1 mini', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPON5207.xml': ['Oppo', 'N3', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPON5209.xml': ['Oppo', 'N3', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPON828.xml': ['Oppo', 'N828', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOR831L.xml': ['Oppo', 'Neo 5 R831L', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOR831.xml': ['Oppo', 'Neo R831', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR829.xml': ['Oppo', 'R1 R829', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR829T.xml': ['Oppo', 'R1 R829T', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R11.xml': ['Oppo', 'R11', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R11 Plus.xml': ['Oppo', 'R11 Plus', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R11 Plusk.xml': ['Oppo', 'R11 Plus', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R11 Pluskt.xml': ['Oppo', 'R11 Plus', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R11t.xml': ['Oppo', 'R11t', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR8200.xml': ['Oppo', 'R1c R8200', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR8207.xml': ['Oppo', 'R1c R8207', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOR8006.xml': ['Oppo', 'R1L R8006', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR8000.xml': ['Oppo', 'R1S R8000', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR8007.xml': ['Oppo', 'R1S R8007', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOR8201.xml': ['Oppo', 'R1x R8201', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOR8206.xml': ['Oppo', 'R1x R8206', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR2010.xml': ['Oppo', 'R2010', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR2017.xml': ['Oppo', 'R2017', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR7007.xml': ['Oppo', 'R3 R7007', 'Android', DeviceType.MOBILE],
  'http://ua.prof.oppo.com/resource/ua-PROF/OPPOR8106.xml': ['Oppo', 'R5 R8106', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR8107.xml': ['Oppo', 'R5 R8107', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR6007.xml': ['Oppo', 'R6007', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R7.xml': ['Oppo', 'R7', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR7.xml': ['Oppo', 'R7', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR7Plus.xml': ['Oppo', 'R7 Plus', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR7Plusm.xml': ['Oppo', 'R7 Plus', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR7005.xml': ['Oppo', 'R7005', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR7c.xml': ['Oppo', 'R7c', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R7s.xml': ['Oppo', 'R7s', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR7s.xml': ['Oppo', 'R7s', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R7sPlus.xml': ['Oppo', 'R7s Plus', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R7sm.xml': ['Oppo', 'R7sm', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR7st.xml': ['Oppo', 'R7st', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R7t.xml': ['Oppo', 'R7t', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR7t.xml': ['Oppo', 'R7t', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR809T.xml': ['Oppo', 'R809', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR813T.xml': ['Oppo', 'R813', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR819.xml': ['Oppo', 'R819', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR8205.xml': ['Oppo', 'R8205', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR823T.xml': ['Oppo', 'R823', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR831S.xml': ['Oppo', 'R831S', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR833T.xml': ['Oppo', 'R833T', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR850.xml': ['Oppo', 'R850', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9 Plusm A.xml': ['Oppo', 'R9 Plus', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9 Plustm A.xml': ['Oppo', 'R9 Plus', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9km.xml': ['Oppo', 'R9km', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9m.xml': ['Oppo', 'R9m', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9s.xml': ['Oppo', 'R9s', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9s Plus.xml': ['Oppo', 'R9s Plus', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9sk.xml': ['Oppo', 'R9sk', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9st.xml': ['Oppo', 'R9st', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9t.xml': ['Oppo', 'R9t', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOOPPO R9tm.xml': ['Oppo', 'R9tm', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR811.xml': ['Oppo', 'Real R811', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR817T.xml': ['Oppo', 'Real R817', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOR819T.xml': ['Oppo', 'Real R819T', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOU707T.xml': ['Oppo', 'U2S U707T', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOU705T.xml': ['Oppo', 'U705T', 'Android', DeviceType.MOBILE],
  'http://www.gigabytecm.com/ua/Boston4G.xml': ['Optimus', 'Boston 4G', 'Android', DeviceType.MOBILE],
  'http://www.qisda.com/UserFiles/uaprof_boston_4g.xml': ['Optimus', 'Boston 4G', 'Android', DeviceType.MOBILE],
  'https://s3-eu-west-1.amazonaws.com/fotabucket/uaprof/uaprof_qisda_boston.xml': [
    'Optimus',
    'Boston 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.opto.co.jp/win_ht/uaprof/H-21-1.0.xml': ['Opto', 'H-21', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/Amoi-Berlin.xml': ['Orange', 'Berlin', null, DeviceType.MOBILE],
  'http://eip2.gigabytecm.com/BOSTON-OPO.xml': ['Orange', 'Boston', 'Android', DeviceType.MOBILE],
  'http://eip2.gigabytecm.com/BOSTON-P2.xml': ['Orange', 'Boston', 'Android', DeviceType.MOBILE],
  'http://eip2.gigabytecm.com/Orange-BOSTON.xml': ['Orange', 'Boston', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Orange Covo.xml': ['Orange', 'Covo', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG510-0200GPRS-Orange.xml': [
    'Orange',
    'Daytona',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://config.51coolpad.com/UAProfile/Orange/Orange-Fova.xml': ['Orange', 'Fova', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG535-L11LTE-OrangeGova.xml': ['Orange', 'Gova', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Orange_Hi_4G.xml': ['Orange', 'Hi', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Orange_Hiro.xml': ['Orange', 'Hiro', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Orange_infinity_996.xml': [
    'Orange',
    'Infinity 996',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/Infinity_X.xml': ['Orange', 'Infinity X', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Orange_KLIF.xml': ['Orange', 'Kilf', 'Firefox OS', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Orange_KLIFD.xml': ['Orange', 'Kilf', 'Firefox OS', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Orange-Kivo.xml': ['Orange', 'Kivo', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY330-U01-OrangeLuno.xml': ['Orange', 'Luno', 'Android', DeviceType.MOBILE],
  'http://www.amobile.com.cn/ua/Amoi-NewYork.xml': ['Orange', 'New York', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Orange_Niva.xml': ['Orange', 'Nivo', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Orange_Nura.xml': ['Orange', 'Nura', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Nura 2.xml': ['Orange', 'Nura 2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Orange_Reyo.xml': ['Orange', 'Reyo', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Orange_Rono.xml': ['Orange', 'Rono', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Orange_Roya.xml': ['Orange', 'Roya', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Orange-San-Francisco.xml': [
    'Orange',
    'San Francisco',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/gen/Excal-1.0.xml': ['Orange', 'SPV E600', null, DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/ph10cd-1.0.xml': ['Orange', 'SPV M1500', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/gen/st21-1.0.xml': ['Orange', 'SPV V550', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Orange_Tado.xml': ['Orange', 'Tado', 'Android', DeviceType.MOBILE],
  'http://www.modelabs.com/uaprofs/Orange-Tokyo.xml': ['Orange', 'Tokyo', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiG740-L00LTE-OrangeYumo.xml': ['Orange', 'Yumo', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Orange-Zali.xml': ['Orange', 'Zali', 'Android', DeviceType.MOBILE],
  'http://www.huaqin.com/mobile/uaprof/Zilo.xml': ['Orange', 'Zilo', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Bucare_Y330-U05_UAProfile.xml': [
    'Orinoquia',
    'Bucare Y330',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/Kavak_Y625_U03_UAProfile.xml': [
    'Orinoquia',
    'Kavak Y625',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/5054A.xml': ['Own', 'S4035 4G', 'Android', DeviceType.MOBILE],
  'http://www.oysters.ru/UAProfile/Arctic450_UAProfile.xml': ['Oysters', 'Arctic 450', 'Android', DeviceType.MOBILE],
  'http://support.acer.com/UAprofile/Acer_G100W_Profile.xml': [
    'Packard Bell',
    'Liberty Tab G100W',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.palm.com/permalinks/mmsuaprofs/ASUS_Crown_1.xml': ['Palm', 'Treo 500', 'Palm OS', DeviceType.MOBILE],
  'http://www.handspring.com/profilespecs/Blazer300_OR.rdf': ['Palm', 'Treo 600', 'Palm OS', DeviceType.MOBILE],
  'http://device.sprintpcs.com/PALMONE/POTR650HK/Blazer400103.rdf': [
    'Palm',
    'Treo 650',
    'Palm OS',
    DeviceType.MOBILE,
  ],
  'http://downloads.palmone.com/profiles/Blazer400.rdf': ['Palm', 'Treo 650', 'Palm OS', DeviceType.MOBILE],
  'http://downloads.palm.com/profiles/Blazer453-ROW.rdf': ['Palm', 'Treo 680', 'Palm OS', DeviceType.MOBILE],
  'http://device.sprintpcs.com/PALM/PTR700PHK/Blazer450108.rdf': ['Palm', 'Treo 700', 'Palm OS', DeviceType.MOBILE],
  'http://downloads.palm.com/profiles/Blazer450.rdf': ['Palm', 'Treo 700p', 'Palm OS', DeviceType.MOBILE],
  'http://downloads.palm.com/profiles/Treo750R1.rdf': ['Palm', 'Treo 750', 'Palm OS', DeviceType.MOBILE],
  'http://downloads.palm.com/profiles/Treo750R2.rdf': ['Palm', 'Treo 750', 'Palm OS', DeviceType.MOBILE],
  'http://device.sprintpcs.com/PALM/PTR755PHK/Blazer450104.rdf': ['Palm', 'Treo 755', 'Palm OS', DeviceType.MOBILE],
  'http://device.sprintpcs.com/PALM/PTR800HK/IEM101.rdf': ['Palm', 'Treo 800', 'Palm OS', DeviceType.MOBILE],
  'http://downloads.palm.com/profiles/Blazer400.rdf': ['Palm', 'TX', 'Palm OS', DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/A200/R1.xml': ['Panasonic', 'A200', null, DeviceType.MOBILE],
  'http://dlcache.mobile.pfota.com/Panasonic/UAProf/DL1R1.xml': [
    'Panasonic',
    'Eluga dL1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://vodafone.51coolpad.com/UAProfile/vodafone/Q475.xml': [
    'Panasonic',
    'Eluga L',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/Panasonic_ELUGA_Switch.xml': [
    'Panasonic',
    'Eluga Switch',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://mobileinternet.panasonicbox.com/UAprof/G50/R1.xml': ['Panasonic', 'G50', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/G60/R1.xml': ['Panasonic', 'G60', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/G70/R1.xml': ['Panasonic', 'G70', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/GD67/04.xml': ['Panasonic', 'GD67', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/GD67/R1.xml': ['Panasonic', 'GD67', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/GD67/R2.xml': ['Panasonic', 'GD67', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/GD86A/R1.xml': ['Panasonic', 'GD86', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/GD87/01.xml': ['Panasonic', 'GD87', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/GD87/R1.xml': ['Panasonic', 'GD87', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/GD88/R1.xml': ['Panasonic', 'GD88', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/GD88D/R1.xml': ['Panasonic', 'GD88', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/GU87/R1.xml': ['Panasonic', 'GU87', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/PANASONIC_P31.xml': ['Panasonic', 'P31', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Panasonic P51.xml': ['Panasonic', 'P51', 'Android', DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/SA7/RP1.xml': ['Panasonic', 'SA7', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Panasonic_T31.xml': ['Panasonic', 'T31', 'Android', DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/vs2/RP1.xml': ['Panasonic', 'VS2', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/VS7/RP1.xml': ['Panasonic', 'VS7', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/VS7aI/RJ1_3G.xml': ['Panasonic', 'VS7', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/VS7aII/RJ1_3G.xml': ['Panasonic', 'VS7', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/VS7x/RJ1_3G.xml': ['Panasonic', 'VS7', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/VS70/RJ1_3G.xml': ['Panasonic', 'VS70', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/VS8x/RJ1_3G.xml': ['Panasonic', 'VS8', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X200/R1.xml': ['Panasonic', 'X200', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X200/RP1.xml': ['Panasonic', 'X200', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X300/R1.xml': ['Panasonic', 'X300', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X400/RP1.xml': ['Panasonic', 'X400', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X410/R1.xml': ['Panasonic', 'X410', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X500/R1.xml': ['Panasonic', 'X500', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X60/R1-D2.xml': ['Panasonic', 'X60', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X60/R1.xml': ['Panasonic', 'X60', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X60/R1new.xml': ['Panasonic', 'X60', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X66/R1.xml': ['Panasonic', 'X66', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/x68/R1.xml': ['Panasonic', 'X68', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X70/R1.xml': ['Panasonic', 'X70', null, DeviceType.MOBILE],
  'http://mobileinternet.panasonicbox.com/UAprof/X700/X700R1.xml': [
    'Panasonic',
    'X700',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://mobileinternet.panasonicbox.com/UAprof/X701/X701R1.xml': [
    'Panasonic',
    'X700',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://mobileinternet.panasonicbox.com/UAprof/X800/X800R1.xml': [
    'Panasonic',
    'X800',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/pcd/adr8995/adr8995.xml': ['Pantech', 'Breakout', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/STARQ/adr8995.xml': ['Pantech', 'Breakout', 'Android', DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/Gsm/C520.xml': ['Pantech', 'Breeze', null, DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P9070.xml': ['Pantech', 'Burst', 'Android', DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P9070R01.xml': ['Pantech', 'Burst', 'Android', DeviceType.MOBILE],
  'http://www.pantech.com/UAPROF/GSM/PG-C150.XML': ['Pantech', 'C150', null, DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/Gsm/PG-C300J.xml': ['Pantech', 'C300', null, DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-C630.xml': ['Pantech', 'C630', null, DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P8000.xml': ['Pantech', 'Crossover', 'Android', DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P8000R01.xml': ['Pantech', 'Crossover', 'Android', DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-C810.xml': ['Pantech', 'Duo', null, DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P4100.xml': ['Pantech', 'Element', 'Android', DeviceType.TABLET],
  'http://www.pantech.com/Uaprof/umts/PU-P4100R01.xml': ['Pantech', 'Element', 'Android', DeviceType.TABLET],
  'http://www.pantech.com/Uaprof/umts/PU-P8010.xml': ['Pantech', 'Flex', 'Android', DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P8010R01.xml': ['Pantech', 'Flex', 'Android', DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P9090.xml': ['Pantech', 'Magnus', 'Android', DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P9090R01.xml': ['Pantech', 'Magnus', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/adr910l/adr910l.xml': ['Pantech', 'Marauder', 'Android', DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-C740.xml': ['Pantech', 'Matrix', null, DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P6020.xml': ['Pantech', 'P6020', 'Brew', DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P6030.xml': ['Pantech', 'P6030', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/pcd/adr930l/adr930l.xml': ['Pantech', 'Perception', 'Android', DeviceType.MOBILE],
  'http://device.telusmobility.com/pantech/PN3200-0.rdf': ['Pantech', 'PN-3200', null, DeviceType.MOBILE],
  'http://www.pantech.com/Uaprof/umts/PU-P9060.xml': ['Pantech', 'Pocket', 'Android', DeviceType.MOBILE],
  'http://www.pantech.co.kr/Uaprof/Gsm/S100J.xml': ['Pantech', 'S100', null, DeviceType.MOBILE],
  'http://mobileuaprof.xtra.co.nz/h_tx215c.rdf': ['Pantech', 'TX215', null, DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/vega-ptl21.xml': ['Pantech', 'Vega Nº6', 'Android', DeviceType.MOBILE],
  'http://ota.phicomm.com.cn/MobileProfile/C630LwRU-UA-Profile.xml': [
    'Phicomm',
    'Clue L',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.consumer.philips.com/wbu/uap289.xml': ['Philips', '289', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uap330.xml': ['Philips', '330', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uap350.xml': ['Philips', '350', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uap530.xml': ['Philips', '530', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uap568.xml': ['Philips', '568', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uap650.xml': ['Philips', '650', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uap755.xml': ['Philips', '755', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uap766.xml': ['Philips', '766', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uap960.xml': ['Philips', '960', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uapCT9A9G.xml': ['Philips', '9A9G', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uapPHILIPS9A9W.xml': ['Philips', '9A9W', null, DeviceType.MOBILE],
  'www-ccpp.tcl-ta.com/files/PI3210G.xml': ['Philips', 'Amio 7', 'Android', DeviceType.TABLET],
  'http://www.consumer.philips.com/wbu/uapP199.xml': ['Philips', 'P100', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uapP598.xml': ['Philips', 'P598', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uapW3550.xml': ['Philips', 'S309', 'Android', DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uapS890.XML': ['Philips', 'S890', null, DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uapW3568.xml': ['Philips', 'W3568', 'Android', DeviceType.MOBILE],
  'http://www.consumer.philips.com/wbu/uapX525.xml': ['Philips', 'X331', 'MTK', DeviceType.MOBILE],
  'http://uriver.co.kr/UAprof/UAprof_M801.xml': ['PhoneOne', 'M801', null, DeviceType.MOBILE],
  'http://www.coobery.com/mobile/Suning_S90w_UAProfile.xml': ['Pioneer', 'S90w', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiMediaPad7951WDWIFIOnly.xml': [
    'PLDT',
    'Telpad Dual S',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.diamond-electronics.com/xmlfiles/PSPC550.XML': ['Polaroid', 'Cosmo 550', 'Android', DeviceType.MOBILE],
  'http://www.diamond-electronics.com/xmlfiles/P5526A.xml': [
    'Polaroid',
    'Cosmo K Plus',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.diamond-electronics.com/xmlfiles/P5046A.xml': [
    'Polaroid',
    'Cosmo P5s Dorado',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.diamond-electronics.com/xmlfiles/P5525A.xml': [
    'Polaroid',
    'Cosmo Q5s Gris',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.diamond-electronics.com/xmlfiles/P4005A.xml': ['Polaroid', 'P4005A', 'Android', DeviceType.MOBILE],
  'http://www.gfivemobile.com/en/xml/PMID703GK.xml': ['Polaroid', 'PMID 703gk', 'Android', DeviceType.MOBILE],
  'http://www.diamond-electronics.com/xmlfiles/PMID704GK.XML': [
    'Polaroid',
    'PMID 704gk',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.diamond-electronics.com/xmlfiles/P4006A.XML': [
    'Polaroid',
    'Polaroid P4006A',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.diamond-electronics.com/xmlfiles/PMID7102DC.xml': [
    'Polaroid',
    'Polaroid PMID7102DC',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.diamond-electronics.com/xmlfiles/PSPC505.XML': ['Polaroid', 'PSPC505', 'Android', DeviceType.MOBILE],
  'http://www.diamond-electronics.com/xmlfiles/PSPT350_UAProfile.xml': [
    'Polaroid',
    'PSPT350',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.diamond-electronics.com/xmlfiles/PSPT401.xml': ['Polaroid', 'Turbo 401', 'Android', DeviceType.MOBILE],
  'http://www.diamond-electronics.com/xmlfiles/P4525A.XML': [
    'Polaroid',
    'Turbo C4 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.diamond-electronics.com/xmlfiles/P5005A.XML': ['Polaroid', 'Turbo C5', 'Android', DeviceType.MOBILE],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PGPS7795_V1.xml': ['Prestigio', 'Geovision Tour', 'Android'],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP7557_V1.xml': [
    'Prestigio',
    'Grace 7557',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP5670C_DUO_V1.xml': [
    'Prestigio',
    'Multipad 2 Pro Duo 7.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7380D3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 2 Pro Quad 8.0 3G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7280C3G_DUO_PL_V1.xml': [
    'Prestigio',
    'Multipad 2 Ultra Duo 8.0 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7280C3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 2 Ultra Duo 8.0 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7110D3G_V1.xml': [
    'Prestigio',
    'Multipad 4 Diamond 10.1 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT7177_3G_V1.xml': [
    'Prestigio',
    'Multipad 4 Diamond 10.1 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7079D_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 4 Diamond 7.85',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7079D3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 4 Diamond 7.85 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7079E3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 4 Diamond 7.85 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT7077_3G_V1.xml': [
    'Prestigio',
    'Multipad 4 Diamond 7.85 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP5101C3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 4 Quantum 10.1 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP5101D3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 4 Quantum 10.1 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP5785C3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 4 Quantum 7.85 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT7287_3G_V1.xml': [
    'Prestigio',
    'Multipad 4 Ultra Quad 8.0 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7100D3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 7100',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7280D3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 7280',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP7480D3G_QUAD_V1.xml': [
    'Prestigio',
    'Multipad 7480',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT5777_3G_V1.xml': [
    'Prestigio',
    'Multipad Color 7.0 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT5887_3G_V1.xml': [
    'Prestigio',
    'Multipad Color 8.0 3G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT5001_3G_V1.xml': [
    'Prestigio',
    'Multipad Muze 5001 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT5008_3G_V1.xml': [
    'Prestigio',
    'Multipad Muze 5008 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT5487_3G_V1.xml': [
    'Prestigio',
    'Multipad Quantum 8.0 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT3277_3G_V1.xml': [
    'Prestigio',
    'Multipad Ranger 7.0 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT3287_3G_V1.xml': [
    'Prestigio',
    'Multipad Ranger 8.0 3G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT5287_4G_V1.xml': [
    'Prestigio',
    'Multipad Ranger 8.0 4G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT7077_4G_V1.xml': [
    'Prestigio',
    'Multipad Ranger 8.0 4G',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP3007C_V1.xml': [
    'Prestigio',
    'Multipad Rider 7.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMP3007C3G_V1.xml': [
    'Prestigio',
    'Multipad Rider 7.0 3G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT7787_3G_V1.xml': [
    'Prestigio',
    'Multipad Thunder 8.0i',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT3057_3G_V1.xml': [
    'Prestigio',
    'Multipad Wize 3057',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT3067_3G_V1.xml': [
    'Prestigio',
    'Multipad Wize 3067',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/tablets/PMT5002_Wi_V1.xml': [
    'Prestigio',
    'Multipad Wize 5002',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP3350DUO_V1.xml': [
    'Prestigio',
    'Multiphone 3350 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP3400DUO_V1.xml': [
    'Prestigio',
    'Multiphone 3400 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP3404DUO_V1.xml': [
    'Prestigio',
    'Multiphone 3404 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP3405DUO_V1.xml': [
    'Prestigio',
    'Multiphone 3405 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP3450DUO_V1.xml': [
    'Prestigio',
    'Multiphone 3450 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP3502DUO_V1.xml': [
    'Prestigio',
    'Multiphone 3502 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP3540DUO_Polcomtel_V1.xml': [
    'Prestigio',
    'Multiphone 3540 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP3540DUO_V1.xml': [
    'Prestigio',
    'Multiphone 3540 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP4044DUO_V1.xml': [
    'Prestigio',
    'Multiphone 4044 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP4055DUO_V1.xml': [
    'Prestigio',
    'Multiphone 4055 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP4322DUO_V1.xml': [
    'Prestigio',
    'Multiphone 4322 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP4500TDUO_V1.XML': [
    'Prestigio',
    'Multiphone 4500 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP5000DUO_V1.XML': [
    'Prestigio',
    'Multiphone 5000 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP5000TDUO_V1.XML': [
    'Prestigio',
    'Multiphone 5000 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP5044DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5044 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP5430_V1.xml': [
    'Prestigio',
    'Multiphone 5430',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP5450DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5450 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP5451DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5451 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5453DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5453 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5454DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5454 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5455_DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5455 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP5500DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5500 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP5501_V1.xml': [
    'Prestigio',
    'Multiphone 5501',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5504DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5504 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5505DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5505 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5507DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5507 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5508DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5508 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5517DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5517 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5550DUO_V1.xml': [
    'Prestigio',
    'Multiphone 5550 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP7500_V1.xml': [
    'Prestigio',
    'Multiphone 7500',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PAP7600DUO_V1.xml': [
    'Prestigio',
    'Multiphone 7600 Duo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP3455DUO_V1.xml': [
    'Prestigio',
    'Multiphone Grace X3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP5470DUO_V1.xml': [
    'Prestigio',
    'Multiphone Grace X5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.dl.prestigio.com/uaprofile/smartphones/PSP3452DUO_V1.xml': [
    'Prestigio',
    'Muze A3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/Unknown_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/Unknown_evdo/7.1.0.rdf': [
    'RIM',
    'BlackBerry',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/5810/3.2.1.rdf': [
    'RIM',
    'BlackBerry 5810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/5810/3.3.0.rdf': [
    'RIM',
    'BlackBerry 5810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/5810/3.3.1.rdf': [
    'RIM',
    'BlackBerry 5810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/5810/3.6.0.rdf': [
    'RIM',
    'BlackBerry 5810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/5810/3.6.1.rdf': [
    'RIM',
    'BlackBerry 5810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/5810/3.7.0.rdf': [
    'RIM',
    'BlackBerry 5810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/5810/3.7.1.rdf': [
    'RIM',
    'BlackBerry 5810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/5810/3.7.2.rdf': [
    'RIM',
    'BlackBerry 5810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/5810/3.7.3.rdf': [
    'RIM',
    'BlackBerry 5810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6210/3.2.1.rdf': [
    'RIM',
    'BlackBerry 6210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6210/3.3.0.rdf': [
    'RIM',
    'BlackBerry 6210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6210/3.3.1.rdf': [
    'RIM',
    'BlackBerry 6210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6210/3.6.0.rdf': [
    'RIM',
    'BlackBerry 6210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6210/3.6.1.rdf': [
    'RIM',
    'BlackBerry 6210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6210/3.7.0.rdf': [
    'RIM',
    'BlackBerry 6210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6210/3.7.1.rdf': [
    'RIM',
    'BlackBerry 6210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6210/3.7.2.rdf': [
    'RIM',
    'BlackBerry 6210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6210/3.7.3.rdf': [
    'RIM',
    'BlackBerry 6210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6230/3.2.1.rdf': [
    'RIM',
    'BlackBerry 6230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6230/3.3.0.rdf': [
    'RIM',
    'BlackBerry 6230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6230/3.3.1.rdf': [
    'RIM',
    'BlackBerry 6230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6230/3.6.0.rdf': [
    'RIM',
    'BlackBerry 6230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6230/3.6.1.rdf': [
    'RIM',
    'BlackBerry 6230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6230/3.7.0.rdf': [
    'RIM',
    'BlackBerry 6230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6230/3.7.1.rdf': [
    'RIM',
    'BlackBerry 6230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6230/3.7.2.rdf': [
    'RIM',
    'BlackBerry 6230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6230/3.7.3.rdf': [
    'RIM',
    'BlackBerry 6230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6280/3.2.1.rdf': [
    'RIM',
    'BlackBerry 6280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6280/3.3.0.rdf': [
    'RIM',
    'BlackBerry 6280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6280/3.3.1.rdf': [
    'RIM',
    'BlackBerry 6280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6280/3.6.0.rdf': [
    'RIM',
    'BlackBerry 6280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6280/3.6.1.rdf': [
    'RIM',
    'BlackBerry 6280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6280/3.7.0.rdf': [
    'RIM',
    'BlackBerry 6280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6280/3.7.1.rdf': [
    'RIM',
    'BlackBerry 6280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6280/3.7.2.rdf': [
    'RIM',
    'BlackBerry 6280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6280/3.7.3.rdf': [
    'RIM',
    'BlackBerry 6280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6510/3.2.1.rdf': [
    'RIM',
    'BlackBerry 6510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6510/3.3.0.rdf': [
    'RIM',
    'BlackBerry 6510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6510/3.3.1.rdf': [
    'RIM',
    'BlackBerry 6510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6510/3.6.0.rdf': [
    'RIM',
    'BlackBerry 6510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6510/3.6.1.rdf': [
    'RIM',
    'BlackBerry 6510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6510/3.7.0.rdf': [
    'RIM',
    'BlackBerry 6510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6510/3.7.1.rdf': [
    'RIM',
    'BlackBerry 6510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6510/3.7.2.rdf': [
    'RIM',
    'BlackBerry 6510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6510/3.7.3.rdf': [
    'RIM',
    'BlackBerry 6510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6710/3.2.1.rdf': [
    'RIM',
    'BlackBerry 6710',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6710/3.3.0.rdf': [
    'RIM',
    'BlackBerry 6710',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6710/3.3.1.rdf': [
    'RIM',
    'BlackBerry 6710',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6710/3.6.0.rdf': [
    'RIM',
    'BlackBerry 6710',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6710/3.6.1.rdf': [
    'RIM',
    'BlackBerry 6710',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6710/3.7.0.rdf': [
    'RIM',
    'BlackBerry 6710',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6710/3.7.1.rdf': [
    'RIM',
    'BlackBerry 6710',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6710/3.7.2.rdf': [
    'RIM',
    'BlackBerry 6710',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6710/3.7.3.rdf': [
    'RIM',
    'BlackBerry 6710',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6750/3.2.1.rdf': [
    'RIM',
    'BlackBerry 6750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6750/3.3.0.rdf': [
    'RIM',
    'BlackBerry 6750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6750/3.3.1.rdf': [
    'RIM',
    'BlackBerry 6750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6750/3.6.0.rdf': [
    'RIM',
    'BlackBerry 6750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6750/3.6.1.rdf': [
    'RIM',
    'BlackBerry 6750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6750/3.7.0.rdf': [
    'RIM',
    'BlackBerry 6750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6750/3.7.1.rdf': [
    'RIM',
    'BlackBerry 6750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6750/3.7.2.rdf': [
    'RIM',
    'BlackBerry 6750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/6750/3.7.3.rdf': [
    'RIM',
    'BlackBerry 6750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7210/3.2.1.rdf': [
    'RIM',
    'BlackBerry 7210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7210/3.3.0.rdf': [
    'RIM',
    'BlackBerry 7210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7210/3.3.1.rdf': [
    'RIM',
    'BlackBerry 7210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7210/3.6.0.rdf': [
    'RIM',
    'BlackBerry 7210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7210/3.6.1.rdf': [
    'RIM',
    'BlackBerry 7210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7210/3.7.0.rdf': [
    'RIM',
    'BlackBerry 7210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7210/3.7.1.rdf': [
    'RIM',
    'BlackBerry 7210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7210/3.7.2.rdf': [
    'RIM',
    'BlackBerry 7210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7210/3.7.3.rdf': [
    'RIM',
    'BlackBerry 7210',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7230/3.2.1.rdf': [
    'RIM',
    'BlackBerry 7230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7230/3.3.0.rdf': [
    'RIM',
    'BlackBerry 7230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7230/3.3.1.rdf': [
    'RIM',
    'BlackBerry 7230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7230/3.6.0.rdf': [
    'RIM',
    'BlackBerry 7230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7230/3.6.1.rdf': [
    'RIM',
    'BlackBerry 7230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7230/3.7.0.rdf': [
    'RIM',
    'BlackBerry 7230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7230/3.7.1.rdf': [
    'RIM',
    'BlackBerry 7230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7230/3.7.2.rdf': [
    'RIM',
    'BlackBerry 7230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7230/3.7.3.rdf': [
    'RIM',
    'BlackBerry 7230',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7280/3.2.1.rdf': [
    'RIM',
    'BlackBerry 7280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7280/3.3.0.rdf': [
    'RIM',
    'BlackBerry 7280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7280/3.3.1.rdf': [
    'RIM',
    'BlackBerry 7280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7280/3.6.0.rdf': [
    'RIM',
    'BlackBerry 7280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7280/3.6.1.rdf': [
    'RIM',
    'BlackBerry 7280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7280/3.7.0.rdf': [
    'RIM',
    'BlackBerry 7280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7280/3.7.1.rdf': [
    'RIM',
    'BlackBerry 7280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7280/3.7.2.rdf': [
    'RIM',
    'BlackBerry 7280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7280/3.7.3.rdf': [
    'RIM',
    'BlackBerry 7280',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7510/3.2.1.rdf': [
    'RIM',
    'BlackBerry 7510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7510/3.3.0.rdf': [
    'RIM',
    'BlackBerry 7510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7510/3.3.1.rdf': [
    'RIM',
    'BlackBerry 7510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7510/3.6.0.rdf': [
    'RIM',
    'BlackBerry 7510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7510/3.6.1.rdf': [
    'RIM',
    'BlackBerry 7510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7510/3.7.0.rdf': [
    'RIM',
    'BlackBerry 7510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7510/3.7.1.rdf': [
    'RIM',
    'BlackBerry 7510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7510/3.7.2.rdf': [
    'RIM',
    'BlackBerry 7510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7510/3.7.3.rdf': [
    'RIM',
    'BlackBerry 7510',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7730/3.2.1.rdf': [
    'RIM',
    'BlackBerry 7730',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7730/3.3.0.rdf': [
    'RIM',
    'BlackBerry 7730',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7730/3.3.1.rdf': [
    'RIM',
    'BlackBerry 7730',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7730/3.6.0.rdf': [
    'RIM',
    'BlackBerry 7730',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7730/3.6.1.rdf': [
    'RIM',
    'BlackBerry 7730',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7730/3.7.0.rdf': [
    'RIM',
    'BlackBerry 7730',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7730/3.7.1.rdf': [
    'RIM',
    'BlackBerry 7730',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7730/3.7.2.rdf': [
    'RIM',
    'BlackBerry 7730',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7730/3.7.3.rdf': [
    'RIM',
    'BlackBerry 7730',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7750/3.2.1.rdf': [
    'RIM',
    'BlackBerry 7750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7750/3.3.0.rdf': [
    'RIM',
    'BlackBerry 7750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7750/3.3.1.rdf': [
    'RIM',
    'BlackBerry 7750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7750/3.6.0.rdf': [
    'RIM',
    'BlackBerry 7750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7750/3.6.1.rdf': [
    'RIM',
    'BlackBerry 7750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7750/3.7.0.rdf': [
    'RIM',
    'BlackBerry 7750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7750/3.7.1.rdf': [
    'RIM',
    'BlackBerry 7750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7750/3.7.2.rdf': [
    'RIM',
    'BlackBerry 7750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/7750/3.7.3.rdf': [
    'RIM',
    'BlackBerry 7750',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8500_edge/4.6.1.rdf': [
    'RIM',
    'BlackBerry 8500',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8707/4.2.2.rdf': [
    'RIM',
    'BlackBerry 8707',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8800/4.2.1.rdf': [
    'RIM',
    'BlackBerry 8800',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8820/4.2.2.rdf': [
    'RIM',
    'BlackBerry 8820',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8820/4.5.0.rdf': [
    'RIM',
    'BlackBerry 8820',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8830/4.2.2.rdf': [
    'RIM',
    'BlackBerry 8830',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9315_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry 9315',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9570_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry 9570',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9620_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry 9620',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9620_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry 9620',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9620_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry 9620',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9720/7.1.0.rdf': [
    'RIM',
    'BlackBerry 9720',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9720_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry 9720',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9720_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry 9720',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9720_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry 9720',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9720_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry 9720',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000/4.6.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000_80211a/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000_80211b/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000_80211g/4.6.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000_edge/4.6.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000_umts/4.6.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9000_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9000',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9650/6.0.0.706.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9650/6.0.0.723.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650_1x/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650_edge/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650_evdo/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650_evdo/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9650_umts/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9650',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700_80211b/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700_edge/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700_gprs/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700_gprs/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9700_umts/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9700',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9780/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9780',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9780_80211b/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9780',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9780_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9780',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9780_edge/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9780',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9780_gprs/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9780',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9780_umts/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9780',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9780_usb/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9780',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9788_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9788',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9788_edge/6.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9788',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_80211a/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_edge/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_gprs/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_umts/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9790_usb/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9790',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_80211a/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_80211a/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_edge/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_gprs/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_umts/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9900_usb/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9930/7.1.0.1066.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_1x/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_1x/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_80211a/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_80211a/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_edge/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_evdo/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_evdo/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_umts/7.0.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9930_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Bold 9930',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8300/4.5.0.rdf': [
    'RIM',
    'BlackBerry Curve 8300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8310/4.2.2.rdf': [
    'RIM',
    'BlackBerry Curve 8310',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8330/4.3.0.rdf': [
    'RIM',
    'BlackBerry Curve 8330',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8350i_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8350',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8520/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8520_80211b/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8520_80211g/4.6.1.rdf': [
    'RIM',
    'BlackBerry Curve 8520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8520_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8520_edge/4.6.1.rdf': [
    'RIM',
    'BlackBerry Curve 8520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8520_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8520_gprs/4.6.1.rdf': [
    'RIM',
    'BlackBerry Curve 8520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8520_gprs/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8520_usb/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry8530/5.0.0.1000.rdf': [
    'RIM',
    'BlackBerry Curve 8530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry8530/5.0.0.1030.rdf': [
    'RIM',
    'BlackBerry Curve 8530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry8530/5.0.0.654.rdf': [
    'RIM',
    'BlackBerry Curve 8530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry8530/5.0.0.973.rdf': [
    'RIM',
    'BlackBerry Curve 8530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8530/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8530_1x/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8530_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8530_evdo/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8900/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8900_80211g/4.6.1.rdf': [
    'RIM',
    'BlackBerry Curve 8900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8900_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8900_edge/4.6.1.rdf': [
    'RIM',
    'BlackBerry Curve 8900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8900_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8900_gprs/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 8900',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9220/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9220',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9220_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9220',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9220_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9220',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9220_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9220',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300_80211b/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300_edge/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300_gprs/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9300_umts/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9300',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9310/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9310',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9310_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9310',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9310_evdo/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9310',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9315_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9315',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9315_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9315',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9320/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9320',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9320_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9320',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9320_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9320',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9320_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9320',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9320_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9320',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9320_usb/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9320',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9330/6.0.0.707.rdf': [
    'RIM',
    'BlackBerry Curve 9330',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9330/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9330',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9330/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9330',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9330_1x/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9330',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9330_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9330',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9330_evdo/5.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9330',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9330_evdo/6.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9330',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9350/7.1.0.580.rdf': [
    'RIM',
    'BlackBerry Curve 9350',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9350/7.1.0.714.rdf': [
    'RIM',
    'BlackBerry Curve 9350',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9350/7.1.0.861.rdf': [
    'RIM',
    'BlackBerry Curve 9350',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9350_1x/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9350',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9350_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9350',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9350_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9350',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9350_evdo/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9350',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9350_evdo/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9350',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360_edge/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360_gprs/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360_umts/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9360_usb/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9360',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9370_1x/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9370',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9370_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9370',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9370_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9370',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9370_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9370',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9370_evdo/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9370',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9370_evdo/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9370',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380_edge/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380_gprs/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380_umts/7.0.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9380_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Curve 9380',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8100/4.2.1.rdf': [
    'RIM',
    'BlackBerry Pearl 8100',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8120/4.3.0.rdf': [
    'RIM',
    'BlackBerry Pearl 8120',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8220_80211g/4.6.0.rdf': [
    'RIM',
    'BlackBerry Pearl 8220',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9100/4.6.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9100',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9100_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9100',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9100_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9100',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9100_edge/6.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9100',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9100_umts/6.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9100',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9105/5.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9105',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9105/6.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9105',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9105_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9105',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9105_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9105',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9105_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9105',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9105_edge/6.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9105',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9105_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9105',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9105_umts/6.0.0.rdf': [
    'RIM',
    'BlackBerry Pearl 9105',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/8220_edge/4.6.0.rdf': [
    'RIM',
    'BlackBerry Pearl Flip 8220',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9981_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Porsche P 9981',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9981_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Porsche P 9981',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9981_edge/7.0.0.rdf': [
    'RIM',
    'BlackBerry Porsche P 9981',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9981_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Porsche P 9981',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9981_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Porsche P 9981',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9981_umts/7.0.0.rdf': [
    'RIM',
    'BlackBerry Porsche P 9981',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9981_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Porsche P 9981',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9500/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9500',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9500_edge/4.7.0.rdf': [
    'RIM',
    'BlackBerry Storm 9500',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9500_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9500',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9500_umts/4.7.0.rdf': [
    'RIM',
    'BlackBerry Storm 9500',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9500_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9500',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9530_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9530_evdo/4.6.0.rdf': [
    'RIM',
    'BlackBerry Storm 9530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9530_evdo/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9530_gprs/4.7.0.rdf': [
    'RIM',
    'BlackBerry Storm 9530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9530_umts/4.7.0.rdf': [
    'RIM',
    'BlackBerry Storm 9530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9530_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9530',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9550/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9550',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9550_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9550',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9550_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9550',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9550_evdo/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9550',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9550_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm 9550',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9520/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm2 9520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9520_80211g/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm2 9520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9520_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm2 9520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9520_gprs/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm2 9520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9520_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Storm2 9520',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9670/6.0.0.706.rdf': [
    'RIM',
    'BlackBerry Style 9670',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9670/6.0.0.707.rdf': [
    'RIM',
    'BlackBerry Style 9670',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9670/6.0.0.rdf': [
    'RIM',
    'BlackBerry Style 9670',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9670_1x/6.0.0.rdf': [
    'RIM',
    'BlackBerry Style 9670',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9670_80211b/6.0.0.rdf': [
    'RIM',
    'BlackBerry Style 9670',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9670_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Style 9670',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9670_evdo/6.0.0.rdf': [
    'RIM',
    'BlackBerry Style 9670',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9800/6.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9800',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9800_80211b/6.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9800',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9800_80211g/6.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9800',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9800_edge/6.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9800',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9800_gprs/6.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9800',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9800_umts/6.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9800',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9800_usb/6.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9800',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_80211g/6.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_edge/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_gprs/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_umts/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9810_usb/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9810',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9850/7.1.0.580.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9850_1x/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9850_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9850_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9850_edge/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9850_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9850_evdo/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9850_evdo/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9850_umts/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9850_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9850',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_80211g/6.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_80211g/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_80211g/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_edge/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_edge/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_gprs/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_gprs/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_umts/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_umts/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_usb/7.0.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9860_usb/7.1.0.rdf': [
    'RIM',
    'BlackBerry Torch 9860',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/RIM/BlackBerry9630/5.0.0.624.rdf': [
    'RIM',
    'BlackBerry Tour 9630',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9630/5.0.0.rdf': [
    'RIM',
    'BlackBerry Tour 9630',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9630_edge/5.0.0.rdf': [
    'RIM',
    'BlackBerry Tour 9630',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9630_evdo/5.0.0.rdf': [
    'RIM',
    'BlackBerry Tour 9630',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/9630_umts/5.0.0.rdf': [
    'RIM',
    'BlackBerry Tour 9630',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://extranet.sagem.com/UAProfile/823044.xml': ['Sagem', '3XXX', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/890054.xml': ['Sagem', 'CO210', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/897807.xml': ['Sagem', 'MC2007', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/896618.xml': ['Sagem', 'my202C', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/897102.xml': ['Sagem', 'my212X', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/897133.xml': ['Sagem', 'my214X', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/897602.xml': ['Sagem', 'my300C', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/892606.xml': ['Sagem', 'my300X', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/898309.xml': ['Sagem', 'my312X', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/894080.xml': ['Sagem', 'my400X', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/896937.xml': ['Sagem', 'my411X', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/899843.xml': ['Sagem', 'my421Z', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/898544.xml': ['Sagem', 'my511X', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/896817.xml': ['Sagem', 'my600V', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/895182.xml': ['Sagem', 'my600X', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/898885.xml': ['Sagem', 'my721X', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/896288.xml': ['Sagem', 'my750C', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/897313.xml': ['Sagem', 'my850C', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/895961.xml': ['Sagem', 'my901C', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/835113.xml': ['Sagem', 'myC-2', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/890172.xml': ['Sagem', 'myC-3b', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/890914.xml': ['Sagem', 'myC-4', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/835402.xml': ['Sagem', 'myC2-2', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/835618.xml': ['Sagem', 'myC5-2', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/892993.xml': ['Sagem', 'myMobileTV', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/893183.xml': ['Sagem', 'myT-22', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/890453.xml': ['Sagem', 'myV-55', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/892154.xml': ['Sagem', 'myV-56', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/834495.xml': ['Sagem', 'myV-65', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/834529.xml': ['Sagem', 'myV-75', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/893401.xml': ['Sagem', 'myV-85', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/893940.xml': ['Sagem', 'myW-7', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/834525.xml': ['Sagem', 'myX-1', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/834118.xml': ['Sagem', 'myX-2', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/823252.xml': ['Sagem', 'myX-3', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/835509.xml': ['Sagem', 'myX-4', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/822962.xml': ['Sagem', 'myX-5', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/823276.xml': ['Sagem', 'myX-5', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/823404.xml': ['Sagem', 'myX-5', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/823622.xml': ['Sagem', 'myX-6', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/834530.xml': ['Sagem', 'myX-7', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/891032.xml': ['Sagem', 'myX-8', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/891863.xml': ['Sagem', 'myX2-2', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/890118.xml': ['Sagem', 'myX5-2', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/892081.xml': ['Sagem', 'myX6-2', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/P9521.xml': ['Sagem', 'Porsche Design P9521', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/898770.xml': ['Sagem', 'VF526', null, DeviceType.MOBILE],
  'http://extranet.sagem.com/UAProfile/899483.xml': ['Sagem', 'VF533', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/740SCUAProf.xml': ['Samsung', '740SC', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A157.xml': ['Samsung', 'A157', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A697.xml': ['Samsung', 'A697 Sunburst', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A927.xml': ['Samsung', 'A927 Flight II', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A827.xml': ['Samsung', 'Access', null, DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/SAMSUNG-SCH-I619_CHN_BRI.xml': ['Samsung', 'Ace A+', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B6520.xml': [
    'Samsung',
    'B6520 OmniaPRO 5',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-B7330.xml': [
    'Samsung',
    'B7330 OmniaPRO',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-B7610.xml': [
    'Samsung',
    'B7610 OmniaPRO',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-B7610_2G.xml': [
    'Samsung',
    'B7610 OmniaPRO',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-B7610_3G.xml': [
    'Samsung',
    'B7610 OmniaPRO',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-T539.xml': ['Samsung', 'Beat', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M3510C.xml': ['Samsung', 'Beat b', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-M6710UAProf.xml': ['Samsung', 'Beat Disc', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-M6710UAProf3G.xml': ['Samsung', 'Beat Disc', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T919.xml': ['Samsung', 'Behold', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i607_10.xml': ['Samsung', 'BlackJack', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i617_10.xml': [
    'Samsung',
    'BlackJack II',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-T729.xml': ['Samsung', 'Blast', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c3010_10.xml': ['Samsung', 'C3010', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c3050_10.xml': ['Samsung', 'C3050', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c3110_10.xml': ['Samsung', 'C3110', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3520I.xml': ['Samsung', 'C3520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C5010_2G.rdf': ['Samsung', 'C5010 Squash', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/C5212.xml': ['Samsung', 'C5212', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/C5220.rdf': ['Samsung', 'C5220', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/C6620UAProf.rdf': ['Samsung', 'C6620', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/C6625UAProf.xml': ['Samsung', 'C6625', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/C6625UAProf2G.xml': ['Samsung', 'C6625', null, DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I879_1_20130130.xml': ['Samsung', 'Captivate', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I896.xml': ['Samsung', 'Captivate', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I897.xml': ['Samsung', 'Captivate', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I927.xml': ['Samsung', 'Captivate Glide', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I927R.xml': ['Samsung', 'Captivate Glide', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2220.xml': ['Samsung', 'Ch@t 220', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2220BR.xml': ['Samsung', 'Ch@t 220', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2222.xml': ['Samsung', 'Ch@t 222', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2262UAProf.xml': ['Samsung', 'Ch@t 226', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3222.xml': ['Samsung', 'Ch@t 322', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3222.xml.jar.jad': ['Samsung', 'Ch@t 322', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3222BR.xml': ['Samsung', 'Ch@t 322', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3332.xml': ['Samsung', 'Ch@t 333', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3332BR.xml': ['Samsung', 'Ch@t 333', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3350UAProf.xml': ['Samsung', 'Ch@t 335', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3353UAProf.xml': ['Samsung', 'Ch@t 335', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3500.xml': ['Samsung', 'Ch@t 350', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3570.xml': ['Samsung', 'Ch@t 357', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3572.xml': ['Samsung', 'Ch@t 357', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5270LBR_3G.xml': ['Samsung', 'Ch@t 527', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5270L_3G.xml': ['Samsung', 'Ch@t 527', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5270Y_2G.xml': ['Samsung', 'Ch@t 527', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5270Y_3G.xml': ['Samsung', 'Ch@t 527', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5270_2G.rdf': ['Samsung', 'Ch@t 527', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5270_3G.rdf': ['Samsung', 'Ch@t 527', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3300i.xml': ['Samsung', 'Champ', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3303.xml': ['Samsung', 'Champ', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3303i.xml': ['Samsung', 'Champ', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3330UAProf.xml': ['Samsung', 'Champ 2', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3332UAProf.xml': ['Samsung', 'Champ 2', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3770L_2G.xml': ['Samsung', 'Champ 3G', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3770L_3G.xml': ['Samsung', 'Champ 3G', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3770M_2G.xml': ['Samsung', 'Champ 3G', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3770M_3G.xml': ['Samsung', 'Champ 3G', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3770_2G.rdf': ['Samsung', 'Champ 3G', 'TouchWiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3310RUAProf.xml': [
    'Samsung',
    'Champ Deluxe',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-C3310UAProf.xml': [
    'Samsung',
    'Champ Deluxe',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-C3312KUAProf.xml': [
    'Samsung',
    'Champ Deluxe Duos',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-C3312RUAProf.xml': [
    'Samsung',
    'Champ Deluxe Duos',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-C3312UAProf.xml': [
    'Samsung',
    'Champ Deluxe Duos',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-E2652WUAProf.xml': [
    'Samsung',
    'Champ Duos',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-C3262.xml': ['Samsung', 'Champ Neo Duos', 'Touchwiz', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D600/FC17.rdf': ['Samsung', 'Conquer 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D600/FE16.rdf': ['Samsung', 'Conquer 4G', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B3310UAProf.xml': ['Samsung', 'Corby', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3650.rdf': ['Samsung', 'Corby', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3650.xml': ['Samsung', 'Corby', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3650C.rdf': ['Samsung', 'Corby', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3653.rdf': ['Samsung', 'Corby', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3653W.rdf': ['Samsung', 'Corby', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3370.rdf': ['Samsung', 'Corby 3G', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3370_3G.rdf': ['Samsung', 'Corby 3G', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-M3710.xml': ['Samsung', 'Corby Beat', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-M3710TCE.xml': ['Samsung', 'Corby Beat', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3850.rdf': ['Samsung', 'Corby II', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3850.xml': ['Samsung', 'Corby II', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3850BR.xml': ['Samsung', 'Corby II', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3850_3G.rdf': ['Samsung', 'Corby II', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B3313UAProf.xml': ['Samsung', 'Corby Mate', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3510T.rdf': ['Samsung', 'Corby Pop', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5310.rdf': ['Samsung', 'Corby Pro', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5310_3G.rdf': ['Samsung', 'Corby Pro', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B3210UAProf.xml': ['Samsung', 'Corby TXT', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D980.xml': ['Samsung', 'D980 DuoS', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T499.xml': ['Samsung', 'Dart', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I857.xml': ['Samsung', 'DoubleTime', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I6712BR.xml': ['Samsung', 'Duos TV', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/E1310B.xml': ['Samsung', 'E1310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/E1310E.xml': ['Samsung', 'E1310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/E1360B.xml': ['Samsung', 'E1360', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e1410_10.xml': ['Samsung', 'E1410', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/E2210B.xml': ['Samsung', 'E2210', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E3210L_3G.xml': ['Samsung', 'E3210', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E3213K_3G.rdf': ['Samsung', 'E3213 Hero', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E3309I.xml': ['Samsung', 'E3309 Manhattan', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D700/DG18.rdf': ['Samsung', 'Epic 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D700/DK28.rdf': ['Samsung', 'Epic 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D700/EC05.rdf': ['Samsung', 'Epic 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D700/EH17.rdf': ['Samsung', 'Epic 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D700/EI22.rdf': ['Samsung', 'Epic 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D700/FC09.rdf': ['Samsung', 'Epic 4G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D700/FC19.rdf': ['Samsung', 'Epic 4G', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i907.xml': ['Samsung', 'Epix', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A867.xml': ['Samsung', 'Eternity', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A597.xml': ['Samsung', 'Eternity II', 'TouchWiz', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M550/CL03.rdf': ['Samsung', 'Exclaim', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T759.xml': ['Samsung', 'Exhibit 4G', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_F839_3_20090707.xml': ['Samsung', 'F839', 'Brew', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/SCH-I500/SCH-I500.xml': ['Samsung', 'Fascinate', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T189N.xml': ['Samsung', 'Freeform M', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-G600.xml': ['Samsung', 'G600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5500.xml': ['Samsung', 'Galaxy 5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5500B.xml': ['Samsung', 'Galaxy 5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5500L.xml': ['Samsung', 'Galaxy 5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5503.xml': ['Samsung', 'Galaxy 5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5503T_Froyo.rdf': ['Samsung', 'Galaxy 5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5510.xml': ['Samsung', 'Galaxy 551', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I5510BO.xml': ['Samsung', 'Galaxy 551', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I5510BR.xml': ['Samsung', 'Galaxy 551', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I5510L.xml': ['Samsung', 'Galaxy 551', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-A3009_1_20140919.xml': [
    'Samsung',
    'Galaxy A3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-A300F.xml': ['Samsung', 'Galaxy A3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A300FU.xml': ['Samsung', 'Galaxy A3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A300G.xml': ['Samsung', 'Galaxy A3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A300H.xml': ['Samsung', 'Galaxy A3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A300M.xml': ['Samsung', 'Galaxy A3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A300Y.xml': ['Samsung', 'Galaxy A3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A300YZ.xml': ['Samsung', 'Galaxy A3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A310F.xml': ['Samsung', 'Galaxy A3 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A320FL.xml': ['Samsung', 'Galaxy A3 (2017)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A320Y.xml': ['Samsung', 'Galaxy A3 (2017)', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-A5009_1_20140811.xml': [
    'Samsung',
    'Galaxy A5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-A500F.xml': ['Samsung', 'Galaxy A5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A500FU.xml': ['Samsung', 'Galaxy A5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A500G.xml': ['Samsung', 'Galaxy A5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A500H.xml': ['Samsung', 'Galaxy A5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A500M.xml': ['Samsung', 'Galaxy A5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A500MPET.xml': ['Samsung', 'Galaxy A5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A500W.xml': ['Samsung', 'Galaxy A5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A500Y.xml': ['Samsung', 'Galaxy A5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A510F.xml': ['Samsung', 'Galaxy A5 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A510Y.xml': ['Samsung', 'Galaxy A5 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A520F.xml': ['Samsung', 'Galaxy A5 (2017)', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-A7009_1_20141110.xml': [
    'Samsung',
    'Galaxy A7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-A700F.xml': ['Samsung', 'Galaxy A7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A700FD.xml': ['Samsung', 'Galaxy A7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A700H.xml': ['Samsung', 'Galaxy A7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A710F.xml': ['Samsung', 'Galaxy A7 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A710Y.xml': ['Samsung', 'Galaxy A7 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A720F.xml': ['Samsung', 'Galaxy A7 (2017)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A800F.xml': ['Samsung', 'Galaxy A8', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A800IZ.xml': ['Samsung', 'Galaxy A8', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-A910F.xml': ['Samsung', 'Galaxy A9 Pro', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I579_1_20101216.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/cooper.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830B.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830BO.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830C.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830D.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830G.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830i.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830iBO.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830L.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830M.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830T.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5830V.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5831i.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5839i.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5839iBO.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5839iBV.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6358.xml': ['Samsung', 'Galaxy Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8160.xml': ['Samsung', 'Galaxy Ace 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8160BO.xml': ['Samsung', 'Galaxy Ace 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8160L.xml': ['Samsung', 'Galaxy Ace 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8160P.xml': ['Samsung', 'Galaxy Ace 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7270.xml': ['Samsung', 'Galaxy Ace 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7270L.xml': ['Samsung', 'Galaxy Ace 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7275B.xml': ['Samsung', 'Galaxy Ace 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7275R.xml': ['Samsung', 'Galaxy Ace 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7275RBO.xml': ['Samsung', 'Galaxy Ace 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7275T.xml': ['Samsung', 'Galaxy Ace 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7275Y.xml': ['Samsung', 'Galaxy Ace 3', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G3139D_1_20140829.xml': [
    'Samsung',
    'Galaxy Ace 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G313F.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G313H.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G313HU.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G313HZ.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G313M.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G313ML.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G313MU.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G313U.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G316M.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G316ML.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G316MLPET.xml': ['Samsung', 'Galaxy Ace 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G318H.xml': ['Samsung', 'Galaxy Ace 4 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G318HZ.xml': ['Samsung', 'Galaxy Ace 4 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G318ML.xml': ['Samsung', 'Galaxy Ace 4 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G318MZ.xml': ['Samsung', 'Galaxy Ace 4 Neo', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I619_1_20120112.xml': [
    'Samsung',
    'Galaxy Ace A+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SCH-I619.xml': ['Samsung', 'Galaxy Ace A+', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_i589_1_20110504.xml': [
    'Samsung',
    'Galaxy Ace Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S6352.xml': ['Samsung', 'Galaxy Ace Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6802.xml': ['Samsung', 'Galaxy Ace Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6802B.xml': ['Samsung', 'Galaxy Ace Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7560.xml': ['Samsung', 'Galaxy Ace II x', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7560BO.xml': ['Samsung', 'Galaxy Ace II x', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7560M.xml': ['Samsung', 'Galaxy Ace II x', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I659_1_20120627.xml': [
    'Samsung',
    'Galaxy Ace Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S7500.xml': ['Samsung', 'Galaxy Ace Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7500L.xml': ['Samsung', 'Galaxy Ace Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7500T.xml': ['Samsung', 'Galaxy Ace Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SHW-M460D.xml': ['Samsung', 'Galaxy Ace Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G357FZ.xml': ['Samsung', 'Galaxy Ace Style', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G357FZBO.xml': [
    'Samsung',
    'Galaxy Ace Style',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G357M.xml': ['Samsung', 'Galaxy Ace Style', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G357MPET.xml': [
    'Samsung',
    'Galaxy Ace Style',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-S765C.xml': ['Samsung', 'Galaxy Ace Style', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G850A.xml': ['Samsung', 'Galaxy Alpha', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G850F.xml': ['Samsung', 'Galaxy Alpha', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G850M.xml': ['Samsung', 'Galaxy Alpha', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G850MPET.xml': ['Samsung', 'Galaxy Alpha', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G850W.xml': ['Samsung', 'Galaxy Alpha', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G850Y.xml': ['Samsung', 'Galaxy Alpha', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I407.xml': ['Samsung', 'Galaxy Amp', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5800.xml': ['Samsung', 'Galaxy Apollo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5800L.xml': ['Samsung', 'Galaxy Apollo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5801.xml': ['Samsung', 'Galaxy Apollo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I827.xml': ['Samsung', 'Galaxy Appeal', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I827D.xml': ['Samsung', 'Galaxy Appeal', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8530.xml': ['Samsung', 'Galaxy Beam', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-C900F.xml': ['Samsung', 'Galaxy C9', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/EK-GC100.xml': ['Samsung', 'Galaxy Camera', 'Android'],
  'http://wap.samsungmobile.com/uaprof/SCH-S738C.xml': ['Samsung', 'Galaxy Centura', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5330.xml': ['Samsung', 'Galaxy Chat', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5330B.xml': ['Samsung', 'Galaxy Chat', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5330L.xml': ['Samsung', 'Galaxy Chat', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8260.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8260L.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8262.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8262B.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G386F.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G386T.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G386T1.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G386U.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G386W.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G386WMTA.xml': ['Samsung', 'Galaxy Core', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G3559_1_20140420.xml': [
    'Samsung',
    'Galaxy Core 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G355H.xml': ['Samsung', 'Galaxy Core 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G355HN.xml': ['Samsung', 'Galaxy Core 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G355HNBO.xml': ['Samsung', 'Galaxy Core 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G355M.xml': ['Samsung', 'Galaxy Core 2', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G3589W_1_20140219.xml': [
    'Samsung',
    'Galaxy Core Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G5109_1_20141010.xml': [
    'Samsung',
    'Galaxy Core Max',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G350.xml': ['Samsung', 'Galaxy Core Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G350BO.xml': ['Samsung', 'Galaxy Core Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G350L.xml': ['Samsung', 'Galaxy Core Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G350M.xml': ['Samsung', 'Galaxy Core Plus', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-G360P-2012071301/NL8.rdf': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G360P-2012071301/OH1.rdf': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G360P-BOOST/NL8.rdf': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G360P-BOOST/OF4.rdf': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G360P-BOOST/OH1.rdf': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G360P-BOOST/PE2.rdf': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G360P-BOOST/QD1.rdf': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G360P-Chameleon/latest': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G360P-MVNO/PE2.rdf': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G360P-SPRPRE/OH1.rdf': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G3609_1_20140826.xml': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G360AZ.xml': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G360F.xml': ['Samsung', 'Galaxy Core Prime', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G360G.xml': ['Samsung', 'Galaxy Core Prime', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G360GY.xml': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G360H.xml': ['Samsung', 'Galaxy Core Prime', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G360HU.xml': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G360M.xml': ['Samsung', 'Galaxy Core Prime', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G360T.xml': ['Samsung', 'Galaxy Core Prime', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G360T1.xml': [
    'Samsung',
    'Galaxy Core Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G361F.xml': [
    'Samsung',
    'Galaxy Core Prime VE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G361H.xml': [
    'Samsung',
    'Galaxy Core Prime VE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G361HU.xml': [
    'Samsung',
    'Galaxy Core Prime VE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SCH-S735C.xml': ['Samsung', 'Galaxy Discover', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-S730G.xml': ['Samsung', 'Galaxy Discover', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-S730M.xml': ['Samsung', 'Galaxy Discover', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-E500H.xml': ['Samsung', 'Galaxy E5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-E500M.xml': ['Samsung', 'Galaxy E5', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-E7009_1_20141208.xml': [
    'Samsung',
    'Galaxy E7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-E700F.xml': ['Samsung', 'Galaxy E7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-E700H.xml': ['Samsung', 'Galaxy E7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-E700M.xml': ['Samsung', 'Galaxy E7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T599.xml': ['Samsung', 'Galaxy Exhibit', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T599N.xml': ['Samsung', 'Galaxy Exhibit', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T599V.xml': ['Samsung', 'Galaxy Exhibit', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T679.xml': ['Samsung', 'Galaxy Exhibit II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T679M.xml': [
    'Samsung',
    'Galaxy Exhibit II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I577.xml': ['Samsung', 'Galaxy Exhilarate', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8730.xml': ['Samsung', 'Galaxy Express', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8730BO.xml': ['Samsung', 'Galaxy Express', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8730T.xml': ['Samsung', 'Galaxy Express', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I437.xml': ['Samsung', 'Galaxy Express', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I437P.xml': ['Samsung', 'Galaxy Express', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I437Z.xml': ['Samsung', 'Galaxy Express', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G3815.xml': ['Samsung', 'Galaxy Express 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6810.xml': ['Samsung', 'Galaxy Fame', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6810B.xml': ['Samsung', 'Galaxy Fame', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6810E.xml': ['Samsung', 'Galaxy Fame', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6810L.xml': ['Samsung', 'Galaxy Fame', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6810M.xml': ['Samsung', 'Galaxy Fame', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6810P.xml': ['Samsung', 'Galaxy Fame', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6810PBO.xml': ['Samsung', 'Galaxy Fame', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6812B.xml': ['Samsung', 'Galaxy Fame', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6790L.xml': ['Samsung', 'Galaxy Fame Lite', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6792L.xml': [
    'Samsung',
    'Galaxy Fame Lite Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5670.xml': ['Samsung', 'Galaxy Fit', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5670B.xml': ['Samsung', 'Galaxy Fit', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5670L.xml': ['Samsung', 'Galaxy Fit', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I569_1_20101216.xml': ['Samsung', 'Galaxy Gio', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/SAMSUNG-SCH-I569_CHN_BRI.xml': ['Samsung', 'Galaxy Gio', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5660.xml': ['Samsung', 'Galaxy Gio', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5660L.xml': ['Samsung', 'Galaxy Gio', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5660M.xml': ['Samsung', 'Galaxy Gio', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5660V.xml': ['Samsung', 'Galaxy Gio', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-W2015_1_20140830.xml': [
    'Samsung',
    'Galaxy Golden 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-W2016_1_20151016.xml': [
    'Samsung',
    'Galaxy Golden 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SCH-I879E_1_20131122.xml': [
    'Samsung',
    'Galaxy Grand',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9080E.xml': ['Samsung', 'Galaxy Grand', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9080L.xml': ['Samsung', 'Galaxy Grand', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G7109_1_20131108.xml': [
    'Samsung',
    'Galaxy Grand 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G710.xml': ['Samsung', 'Galaxy Grand 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G7102T.xml': ['Samsung', 'Galaxy Grand 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G7105.xml': ['Samsung', 'Galaxy Grand 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G7105H.xml': ['Samsung', 'Galaxy Grand 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G7105L.xml': ['Samsung', 'Galaxy Grand 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G7105PCL.xml': ['Samsung', 'Galaxy Grand 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G7105PTR.xml': ['Samsung', 'Galaxy Grand 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G720AX.xml': ['Samsung', 'Galaxy Grand 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9082.xml': ['Samsung', 'Galaxy Grand Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9082L.xml': [
    'Samsung',
    'Galaxy Grand Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G7102.xml': ['Samsung', 'Galaxy Grand II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9060.xml': ['Samsung', 'Galaxy Grand Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9060C.xml': ['Samsung', 'Galaxy Grand Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9060I.xml': ['Samsung', 'Galaxy Grand Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9060L.xml': ['Samsung', 'Galaxy Grand Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9060M.xml': ['Samsung', 'Galaxy Grand Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9063T.xml': [
    'Samsung',
    'Galaxy Grand Neo Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-MVNO/QF2.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-SPRINT/OF8.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-SPRINT/OG2.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-SPRINT/OI1.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-SPRINT/PC4.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-SPRINT/PF1.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-SPRINT/PI2.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-SPRINT/QA1.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-SPRINT/QD1.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G530P-SPRINT/QF2.rdf': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G5309W_1_20140909.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530AZ.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530BT.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530F.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530FZ.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530FZBO.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530H.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530M.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530MU.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530T.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530T1.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G530W.xml': [
    'Samsung',
    'Galaxy Grand Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G531BT.xml': [
    'Samsung',
    'Galaxy Grand Prime VE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G531FBO.xml': [
    'Samsung',
    'Galaxy Grand Prime VE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G531H.xml': [
    'Samsung',
    'Galaxy Grand Prime VE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G531M.xml': [
    'Samsung',
    'Galaxy Grand Prime VE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G532G.xml': [
    'Samsung',
    'Galaxy Grand Prime+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-B9150.xml': ['Samsung', 'Galaxy HomeSync', 'Android'],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I759_1_20130111.xml': [
    'Samsung',
    'Galaxy Infinite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-J100H.xml': ['Samsung', 'Galaxy J1', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J100M.xml': ['Samsung', 'Galaxy J1', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J100ML.xml': ['Samsung', 'Galaxy J1', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J100MU.xml': ['Samsung', 'Galaxy J1', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J100Y.xml': ['Samsung', 'Galaxy J1', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J120F.xml': ['Samsung', 'Galaxy J1 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J120G.xml': ['Samsung', 'Galaxy J1 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J120H.xml': ['Samsung', 'Galaxy J1 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J110F.xml': ['Samsung', 'Galaxy J1 Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J110G.xml': ['Samsung', 'Galaxy J1 Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J110L.xml': ['Samsung', 'Galaxy J1 Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J110M.xml': ['Samsung', 'Galaxy J1 Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J111F.xml': ['Samsung', 'Galaxy J1 Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J111M.xml': ['Samsung', 'Galaxy J1 Ace', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J105B.xml': ['Samsung', 'Galaxy J1 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J105F.xml': ['Samsung', 'Galaxy J1 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J106B.xml': [
    'Samsung',
    'Galaxy J1 Mini Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-J106F.xml': [
    'Samsung',
    'Galaxy J1 Mini Prime',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-J200BT.xml': ['Samsung', 'Galaxy J2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J200G.xml': ['Samsung', 'Galaxy J2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J200GU.xml': ['Samsung', 'Galaxy J2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J200Y.xml': ['Samsung', 'Galaxy J2', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-J320P-BOOST/OL2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-BOOST/PE1.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-BOOST/PH2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-BOOST/PK2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-BOOST/QD2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-BOOST/QG3.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-BOOST/RA1.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-Chameleon/latest': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-SPRINT/OL2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-SPRINT/PE1.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-SPRINT/PH2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-SPRINT/PK2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-SPRINT/QD2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-SPRINT/QG3.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-SPRINT/RA1.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-VIRGIN/OL2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-VIRGIN/PK2.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J320P-VIRGIN/QG3.rdf': [
    'Samsung',
    'Galaxy J3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-J320F.xml': ['Samsung', 'Galaxy J3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J320FN.xml': ['Samsung', 'Galaxy J3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J320G.xml': ['Samsung', 'Galaxy J3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J320H.xml': ['Samsung', 'Galaxy J3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J320MPET.xml': ['Samsung', 'Galaxy J3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J320Y.xml': ['Samsung', 'Galaxy J3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J320ZN.xml': ['Samsung', 'Galaxy J3', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-J3119_1_20160426.xml': [
    'Samsung',
    'Galaxy J3 (2016)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-BOOST/PL1.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-BOOST/QB6.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-BOOST/QF4.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-BOOST/QJ3.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-BOOST/QL3.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-BOOST/RC1.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-Chameleon/latest': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-SPRINT/PL1.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-SPRINT/QB6.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-SPRINT/QF4.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-SPRINT/QI2.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-SPRINT/QJ3.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-SPRINT/QL3.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-SPRINT/RC1.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-VIRGIN/QB6.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J327P-VIRGIN/QF4.rdf': [
    'Samsung',
    'Galaxy J3 Emerge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-J500F.xml': ['Samsung', 'Galaxy J5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J500FN.xml': ['Samsung', 'Galaxy J5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J500G.xml': ['Samsung', 'Galaxy J5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J500H.xml': ['Samsung', 'Galaxy J5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J500M.xml': ['Samsung', 'Galaxy J5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J500MPET.xml': ['Samsung', 'Galaxy J5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J500Y.xml': ['Samsung', 'Galaxy J5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J510FN.xml': ['Samsung', 'Galaxy J5 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J510FPTR.xml': [
    'Samsung',
    'Galaxy J5 (2016)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-J510GN.xml': ['Samsung', 'Galaxy J5 (2016)', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G570Y.xml': ['Samsung', 'Galaxy J5 Prime', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-J700P-BOOST/PB7.rdf': [
    'Samsung',
    'Galaxy J7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J700P-BOOST/PF3.rdf': [
    'Samsung',
    'Galaxy J7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J700P-BOOST/PH4.rdf': [
    'Samsung',
    'Galaxy J7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J700P-BOOST/QF3.rdf': [
    'Samsung',
    'Galaxy J7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J700P-Chameleon/latest': [
    'Samsung',
    'Galaxy J7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J700P-VIRGIN/PB7.rdf': [
    'Samsung',
    'Galaxy J7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J700P-VIRGIN/PF3.rdf': [
    'Samsung',
    'Galaxy J7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J700P-VIRGIN/PH4.rdf': [
    'Samsung',
    'Galaxy J7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J700P-VIRGIN/QF3.rdf': [
    'Samsung',
    'Galaxy J7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-J700F.xml': ['Samsung', 'Galaxy J7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J700H.xml': ['Samsung', 'Galaxy J7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J700M.xml': ['Samsung', 'Galaxy J7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J700MPET.xml': ['Samsung', 'Galaxy J7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-J710FPTR.xml': [
    'Samsung',
    'Galaxy J7 (2016)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-J710GN.xml': ['Samsung', 'Galaxy J7 (2016)', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-J727P-BOOST/QF5.rdf': [
    'Samsung',
    'Galaxy J7 Perx',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-J727P-BOOST/RC2.rdf': [
    'Samsung',
    'Galaxy J7 Perx',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G610F.xml': ['Samsung', 'Galaxy J7 Prime', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G610Y.xml': ['Samsung', 'Galaxy J7 Prime', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-N075T.xml': ['Samsung', 'GALAXY J SC-02F', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-C111.xml': ['Samsung', 'Galaxy K Zoom', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-C111M.xml': ['Samsung', 'Galaxy K Zoom', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-C115.xml': ['Samsung', 'Galaxy K Zoom', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-C115M.xml': ['Samsung', 'Galaxy K Zoom', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-C115W.xml': ['Samsung', 'Galaxy K Zoom', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/SCH-I200PP/SCH-I200PP.xml': [
    'Samsung',
    'Galaxy Legend',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-T399.xml': ['Samsung', 'Galaxy Light', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G7509_1_20141014.xml': [
    'Samsung',
    'Galaxy Mega 2 ',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G750A.xml': ['Samsung', 'Galaxy Mega 2 ', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G750F.xml': ['Samsung', 'Galaxy Mega 2 ', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G750H.xml': ['Samsung', 'Galaxy Mega 2 ', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SCH-P709E_1_20140113.xml': [
    'Samsung',
    'Galaxy Mega 5.8',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9150.xml': ['Samsung', 'Galaxy Mega 5.8', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9152.xml': [
    'Samsung',
    'Galaxy Mega 5.8 Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L600-MVNO/QA1.rdf': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L600-SPRINT/MI6.rdf': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L600-SPRINT/MK1.rdf': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L600-SPRINT/NA7.rdf': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L600-SPRINT/ND4.rdf': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L600-SPRINT/NE4.rdf': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L600-SPRINT/NJ1.rdf': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L600-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L600-SPRINT/QA1.rdf': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_P729_1_20130510.xml': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9200.xml': ['Samsung', 'Galaxy Mega 6.3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9205.xml': ['Samsung', 'Galaxy Mega 6.3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9205BO.xml': ['Samsung', 'Galaxy Mega 6.3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I527.xml': ['Samsung', 'Galaxy Mega 6.3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I527M.xml': ['Samsung', 'Galaxy Mega 6.3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I527MBMC.xml': [
    'Samsung',
    'Galaxy Mega 6.3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5570.xml': ['Samsung', 'Galaxy Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5570B.xml': ['Samsung', 'Galaxy Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5570I.xml': ['Samsung', 'Galaxy Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5570L.xml': ['Samsung', 'Galaxy Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T499V.xml': ['Samsung', 'Galaxy Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T499Y.xml': ['Samsung', 'Galaxy Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6500.xml': ['Samsung', 'Galaxy Mini 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6500BO.xml': ['Samsung', 'Galaxy Mini 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6500D.xml': ['Samsung', 'Galaxy Mini 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6500DBO.xml': ['Samsung', 'Galaxy Mini 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6500L.xml': ['Samsung', 'Galaxy Mini 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6500T.xml': ['Samsung', 'Galaxy Mini 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6010.xml': ['Samsung', 'Galaxy Music', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6010L.xml': ['Samsung', 'Galaxy Music', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6012B.xml': [
    'Samsung',
    'Galaxy Music Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/sam/Galaxy Nexus/Galaxy Nexus.xml': [
    'Samsung',
    'Galaxy Nexus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/Galaxy Nexus.xml': ['Samsung', 'Galaxy Nexus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i9250.xml': ['Samsung', 'Galaxy Nexus', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_i889_1_20111028.xml': [
    'Samsung',
    'Galaxy Note',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9220.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9228.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7000.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7000.xmlhttp://wap.samsungmobile.com/uaprof/.xml': [
    'Samsung',
    'Galaxy Note',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-N7000B.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7000BO.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7005.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SAMSUNG-SGH-I717.xml': [
    'Samsung',
    'Galaxy Note',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I717.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I717D.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I717M.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I717R.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I9220.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T879.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SHV-E160K.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SHV-E160L.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SHV-E160S.xml': ['Samsung', 'Galaxy Note', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/SCH-I925/SCH-I925.xml': ['Samsung', 'Galaxy Note 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-N8000.xml': ['Samsung', 'Galaxy Note 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-N8010.xml': ['Samsung', 'Galaxy Note 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-N8020.xml': ['Samsung', 'Galaxy Note 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-N8020BO.xml': [
    'Samsung',
    'Galaxy Note 10.1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-N8020T.xml': ['Samsung', 'Galaxy Note 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-P600.xml': [
    'Samsung',
    'Galaxy Note 10.1 (2014)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P601.xml': [
    'Samsung',
    'Galaxy Note 10.1 (2014)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P605.xml': [
    'Samsung',
    'Galaxy Note 10.1 (2014)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P605BO.xml': [
    'Samsung',
    'Galaxy Note 10.1 (2014)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P605M.xml': [
    'Samsung',
    'Galaxy Note 10.1 (2014)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P607T.xml': [
    'Samsung',
    'Galaxy Note 10.1 (2014)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-Chameleon/AAA.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-Chameleon/latest': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-Chameleon/ML9.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-Chameleon/NC5.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-MVNO/OC5.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-MVNO/OH1.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/C5D.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/MI3.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/MI5.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/MJ4.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/NAB.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/NC5.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/NH7.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/NK4.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/OC5.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/OK2.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/PH1.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N900P-SPRINT/PL1.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-BOOSTNC5.rdf': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-N9009_2_20130829.xml': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SAMSUNG-SM-N900A.xml': [
    'Samsung',
    'Galaxy Note 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-N900.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N9005.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N9005BO.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N9005T.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N9007.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N9009.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N900A.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N900K.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N900L.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N900PET.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N900PTR.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N900T.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N900V.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N900W8.xml': ['Samsung', 'Galaxy Note 3', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-N7509V_1_20140204.xml': [
    'Samsung',
    'Galaxy Note 3 Neo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-N750.xml': ['Samsung', 'Galaxy Note 3 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N7502.xml': ['Samsung', 'Galaxy Note 3 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N7505.xml': ['Samsung', 'Galaxy Note 3 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N7505L.xml': [
    'Samsung',
    'Galaxy Note 3 Neo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910F-Chameleon/latest': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-Chameleon/latest': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-MVNO/OB7.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/NIE.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/NK2.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/OB7.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/OE1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/OF5.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/OG5.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/OJ6.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/OK1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/PC1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/PD1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/PE1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/PE2.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/PG1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/PH4.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/PJ1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/PK1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/PL1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/QA1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/QB3.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N910P-SPRINT/QD1.rdf': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-N9109W_1_20140903.xml': [
    'Samsung',
    'Galaxy Note 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-N9106W.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910A.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910C.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910CPET.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910F.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910FPTR.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910G.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910H.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910T.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910T2.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910T3.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910U.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N910W8.xml': ['Samsung', 'Galaxy Note 4', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-N9200-Chameleon/latest': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-Chameleon/latest': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-MVNO/PD1.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/OGD.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/OI6.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/OJ6.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/OK3.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/PC3.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/PD1.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/PD2.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/PG1.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/PH9.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/PJ2.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/PK1.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/PL1.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/QA1.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N920P-SPRINT/QB1.rdf': [
    'Samsung',
    'Galaxy Note 5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-N920G.xml': ['Samsung', 'Galaxy Note 5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N920T.xml': ['Samsung', 'Galaxy Note 5', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-N930P-SPRINT/PGC.rdf': [
    'Samsung',
    'Galaxy Note 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N930P-SPRINT/PH9.rdf': [
    'Samsung',
    'Galaxy Note 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N930P-SPRINT/PHE.rdf': [
    'Samsung',
    'Galaxy Note 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N930P-SPRINT/PK1.rdf': [
    'Samsung',
    'Galaxy Note 7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-N930F.xml': ['Samsung', 'Galaxy Note 7', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N5100.xml': ['Samsung', 'Galaxy Note 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-N5110.xml': ['Samsung', 'Galaxy Note 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-N5120.xml': ['Samsung', 'Galaxy Note 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SGH-I467.xml': ['Samsung', 'Galaxy Note 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SGH-I467M.xml': ['Samsung', 'Galaxy Note 8.0', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/Samsung/SM-N915P-Chameleon/latest': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/NJL.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/NK1.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/OC8.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/OF6.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/OFE.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/OG1.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/OJ5.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/OK2.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/PD1.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/PE2.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/PG1.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/PH2.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/PH3.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/PJ1.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-N915P-SPRINT/QB3.rdf': [
    'Samsung',
    'Galaxy Note Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-N9150.xml': ['Samsung', 'Galaxy Note Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N915A.xml': ['Samsung', 'Galaxy Note Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N915F.xml': ['Samsung', 'Galaxy Note Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N915FY.xml': ['Samsung', 'Galaxy Note Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N915G.xml': ['Samsung', 'Galaxy Note Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N915S.xml': ['Samsung', 'Galaxy Note Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N915T.xml': ['Samsung', 'Galaxy Note Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-N915W8.xml': ['Samsung', 'Galaxy Note Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SCL24.xml': [
    'Samsung',
    'GALAXY Note Edge SCL24',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-2011011301/MC2.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-2011011301/MK4.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-2011011301/OH3.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-BOOST/OH3.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-Chameleon/LJC.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-Chameleon/MA7.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-Chameleon/MC2.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-Chameleon/MK4D.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/LJ1.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/LJ8.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/LJC.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/MA5.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/MA7.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/MC2.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/MK4.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/NE2.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/NK2.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/OH3.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900-SPRINT/QA1.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L900/MC2.rdf': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_N719_1_20121012.xml': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/sam/SCH-I605/SCH-I605.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7100.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7100BO.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7100PET.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7100T.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7105.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7105BO.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-N7105T.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/N7100T.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SAMSUNG-SGH-I317.xml': [
    'Samsung',
    'Galaxy Note II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I317.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I317M.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T889.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T889V.xml': ['Samsung', 'Galaxy Note II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SC-05D.xml': ['Samsung', 'Galaxy Note LTE', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-P900.xml': ['Samsung', 'Galaxy Note Pro', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-P901.xml': ['Samsung', 'Galaxy Note Pro', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-P905.xml': ['Samsung', 'Galaxy Note Pro', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-P905M.xml': ['Samsung', 'Galaxy Note Pro', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-P907A.xml': ['Samsung', 'Galaxy Note Pro', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/YP-GB70D.xml': ['Samsung', 'Galaxy Player 70 Plus', 'Android'],
  'http://wap.samsungmobile.com/uaprof/GT-S5300.xml': ['Samsung', 'Galaxy Pocket', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5300B.xml': ['Samsung', 'Galaxy Pocket', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5300L.xml': ['Samsung', 'Galaxy Pocket', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5310.xml': ['Samsung', 'Galaxy Pocket 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5310B.xml': ['Samsung', 'Galaxy Pocket 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5310BO.xml': ['Samsung', 'Galaxy Pocket 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5310L.xml': ['Samsung', 'Galaxy Pocket 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5310T.xml': ['Samsung', 'Galaxy Pocket 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5312.xml': [
    'Samsung',
    'Galaxy Pocket 2 Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5312B.xml': [
    'Samsung',
    'Galaxy Pocket 2 Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5302.xml': [
    'Samsung',
    'Galaxy Pocket Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5302B.xml': [
    'Samsung',
    'Galaxy Pocket Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5310G.xml': [
    'Samsung',
    'Galaxy Pocket Neo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5301.xml': [
    'Samsung',
    'Galaxy Pocket Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5301B.xml': [
    'Samsung',
    'Galaxy Pocket Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5301L.xml': [
    'Samsung',
    'Galaxy Pocket Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I559_1_20101216.xml': ['Samsung', 'Galaxy Pop', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/Galaxy Precedent/EJ06.rdf': [
    'Samsung',
    'Galaxy Precedent',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/Precedent/EJ06.rdf': [
    'Samsung',
    'Galaxy Precedent',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SCH-M828C/EH03.rdf': [
    'Samsung',
    'Galaxy Precedent',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SCH-M828C/EJ06.rdf': [
    'Samsung',
    'Galaxy Precedent',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SCH-M828C/FE16.rdf': [
    'Samsung',
    'Galaxy Precedent',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M820-BST/EE14.rdf': [
    'Samsung',
    'Galaxy Prevail',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M820-BST/EJ06.rdf': [
    'Samsung',
    'Galaxy Prevail',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M820-BST/FA19.rdf': [
    'Samsung',
    'Galaxy Prevail',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M820-BST/FF19.rdf': [
    'Samsung',
    'Galaxy Prevail',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SPH-M820-BST.xml': [
    'Samsung',
    'Galaxy Prevail',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-B7510.xml': ['Samsung', 'Galaxy Pro', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B7510B.xml': ['Samsung', 'Galaxy Pro', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B7510L.xml': ['Samsung', 'Galaxy Pro', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/i110/i110.xml': ['Samsung', 'Galaxy Proclaim', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9103.xml': ['Samsung', 'Galaxy R', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/Samsung/SPH-M950-VMUB/1.0/UAProf.xml': [
    'Samsung',
    'Galaxy Reverb',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-6100000231/OI1.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-6102952738/OI1.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-BOOST/MH5.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-BOOST/NK1.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-BOOST/OI1.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-Chameleon/MH5.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-VIRGIN/ME3.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-VIRGIN/MH5.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-VIRGIN/NK1.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M840-VIRGIN/OI1.rdf': [
    'Samsung',
    'Galaxy Ring',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I547.xml': ['Samsung', 'Galaxy Rugby Pro', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I547C.xml': ['Samsung', 'Galaxy Rugby Pro', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M830-2012042701/MD5.rdf': [
    'Samsung',
    'Galaxy Rush',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M830-2012042701/OI1.rdf': [
    'Samsung',
    'Galaxy Rush',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M830-BOOST/LK7.rdf': [
    'Samsung',
    'Galaxy Rush',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M830-BOOST/MB3.rdf': [
    'Samsung',
    'Galaxy Rush',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M830-BOOST/MD5.rdf': [
    'Samsung',
    'Galaxy Rush',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M830-BOOST/OI1.rdf': [
    'Samsung',
    'Galaxy Rush',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M830-Chameleon/MD5.rdf': [
    'Samsung',
    'Galaxy Rush',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M830-Chameleon/OI1.rdf': [
    'Samsung',
    'Galaxy Rush',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_i809_1_20110307.xml': ['Samsung', 'Galaxy S', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_i909_1_20100527.xml': ['Samsung', 'Galaxy S', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/samsung-schi909.xml': ['Samsung', 'Galaxy S', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9000.xml': ['Samsung', 'Galaxy S', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i9000B.xml': ['Samsung', 'Galaxy S', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9000BO.xml': ['Samsung', 'Galaxy S', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9000M.xml': ['Samsung', 'Galaxy S', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i9000T.rdf': ['Samsung', 'Galaxy S', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9000T.xml': ['Samsung', 'Galaxy S', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T959V.xml': ['Samsung', 'Galaxy S 4G', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9070.xml': ['Samsung', 'Galaxy S Advance', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9070BO.xml': [
    'Samsung',
    'Galaxy S Advance',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9070P.xml': ['Samsung', 'Galaxy S Advance', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9070PBO.xml': [
    'Samsung',
    'Galaxy S Advance',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-T769.xml': ['Samsung', 'Galaxy S Blaze', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I919U_1_20120216.xml': [
    'Samsung',
    'Galaxy S Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_i919_1_20110615.xml': [
    'Samsung',
    'Galaxy S Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S7562.xml': ['Samsung', 'Galaxy S Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7562L.xml': ['Samsung', 'Galaxy S Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7582.xml': ['Samsung', 'Galaxy S Duos 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7582L.xml': ['Samsung', 'Galaxy S Duos 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7583T.xml': ['Samsung', 'Galaxy S Duos 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G316HU.xml': [
    'Samsung',
    'Galaxy S Duos 3-VE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-T959D.xml': [
    'Samsung',
    'Galaxy S Fascinate 3G+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-T959P.xml': [
    'Samsung',
    'Galaxy S Fascinate 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/DPH-D710/L14.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/DPH-D710vmub/L14.rdf': [
    'Samsung',
    'Galaxy S II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/GT-I9100/LIB.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9100/LP7.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9100/LPA.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9100/LPB.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9100/LPF.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9100/LPS.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9100/LPX.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9100/LQ6.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9100/LS8.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SCH-R760X/B28.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/A10.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/B27.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/EG30.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/EK02.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/EL29.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/EL88.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FD19.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FD24.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FD26.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FE22.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FF18.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FH13.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FI03.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FI25.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FI27.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/FL24.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/GA10.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/I23.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/K09.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/K23.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/L24.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710/SPH-D710.rdf': [
    'Samsung',
    'Galaxy S II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-D710/ZZ99.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710BST/C01.rdf': [
    'Samsung',
    'Galaxy S II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-D710BST/FH29.rdf': [
    'Samsung',
    'Galaxy S II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-D710BST/FI22.rdf': [
    'Samsung',
    'Galaxy S II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-D710BST/FL24.rdf': [
    'Samsung',
    'Galaxy S II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-D710VMUB/.rdf': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-D710VMUB/FL26.rdf': [
    'Samsung',
    'Galaxy S II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-D710VMUBVMUB/.rdf': [
    'Samsung',
    'Galaxy S II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9100.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9100BO.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9100G.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9100M.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9100P.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9100T.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9100THZ.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SC-02C.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I727R.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I777.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-S959G.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T989.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/soju.xml': ['Samsung', 'Galaxy S II', 'Android', DeviceType.MOBILE],
  'http://­device.sprintpcs.com /­HTC/HTCPN702-SPRINT/­3046512.rdf': [
    'Samsung',
    'Galaxy S II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_i929_1_20110901.xml': [
    'Samsung',
    'Galaxy S II Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_i929_2_20120705.XML': [
    'Samsung',
    'Galaxy S II Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9210.xml': ['Samsung', 'Galaxy S II LTE', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9210T.xml': ['Samsung', 'Galaxy S II LTE', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SHV-E110S.xml': ['Samsung', 'Galaxy S II LTE', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9105P.xml': ['Samsung', 'Galaxy S II Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9105PBO.xml': [
    'Samsung',
    'Galaxy S II Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SAMSUNG-SGH-I727.xml': [
    'Samsung',
    'Galaxy S II Skyrocket',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I727.xml': [
    'Samsung',
    'Galaxy S II Skyrocket',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/soljus.xml': [
    'Samsung',
    'Galaxy S II Skyrocket',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I757.xml': [
    'Samsung',
    'Galaxy S II Skyrocket HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I757M.xml': [
    'Samsung',
    'Galaxy S II Skyrocket HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S7273T.xml': ['Samsung', 'Galaxy S II TV', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T989D.xml': ['Samsung', 'Galaxy S II X', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/LF5.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/LH1.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/LI1.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/LI2.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/LIB.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/LID.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/LJ1.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/LK1.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/LL4.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/MA1.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/MB1.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9300/MB5.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SAMSUNG-SGH-I747/LK3.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SCH-S960L/MD6.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SHV-E210S/LH7.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710-2012083001/MG2.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-BOOST/MG2.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-BOOST/MK5.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-BOOST/NDC.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-BOOST/NJ3.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-BOOST/OJ1.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-Chameleon/latest': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-VIRGIN/MD7.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-VIRGIN/MG2.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-VIRGIN/MK5.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-VIRGIN/NDC.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-VIRGIN/NJ3.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710-VIRGIN/OJ1.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710/LE5.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/LEN.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/LF9.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/LG2.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/LG8.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/LI3.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/LIF.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/LIH.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/LJ7.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/MA4.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/MA6.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/MB1.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/MB3.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/MC3.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/MD4.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/MK3.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/MK5.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/ND8.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/NJ2.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710/OH1.rdf': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-2012071301/OF2.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-2012071301/OH1.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-BOOST/NE5.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-BOOST/NF4.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-BOOST/OA3.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-BOOST/OF2.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-BOOST/OH1.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-SPRINT/NE5.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-SPRINT/OA3.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-SPRINT/OF2.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-SPRPRE/NF4.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-SPRPRE/OA3.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-SPRPRE/OF2.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-SPRPRE/OH1.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-VIRGIN/NF4.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L710T-VIRGIN/OH1.rdf': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I939D_1_20121031.xml': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I939_1_20120309.xml': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SCH-I939I_1_20140116.xml': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.metropcs.net/UAProf/SCH-R530M.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/SAMSUNG-SCH-I939_CHN_BRI.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/GT-I9300/GT-I9300.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/r530/r530v1.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/SCH-I535/SCH-I535.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/SCH-I535PP/SCH-I535PP.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/SPH-L710/SPH-L710.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Galaxy S III.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9300.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9300BO.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9300I.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9300MIRS.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9300PCL.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9300T.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9301IBO.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9305.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9305BO.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9305T.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SAMSUNG-SGH-I747.xml': [
    'Samsung',
    'Galaxy S III',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SCH-S968C.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I747.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I747M.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I748.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T999.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T999N.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T999V.xml': ['Samsung', 'Galaxy S III', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8190.xml': ['Samsung', 'Galaxy S III Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8190BO.xml': [
    'Samsung',
    'Galaxy S III Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I8190L.xml': [
    'Samsung',
    'Galaxy S III Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I8190N.xml': [
    'Samsung',
    'Galaxy S III Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I8190NBO.xml': [
    'Samsung',
    'Galaxy S III Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I8190T.xml': [
    'Samsung',
    'Galaxy S III Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G730A.xml': ['Samsung', 'Galaxy S III Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G730W8.xml': [
    'Samsung',
    'Galaxy S III Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I8200.xml': [
    'Samsung',
    'Galaxy S III Mini Value Edition',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I8200L.xml': [
    'Samsung',
    'Galaxy S III Mini Value Edition',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I8200N.xml': [
    'Samsung',
    'Galaxy S III Mini Value Edition',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I8200NAO.xml': [
    'Samsung',
    'Galaxy S III Mini Value Edition',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G3812B.xml': [
    'Samsung',
    'Galaxy S III Slim',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9001.xml': ['Samsung', 'Galaxy S Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9001BO.xml': ['Samsung', 'Galaxy S Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T699.xml': ['Samsung', 'Galaxy S Relay', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/YP-GI1.xml': ['Samsung', 'Galaxy S WiFi 4.2', 'Android'],
  'http://wap.samsungmobile.com/uaprof/GT-I9301I.xml': ['Samsung', 'Galaxy S3 Neo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/GT-I9500-Chameleon/latest': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/GT-I9500-Chameleon/NAE.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/GT-I9500/GT-I9500.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/GT-I9505-Chameleon/NAE.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/L720-BOOST/PL1.rdf': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/NB4.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-11/NAE.rdf': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L720-11/OK3.rdf': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L720-11/PL1.rdf': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-L720-2010122001/NAE.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-2011011301/OD2.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-2011011301/OH1.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-2012083001/NG2.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-2012083001/PL1.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-500002419/NAE.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-Chameleon/latest': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-Chameleon/MCI.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-Chameleon/MDC.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-Chameleon/MDL.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-Chameleon/MF9.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-Chameleon/NAE.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-Chameleon/NG2.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/MDC.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/MDL.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/MF9.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/MJA.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/MK2.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/NA7.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/NAE.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/NG2.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/OD2.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/OK3.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/PI2.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720-SPRINT/PL1.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-BOOST/OK3.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-BOOST/PL1.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-Chameleon/latest': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-Chameleon/NG5.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-MVNO/NC6.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-MVNO/NG5.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-MVNO/OA3.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-MVNO/OK3.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/MK5.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/NAF.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/NC6.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/NG5.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/OA3.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/OD2.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/OF1.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/OK3.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L720T-SPRINT/PL1.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L72A-SPRINT/MF9.rdf': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://gsm.lge.com/html/gsm/I9500-M3-D1-KK.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I959_1_20130319.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I959_2_20131021.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SCH-I959_1_20140317.xml': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://pix.cspire.com/UA/profile/samsung/r970x/r970x.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://pix.cspire.com/UA/profile/samsung/SCH-L710/SCH-L710.xml': [
    'Samsung',
    'Galaxy S4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/sam/GT-I9500/GT-I9500.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9500.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9500MIRS.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9500PCL.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9500PET.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9505.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9505BMC.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9505BO.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9505G.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9505T.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9507.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I217.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I337.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I337M.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I337MBMC.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I337MPET.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I337Z.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M919.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M919N.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M919V.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M919VLTN.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-S970G.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-S975L.xml': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://www.cherrymobile.com.ph/Burst_2-0_UAprofile.XML': ['Samsung', 'Galaxy S4', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9295.xml': ['Samsung', 'Galaxy S4 Active', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9295BO.xml': [
    'Samsung',
    'Galaxy S4 Active',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SAMSUNG-SGH-I537.xml': [
    'Samsung',
    'Galaxy S4 Active',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I537.xml': ['Samsung', 'Galaxy S4 Active', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9506.xml': ['Samsung', 'Galaxy S4 Advance', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9506BO.xml': [
    'Samsung',
    'Galaxy S4 Advance',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9506T.xml': [
    'Samsung',
    'Galaxy S4 Advance',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-Chameleon/latest': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-Chameleon/ME3.rdf': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-Chameleon/NA7.rdf': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-SPRINT/MI3.rdf': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-SPRINT/MK2.rdf': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-SPRINT/NA7.rdf': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-SPRINT/NE3.rdf': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-SPRINT/NJ1.rdf': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L520-SPRINT/QA1.rdf': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9190.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9190PET.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9195.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9195BO.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9195I.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9195L.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9195LPET.xml': [
    'Samsung',
    'Galaxy S4 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9195T.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9197.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I257.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I257M.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-S890L.xml': ['Samsung', 'Galaxy S4 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9192.xml': [
    'Samsung',
    'Galaxy S4 Mini Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-I9515.xml': ['Samsung', 'Galaxy S4 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9515L.xml': ['Samsung', 'Galaxy S4 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9515LPET.xml': ['Samsung', 'Galaxy S4 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SAMSUNG-SM-C105A.xml': [
    'Samsung',
    'Galaxy S4 Zoom',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-C101.xml': ['Samsung', 'Galaxy S4 Zoom', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-C105.xml': ['Samsung', 'Galaxy S4 Zoom', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-C105A.xml': ['Samsung', 'Galaxy S4 Zoom', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/G900P-BOOST/PE2.rdf': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-G900A/SM-G900A.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-2012071301/PCA.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/NE5.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/OA6.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/OD3.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/OF6.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/OG1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/OK4.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/PCA.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/PE1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/PE2.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/PG1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/PH3.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/PJ2.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-BOOST/QD1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-Chameleon/latest': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-Chameleon/NCB.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-MVNO/ND2.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/NCB.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/ND2.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/NE5.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/NK4.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/NKD.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/OA6.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/OD3.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/OF6.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/OG1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/OK4.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/PCA.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/PE1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/PE2.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/PG1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/PH3.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/PJ2.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/PK1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/PL2.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/QA2.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/QB3.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/QC1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-SPRINT/QD1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-VIRGIN/NE5.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-VIRGIN/NK4.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-VIRGIN/OA6.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-VIRGIN/OD3.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-VIRGIN/OF6.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-VIRGIN/OG1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-VIRGIN/PL2.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P-VIRGIN/QD1.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G900P/SM-G900P.rdf': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G9009D_1_20140227.xml': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G9009W_1_20140415.xml': [
    'Samsung',
    'Galaxy S5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.sonymobile.com/SM-G900MR621.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SAMSUNG-SM-G900A.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SCL23.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G9008W.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900A.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900AZ.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900F.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900FBO.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900FPCL.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900FPTR.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900H.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900I.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900J.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900L.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900M.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900MD.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900MPET.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900T.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900T1.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900T3.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900V.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900W8.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G900W8MTA.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G901F.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G906L.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G906S.xml': ['Samsung', 'Galaxy S5', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G870A.xml': ['Samsung', 'Galaxy S5 Active', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G870W.xml': ['Samsung', 'Galaxy S5 Active', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G800A.xml': ['Samsung', 'Galaxy S5 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G800F.xml': ['Samsung', 'Galaxy S5 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G800H.xml': ['Samsung', 'Galaxy S5 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G800M.xml': ['Samsung', 'Galaxy S5 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G800MPET.xml': ['Samsung', 'Galaxy S5 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G800Y.xml': ['Samsung', 'Galaxy S5 Mini', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G903F.xml': ['Samsung', 'Galaxy S5 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G903M.xml': ['Samsung', 'Galaxy S5 Neo', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G903W.xml': ['Samsung', 'Galaxy S5 Neo', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-G860P-Chameleon/latest': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G860P-SPRINT/latest': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G860P-SPRINT/NG2.rdf': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G860P-SPRINT/NG3.rdf': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G860P-SPRINT/NK2.rdf': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G860P-SPRINT/OC5.rdf': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G860P-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G860P-SPRINT/OK1.rdf': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G860P-SPRINT/PD1.rdf': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G860P-SPRINT/PH4.rdf': [
    'Samsung',
    'Galaxy S5 Sport',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-BOOST/OCF.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-BOOST/OE2.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-BOOST/OI1.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-BOOST/PD2.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-Chameleon/latest': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-MVNO/OE2.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/latest': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OC9.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OCF.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OE2.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OF7.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OFE.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OGA.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OI1.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OJ7.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/OL1.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PB6.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PD2.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PD3.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PF4.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PG1.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PG3.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PI3.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PJ1.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PK1.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/PL3.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/QA2.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G920P-SPRINT/QB1.rdf': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G9209_1_20150302.xml': [
    'Samsung',
    'Galaxy S6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G920A.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G920AZ.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G920F.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G920FPCL.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G920FPTR.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G920I.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G920IPET.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G920T.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G920T1.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G920W8.xml': ['Samsung', 'Galaxy S6', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G890A.xml': ['Samsung', 'Galaxy S6 Active', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-G925P-Chameleon/latest': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OC9.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OCF.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OE2.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OF7.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OFE.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OGA.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OI1.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OJ7.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/OL1.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PB6.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PD2.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PD3.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PF4.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PG1.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PG3.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PI3.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PJ1.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PK1.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/PL3.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/QA2.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G925P-SPRINT/QB1.rdf': [
    'Samsung',
    'Galaxy S6 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G925A.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G925D.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G925F.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G925FPCL.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G925FPTR.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G925I.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G925IPET.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G925K.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G925T.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G925W8.xml': ['Samsung', 'Galaxy S6 Edge', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-G928P-Chameleon/latest': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/OGD.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/OI6.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/OJ6.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/OK3.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/PC3.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/PD1.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/PD2.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/PG1.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/PH9.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/PJ2.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G928P-SPRINT/QB1.rdf': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SAMSUNGUAPROFA.xml': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G928F.xml': ['Samsung', 'Galaxy S6 Edge+', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G928G.xml': ['Samsung', 'Galaxy S6 Edge+', 'Android', DeviceType.MOBILE],
  'Mozilla/5.0 (Linux; Android 6.0.1; SAMSUNG SM-G928P Build/MMB29K) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/5.0 Chrome/51.0.2704.106 Mobile Safari/537.36': [
    'Samsung',
    'Galaxy S6 Edge+',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SC-05G.xml': ['Samsung', 'GALAXY S6 SC-05G', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-G930P-BOOST/PH7.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-Chameleon/latest': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-MVNO/PG1.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PB5.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PC5.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PD3.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PE1.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PF2.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PG1.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PH7.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PJ2.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PK1.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/PL6.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/QAA.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/QC1.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/QD2.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G930P-SPRINT/QE1.rdf': [
    'Samsung',
    'Galaxy S7',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G930F.xml': ['Samsung', 'Galaxy S7', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SM-G935P-Chameleon/latest': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PB5.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PC5.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PD3.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PE1.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PF2.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PG1.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PH7.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PJ2.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PK1.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/PL6.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/QAA.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-G935P-SPRINT/QC1.rdf': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SAMSUNGUAPROFC.xml': [
    'Samsung',
    'Galaxy S7 Edge',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G935F.xml': ['Samsung', 'Galaxy S7 Edge', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G935T.xml': ['Samsung', 'Galaxy S7 Edge', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/odsamg955u/odsamg955u.xml': ['Samsung', 'Galaxy S8+', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I9003.xml': ['Samsung', 'Galaxy SL', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i9003L.xml': ['Samsung', 'Galaxy SL', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5700L.xml': ['Samsung', 'Galaxy Spica', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i5700R.xml': ['Samsung', 'Galaxy Spica', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5280.xml': ['Samsung', 'Galaxy Star', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5282.xml': ['Samsung', 'Galaxy Star', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7262.xml': ['Samsung', 'Galaxy Star Pro', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5283B.xml': [
    'Samsung',
    'Galaxy Star Trios',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-S766C.xml': ['Samsung', 'Galaxy Stardust', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/SCH-I200/SCH-I200.xml': ['Samsung', 'Galaxy Stellar', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-P100/EA24.rdf': ['Samsung', 'Galaxy Tab', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/Samsung/SPH-P100/EF17.rdf': ['Samsung', 'Galaxy Tab', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-p1000.xml': ['Samsung', 'Galaxy Tab', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P1000L.xml': ['Samsung', 'Galaxy Tab', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P1000M.xml': ['Samsung', 'Galaxy Tab', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P1000N.xml': ['Samsung', 'Galaxy Tab', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P1000R.xml': ['Samsung', 'Galaxy Tab', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P1000T.xml': ['Samsung', 'Galaxy Tab', 'Android', DeviceType.TABLET],
  'http://uaprof.vtext.com/sam/i905/i905.xml': ['Samsung', 'Galaxy Tab 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7500.xml': ['Samsung', 'Galaxy Tab 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7500BO.xml': ['Samsung', 'Galaxy Tab 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7500D.xml': ['Samsung', 'Galaxy Tab 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7500M.xml': ['Samsung', 'Galaxy Tab 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7500R.xml': ['Samsung', 'Galaxy Tab 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7500V.xml': ['Samsung', 'Galaxy Tab 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7510.xml': ['Samsung', 'Galaxy Tab 10.1', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7501BO.xml': [
    'Samsung',
    'Galaxy Tab 10.1N',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprof.vtext.com/sam/SCH-I915/SCH-I915.xml': [
    'Samsung',
    'Galaxy Tab 2 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P5100.xml': [
    'Samsung',
    'Galaxy Tab 2 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P5100BO.xml': [
    'Samsung',
    'Galaxy Tab 2 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P5110.xml': [
    'Samsung',
    'Galaxy Tab 2 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P5113.xml': [
    'Samsung',
    'Galaxy Tab 2 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I497.xml': [
    'Samsung',
    'Galaxy Tab 2 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprof.vtext.com/sam/SCH-i705/SCH-i705.xml': [
    'Samsung',
    'Galaxy Tab 2 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P3100.xml': [
    'Samsung',
    'Galaxy Tab 2 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P3100B.xml': [
    'Samsung',
    'Galaxy Tab 2 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P3105.xml': [
    'Samsung',
    'Galaxy Tab 2 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P3110.xml': [
    'Samsung',
    'Galaxy Tab 2 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-P500/LI6.rdf': [
    'Samsung',
    'Galaxy Tab 2 10.1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-P500/MB3.rdf': [
    'Samsung',
    'Galaxy Tab 2 10.1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I497OYA.xml': [
    'Samsung',
    'Galaxy Tab 2 10.1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P5200.xml': [
    'Samsung',
    'Galaxy Tab 3 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P5210.xml': [
    'Samsung',
    'Galaxy Tab 3 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P5220.xml': [
    'Samsung',
    'Galaxy Tab 3 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P5220BO.xml': [
    'Samsung',
    'Galaxy Tab 3 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T217S-Chameleon/latest': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T217S-Chameleon/NB8.rdf': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T217S-SPRINT/MH9.rdf': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T217S-SPRINT/NB8.rdf': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T217S-SPRINT/NE7.rdf': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T217S-SPRINT/NH4.rdf': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T217S-SPRINT/NK1.rdf': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T217S-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T210.xml': ['Samsung', 'Galaxy Tab 3 (7.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T211.xml': ['Samsung', 'Galaxy Tab 3 (7.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T211M.xml': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T215.xml': ['Samsung', 'Galaxy Tab 3 (7.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T217A.xml': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T217T.xml': [
    'Samsung',
    'Galaxy Tab 3 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T310.xml': ['Samsung', 'Galaxy Tab 3 (8.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T311.xml': ['Samsung', 'Galaxy Tab 3 (8.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T315.xml': ['Samsung', 'Galaxy Tab 3 (8.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T315BO.xml': [
    'Samsung',
    'Galaxy Tab 3 (8.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T315T.xml': [
    'Samsung',
    'Galaxy Tab 3 (8.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T217S-SPRINT/QA1.rdf': [
    'Samsung',
    'Galaxy Tab 3 7.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T2105.xml': ['Samsung', 'Galaxy Tab 3 Kids', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T110.xml': ['Samsung', 'Galaxy Tab 3 Lite', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T111.xml': ['Samsung', 'Galaxy Tab 3 Lite', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T111BO.xml': [
    'Samsung',
    'Galaxy Tab 3 Lite',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T111M.xml': ['Samsung', 'Galaxy Tab 3 Lite', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-T535.xml': [
    'Samsung',
    'Galaxy Tab 4 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T530.xml': [
    'Samsung',
    'Galaxy Tab 4 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T531.xml': [
    'Samsung',
    'Galaxy Tab 4 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T535.xml': [
    'Samsung',
    'Galaxy Tab 4 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T535BO.xml': [
    'Samsung',
    'Galaxy Tab 4 (10.1)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T237P-SPRINT/NG3.rdf': [
    'Samsung',
    'Galaxy Tab 4 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T237P-SPRINT/NL1.rdf': [
    'Samsung',
    'Galaxy Tab 4 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T237P-SPRINT/OH7.rdf': [
    'Samsung',
    'Galaxy Tab 4 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T230.xml': ['Samsung', 'Galaxy Tab 4 (7.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T230NT.xml': [
    'Samsung',
    'Galaxy Tab 4 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T231.xml': ['Samsung', 'Galaxy Tab 4 (7.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T235.xml': ['Samsung', 'Galaxy Tab 4 (7.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T235BO.xml': [
    'Samsung',
    'Galaxy Tab 4 (7.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T330.xml': ['Samsung', 'Galaxy Tab 4 (8.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T331.xml': ['Samsung', 'Galaxy Tab 4 (8.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T335.xml': ['Samsung', 'Galaxy Tab 4 (8.0)', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T335BO.xml': [
    'Samsung',
    'Galaxy Tab 4 (8.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T337A.xml': [
    'Samsung',
    'Galaxy Tab 4 (8.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T337T.xml': [
    'Samsung',
    'Galaxy Tab 4 (8.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T237P-SPRINT/PF1.rdf': [
    'Samsung',
    'Galaxy Tab 4 7.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T237P-SPRINT/PH4.rdf': [
    'Samsung',
    'Galaxy Tab 4 7.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T237P-SPRINT/PL1.rdf': [
    'Samsung',
    'Galaxy Tab 4 7.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T239.xml': ['Samsung', 'Galaxy Tab 4 Lite', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T239M.xml': ['Samsung', 'Galaxy Tab 4 Lite', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/Samsung/SPH-P100/DJ30.rdf': [
    'Samsung',
    'Galaxy Tab 7.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-I987.xml': ['Samsung', 'Galaxy Tab 7.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SGH-T849.xml': ['Samsung', 'Galaxy Tab 7.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P6200.xml': [
    'Samsung',
    'Galaxy Tab 7.0 Plus',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P6200L.xml': [
    'Samsung',
    'Galaxy Tab 7.0 Plus',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-P6210.xml': [
    'Samsung',
    'Galaxy Tab 7.0 Plus',
    'Android',
    DeviceType.TABLET,
  ],
  'http://uaprof.vtext.com/sam/i815/i815.xml': ['Samsung', 'Galaxy Tab 7.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P6800.xml': ['Samsung', 'Galaxy Tab 7.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P6810.xml': ['Samsung', 'Galaxy Tab 7.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SHV-E150S.xml': ['Samsung', 'Galaxy Tab 7.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7300.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7300B.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7300BO.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7310.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7320.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-P7320T.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SGH-I957.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SGH-I957D.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SGH-I957M.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SGH-I957R.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SHV-E140K.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SHV-E140L.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SHV-E140S.xml': ['Samsung', 'Galaxy Tab 8.9', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/Samsung/SM-T587P-Chameleon/latest': [
    'Samsung',
    'Galaxy Tab A 10.1 (2016)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T587P-SPRINT/QB1.rdf': [
    'Samsung',
    'Galaxy Tab A 10.1 (2016)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T580.xml': [
    'Samsung',
    'Galaxy Tab A 10.1 (2016)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T585.xml': [
    'Samsung',
    'Galaxy Tab A 10.1 (2016)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P585Y.xml': [
    'Samsung',
    'Galaxy Tab A 10.1 with S Pen (2016)',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T280.xml': ['Samsung', 'Galaxy Tab A 7.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T285YD.xml': ['Samsung', 'Galaxy Tab A 7.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T350.xml': ['Samsung', 'Galaxy Tab A 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T355Y.xml': ['Samsung', 'Galaxy Tab A 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T357T.xml': ['Samsung', 'Galaxy Tab A 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T357W.xml': ['Samsung', 'Galaxy Tab A 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T365Y.xml': ['Samsung', 'Galaxy Tab A 9.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T550.xml': ['Samsung', 'Galaxy Tab A 9.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-P350.xml': [
    'Samsung',
    'Galaxy Tab A Plus 8.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P355.xml': [
    'Samsung',
    'Galaxy Tab A Plus 8.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P550.xml': [
    'Samsung',
    'Galaxy Tab A Plus 9.7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P555.xml': [
    'Samsung',
    'Galaxy Tab A Plus 9.7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-P555M.xml': [
    'Samsung',
    'Galaxy Tab A Plus 9.7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T365.xml': [
    'Samsung',
    'Galaxy Tab Active (8.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T365M.xml': [
    'Samsung',
    'Galaxy Tab Active (8.0)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T555.xml': ['Samsung', 'Galaxy Tab AL', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T285.xml': ['Samsung', 'Galaxy Tab E 7.0', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/Samsung/SM-T377P-Chameleon/latest': [
    'Samsung',
    'Galaxy Tab E 8.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T377P-SPRINT/OJ5.rdf': [
    'Samsung',
    'Galaxy Tab E 8.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T377P-SPRINT/PE6.rdf': [
    'Samsung',
    'Galaxy Tab E 8.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T377P-SPRINT/PI3.rdf': [
    'Samsung',
    'Galaxy Tab E 8.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T377P-SPRINT/PJ1.rdf': [
    'Samsung',
    'Galaxy Tab E 8.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T377P-SPRINT/QH2.rdf': [
    'Samsung',
    'Galaxy Tab E 8.0',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T520.xml': [
    'Samsung',
    'Galaxy Tab Pro 10.1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T525.xml': [
    'Samsung',
    'Galaxy Tab Pro 10.1',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T320.xml': ['Samsung', 'Galaxy Tab Pro 8.4', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T325.xml': ['Samsung', 'Galaxy Tab Pro 8.4', 'Android', DeviceType.TABLET],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-T2519_1_20140428.xml': [
    'Samsung',
    'Galaxy Tab Q',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T807P-Chameleon/latest': [
    'Samsung',
    'Galaxy Tab S 10.5',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T807P-SPRINT/NH1.rdf': [
    'Samsung',
    'Galaxy Tab S 10.5',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T807P-SPRINT/NK1.rdf': [
    'Samsung',
    'Galaxy Tab S 10.5',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T807P-SPRINT/OH1.rdf': [
    'Samsung',
    'Galaxy Tab S 10.5',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T807P-SPRINT/OJ4.rdf': [
    'Samsung',
    'Galaxy Tab S 10.5',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T807P-SPRINT/OL3.rdf': [
    'Samsung',
    'Galaxy Tab S 10.5',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T807P-SPRINT/PI1.rdf': [
    'Samsung',
    'Galaxy Tab S 10.5',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T537A.xml': ['Samsung', 'Galaxy Tab S 10.5', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T800.xml': ['Samsung', 'Galaxy Tab S 10.5', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T805.xml': ['Samsung', 'Galaxy Tab S 10.5', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T805M.xml': ['Samsung', 'Galaxy Tab S 10.5', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T805W.xml': ['Samsung', 'Galaxy Tab S 10.5', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T805Y.xml': ['Samsung', 'Galaxy Tab S 10.5', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T807A.xml': ['Samsung', 'Galaxy Tab S 10.5', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T807T.xml': ['Samsung', 'Galaxy Tab S 10.5', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T700.xml': ['Samsung', 'Galaxy Tab S 8.4', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T705.xml': ['Samsung', 'Galaxy Tab S 8.4', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T705M.xml': ['Samsung', 'Galaxy Tab S 8.4', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T705W.xml': ['Samsung', 'Galaxy Tab S 8.4', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T705Y.xml': ['Samsung', 'Galaxy Tab S 8.4', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T707A.xml': ['Samsung', 'Galaxy Tab S 8.4', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T710.xml': ['Samsung', 'Galaxy Tab S2 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T715.xml': ['Samsung', 'Galaxy Tab S2 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T715Y.xml': ['Samsung', 'Galaxy Tab S2 8.0', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T719.xml': [
    'Samsung',
    'Galaxy Tab S2 8.0 (2016)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T719Y.xml': [
    'Samsung',
    'Galaxy Tab S2 8.0 (2016)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T817P-Chameleon/latest': [
    'Samsung',
    'Galaxy Tab S2 9.7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T817P-SPRINT/OH6.rdf': [
    'Samsung',
    'Galaxy Tab S2 9.7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T817P-SPRINT/OJ5.rdf': [
    'Samsung',
    'Galaxy Tab S2 9.7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T817P-SPRINT/OL1.rdf': [
    'Samsung',
    'Galaxy Tab S2 9.7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T817P-SPRINT/PE1.rdf': [
    'Samsung',
    'Galaxy Tab S2 9.7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://device.sprintpcs.com/Samsung/SM-T817P-SPRINT/PL1.rdf': [
    'Samsung',
    'Galaxy Tab S2 9.7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T810.xml': ['Samsung', 'Galaxy Tab S2 9.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T815.xml': ['Samsung', 'Galaxy Tab S2 9.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T815Y.xml': ['Samsung', 'Galaxy Tab S2 9.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T817A.xml': ['Samsung', 'Galaxy Tab S2 9.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T817T.xml': ['Samsung', 'Galaxy Tab S2 9.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T817W.xml': ['Samsung', 'Galaxy Tab S2 9.7', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T813.xml': [
    'Samsung',
    'Galaxy Tab S2 9.7 (2016)',
    'Android',
    DeviceType.TABLET,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T819Y.xml': ['Samsung', 'Galaxy Tab S3 9.7', 'Android', DeviceType.TABLET],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I719_1_20120413.xml': [
    'Samsung',
    'Galaxy Trend',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S7392.xml': ['Samsung', 'Galaxy Trend', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7392L.xml': ['Samsung', 'Galaxy Trend', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SCH-I699I.xml': ['Samsung', 'Galaxy Trend', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SCH-I699I_1_20130805.xml': [
    'Samsung',
    'Galaxy Trend',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G3509_1_20130816.xml': [
    'Samsung',
    'Galaxy Trend 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G3509_2_20130816.xml': [
    'Samsung',
    'Galaxy Trend 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SM-G3509I_1_20131030.xml': [
    'Samsung',
    'Galaxy Trend 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G3502L.xml': ['Samsung', 'Galaxy Trend 3', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G3502T.xml': ['Samsung', 'Galaxy Trend 3', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I739_1_20130122.XML': [
    'Samsung',
    'Galaxy Trend II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S7390L.xml': [
    'Samsung',
    'Galaxy Trend Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S7580.xml': ['Samsung', 'Galaxy Trend Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7580BO.xml': [
    'Samsung',
    'Galaxy Trend Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S7580E.xml': [
    'Samsung',
    'Galaxy Trend Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S7580L.xml': [
    'Samsung',
    'Galaxy Trend Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S7580LPET.xml': [
    'Samsung',
    'Galaxy Trend Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/`per`s.xml': ['Samsung', 'Galaxy Trend Plus', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/Samsung/SPH-L300-VMUB/1.0/UAProf.xml': [
    'Samsung',
    'Galaxy Victory',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300-2012083001/MG5.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300-Chameleon/LK5.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300-Chameleon/MG5.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300-VIRGIN/MA8.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300-VIRGIN/MC1.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300-VIRGIN/MG5.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300-VIRGIN/ND4.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300/LH1.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300/LI3.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300/LJ9.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300/MC1.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-L300/ND4.rdf': [
    'Samsung',
    'Galaxy Victory 4G LTE',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-T670.xml': ['Samsung', 'Galaxy View', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/SM-T677.xml': ['Samsung', 'Galaxy View', 'Android', DeviceType.TABLET],
  'http://wap.samsungmobile.com/uaprof/GT-I8150.xml': ['Samsung', 'Galaxy W', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8150B.xml': ['Samsung', 'Galaxy W', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8150T.xml': ['Samsung', 'Galaxy W', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-W2014_1_20130916.xml': [
    'Samsung',
    'Galaxy W2014',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I869_1_20130415.xml': ['Samsung', 'Galaxy Win', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8550L.xml': ['Samsung', 'Galaxy Win', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8552.xml': ['Samsung', 'Galaxy Win', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8552B.xml': ['Samsung', 'Galaxy Win', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G360BT.xml': [
    'Samsung',
    'Galaxy Win 2 Duos TV',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SM-G3819D_1_20130821.xml': [
    'Samsung',
    'Galaxy Win Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.qma.com.tw/SAMSUNG-SM-G3819_CHN_BRI.xml': [
    'Samsung',
    'Galaxy Win Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5690.xml': ['Samsung', 'Galaxy Xcover', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5690BO.xml': ['Samsung', 'Galaxy Xcover', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5690L.xml': ['Samsung', 'Galaxy Xcover', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5690M.xml': ['Samsung', 'Galaxy Xcover', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5690R.xml': ['Samsung', 'Galaxy Xcover', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5698.xml': ['Samsung', 'Galaxy Xcover', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7710.xml': ['Samsung', 'Galaxy Xcover 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7710BO.xml': ['Samsung', 'Galaxy Xcover 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7710L.xml': ['Samsung', 'Galaxy Xcover 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G388F.xml': ['Samsung', 'Galaxy Xcover 3', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I509_1_20101216.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/SAMSUNG-SCH-I509_CHN_BRI.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5360.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5360B.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5360BO.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5360L.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5360T.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5363.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5369.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Hamitsuka.xml': ['Samsung', 'Galaxy Y', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6102.xml': ['Samsung', 'Galaxy Y Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6102B.xml': ['Samsung', 'Galaxy Y Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6102E.xml': ['Samsung', 'Galaxy Y Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6313T.xml': ['Samsung', 'Galaxy Y Duos TV', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5303B.xml': ['Samsung', 'Galaxy Y Plus', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5510.xml': ['Samsung', 'Galaxy Y Pro', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5510B.xml': ['Samsung', 'Galaxy Y Pro', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5510BO.xml': ['Samsung', 'Galaxy Y Pro', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5510BV.xml': ['Samsung', 'Galaxy Y Pro', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5510L.xml': ['Samsung', 'Galaxy Y Pro', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5512.xml': ['Samsung', 'Galaxy Y Pro Duos', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5512B.xml': [
    'Samsung',
    'Galaxy Y Pro Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5367.xml': ['Samsung', 'Galaxy Y TV', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6310.xml': ['Samsung', 'Galaxy Young', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6310B.xml': ['Samsung', 'Galaxy Young', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6310BO.xml': ['Samsung', 'Galaxy Young', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6310L.xml': ['Samsung', 'Galaxy Young', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6310N.xml': ['Samsung', 'Galaxy Young', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6310NBO.xml': ['Samsung', 'Galaxy Young', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6310T.xml': ['Samsung', 'Galaxy Young', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G130BT.xml': ['Samsung', 'Galaxy Young 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G130BU.xml': ['Samsung', 'Galaxy Young 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G130H.xml': ['Samsung', 'Galaxy Young 2', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-G130HN.xml': [
    'Samsung',
    'Galaxy Young 2 Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G130HNBO.xml': [
    'Samsung',
    'Galaxy Young 2 Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-G130M.xml': [
    'Samsung',
    'Galaxy Young 2 Duos',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S6293T.xml': [
    'Samsung',
    'Galaxy Young Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/sam/i100/i100v1.xml': ['Samsung', 'Gem', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B7620.xml': [
    'Samsung',
    'Giorgio Armani',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/U700VUAProf2G.rdf': ['Samsung', 'Gleam', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T459.xml': ['Samsung', 'Gravity', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T469.xml': ['Samsung', 'Gravity 2', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T289.xml': ['Samsung', 'Gravity Q', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T589.xml': ['Samsung', 'Gravity Smart', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T589R.xml': ['Samsung', 'Gravity Smart', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T589W.xml': ['Samsung', 'Gravity Smart', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B2100i.xml': ['Samsung', 'GT-B2100i', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5210U-3G_10.xml': ['Samsung', 'GT-B5210', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B5210U_10.xml': ['Samsung', 'GT-B5210', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3010UAProf.xml': ['Samsung', 'GT-C3010', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3011.xml': ['Samsung', 'GT-C3011', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3060UAProf.xml': ['Samsung', 'GT-C3060', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3230_2G.rdf': ['Samsung', 'GT-C3230', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3313TBR.xml': ['Samsung', 'GT-C3313', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3322.xml': ['Samsung', 'GT-C3322 Duos', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3322iUAProf.xml': ['Samsung', 'GT-C3322 Duos', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3380UAProf.xml': ['Samsung', 'GT-C3380', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3510.xml': ['Samsung', 'GT-C3510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3520.xml': ['Samsung', 'GT-C3520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3530UAProf.xml': ['Samsung', 'GT-C3530', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3560UAProf.xml': ['Samsung', 'GT-C3560', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3590UAProf.xml': ['Samsung', 'GT-C3590', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3592UAProf.xml': ['Samsung', 'GT-C3592', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3595_3G.rdf': ['Samsung', 'GT-C3595', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3750UAProf.xml': ['Samsung', 'GT-C3750', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3752UAProf.xml': ['Samsung', 'GT-C3752', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C5130UAProf.xml': ['Samsung', 'GT-C5130', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C5180.rdf': ['Samsung', 'GT-C5180', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C5510UAProf.xml': ['Samsung', 'GT-C5510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C5510UAProf3G.xml': ['Samsung', 'GT-C5510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2152.xml': ['Samsung', 'GT-E2152 Duos', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2152iUAProf.xml': ['Samsung', 'GT-E2152i', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2200.xml': ['Samsung', 'GT-E2200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2230UAProf.xml': ['Samsung', 'GT-E2230', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2232UAProf.xml': ['Samsung', 'GT-E2232', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2330BUAProf.xml': ['Samsung', 'GT-E2330', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2330UAProf.xml': ['Samsung', 'GT-E2330', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2350BUAProf.xml': ['Samsung', 'GT-E2350', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2530UAProf.xml': ['Samsung', 'GT-E2530', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2600UAProf.xml': ['Samsung', 'GT-E2600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E3300L_3G.rdf': ['Samsung', 'GT-E3300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I6410UAProf3G.rdf': ['Samsung', 'GT-I6410 M1', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8240.xml': ['Samsung', 'GT-I8240', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I8245.xml': ['Samsung', 'GT-I8245', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3550UAProf.xml': ['Samsung', 'GT-S3550', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3600i.xml': ['Samsung', 'GT-S3600i', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3970C_3G.rdf': ['Samsung', 'GT-S3970', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5500UAProf.xml': ['Samsung', 'GT-S5500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5500UAProf3G.xml': ['Samsung', 'GT-S5500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5503UAProf.xml': ['Samsung', 'GT-S5503', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5503UAProf3G.xml': ['Samsung', 'GT-S5503', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5510UAProf.xml': ['Samsung', 'GT-S5510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5510UAProf3G.xml': ['Samsung', 'GT-S5510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5611.xml': ['Samsung', 'GT-S5611', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5680_3G.rdf': ['Samsung', 'GT-S5680', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6700TUAProf.xml': ['Samsung', 'GT-S6700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6700UAProf.xml': ['Samsung', 'GT-S6700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S6700UAProf3G.xml': ['Samsung', 'GT-S6700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E1282T.xml': ['Samsung', 'Guru', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8320UAProf3G.rdf': ['Samsung', 'H1', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M630/BI09.rdf': ['Samsung', 'Highnote', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/samsung/r500/r500.xml': ['Samsung', 'Hue', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i637.xml': ['Samsung', 'i637 Jack', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I7110-3G.xml': ['Samsung', 'i7110', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I7110.xml': ['Samsung', 'i7110', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I7110C_10.xml': ['Samsung', 'i7110', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I9100.xml': ['Samsung', 'Infuse 4G', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I997.xml': ['Samsung', 'Infuse 4G', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8510-3G.xml': ['Samsung', 'INNOV8', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8510.xml': ['Samsung', 'INNOV8', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8510C_10.xml': ['Samsung', 'INNOV8', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8510H-3G_10.xml': ['Samsung', 'INNOV8', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8510H_10.xml': ['Samsung', 'INNOV8', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8510T-3G_10.xml': ['Samsung', 'INNOV8', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8510T_10.xml': ['Samsung', 'INNOV8', 'Series60', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M800/BE09.rdf': ['Samsung', 'Instinct', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M800/BF30.rdf': ['Samsung', 'Instinct', null, DeviceType.MOBILE],
  'http://uaprof.vmobl.com/Samsung/SPH-M910-VMUB/VMU_M910_UAProf.xml': [
    'Samsung',
    'Intercept',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vmobl.com/Samsung/SPH-M910/DI06/VMU_M910_UAProf.xml': [
    'Samsung',
    'Intercept',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/S8000.rdf': ['Samsung', 'Jet', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S8000OP.rdf': ['Samsung', 'Jet', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S8000_3G.rdf': ['Samsung', 'Jet', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S8003.rdf': ['Samsung', 'Jet', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S8003_3G.rdf': ['Samsung', 'Jet', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8000C.rdf': ['Samsung', 'Jet S8000', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T739.xml': ['Samsung', 'Katalyst', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-M5650.rdf': ['Samsung', 'Lindy', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-J800_3G.rdf': ['Samsung', 'Luxe', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m2510_10.xml': ['Samsung', 'M2510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M3200.xml': ['Samsung', 'M3200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M3510.xml': ['Samsung', 'M3510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M7500UAProf.xml': ['Samsung', 'M7500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M7500UAProf3G.xml': ['Samsung', 'M7500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M7600UAProf.xml': ['Samsung', 'M7600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M7600UAProf3G.xml': ['Samsung', 'M7600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M7603UAProf.xml': ['Samsung', 'M7603', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M7603UAProf3G.xml': ['Samsung', 'M7603', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M8000-3G.xml': ['Samsung', 'M8000', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/M8000.xml': ['Samsung', 'M8000', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5560.rdf': ['Samsung', 'Marvel', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5560i.rdf': ['Samsung', 'Marvel', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5560i.xml': ['Samsung', 'Marvel', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5560LTCE.xml': ['Samsung', 'Marvel', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5560_3G.rdf': ['Samsung', 'Marvel', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T929.xml': ['Samsung', 'Memoir', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2202.xml': ['Samsung', 'Metro', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S3310.rdf': ['Samsung', 'Metro', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-E2252.xml': ['Samsung', 'Metro 2252', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-B312EUAProf.xml': ['Samsung', 'Metro 312', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-B313E.xml': ['Samsung', 'Metro 313', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-B350E.xml': ['Samsung', 'Metro 350', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-B360E.xml': ['Samsung', 'Metro 360', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i780.xml': ['Samsung', 'Mirage', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i780ORANGE.xml': [
    'Samsung',
    'Mirage',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M900/CJ05.rdf': ['Samsung', 'Moment', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M900/DE03.rdf': ['Samsung', 'Moment', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M900/DI06.rdf': ['Samsung', 'Moment', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M900/DJ07.rdf': ['Samsung', 'Moment', 'Android', DeviceType.MOBILE],
  'http://uaprof.vmobl.com/Samsung/SPH-M390-PLB/1.0/UAProf.xml': ['Samsung', 'Montage', 'Brew', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5620_2G.rdf': ['Samsung', 'Monte', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5620_3G.rdf': ['Samsung', 'Monte', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3200BR.xml': ['Samsung', 'Monte Bar', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3200UAProf.xml': ['Samsung', 'Monte Bar', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3310iUAProf.xml': ['Samsung', 'Monte Bar', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/sch_s239.xml': ['Samsung', 'mPower TV', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/samsung/u706/u706.xml': ['Samsung', 'Muse', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/samsung/spha523-0.rdf': ['Samsung', 'Mysto', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/sojua.xml': ['Samsung', 'Nexus S', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5520_3G.rdf': ['Samsung', 'NORi', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i900.xml': ['Samsung', 'Omnia', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i900V.xml': ['Samsung', 'Omnia', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i908_OPEN.XML': [
    'Samsung',
    'Omnia Deluxe',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/I8910-3G.xml': ['Samsung', 'Omnia HD', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8910.xml': ['Samsung', 'Omnia HD', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-i8000.xml': ['Samsung', 'Omnia II', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I8315UAProf3G.rdf': [
    'Samsung',
    'Omnia W',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-M8800MR.rdf': ['Samsung', 'Pixon', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-M8800MR_3G.rdf': ['Samsung', 'Pixon', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-M8800_3G.rdf': ['Samsung', 'Pixon', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M8800.rdf': ['Samsung', 'Pixon', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M8800_3G.rdf': ['Samsung', 'Pixon', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5600.rdf': ['Samsung', 'Preston', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5600LUAProf.xml': ['Samsung', 'Preston', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5600_3G.rdf': ['Samsung', 'Preston', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5610_2G.rdf': ['Samsung', 'Primo', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5610_3G.rdf': ['Samsung', 'Primo', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SCH_W279.xml': ['Samsung', 'Primo Duos', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A767.xml': ['Samsung', 'Propel', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M540/BI09.rdf': ['Samsung', 'Rant', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/samsung/sphm540-0.rdf': ['Samsung', 'Rant', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/sch/u820/u820.xml': ['Samsung', 'Reality', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M580/EF27.rdf': ['Samsung', 'Replenish', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M580/FA19.rdf': ['Samsung', 'Replenish', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M580BST/FB03.rdf': ['Samsung', 'Replenish', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3800UAProf.xml': ['Samsung', 'Rex 70', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3800WUAProf.xml': ['Samsung', 'Rex 70', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S3802UAProf.xml': [
    'Samsung',
    'Rex 70 Duos',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5220RUAProf.xml': ['Samsung', 'Rex 80', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5222RUAProf.xml': [
    'Samsung',
    'Rex 80 Duos',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SM-B780AUAProf.xml': ['Samsung', 'Rugby 4', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-B780WUAProf.xml': ['Samsung', 'Rugby 4', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A997.xml': ['Samsung', 'Rugby III', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I847.xml': ['Samsung', 'Rugby Smart', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-S150G.xml': ['Samsung', 'S150G TracFone', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/s3500_10.xml': ['Samsung', 'S3500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S3600.xml': ['Samsung', 'S3600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-S425G.xml': ['Samsung', 'S425G', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S7330UAProf.xml': ['Samsung', 'S7330', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S7330UAProf3G.xml': ['Samsung', 'S7330', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S7350UAProf3G.xml': ['Samsung', 'S7350 Ultra S', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S9500UAProf.xml': ['Samsung', 'S9500', null, DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I779_1_20110615.xml': ['Samsung', 'Saga', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I779_1_20120220.xml': ['Samsung', 'Saga', 'Android', DeviceType.MOBILE],
  'http://device.telusmobility.com/samsung/scha600.rdf': ['Samsung', 'SCH-A600', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/samsung/a645/a645.xml': ['Samsung', 'SCH-A645', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/samsung/scha650.rdf': ['Samsung', 'SCH-A650', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/samsung/scha670.rdf': ['Samsung', 'SCH-A670', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/samsung/scha870-0.rdf': ['Samsung', 'SCH-A870', null, DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_I339_1_20120220.xml': ['Samsung', 'SCH-I339', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SCH-I629_1_20131010.xml': [
    'Samsung',
    'SCH-I629',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/sam/SCH-I665/SCH-I665.xml': ['Samsung', 'SCH-I665', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_SCH-I679_1_20131211.xml': [
    'Samsung',
    'SCH-I679',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/sch/n330/n330v1.xml': ['Samsung', 'SCH-N330', null, DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/sam-r450.xml': ['Samsung', 'SCH-R450', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/Samsung_SCH-R610.rdf': ['Samsung', 'SCH-R610', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SCH-R740C.xml': ['Samsung', 'SCH-R740', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_S559_1_20100515.xml': ['Samsung', 'SCH-S559', 'Brew', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_S579_1_20100427.xml': ['Samsung', 'SCH-S579', 'Brew', DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/samsung/u340/u340.xml': ['Samsung', 'SCH-U340', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/samsung/schu410t-0.rdf': ['Samsung', 'SCH-U410', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/sch/u430/u430v1.xml': ['Samsung', 'SCH-U430', null, DeviceType.MOBILE],
  'http://www.alltel.net/uaprof/samsung/u520/u520.xml': ['Samsung', 'SCH-U520', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/sch/u540/u540v1.xml': ['Samsung', 'SCH-U540', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/sch/u550/u550v1.xml': ['Samsung', 'SCH-U550', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/sch/u740/u740v1.xml': ['Samsung', 'SCH-U740', null, DeviceType.MOBILE],
  'http://uaprof.uni-wise.com/uaprof/SAM/SAM-W109.xml': ['Samsung', 'SCH-W109', null, DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_W2013_1_20120918.xml': ['Samsung', 'SCH-W2013', 'Android', DeviceType.MOBILE],
  'http://mobileuaprof.xtra.co.nz/sch_w531.rdf': ['Samsung', 'SCH-W531', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SCH-W709_CTC.xml': ['Samsung', 'SCH-W709', 'Brew', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_W789_1_20120309.xml': ['Samsung', 'SCH-W789', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_W799_1_20091014.xml': ['Samsung', 'SCH-W799', 'Brew', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_W899_1_2010816.xml': ['Samsung', 'SCH-W899', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/SCH/SCH_W999_1_20110901.xml': ['Samsung', 'SCH-W999', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A117.xml': ['Samsung', 'SGH-A117', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/a127_10.xml': ['Samsung', 'SGH-A127', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A137.xml': ['Samsung', 'SGH-A137', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A157V.xml': ['Samsung', 'SGH-A157V', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A237.xml': ['Samsung', 'SGH-A237', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A436.xml': ['Samsung', 'SGH-A436', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A437.xml': ['Samsung', 'SGH-A437', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/A501.xml': ['Samsung', 'SGH-A501', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A516.xml': ['Samsung', 'SGH-A516', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A517.xml': ['Samsung', 'SGH-A517', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/A561UAProf.rdf': ['Samsung', 'SGH-A561', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/A706UAProf.xml': ['Samsung', 'SGH-A706', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/A717UAProf.xml': ['Samsung', 'SGH-A717', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/A727UAProf.xml': ['Samsung', 'SGH-A727', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A736.xml': ['Samsung', 'SGH-A736', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/A737UAProf.xml': ['Samsung', 'SGH-A737', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A746.xml': ['Samsung', 'SGH-A746', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/A747UAProf.xml': ['Samsung', 'SGH-A747', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/L170UAProf.xml': ['Samsung', 'SGH-A767', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A800.xml': ['Samsung', 'SGH-A800', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A811_3G.xml': ['Samsung', 'SGH-A811', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b100_10.xml': ['Samsung', 'SGH-B100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b120_10.xml': ['Samsung', 'SGH-B120', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-B130.xml': ['Samsung', 'SGH-B130', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-B130L.xml': ['Samsung', 'SGH-B130', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b200_10.xml': ['Samsung', 'SGH-B200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b220b_10.xml': ['Samsung', 'SGH-B220', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b220_10.xml': ['Samsung', 'SGH-B220', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b270_10.xml': ['Samsung', 'SGH-B270', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b300_10.xml': ['Samsung', 'SGH-B300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b310_10.xml': ['Samsung', 'SGH-B310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b320_10.xml': ['Samsung', 'SGH-B320', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b500_10.xml': ['Samsung', 'SGH-B500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b510_10.xml': ['Samsung', 'SGH-B510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b520b_10.xml': ['Samsung', 'SGH-B520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b520v_10.xml': ['Samsung', 'SGH-B520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b520_10.xml': ['Samsung', 'SGH-B520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/b860_10.xml': ['Samsung', 'SGH-B860', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c110_10.xml': ['Samsung', 'SGH-C110', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c130b_10.xml': ['Samsung', 'SGH-C130', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c130_10.xml': ['Samsung', 'SGH-C130', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c130_11.xml': ['Samsung', 'SGH-C130', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c137_10.xml': ['Samsung', 'SGH-C137', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c140_10.xml': ['Samsung', 'SGH-C140', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c158_10.xml': ['Samsung', 'SGH-C158', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-C160.xml': ['Samsung', 'SGH-C160', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-C165.xml': ['Samsung', 'SGH-C165', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-C166.xml': ['Samsung', 'SGH-C166', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c170_10.xml': ['Samsung', 'SGH-C170', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c178_10.xml': ['Samsung', 'SGH-C178', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-C180.xml': ['Samsung', 'SGH-C180', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c188_10.xml': ['Samsung', 'SGH-C188', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c200.xml': ['Samsung', 'SGH-C200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c207_10.xml': ['Samsung', 'SGH-C207', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c208_10.xml': ['Samsung', 'SGH-C208', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c210_10.xml': ['Samsung', 'SGH-C210', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c216_10.xml': ['Samsung', 'SGH-C216', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c218_10.xml': ['Samsung', 'SGH-C218', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c230C_10.xml': ['Samsung', 'SGH-C230', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c230_10.xml': ['Samsung', 'SGH-C230', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c238_10.xml': ['Samsung', 'SGH-C238', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-C240.xml': ['Samsung', 'SGH-C240', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c250_10.xml': ['Samsung', 'SGH-C250', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c258_10.xml': ['Samsung', 'SGH-C258', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c260m_10.xml': ['Samsung', 'SGH-C260', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c260_10.xml': ['Samsung', 'SGH-C260', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c268_10.xml': ['Samsung', 'SGH-C268', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c275_10.xml': ['Samsung', 'SGH-C275', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c300_10.xml': ['Samsung', 'SGH-C300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c308_10.xml': ['Samsung', 'SGH-C308', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c320c_10.xml': ['Samsung', 'SGH-C320', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-C408.xml': ['Samsung', 'SGH-C408', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-C416.xml': ['Samsung', 'SGH-C416', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-C417.xml': ['Samsung', 'SGH-C417', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-C425.xml': ['Samsung', 'SGH-C425', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c500_10.xml': ['Samsung', 'SGH-C500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c510_10.xml': ['Samsung', 'SGH-C510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c516_10.xml': ['Samsung', 'SGH-C516', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/c520_10.xml': ['Samsung', 'SGH-C520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-CC03.xml': ['Samsung', 'SGH-CC03', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d100.xml': ['Samsung', 'SGH-D100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d100a.xml': ['Samsung', 'SGH-D100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d108.xml': ['Samsung', 'SGH-D108', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d300_10.xml': ['Samsung', 'SGH-D300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d307_10.xml': ['Samsung', 'SGH-D307', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d347t_10.xml': ['Samsung', 'SGH-D347', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d347_10.xml': ['Samsung', 'SGH-D347', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d357_10.xml': ['Samsung', 'SGH-D357', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d406_10.xml': ['Samsung', 'SGH-D406', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d407t_10.xml': ['Samsung', 'SGH-D407', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d407_10.xml': ['Samsung', 'SGH-D407', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/D410.xml': ['Samsung', 'SGH-D410', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d410c.xml': ['Samsung', 'SGH-D410', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d415.xml': ['Samsung', 'SGH-D415', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d418.xml': ['Samsung', 'SGH-D418', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d428_10.xml': ['Samsung', 'SGH-D428', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D488.xml': ['Samsung', 'SGH-D488', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D500.xml': ['Samsung', 'SGH-D500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D500C.xml': ['Samsung', 'SGH-D500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D500E.xml': ['Samsung', 'SGH-D500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D508.xml': ['Samsung', 'SGH-D508', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D510.xml': ['Samsung', 'SGH-D510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d520_10.xml': ['Samsung', 'SGH-D520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d528_10.xml': ['Samsung', 'SGH-D528', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d567_10.xml': ['Samsung', 'SGH-D567', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D600.xml': ['Samsung', 'SGH-D600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D600E.xml': ['Samsung', 'SGH-D600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D600E_FD.xml': ['Samsung', 'SGH-D600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D600_FD.xml': ['Samsung', 'SGH-D600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d710.xml': ['Samsung', 'SGH-D710', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d720_10.xml': ['Samsung', 'SGH-D720', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d728_10.xml': ['Samsung', 'SGH-D728', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d730_10.xml': ['Samsung', 'SGH-D730', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D780.xml': ['Samsung', 'SGH-D780', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d800_10.xml': ['Samsung', 'SGH-D800', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d806_10.xml': ['Samsung', 'SGH-D806', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d807_10.xml': ['Samsung', 'SGH-D807', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d807_11.xml': ['Samsung', 'SGH-D807', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d808_10.xml': ['Samsung', 'SGH-D808', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D820.xml': ['Samsung', 'SGH-D820', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D828.xml': ['Samsung', 'SGH-D828', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d830_10.xml': ['Samsung', 'SGH-D830', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d830_11.xml': ['Samsung', 'SGH-D830', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d838_10.xml': ['Samsung', 'SGH-D838', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d840_10.xml': ['Samsung', 'SGH-D840', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d840_11.xml': ['Samsung', 'SGH-D840', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/d848_10.xml': ['Samsung', 'SGH-D848', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D900-FD.xml': ['Samsung', 'SGH-D900', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D900.xml': ['Samsung', 'SGH-D900', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D908.xml': ['Samsung', 'SGH-D908', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-D908i.xml': ['Samsung', 'SGH-D908', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E100.xml': ['Samsung', 'SGH-E100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E100A.xml': ['Samsung', 'SGH-E100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e105.xml': ['Samsung', 'SGH-E105', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E108.xml': ['Samsung', 'SGH-E108', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e116.xml': ['Samsung', 'SGH-E116', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E200.xml': ['Samsung', 'SGH-E200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e210_10.xml': ['Samsung', 'SGH-E210', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e215l_10.xml': ['Samsung', 'SGH-E215', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e218_10.xml': ['Samsung', 'SGH-E218', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e230_10.xml': ['Samsung', 'SGH-E230', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E236.xml': ['Samsung', 'SGH-E236', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E250-ORANGE.xml': ['Samsung', 'SGH-E250', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E250.xml': ['Samsung', 'SGH-E250', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E251L.xml': ['Samsung', 'SGH-E251', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E258.xml': ['Samsung', 'SGH-E258', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e300.xml': ['Samsung', 'SGH-E300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e300_10.xml': ['Samsung', 'SGH-E300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e310c_10.xml': ['Samsung', 'SGH-E310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e310_00.xml': ['Samsung', 'SGH-E310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e310_10.xml': ['Samsung', 'SGH-E310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e315_10.xml': ['Samsung', 'SGH-E315', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e316.xml': ['Samsung', 'SGH-E316', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e317.xml': ['Samsung', 'SGH-E317', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e318.xml': ['Samsung', 'SGH-E318', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e320_10.xml': ['Samsung', 'SGH-E320', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E330.xml': ['Samsung', 'SGH-E330', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E330C.xml': ['Samsung', 'SGH-E330', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E330N.xml': ['Samsung', 'SGH-E330', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E335.xml': ['Samsung', 'SGH-E335', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E338.xml': ['Samsung', 'SGH-E338', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E340.xml': ['Samsung', 'SGH-E340', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E350.xml': ['Samsung', 'SGH-E350', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E350V.xml': ['Samsung', 'SGH-E350', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E358.xml': ['Samsung', 'SGH-E358', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E360.xml': ['Samsung', 'SGH-E360', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E370.xml': ['Samsung', 'SGH-E370', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E378.xml': ['Samsung', 'SGH-E378', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E380.xml': ['Samsung', 'SGH-E380', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e470_10.xml': ['Samsung', 'SGH-E470', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E480.xml': ['Samsung', 'SGH-E480', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e490_10.xml': ['Samsung', 'SGH-E490', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e496_10.xml': ['Samsung', 'SGH-E496', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e498_10.xml': ['Samsung', 'SGH-E498', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e530c_10.xml': ['Samsung', 'SGH-E530', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e530_10.xml': ['Samsung', 'SGH-E530', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e530_11.xml': ['Samsung', 'SGH-E530', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e568_10.xml': ['Samsung', 'SGH-E568', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e570v_10.xml': ['Samsung', 'SGH-E570', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e570_10.xml': ['Samsung', 'SGH-E570', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e578_10.xml': ['Samsung', 'SGH-E578', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E590.xml': ['Samsung', 'SGH-E590', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e600.xml': ['Samsung', 'SGH-E600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e600c.xml': ['Samsung', 'SGH-E600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e608.xml': ['Samsung', 'SGH-E608', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e610c_10.xml': ['Samsung', 'SGH-E610', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e610_10.xml': ['Samsung', 'SGH-E610', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e620_10.xml': ['Samsung', 'SGH-E620', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E630.xml': ['Samsung', 'SGH-E630', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E630C.xml': ['Samsung', 'SGH-E630', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E638.xml': ['Samsung', 'SGH-E638', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E640.xml': ['Samsung', 'SGH-E640', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E700.xml': ['Samsung', 'SGH-E700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E700A.xml': ['Samsung', 'SGH-E700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E708.xml': ['Samsung', 'SGH-E708', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e710_00.xml': ['Samsung', 'SGH-E710', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e710_10.xml': ['Samsung', 'SGH-E710', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e715.xml': ['Samsung', 'SGH-E715', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e720c_10.xml': ['Samsung', 'SGH-E720', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e720_00.xml': ['Samsung', 'SGH-E720', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e720_10.xml': ['Samsung', 'SGH-E720', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e728_10.xml': ['Samsung', 'SGH-E728', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E730.xml': ['Samsung', 'SGH-E730', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E736.xml': ['Samsung', 'SGH-E736', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E740.xml': ['Samsung', 'SGH-E740', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E747_FL.xml': ['Samsung', 'SGH-E747', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E758.xml': ['Samsung', 'SGH-E758', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e770_10.xml': ['Samsung', 'SGH-E770', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e778_10.xml': ['Samsung', 'SGH-E778', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e790_10.xml': ['Samsung', 'SGH-E790', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E800.xml': ['Samsung', 'SGH-E800', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E800C.xml': ['Samsung', 'SGH-E800', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E808.xml': ['Samsung', 'SGH-E808', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e810c_10.xml': ['Samsung', 'SGH-E810', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e810_00.xml': ['Samsung', 'SGH-E810', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e810_10.xml': ['Samsung', 'SGH-E810', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e818.xml': ['Samsung', 'SGH-E818', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E820.xml': ['Samsung', 'SGH-E820', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E830.xml': ['Samsung', 'SGH-E830', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e840_10.xml': ['Samsung', 'SGH-E840', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e848_10.xml': ['Samsung', 'SGH-E848', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e850_10.xml': ['Samsung', 'SGH-E850', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e860v_10.xml': ['Samsung', 'SGH-E860', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e865_10.xml': ['Samsung', 'SGH-E865', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e870_10.xml': ['Samsung', 'SGH-E870', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e878_10.xml': ['Samsung', 'SGH-E878', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e880_10.xml': ['Samsung', 'SGH-E880', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-E890.xml': ['Samsung', 'SGH-E890', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e900_10.xml': ['Samsung', 'SGH-E900', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e906_10.xml': ['Samsung', 'SGH-E906', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e908_10.xml': ['Samsung', 'SGH-E908', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e910_10.xml': ['Samsung', 'SGH-E910', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e910_11.xml': ['Samsung', 'SGH-E910', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e918_10.xml': ['Samsung', 'SGH-E918', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e950_10.xml': ['Samsung', 'SGH-E950', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/e958_10.xml': ['Samsung', 'SGH-E958', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-F110.xml': ['Samsung', 'SGH-F110', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/f200_10.xml': ['Samsung', 'SGH-F200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/f210_10.xml': ['Samsung', 'SGH-F210', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/f218_10.xml': ['Samsung', 'SGH-F218', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-F250.xml': ['Samsung', 'SGH-F250', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-F250L.xml': ['Samsung', 'SGH-F250', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/f300_10.xml': ['Samsung', 'SGH-F300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/f308_10.xml': ['Samsung', 'SGH-F308', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/f310_00.xml': ['Samsung', 'SGH-F310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/F330UAProf3G.rdf': ['Samsung', 'SGH-F330', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/F338UAProf.xml': ['Samsung', 'SGH-F338', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/F400UAProf.xml': ['Samsung', 'SGH-F400', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-F480.rdf': ['Samsung', 'SGH-F480', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-F480_3G.rdf': ['Samsung', 'SGH-F480', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-F480I_3G.rdf': ['Samsung', 'SGH-F480I', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-F488.rdf': ['Samsung', 'SGH-F488', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/f500.xml': ['Samsung', 'SGH-F500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/F700VUAProf3G.rdf': ['Samsung', 'SGH-F700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/f900_10.xml': ['Samsung', 'SGH-F900', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-G608.xml': ['Samsung', 'SGH-G608', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/G800UAProf3G.rdf': ['Samsung', 'SGH-G800', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/G810-3G.xml': ['Samsung', 'SGH-G810', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/G810.xml': ['Samsung', 'SGH-G810', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/G818E_10.xml': ['Samsung', 'SGH-G818', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i200OrangeUAProf.rdf': [
    'Samsung',
    'SGH-I200',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/i300_10.xml': ['Samsung', 'SGH-I300', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i308_10.xml': ['Samsung', 'SGH-I308', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i310_10.xml': ['Samsung', 'SGH-I310', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i320_10.xml': ['Samsung', 'SGH-I320', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i321n_10.xml': ['Samsung', 'SGH-I321', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i400_10.xml': ['Samsung', 'SGH-I400', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i408_10.xml': ['Samsung', 'SGH-I408', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i450.xml': ['Samsung', 'SGH-I450', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i455l_10.xml': ['Samsung', 'SGH-I455', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i455_10.xml': ['Samsung', 'SGH-I455', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i458B-3G.xml': ['Samsung', 'SGH-I458', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i458_10.xml': ['Samsung', 'SGH-I458', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i520.xml': ['Samsung', 'SGH-I520', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i530.xml': ['Samsung', 'SGH-i530', 'Palm OS', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i550.xml': ['Samsung', 'SGH-I550', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i590_10.xml': ['Samsung', 'SGH-I590', 'Series60', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i600.xml': ['Samsung', 'SGH-I600', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i601_10.xml': ['Samsung', 'SGH-I601', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i608_10.xml': ['Samsung', 'SGH-I608', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i620v_10.xml': ['Samsung', 'SGH-I620', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i640V_3G.xml': [
    'Samsung',
    'SGH-I640',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-i688.xml': ['Samsung', 'SGH-I688', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/i700_10.xml': ['Samsung', 'SGH-I700', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-i728.xml': ['Samsung', 'SGH-I728', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-I750.xml': ['Samsung', 'SGH-I750', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-J150.xml': ['Samsung', 'SGH-J150', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/J208UAProf3G.rdf': ['Samsung', 'SGH-J208', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/j600e_10.xml': ['Samsung', 'SGH-J600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/j600e_11.xml': ['Samsung', 'SGH-J600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/j600v_10.xml': ['Samsung', 'SGH-J600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/j600_10.xml': ['Samsung', 'SGH-J600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/j608_10.xml': ['Samsung', 'SGH-J608', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/j610_10.xml': ['Samsung', 'SGH-J610', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/j618_10.xml': ['Samsung', 'SGH-J618', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-J700L.xml': ['Samsung', 'SGH-J700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-J706.xml': ['Samsung', 'SGH-J706', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/J750UAProf3G.rdf': ['Samsung', 'SGH-J750', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-J770.xml': ['Samsung', 'SGH-J770', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/L170UAProf3G.xml': ['Samsung', 'SGH-L170', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/l320_10.xml': ['Samsung', 'SGH-L320', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-L700_2G.rdf': ['Samsung', 'SGH-L700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-L750_2G.rdf': ['Samsung', 'SGH-L750', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/L760UAProf.rdf': ['Samsung', 'SGH-L760', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/L760UAProf3G.rdf': ['Samsung', 'SGH-L760', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/L770UAProf3G.rdf': ['Samsung', 'SGH-L770', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-L810V_3G.rdf': ['Samsung', 'SGH-L810', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-L811_3G.rdf': ['Samsung', 'SGH-L811', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/L870_10.xml': ['Samsung', 'SGH-L870', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/L878-3G_10.xml': ['Samsung', 'SGH-L878', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/L878E_10.xml': ['Samsung', 'SGH-L878', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/L878_10.xml': ['Samsung', 'SGH-L878', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M110.xml': ['Samsung', 'SGH-M110', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m120_10.xml': ['Samsung', 'SGH-M120', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m128_10.xml': ['Samsung', 'SGH-M128', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M140L.xml': ['Samsung', 'SGH-M140', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M150.xml': ['Samsung', 'SGH-M150', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m300v_10.xml': ['Samsung', 'SGH-M300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m300_10.xml': ['Samsung', 'SGH-M300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m310v_10.xml': ['Samsung', 'SGH-M310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m310_10.xml': ['Samsung', 'SGH-M310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m600_10.xml': ['Samsung', 'SGH-M600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m608_10.xml': ['Samsung', 'SGH-M608', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/m620_10.xml': ['Samsung', 'SGH-M620', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-M628.xml': ['Samsung', 'SGH-M628', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-N600.xml': ['Samsung', 'SGH-N600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-N620.xml': ['Samsung', 'SGH-N620', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/n700_10.xml': ['Samsung', 'SGH-N700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/n707_10.xml': ['Samsung', 'SGH-N707', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p100.xml': ['Samsung', 'SGH-P100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p107.xml': ['Samsung', 'SGH-P107', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p110v_10.xml': ['Samsung', 'SGH-P110', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-P180-ORANGE.xml': ['Samsung', 'SGH-P180', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p207_10.xml': ['Samsung', 'SGH-P207', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-P220-ORANGE.xml': ['Samsung', 'SGH-P220', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-P260-ORANGE.xml': ['Samsung', 'SGH-P260', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p300_10.xml': ['Samsung', 'SGH-P300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p308_10.xml': ['Samsung', 'SGH-P308', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p310_10.xml': ['Samsung', 'SGH-P310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p318plus_10.xml': ['Samsung', 'SGH-P318', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p318_10.xml': ['Samsung', 'SGH-P318', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p400_00.xml': ['Samsung', 'SGH-P400', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/P510_UAProf.xml': ['Samsung', 'SGH-P510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/resolutionP510_UAProf.xml': ['Samsung', 'SGH-P510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p518.xml': ['Samsung', 'SGH-P518', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p520_10.xml': ['Samsung', 'SGH-P520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p700.xml': ['Samsung', 'SGH-P700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p710.xml': ['Samsung', 'SGH-P710', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p716_10.xml': ['Samsung', 'SGH-P716', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p717_10.xml': ['Samsung', 'SGH-P717', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p730.xml': ['Samsung', 'SGH-P730', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p730c_10.xml': ['Samsung', 'SGH-P730', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p730_10.xml': ['Samsung', 'SGH-P730', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p735_10.xml': ['Samsung', 'SGH-P735', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p738_10.xml': ['Samsung', 'SGH-P738', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p777_10.xml': ['Samsung', 'SGH-P777', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p777_12.xml': ['Samsung', 'SGH-P777', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-P850.xml': ['Samsung', 'SGH-P850', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p900_10.xml': ['Samsung', 'SGH-P900', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/p908t_10.xml': ['Samsung', 'SGH-P908', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/P910UAProf2G.rdf': ['Samsung', 'SGH-P910', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-P960.rdf': ['Samsung', 'SGH-P960', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-P960_3G.rdf': ['Samsung', 'SGH-P960', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-S275G.xml': ['Samsung', 'SGH-S275G', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/s300m_00.xml': ['Samsung', 'SGH-S300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-S500.xml': ['Samsung', 'SGH-S500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T100.xml': ['Samsung', 'SGH-T100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T109.xml': ['Samsung', 'SGH-T109', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T159.xml': ['Samsung', 'SGH-T159', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T199.xml': ['Samsung', 'SGH-T199', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T209.xml': ['Samsung', 'SGH-T209', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T219S.xml': ['Samsung', 'SGH-T219', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T229.xml': ['Samsung', 'SGH-T229', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T259.xml': ['Samsung', 'SGH-T259', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T329.xml': ['Samsung', 'SGH-T329', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T336.xml': ['Samsung', 'SGH-T336', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T339.xml': ['Samsung', 'SGH-T339', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T409.xml': ['Samsung', 'SGH-T409', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T419.xml': ['Samsung', 'SGH-T419', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T429.xml': ['Samsung', 'SGH-T429', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T439.xml': ['Samsung', 'SGH-T439', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T479.xml': ['Samsung', 'SGH-T479', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T500.xml': ['Samsung', 'SGH-T500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T509.xml': ['Samsung', 'SGH-T509', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/t519_10.xml': ['Samsung', 'SGH-T519', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T528G.xml': ['Samsung', 'SGH-T528', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/t609_10.xml': ['Samsung', 'SGH-T609', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/t609_11.xml': ['Samsung', 'SGH-T609', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T619.xml': ['Samsung', 'SGH-T619', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/t629_10.xml': ['Samsung', 'SGH-T629', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T639.xml': ['Samsung', 'SGH-T639', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/t649_10.xml': ['Samsung', 'SGH-T649', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/t719_10.xml': ['Samsung', 'SGH-T719', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T819.xml': ['Samsung', 'SGH-T819', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/u100_10.xml': ['Samsung', 'SGH-U100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/u106_10.xml': ['Samsung', 'SGH-U106', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/u108_10.xml': ['Samsung', 'SGH-U108', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/U200UAProf3G.xml': ['Samsung', 'SGH-U200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/u300_10.xml': ['Samsung', 'SGH-U300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/u308_10.xml': ['Samsung', 'SGH-U308', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/u600_10.xml': ['Samsung', 'SGH-U600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/u608_10.xml': ['Samsung', 'SGH-U608', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/U708UAProf.rdf': ['Samsung', 'SGH-U708', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/V200_00.xml': ['Samsung', 'SGH-V200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/V206_00.xml': ['Samsung', 'SGH-V206', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X100.xml': ['Samsung', 'SGH-X100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X100A.xml': ['Samsung', 'SGH-X100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x105.xml': ['Samsung', 'SGH-X105', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X108.xml': ['Samsung', 'SGH-X108', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x120_10.xml': ['Samsung', 'SGH-X120', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x140_10.xml': ['Samsung', 'SGH-X140', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x140_11.xml': ['Samsung', 'SGH-X140', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x160_10.xml': ['Samsung', 'SGH-X160', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x168_10.xml': ['Samsung', 'SGH-X168', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x200.xml': ['Samsung', 'SGH-X200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x200_01.xml': ['Samsung', 'SGH-X200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x200_02.xml': ['Samsung', 'SGH-X200', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x208_00.xml': ['Samsung', 'SGH-X208', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x210_10.xml': ['Samsung', 'SGH-X210', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x218_10.xml': ['Samsung', 'SGH-X218', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X300.xml': ['Samsung', 'SGH-X300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x410.xml': ['Samsung', 'SGH-X410', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x410_10.xml': ['Samsung', 'SGH-X410', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x426.xml': ['Samsung', 'SGH-X426', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x426m_10.xml': ['Samsung', 'SGH-X426', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x426m_11.xml': ['Samsung', 'SGH-X426', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x427m_10.xml': ['Samsung', 'SGH-X427', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x430.xml': ['Samsung', 'SGH-X430', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x450.xml': ['Samsung', 'SGH-X450', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x458.xml': ['Samsung', 'SGH-X458', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X460.xml': ['Samsung', 'SGH-X460', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X460C.xml': ['Samsung', 'SGH-X460', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X461.xml': ['Samsung', 'SGH-X461', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x466_10.xml': ['Samsung', 'SGH-X466', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X467.xml': ['Samsung', 'SGH-X467', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X468.xml': ['Samsung', 'SGH-X468', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x475_10.xml': ['Samsung', 'SGH-X475', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x478_10.xml': ['Samsung', 'SGH-X478', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X480.xml': ['Samsung', 'SGH-X480', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X480C.xml': ['Samsung', 'SGH-X480', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X481.xml': ['Samsung', 'SGH-X481', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/X486_10.xml': ['Samsung', 'SGH-X486', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x488_10.xml': ['Samsung', 'SGH-X488', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X490.xml': ['Samsung', 'SGH-X490', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X496.xml': ['Samsung', 'SGH-X496', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X497.xml': ['Samsung', 'SGH-X497', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x500_10.xml': ['Samsung', 'SGH-X500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x506_10.xml': ['Samsung', 'SGH-X506', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x507_10.xml': ['Samsung', 'SGH-X507', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x507_11.xml': ['Samsung', 'SGH-X507', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x508_10.xml': ['Samsung', 'SGH-X508', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x508_11.xml': ['Samsung', 'SGH-X508', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x510v_10.xml': ['Samsung', 'SGH-X510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x510_10.xml': ['Samsung', 'SGH-X510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x510_11.xml': ['Samsung', 'SGH-X510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x518_10.xml': ['Samsung', 'SGH-X518', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x520_10.xml': ['Samsung', 'SGH-X520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x526_10.xml': ['Samsung', 'SGH-X526', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x528_10.xml': ['Samsung', 'SGH-X528', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x530_10.xml': ['Samsung', 'SGH-X530', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X550.xml': ['Samsung', 'SGH-X550', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X566.xml': ['Samsung', 'SGH-X566', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x568_10.xml': ['Samsung', 'SGH-X568', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X576.xml': ['Samsung', 'SGH-X576', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X600.xml': ['Samsung', 'SGH-X600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X600A.xml': ['Samsung', 'SGH-X600', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com.cn/uaprof/SGH-X608.xml': ['Samsung', 'SGH-X608', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X608.xml': ['Samsung', 'SGH-X608', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x610.xml': ['Samsung', 'SGH-X610', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X620.xml': ['Samsung', 'SGH-X620', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x630_10.xml': ['Samsung', 'SGH-X630', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X636.xml': ['Samsung', 'SGH-X636', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com.cn/uaprof/SGH-X640.xml': ['Samsung', 'SGH-X640', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X640.xml': ['Samsung', 'SGH-X640', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X650.xml': ['Samsung', 'SGH-X650', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X650C.xml': ['Samsung', 'SGH-X650', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x660v_10.xml': ['Samsung', 'SGH-X660', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x660_10.xml': ['Samsung', 'SGH-X660', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x668_10.xml': ['Samsung', 'SGH-X668', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X670.xml': ['Samsung', 'SGH-X670', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x680v_10.xml': ['Samsung', 'SGH-X680', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x680_10.xml': ['Samsung', 'SGH-X680', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x686_10.xml': ['Samsung', 'SGH-X686', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x688_10.xml': ['Samsung', 'SGH-X688', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x688_11.xml': ['Samsung', 'SGH-X688', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X700.xml': ['Samsung', 'SGH-X700', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-X708.xml': ['Samsung', 'SGH-X708', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x800_10.xml': ['Samsung', 'SGH-X800', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x808_10.xml': ['Samsung', 'SGH-X808', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x810_10.xml': ['Samsung', 'SGH-X810', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x818_10.xml': ['Samsung', 'SGH-X818', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x820_10.xml': ['Samsung', 'SGH-X820', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x820_11.xml': ['Samsung', 'SGH-X820', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x828_10.xml': ['Samsung', 'SGH-X828', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x830_10.xml': ['Samsung', 'SGH-X830', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x836_10.xml': ['Samsung', 'SGH-X836', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x838_10.xml': ['Samsung', 'SGH-X838', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/x910_10.xml': ['Samsung', 'SGH-X910', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/ZV10UAProf3G.rdf': ['Samsung', 'SGH-ZV10', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/ZV30UAProf.rdf': ['Samsung', 'SGH-ZV30', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/ZV60UAProf3G.rdf': ['Samsung', 'SGH-ZV60', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5350UAProf.xml': ['Samsung', 'Shark', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T359.xml': ['Samsung', 'Smiley :)', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-A817.xml': ['Samsung', 'Solstice II', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-G400_3G.rdf': ['Samsung', 'Soul', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/U900UAProf.xml': ['Samsung', 'Soul', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/U800UAProf.xml': ['Samsung', 'Soul b', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/U800UAProf3G.xml': ['Samsung', 'Soul b', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A500/VE31.rdf': ['Samsung', 'SPH-A500', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A640/ZE12.rdf': ['Samsung', 'SPH-A640', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A660/XA28.rdf': ['Samsung', 'SPH-A660', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A680/XC15.rdf': ['Samsung', 'SPH-A680', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A700/XG23.rdf': ['Samsung', 'SPH-A700', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/samsung/spha720-1.rdf': ['Samsung', 'SPH-A720', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A740/XK12.rdf': ['Samsung', 'SPH-A740', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A790/XK26.rdf': ['Samsung', 'SPH-A790', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A800/YD11.rdf': ['Samsung', 'SPH-A800', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A840/YH09.rdf': ['Samsung', 'SPH-A840', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A880/YC24.rdf': ['Samsung', 'SPH-A880', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A900P/ZH03.rdf': ['Samsung', 'SPH-A900', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-A920/YK12.rdf': ['Samsung', 'SPH-A920', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-i550/XE07.rdf': ['Samsung', 'SPH-I550', 'Palm OS', DeviceType.MOBILE],
  'http://device.telusmobility.com/samsung/sphm210-0.rdf': ['Samsung', 'SPH-M210', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M220/BG24.rdf': ['Samsung', 'SPH-M220', null, DeviceType.MOBILE],
  'http://uaprof.vmobl.com/samsung/m310/VMU_m310_UAProf.xml': ['Samsung', 'SPH-M310', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M320/BG24.rdf': ['Samsung', 'SPH-M320', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M500/ZK03.rdf': ['Samsung', 'SPH-M500', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M510/AE15.rdf': ['Samsung', 'SPH-M510', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/PLS-M520/AD30.rdf': ['Samsung', 'SPH-M520', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/Samsung_SPH-M530.rdf': ['Samsung', 'SPH-M530', null, DeviceType.MOBILE],
  'http://uaprof.vmobl.com/samsung/SPH-M575-VMUB/1.0/M575_VMUB_UAProf.xml': [
    'Samsung',
    'SPH-M575',
    null,
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M610/ZJ29.rdf': ['Samsung', 'SPH-M610', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-N400/VH27.rdf': ['Samsung', 'SPH-N400', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-Z400/BE03.rdf': ['Samsung', 'SPH-Z400', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5230.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5230C.rdf': ['Samsung', 'Star', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5230G.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5230MR.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5230N.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5230W.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5230W_3G.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5233A.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5233S.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5233T.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5233T.xml': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5233TTCE.xml': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5233W.rdf': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5233W.xml': ['Samsung', 'Star', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5220UAProf.xml': ['Samsung', 'Star 3', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5222BR.xml': ['Samsung', 'Star 3 Duos', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5222UAProf.xml': [
    'Samsung',
    'Star 3 Duos',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-S5603.rdf': ['Samsung', 'Star 3G', 'TouchWiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5292UAProf.xml': [
    'Samsung',
    'Star Deluxe Duos',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/GT-B7722_2G.rdf': ['Samsung', 'Star Duos', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B7722_3G.rdf': ['Samsung', 'Star Duos', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5260.rdf': ['Samsung', 'Star II', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5260.xml': ['Samsung', 'Star II', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5260BR.xml': ['Samsung', 'Star II', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5263.rdf': ['Samsung', 'Star II', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C6712.rdf': ['Samsung', 'Star II Duos', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/B3410.xml': ['Samsung', 'Star Qwerty', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B3410.xml': ['Samsung', 'Star Qwerty', 'Touchwiz', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-I6230.xml': ['Samsung', 'Star TV', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/i405/i405.xml': ['Samsung', 'Stratosphere', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/sam/SCH-I415/SCH-I415.xml': ['Samsung', 'Stratosphere II', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T839.xml': ['Samsung', 'T-Mobile Sidekick', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/s3030_10.xml': ['Samsung', 'Tobi', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-F480L.xml': ['Samsung', 'Tocco', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5229UAProf.xml': [
    'Samsung',
    'Tocco Lite 2',
    'Touchwiz',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/SGH-S390G.xml': ['Samsung', 'TracFone', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M920/EB28.rdf': ['Samsung', 'Transform', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M920/EF09.rdf': ['Samsung', 'Transform', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M930-BST/EG29.rdf': [
    'Samsung',
    'Transform Ultra',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M930-BST/FF27.rdf': [
    'Samsung',
    'Transform Ultra',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M930-BST/FF28.rdf': [
    'Samsung',
    'Transform Ultra',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M930/FF27.rdf': [
    'Samsung',
    'Transform Ultra',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Samsung/SPH-M930/FG11.rdf': [
    'Samsung',
    'Transform Ultra',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/S8300UAProf.xml': ['Samsung', 'UltraTOUCH', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/S8300UAProf3G.xml': ['Samsung', 'UltraTOUCH', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Samsung/SPH-M620/AC08.rdf': ['Samsung', 'UpStage', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/V804SSUAProf.rdf': ['Samsung', 'V804', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SGH-T959.xml': ['Samsung', 'Vibrant', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/sch_w259.xml': ['Samsung', 'W169 Duos', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8500.rdf': ['Samsung', 'Wave', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8500M.rdf': ['Samsung', 'Wave', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8500R.rdf': ['Samsung', 'Wave', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8500_2G.rdf': ['Samsung', 'Wave', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8500_3G.rdf': ['Samsung', 'Wave', 'Bada', DeviceType.MOBILE],
  'wap.samsungmobile.com/uaprof/GT-S8600_3G.rdf': ['Samsung', 'Wave', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8600.rdf': ['Samsung', 'Wave 3', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8600_3G.rdf': ['Samsung', 'Wave 3', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5250.rdf': ['Samsung', 'Wave 525', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5253.rdf': ['Samsung', 'Wave 525', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5253_3G.rdf': ['Samsung', 'Wave 525', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5330BR.xml': ['Samsung', 'Wave 533', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5333.rdf': ['Samsung', 'Wave 533', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5333_3G.rdf': ['Samsung', 'Wave 533', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5750E_2G.rdf': ['Samsung', 'Wave 575', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5750E_3G.rdf': ['Samsung', 'Wave 575', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5753E_2G.rdf': ['Samsung', 'Wave 575', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5753E_3G.rdf': ['Samsung', 'Wave 575', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5780.rdf': ['Samsung', 'Wave 578', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7230E.rdf': ['Samsung', 'Wave 723', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7230E_3G.rdf': ['Samsung', 'Wave 723', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7233E_3G.rdf': ['Samsung', 'Wave 723', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8530.rdf': ['Samsung', 'Wave II', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S8530_3G.rdf': ['Samsung', 'Wave II', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S7250_3G.rdf': ['Samsung', 'Wave M', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5380.rdf': ['Samsung', 'Wave Y', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-S5380_3G.rdf': ['Samsung', 'Wave Y', 'Bada', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-C3350UAProf.xml': ['Samsung', 'Xcover 2', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B2710.rdf': ['Samsung', 'Xcover 271', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/GT-B2710_3G.rdf': ['Samsung', 'Xcover 271', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-B550H.xml': ['Samsung', 'Xcover 550', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/SM-Z130H.xml': ['Samsung', 'Z1', 'Tizen', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z100UAProf.rdf': ['Samsung', 'Z100', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/z130_00.xml': ['Samsung', 'Z130', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z150UAProf2G.rdf': ['Samsung', 'Z150', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/z160_10.xml': ['Samsung', 'Z160', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z170UAProf3G.rdf': ['Samsung', 'Z170', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z230UAProf3G.rdf': ['Samsung', 'Z230', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z240UAProf.rdf': ['Samsung', 'Z240', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z240UAProf3G.rdf': ['Samsung', 'Z240', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z300UAProf.rdf': ['Samsung', 'Z300', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z308UAProf.rdf': ['Samsung', 'Z308', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z310UAProf3G.rdf': ['Samsung', 'Z310', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z400UAProf3G.rdf': ['Samsung', 'Z400', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z500UAProf.rbf': ['Samsung', 'Z500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z500UAProf2G.rdf': ['Samsung', 'Z500', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/z510_00.xml': ['Samsung', 'Z510', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z520UAProf2G.rdf': ['Samsung', 'Z520', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z540UAProf2G.rdf': ['Samsung', 'Z540', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z540UAProf3G.rdf': ['Samsung', 'Z540', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z548UAProf.rdf': ['Samsung', 'Z548', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z560UAProf3G.rdf': ['Samsung', 'Z560', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/z630_00.xml': ['Samsung', 'Z630', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/Z720UAProf3G.rdf': ['Samsung', 'Z720', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/6760Boost/1006Boost.rdf': ['Sanyo', 'Incognito', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP6760/1002SP.rdf': ['Sanyo', 'Incognito', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/6780Boost/1001Boost.rdf': ['Sanyo', 'Innuendo', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/6780Boost/1101Boost.rdf': ['Sanyo', 'Innuendo', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/2700Boost/1001Boost.rdf': ['Sanyo', 'Juno', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP8500/1000SP.rdf': ['Sanyo', 'Katana DLX', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCPM1/1001SP.rdf': ['Sanyo', 'M1', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/MM5600/0702SP.rdf': ['Sanyo', 'MM-5600', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/MM7400/1030SP.rdf': ['Sanyo', 'MM-7400', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/PL6650/1001PLS.rdf': ['Sanyo', 'PL-6650', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/PLS4920/1000QW.rdf': ['Sanyo', 'PLS-4920', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/PLS6600/1001QW.rdf': ['Sanyo', 'PLS-6600', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/PLS6650/1002QW.rdf': ['Sanyo', 'PLS-6650', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/PLS7400/1000QW.rdf': ['Sanyo', 'PLS-7400', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/PLS8100/1005QW.rdf': ['Sanyo', 'PLS-8100', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/PLS8200/1001QW.rdf': ['Sanyo', 'PLS-8200', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/PM8200/1007SP.rdf': ['Sanyo', 'PM-8200', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP-PRO700/1008SP.rdf': ['Sanyo', 'PRO-700', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP2300/0501SP.rdf': ['Sanyo', 'SCP-2300', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_Sanyo_SCP2300CA_1004BM.rdf': ['Sanyo', 'SCP-2300', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP2400/1004SP.rdf': ['Sanyo', 'SCP-2400', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP2500/1001SP.rdf': ['Sanyo', 'SCP-2500', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_Sanyo_SCP2500CA_1002BM.rdf': ['Sanyo', 'SCP-2500', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP3100/1005SP.rdf': ['Sanyo', 'SCP-3100', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP3200/1000SP.rdf': ['Sanyo', 'SCP-3200', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP3800/0700SP.rdf': ['Sanyo', 'SCP-3800', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_Sanyo_SCP3800CA_1003BM.rdf': ['Sanyo', 'SCP-3800', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP4920/1006SP.rdf': ['Sanyo', 'SCP-4920', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP4930/1004SP.rdf': ['Sanyo', 'SCP-4930', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP5300/1036SP.rdf': ['Sanyo', 'SCP-5300', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP6400/1032SP.rdf': ['Sanyo', 'SCP-6400', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP6600/1001SP.rdf': ['Sanyo', 'SCP-6600', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_Sanyo_SCP6600CA_1001BM.rdf': ['Sanyo', 'SCP-6600', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP6650/1004SP.rdf': ['Sanyo', 'SCP-6650', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP6750/1002SP.rdf': ['Sanyo', 'SCP-6750', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP7000/1000SP.rdf': ['Sanyo', 'SCP-7000', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_Sanyo_SCP7000CA_1008BM.rdf': ['Sanyo', 'SCP-7000', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP7050/1002SP.rdf': ['Sanyo', 'SCP-7050', null, DeviceType.MOBILE],
  'http://uaprof.bellmobilite.ca/BMC_Sanyo_SCP7050CA_1004BM.rdf': ['Sanyo', 'SCP-7050', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP7200/2046SP.rdf': ['Sanyo', 'SCP-7200', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP7300/1004SP.rdf': ['Sanyo', 'SCP-7300', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP7500/1022SP.rdf': ['Sanyo', 'SCP-7500', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP8100/1115SP.rdf': ['Sanyo', 'SCP-8100', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP9000/0103SP.rdf': ['Sanyo', 'SCP-9000', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/SCP9000/1000SP.rdf': ['Sanyo', 'SCP-9000', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/Sanyo/E4100/1008SP.rdf': ['Sanyo', 'Taho', 'Brew', DeviceType.MOBILE],
  'http://wap.sendo.com/uaprof/sendo_S600_r1.0.xml': ['Sendo', 'S600', null, DeviceType.MOBILE],
  'http://senseit.ru/UAProfile/SENSEIT_R390.xml': ['Senseit', 'R390', 'Android', DeviceType.MOBILE],
  'http://www.senwamobile.com/UA/S970.xml': ['Senwa', 'S970', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-STARADDICTII.xml': ['SFR', 'STARADDICT II', 'Android', DeviceType.MOBILE],
  'http://sfr.51coolpad.com/UAProfile/sfr/STARADDICT-3.xml': ['SFR', 'STARADDICT III', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/ZTE-V6600_Style_Pro_Profile.xml': [
    'sfr',
    'STARNAUTE II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/STARXTREM II.xml': ['SFR', 'STARXTREM II', 'Android', DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/880SH_G001_3g.xml': ['Sharp', '880SH', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/880SH_G001_base.xml': ['Sharp', '880SH', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/SH80DE.XML': ['Sharp', 'Aquos SH80F', 'Android', DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/SHARP-ADS1.xml': ['Sharp', 'FX Plus', 'Android', DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GXi98.xml': ['Sharp', 'GX-i98', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX1.xml': ['Sharp', 'GX1', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX10.xml': ['Sharp', 'GX10', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX10m.xml': ['Sharp', 'GX10m', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX12.xml': ['Sharp', 'GX12', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX13.xml': ['Sharp', 'GX13', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX15.xml': ['Sharp', 'GX15', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX17.xml': ['Sharp', 'GX17', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX20.xml': ['Sharp', 'GX20', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX23.xml': ['Sharp', 'GX23', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX25.xml': ['Sharp', 'GX25', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX29.xml': ['Sharp', 'GX29', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX30.xml': ['Sharp', 'GX30', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX32.xml': ['Sharp', 'GX32', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GX33.xml': ['Sharp', 'GX33', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GZ100.xml': ['Sharp', 'GZ100', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GZ100S.xml': ['Sharp', 'GZ100S', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GZ200.xml': ['Sharp', 'GZ200', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/GZ200S.xml': ['Sharp', 'GZ200S', null, DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/MK5/SH530U.xml': ['Sharp', 'SH530U', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/MK5/SH530U.xml': ['Sharp', 'SH530U', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/S2U/SH631W.xml': ['Sharp', 'SH631W', 'Android', DeviceType.MOBILE],
  'http://wap1.sharp.com/uaprof/SharpSH8188U.xml': ['Sharp', 'SH8188U', 'Android', DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/SHP_SH831T_3_20120214.xml': ['Sharp', 'SH831T', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/S1M/SH837M.xml': ['Sharp', 'SH837M', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/S1U/SH837W.xml': ['Sharp', 'SH837W', 'Android', DeviceType.MOBILE],
  'http://cn.c2dms.com/UAProfile/VKY/SH931W.xml': ['Sharp', 'SH931W', 'Android', DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAprofTM/tm100.xml': ['Sharp', 'TM100', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAprofTM/tm150.xml': ['Sharp', 'TM150', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAprofTM/tm200.xml': ['Sharp', 'TM200', null, DeviceType.MOBILE],
  'http://sharp-mobile.com/UAprof/V750.xml': ['Sharp', 'V750', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?device=A21a&v=03': [
    'Siemens',
    'A21',
    null,
    DeviceType.MOBILE,
  ],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?device=A31C&v=02': [
    'Siemens',
    'A31',
    null,
    DeviceType.MOBILE,
  ],
  'http://communication-market.siemens.de/UAProf/A60_14.xml': ['Siemens', 'A60', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/A60_20.xml': ['Siemens', 'A60', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?device=AF51': [
    'Siemens',
    'AF51',
    null,
    DeviceType.MOBILE,
  ],
  'http://communicationmarket.siemens.de/portal/UAProf/UAP.aspx?device=AL21': [
    'Siemens',
    'AL21',
    null,
    DeviceType.MOBILE,
  ],
  'http://uap.benq.com/mb_ap75/sie_ap75_v3.xml': ['Siemens', 'AP75', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/C60_10.xml': ['Siemens', 'C60', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/C60_14.xml': ['Siemens', 'C60', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?device=C66': [
    'Siemens',
    'C66',
    null,
    DeviceType.MOBILE,
  ],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?device=C72': [
    'Siemens',
    'C72',
    null,
    DeviceType.MOBILE,
  ],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?CF62': ['Siemens', 'CF62', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/M55_01.xml': ['Siemens', 'M55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/M55_07.xml': ['Siemens', 'M55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/M55_11.xml': ['Siemens', 'M55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/MC60_10.xml': ['Siemens', 'MC60', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/S55_00.xml': ['Siemens', 'S55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/S55_04.xml': ['Siemens', 'S55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/S55_05.xml': ['Siemens', 'S55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/S55_06.xml': ['Siemens', 'S55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/S55_20.xml': ['Siemens', 'S55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?SF65': ['Siemens', 'SF65', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?SK65': ['Siemens', 'SK65', null, DeviceType.MOBILE],
  'http://www.blackberry.net/go/mobile/profiles/uaprof/Siemens SK65/3.8.0.rdf': [
    'Siemens',
    'SK65',
    'BlackBerry OS',
    DeviceType.MOBILE,
  ],
  'http://communication-market.siemens.de/UAProf/SL55_02.xml': ['Siemens', 'SL55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/SL55_14.xml': ['Siemens', 'SL55', null, DeviceType.MOBILE],
  'http://communication-market.siemens.de/UAProf/ST55_01.xml': ['Siemens', 'SL55', null, DeviceType.MOBILE],
  'http://wap.annyway.com/UAProf/cgi-bin/UAProf?AnnyWap1.2': [
    'Siemens',
    'SX45',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://communication-market.siemens.de/portal/UAProf/UAP.aspx?DeviceID=SX66': [
    'Siemens',
    'SX66',
    null,
    DeviceType.MOBILE,
  ],
  'http://skyspring.co.kr/UAprof/UAprof_Sp710_wap20.xml': ['Skyspring', 'SP710', null, DeviceType.MOBILE],
  'http://skyspring.co.kr/UAprof/UAprof_SP770.xml': ['Skyspring', 'SP770', null, DeviceType.MOBILE],
  'http://wap.my-fun.cn/tclPortal/ua/Smartfren_E781A_20110928.xml': [
    'Smartfren',
    'Xstre@m',
    'Brew',
    DeviceType.MOBILE,
  ],
  'http://uaprof.softbank.ne.jp/uaprof/3G_103P.xml': ['Softbank', '103P', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiY300-J1-Normal.xml': ['Softbank', '204HW', 'Android', DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/705SCUAProf.rdf': ['Softbank', '705SC', null, DeviceType.MOBILE],
  'http://nec-uap.com/prof/706N.xml': ['Softbank', '706N', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/706SCUAProf.rdf': ['Softbank', '706SC', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/707SCUAProf.rdf': ['Softbank', '707SC', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/707SC2UAProf.rdf': ['Softbank', '707SCII', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/708SCUAProf.rdf': ['Softbank', '708SC', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/709SCUAProf.rdf': ['Softbank', '709SC', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/805SCUAProf.rdf': ['Softbank', '805SC', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/811SH_SHJ001_3g.xml': ['Softbank', '811SH', null, DeviceType.MOBILE],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/SoftBank/810T_r100_3G.xml': [
    'Softbank',
    '811T',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/SoftBank/811T_r100_3G.xml': [
    'Softbank',
    '811T',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/SoftBank/814T_r100_3G.xml': [
    'Softbank',
    '814T',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/SoftBank/815T_r100_3G.xml': [
    'Softbank',
    '815T',
    null,
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/820SCUAProf.xml': ['Softbank', '820SC', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/821SCUAProf.xml': ['Softbank', '821SC', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/910SH_SHJ001_3g.xml': ['Softbank', '910SH', null, DeviceType.MOBILE],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/SoftBank/910T_r100_3G.xml': [
    'Softbank',
    '910T',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.sharp-mobile.com/UAProf/911SH_SHJ001_3g.xml': ['Softbank', '911SH', null, DeviceType.MOBILE],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/SoftBank/911T_r100_3G.xml': [
    'Softbank',
    '911T',
    null,
    DeviceType.MOBILE,
  ],
  'http://wap.samsungmobile.com/uaprof/920SCUAProf.xml': ['Softbank', '920SC', null, DeviceType.MOBILE],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/SoftBank/920T_r100_3G.xml': [
    'Softbank',
    '920T',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/SoftBank/921T_r100_3G.xml': [
    'Softbank',
    '921T',
    null,
    DeviceType.MOBILE,
  ],
  'http://omaptt.net/xp1/wap/uapM639.xml': ['Sonim', 'XP1', null, DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-04ER1002.xml': ['Sony', 'Xperia A', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-04ER1003.xml': ['Sony', 'Xperia A', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-04FR1421.xml': ['Sony', 'Xperia A2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT26wR621.xml': ['Sony', 'Xperia Acro S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT26wR601.xml': ['Sony', 'Xperia Acro S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT26wR611.xml': ['Sony', 'Xperia Acro S', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-01ER901.xml': ['Sony', 'Xperia AX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-01ER911.xml': ['Sony', 'Xperia AX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C2305R401.xml': ['Sony', 'Xperia C', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/S39hR401.xml': ['Sony', 'Xperia C', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2502R1901.xml': ['Sony', 'Xperia C3 dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/S55tR1901.xml': ['Sony', 'Xperia C3 dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/S55uR1901.xml': ['Sony', 'Xperia C3 dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C1504 UnavailableR402.xml': ['Sony', 'Xperia E', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C1504R402.xml': ['Sony', 'Xperia E', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C1505R402.xml': ['Sony', 'Xperia E', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C1604JBR402.xml': ['Sony', 'Xperia E dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C1604R402.xml': ['Sony', 'Xperia E dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C1605JBR402.xml': ['Sony', 'Xperia E dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C1605R402.xml': ['Sony', 'Xperia E dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2004R2001.xml': ['Sony', 'Xperia E1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2004R2011.xml': ['Sony', 'Xperia E1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2005R2001.xml': ['Sony', 'Xperia E1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2005R2011.xml': ['Sony', 'Xperia E1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2104R2011.xml': ['Sony', 'Xperia E1 dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2105R2001.xml': ['Sony', 'Xperia E1 dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2114R2001.xml': ['Sony', 'Xperia E1 dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2203R1801.xml': ['Sony', 'Xperia E3', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2206R1801.xml': ['Sony', 'Xperia E3', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2243R1801.xml': ['Sony', 'Xperia E3', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5103R1411.xml': ['Sony', 'Xperia G', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LotusR620.xml': ['Sony', 'Xperia Go', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST27aR620.xml': ['Sony', 'Xperia Go', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST27iR620.xml': ['Sony', 'Xperia Go', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST27aR601.xml': ['Sony', 'Xperia Go', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST27aR611.xml': ['Sony', 'Xperia Go', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST27iR601.xml': ['Sony', 'Xperia Go', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST27iR611.xml': ['Sony', 'Xperia Go', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-04DR701.xml': ['Sony', 'Xperia GX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-04DR911.xml': ['Sony', 'Xperia GX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT28hR621.xml': ['Sony', 'Xperia Ion', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT28iR1002.xml': ['Sony', 'Xperia Ion', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT28iR621.xml': ['Sony', 'Xperia Ion', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT28atR601.xml': ['Sony', 'Xperia Ion', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT28hR411.xml': ['Sony', 'Xperia Ion', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT28hR601.xml': ['Sony', 'Xperia Ion', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT28hR611.xml': ['Sony', 'Xperia Ion', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT28iR601.xml': ['Sony', 'Xperia Ion', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT28iR611.xml': ['Sony', 'Xperia Ion', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST26aR402.xml': ['Sony', 'Xperia J', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST26iR402.xml': ['Sony', 'Xperia J', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST26R402.xml': ['Sony', 'Xperia J', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C2104R401.xml': ['Sony', 'Xperia L', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C2105R401.xml': ['Sony', 'Xperia L', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/S36hR401.xml': ['Sony', 'Xperia L', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C1904R401.xml': ['Sony', 'Xperia M', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C1905R401.xml': ['Sony', 'Xperia M', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C19R401.xml': ['Sony', 'Xperia M', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2302R1811.xml': ['Sony', 'Xperia M2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2303R1811.xml': ['Sony', 'Xperia M2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2305R1811.xml': ['Sony', 'Xperia M2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2306R1811.xml': ['Sony', 'Xperia M2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2403R1811.xml': ['Sony', 'Xperia M2 Aqua', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D2406R1811.xml': ['Sony', 'Xperia M2 Aqua', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST23aR402.xml': ['Sony', 'Xperia Miro', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST23iR402.xml': ['Sony', 'Xperia Miro', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT25iR411.xml': ['Sony', 'Xperia Neo L', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT22iR620.xml': ['Sony', 'Xperia P', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT22iR601.xml': ['Sony', 'Xperia P', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT22iR611.xml': ['Sony', 'Xperia P', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT26iiR621.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT26iR1002.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT26iR621.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Android on nozomiR601.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT26iiR601.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT26iiR611.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT26iR301.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT26iR411.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT26iR601.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT26iR611.xml': ['Sony', 'Xperia S', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/MT27iR620.xml': ['Sony', 'Xperia Sola', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT27iR601.xml': ['Sony', 'Xperia Sola', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT27iR611.xml': ['Sony', 'Xperia Sola', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/pepperR611.xml': ['Sony', 'Xperia Sola', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Xperia SolaR611.xml': ['Sony', 'Xperia Sola', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5302R1211.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5302R1411.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5302R401.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5303R1211.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5303R1411.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5303R401.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5303R701.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5306R1211.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5306R1401.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5306R1411.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5306R401.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M35cR401.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M35hR1211.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M35hR1411.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M35hR401.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M35tR401.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/Xperia™ SPR1211.xml': ['Sony', 'Xperia SP', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-05DR701.xml': ['Sony', 'Xperia SX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-05DR911.xml': ['Sony', 'Xperia SX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30aR1401.xml': ['Sony', 'Xperia T', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30aR1411.xml': ['Sony', 'Xperia T', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30aR701.xml': ['Sony', 'Xperia T', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30aR911.xml': ['Sony', 'Xperia T', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30pR1411.xml': ['Sony', 'Xperia T', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30pR701.xml': ['Sony', 'Xperia T', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30pR911.xml': ['Sony', 'Xperia T', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30pR921.xml': ['Sony', 'Xperia T', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5303R1411.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5303R1903.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5306R1903.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5306R1912.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5316R1903.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5322R1903.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/XM50hR1911.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/XM50hR1912.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/XM50tR1903.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/XM50tR1912.xml': ['Sony', 'Xperia T2 Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5322R1912.xml': ['Sony', 'Xperia T2 Ultra dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/XM50hR1903.xml': ['Sony', 'Xperia T2 Ultra dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5103R1801.xml': ['Sony', 'Xperia T3', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5106R1801.xml': ['Sony', 'Xperia T3', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M50wR1801.xml': ['Sony', 'Xperia T3', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/PolluxWindyR1002.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP311R1002.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP311R1003.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP311R1004.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP311R1005.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP312R1002.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP312R1003.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP312R1004.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SGP321R1002.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP321R1003.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP321R1004.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP321R1005.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP341R1002.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP341R1003.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP341R1004.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP341R1005.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP351R1002.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SO-03ER1002.xml': ['Sony', 'Xperia Tablet Z', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP412R1401.xml': ['Sony', 'Xperia Tablet Z Ultra', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP412R1421.xml': ['Sony', 'Xperia Tablet Z Ultra', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP511R1701.xml': ['Sony', 'Xperia Tablet Z2', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP512R1701.xml': ['Sony', 'Xperia Tablet Z2', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SGP521R1701.xml': ['Sony', 'Xperia Tablet Z2', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SO-05FR1701.xml': ['Sony', 'Xperia Tablet Z2', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/SOT21R1701.xml': ['Sony', 'Xperia Tablet Z2', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/ST21aR402.xml': ['Sony', 'Xperia Tipo', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST21iR402.xml': ['Sony', 'Xperia Tipo', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST21iR402.xml': ['Sony', 'Xperia Tipo', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST21R402.xml': ['Sony', 'Xperia Tipo', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST21a2R402.xml': ['Sony', 'Xperia Tipo Dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST21i2R402.xml': ['Sony', 'Xperia Tipo Dual', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30atR601.xml': ['Sony', 'Xperia TL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30atR701.xml': ['Sony', 'Xperia TL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT30atR911.xml': ['Sony', 'Xperia TL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT29iR1002.xml': ['Sony', 'Xperia TX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT29iR1411.xml': ['Sony', 'Xperia TX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT29iR601.xml': ['Sony', 'Xperia TX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT29iR701.xml': ['Sony', 'Xperia TX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT29iR911.xml': ['Sony', 'Xperia TX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT29iR921.xml': ['Sony', 'Xperia TX', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/HayabusaR601.xml': ['Sony', 'Xperia TX', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT29iR601.xml': ['Sony', 'Xperia TX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST25iR620.xml': ['Sony', 'Xperia U', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST25aR601.xml': ['Sony', 'Xperia U', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST25aR611.xml': ['Sony', 'Xperia U', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST25iR601.xml': ['Sony', 'Xperia U', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST25iR611.xml': ['Sony', 'Xperia U', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL22R1002.xml': ['Sony', 'Xperia UL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL22R1003.xml': ['Sony', 'Xperia UL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT25iR1411.xml': ['Sony', 'Xperia V', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT25iR701.xml': ['Sony', 'Xperia V', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT25iR901.xml': ['Sony', 'Xperia V', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT25iR911.xml': ['Sony', 'Xperia V', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT25iR921.xml': ['Sony', 'Xperia V', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT25cR901.xml': ['Sony', 'Xperia VC', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT25cR911.xml': ['Sony', 'Xperia VC', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL21R901.xml': ['Sony', 'Xperia VL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL21R911.xml': ['Sony', 'Xperia VL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL21R921.xml': ['Sony', 'Xperia VL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6602R1002.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6602R1003.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6602R1004.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6602R1005.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6602R402.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6603R1002.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6603R1003.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6603R1004.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6603R1005.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6606R1002.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6606R1003.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6606R1004.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6616R1002.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6616R1004.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6616R1005.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L36hR1002.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L36hR1003.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L36hR1004.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L36hR1005.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L36hR911.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-02ER1002.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-02ER1003.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-02ER1005.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-02ER1411.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/C6603R611.xml': ['Sony', 'Xperia Z', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6802R1002.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6802R1401.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6802R1411.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6802R1421.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6806R1401.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6806R1411.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6806R1421.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6833R1401.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6833R1411.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/C6833R1421.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL24R1401.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL24R1421.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/XL39hR1401.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.TABLET],
  'http://uaprof.sonymobile.com/XL39hR1411.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/XL39hR1421.xml': ['Sony', 'Xperia Z Ultra', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6902R1401.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6902R1411.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6902R1421.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6903R1401.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6903R1411.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6903R1421.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6906R1401.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6906R1411.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6906R1421.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6916R1411.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6943R1401.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6943R1411.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6943R1421.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L39hR1003.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L39hR1401.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L39hR1411.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L39hR1421.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L39hR911.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L39tR1401.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L39uR1401.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-01FR1401.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-01FR1411.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-01FR1421.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL23R1401.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL23R1421.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/Xperia Z1R620.xml': ['Sony', 'Xperia Z1', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5503R1411.xml': ['Sony', 'Xperia Z1 Compact', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D5503R1421.xml': ['Sony', 'Xperia Z1 Compact', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M51wR1411.xml': ['Sony', 'Xperia Z1 Compact', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M51wR1421.xml': ['Sony', 'Xperia Z1 Compact', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-02FR1401.xml': ['Sony', 'Xperia Z1f', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-02FR1421.xml': ['Sony', 'Xperia Z1f', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D6502R1701.xml': ['Sony', 'Xperia Z2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D6503R1701.xml': ['Sony', 'Xperia Z2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D6543R1701.xml': ['Sony', 'Xperia Z2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L50tR1701.xml': ['Sony', 'Xperia Z2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L50uR1701.xml': ['Sony', 'Xperia Z2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L50wR1701.xml': ['Sony', 'Xperia Z2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L50wR911.xml': ['Sony', 'Xperia Z2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SO-03FR1701.xml': ['Sony', 'Xperia Z2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/D6563R1701.xml': ['Sony', 'Xperia Z2a', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L55tR2301.xml': ['Sony', 'Xperia Z3', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L55uR2301.xml': ['Sony', 'Xperia Z3', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6502R1002.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6502R1003.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6502R1004.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6502R1005.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6503R1002.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6503R1003.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6503R1004.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6503R1005.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6503R1411.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6503R701.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6506R1002.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6506R1003.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6506R1004.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C6506R1005.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L35hR1002.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L35hR1003.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/L35hR1005.xml': ['Sony', 'Xperia ZL', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/SOL25R1701.xml': ['Sony', 'Xperia ZL2', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5502R1002.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5502R1003.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5502R1004.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5502R1005.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5503R1002.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5503R1003.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5503R1004.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/C5503R1005.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M36hR1002.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M36hR1003.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M36hR1004.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/M36hR1005.xml': ['Sony', 'Xperia ZR', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/A100iR201.xml': ['Sony Ericsson', 'A100i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/A260R101.xml': ['Sony Ericsson', 'A260', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/A270R101.xml': ['Sony Ericsson', 'A270', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/A290iR101.xml': ['Sony Ericsson', 'A290i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/A8iR101.xml': ['Sony Ericsson', 'A8i', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/U100iR101.xml': ['Sony Ericsson', 'Aino', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/U10iR101.xml': ['Sony Ericsson', 'Aino', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ArcR402.xml': ['Sony Ericsson', 'Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/M1iR101.xml': ['Sony Ericsson', 'Aspen', 'Windows Mobile', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/C123R101.xml': ['Sony Ericsson', 'C123', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/C510R101.xml': ['Sony Ericsson', 'C510', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/C510aR101.xml': ['Sony Ericsson', 'C510a', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/C702R101.xml': ['Sony Ericsson', 'C702', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/C901R101.xml': ['Sony Ericsson', 'C901', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/C902R101.xml': ['Sony Ericsson', 'C902', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/C905R101.xml': ['Sony Ericsson', 'C905', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/C905R101-3G.xml': ['Sony Ericsson', 'C905v', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/J108aR101.xml': ['Sony Ericsson', 'Cedar', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/J108iR101.xml': ['Sony Ericsson', 'Cedar', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/J10i2R101.xml': ['Sony Ericsson', 'Elm', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/J10iR101.xml': ['Sony Ericsson', 'Elm', null, DeviceType.MOBILE],
  'http://www.sonyericsson.com/uaprof/R300R101.xml': ['Sony Ericsson', 'F300', null, DeviceType.MOBILE],
  'http://www.sonyericsson.com/uaprof/F305R101.xml': ['Sony Ericsson', 'F305', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/G502R101.xml': ['Sony Ericsson', 'G502', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAProf/G700R100.xml': ['Sony Ericsson', 'G700', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/G705R101.xml': ['Sony Ericsson', 'G705', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAProf/G900R100.xml': ['Sony Ericsson', 'G900', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/J20iR101.xml': ['Sony Ericsson', 'Hazel', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K310iR301.xml': ['Sony Ericsson', 'K310i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K530iR201.xml': ['Sony Ericsson', 'K530i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K550cR201.xml': ['Sony Ericsson', 'K550c', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K550iR201.xml': ['Sony Ericsson', 'K550i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K610iR201.xml': ['Sony Ericsson', 'K610i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K630iR101.xml': ['Sony Ericsson', 'K630i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K660iR101.xml': ['Sony Ericsson', 'K660i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K770iR201-3G.xml': ['Sony Ericsson', 'K770i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K770iR201.xml': ['Sony Ericsson', 'K770i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K790aR201.xml': ['Sony Ericsson', 'K790a', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K790iR201.xml': ['Sony Ericsson', 'K790i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K800iR201.xml': ['Sony Ericsson', 'K800i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K810iR201.xml': ['Sony Ericsson', 'K810i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/K850iR101.xml': ['Sony Ericsson', 'K850i', null, DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/WT19iR1002.xml': [
    'Sony Ericsson',
    'Live with Walkman',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/Live with WalkmanR411.xml': [
    'Sony Ericsson',
    'Live with Walkman',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/WT19aR402.xml': [
    'Sony Ericsson',
    'Live with Walkman',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/WT19aR411.xml': [
    'Sony Ericsson',
    'Live with Walkman',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/WT19iR402.xml': [
    'Sony Ericsson',
    'Live with Walkman',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/WT19iR411.xml': [
    'Sony Ericsson',
    'Live with Walkman',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAProf/M600iR100.xml': ['Sony Ericsson', 'M600i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAProf/M608cR100.xml': ['Sony Ericsson', 'M608c', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/uaprof/WT13iR101.xml': ['Sony Ericsson', 'Mix Walkman', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/J105aR101.xml': ['Sony Ericsson', 'Naite', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/J105iR101.xml': ['Sony Ericsson', 'Naite', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAProf/P1iR100.xml': ['Sony Ericsson', 'P1i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/P800R101.xml': ['Sony Ericsson', 'P800', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/P800R102.xml': ['Sony Ericsson', 'P800', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/P900R101.xml': ['Sony Ericsson', 'P900', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/P908R101.xml': ['Sony Ericsson', 'P908', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAProf/P990iR100.xml': ['Sony Ericsson', 'P990i', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAProf/P200R100.xml': ['Sony Ericsson', 'Paris', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/S500iR201.xml': ['Sony Ericsson', 'S500i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/U1aR000.xml': ['Sony Ericsson', 'Satio', 'Series60', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/U1iR000.xml': ['Sony Ericsson', 'Satio', 'Series60', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/U_1R000.xml': ['Sony Ericsson', 'Satio', 'Series60', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T100R101.xml': ['Sony Ericsson', 'T100', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T123iR101.xml': ['Sony Ericsson', 'T123', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T200.xml': ['Sony Ericsson', 'T200', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T226R101.xml': ['Sony Ericsson', 'T226', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T230R101.xml': ['Sony Ericsson', 'T230', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T238R101.xml': ['Sony Ericsson', 'T238', null, DeviceType.MOBILE],
  'http://www.sonyericsson.com/uaprof/T250iR101.xml': ['Sony Ericsson', 'T250i', null, DeviceType.MOBILE],
  'http://www.sonyericsson.com/uaprof/T280aR101.xml': ['Sony Ericsson', 'T280a', null, DeviceType.MOBILE],
  'http://www.sonyericsson.com/uaprof/T280iR101.xml': ['Sony Ericsson', 'T280i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T300R101.xml': ['Sony Ericsson', 'T300', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T300R201.xml': ['Sony Ericsson', 'T300', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T302R201.xml': ['Sony Ericsson', 'T302', null, DeviceType.MOBILE],
  'http://www.sonyericsson.com/uaprof/T303R101.xml': ['Sony Ericsson', 'T303', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T306R101.xml': ['Sony Ericsson', 'T306', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T310R201.xml': ['Sony Ericsson', 'T310', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T312R201.xml': ['Sony Ericsson', 'T312', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T600R101.xml': ['Sony Ericsson', 'T600', null, DeviceType.MOBILE],
  'http://device.sprintpcs.com/SonyEricsson/SEMCT608/r1a.rdf': ['Sony Ericsson', 'T608', null, DeviceType.MOBILE],
  'http://wap.sonyericssonmobile.com/UAprof/T61.xml': ['Sony Ericsson', 'T61', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T610R101.xml': ['Sony Ericsson', 'T610', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T610R201.xml': ['Sony Ericsson', 'T610', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T610R301.xml': ['Sony Ericsson', 'T610', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T610R401.xml': ['Sony Ericsson', 'T610', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T616R101.xml': ['Sony Ericsson', 'T616', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T616R201.xml': ['Sony Ericsson', 'T616', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T618R101.xml': ['Sony Ericsson', 'T618', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T618R201.xml': ['Sony Ericsson', 'T618', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T618R301.xml': ['Sony Ericsson', 'T618', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T618R401.xml': ['Sony Ericsson', 'T618', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T628R401.xml': ['Sony Ericsson', 'T628', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T630R401.xml': ['Sony Ericsson', 'T630', null, DeviceType.MOBILE],
  'http://wap.sonyericssonmobile.com/UAprof/T65.xml': ['Sony Ericsson', 'T65', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAProf/T650iR201.xml': ['Sony Ericsson', 'T650i', null, DeviceType.MOBILE],
  'http://wap.sonyericssonmobile.com/UAprof/T68R1.xml': ['Sony Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://wap.sonyericssonmobile.com/UAprof/T68R201.xml': ['Sony Ericsson', 'T68', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T700R101.xml': ['Sony Ericsson', 'T700', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/T707R101.xml': ['Sony Ericsson', 'T707', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/TM506R101.xml': ['Sony Ericsson', 'TM506', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/uaprof/CK13iR101.xml': ['Sony Ericsson', 'txt', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/uaprof/CK15aR101.xml': ['Sony Ericsson', 'txt Pro', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/uaprof/CK15iR101.xml': ['Sony Ericsson', 'txt Pro', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/V640iR101-3G.xml': ['Sony Ericsson', 'V640i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/V640iR101.xml': ['Sony Ericsson', 'V640i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/U5aR000.xml': ['Sony Ericsson', 'Vivaz', 'Series60', DeviceType.MOBILE],
  'http://www.sonyericsson.com/downloads/U5iR000.xml': ['Sony Ericsson', 'Vivaz', 'Series60', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/U8aR000.xml': ['Sony Ericsson', 'Vivaz Pro', 'Series60', DeviceType.MOBILE],
  'http://www.sonyericsson.com/downloads/U8iR000.xml': ['Sony Ericsson', 'Vivaz Pro', 'Series60', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W200iR301.xml': ['Sony Ericsson', 'W200i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W20iR101.xml': ['Sony Ericsson', 'W20i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W300iR301.xml': ['Sony Ericsson', 'W300i', null, DeviceType.MOBILE],
  'http://www.sonyericsson.com/uaprof/W302R101.xml': ['Sony Ericsson', 'W302', null, DeviceType.MOBILE],
  'http://www.sonyericsson.com/uaprof/W302R201.xml': ['Sony Ericsson', 'W302', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W350iR201.xml': ['Sony Ericsson', 'W350i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W380iR201.xml': ['Sony Ericsson', 'W380i', null, DeviceType.MOBILE],
  'http://www.sonyericsson.com/downloads/W395R101.xml': ['Sony Ericsson', 'W395', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W508R101.xml': ['Sony Ericsson', 'W508', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W595R101.xml': ['Sony Ericsson', 'W595', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W610iR201.xml': ['Sony Ericsson', 'W610i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W660iR201-3G.xml': ['Sony Ericsson', 'W660i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W660iR201.xml': ['Sony Ericsson', 'W660i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W705R101.xml': ['Sony Ericsson', 'W705', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W715R101-HS.xml': ['Sony Ericsson', 'W715', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W715R101.xml': ['Sony Ericsson', 'W715', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W760iR101.xml': ['Sony Ericsson', 'W760i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/E16iR202.xml': ['Sony Ericsson', 'W8 Walkman', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W890iR101.xml': ['Sony Ericsson', 'W890i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W902R101.xml': ['Sony Ericsson', 'W902', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W908cR101.xml': ['Sony Ericsson', 'W908c', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W910iR101-3G.xml': ['Sony Ericsson', 'W910i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W910iR101-HS.xml': ['Sony Ericsson', 'W910i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W910iR101.xml': ['Sony Ericsson', 'W910i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAProf/W950iR100.xml': ['Sony Ericsson', 'W950i', 'UIQ', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W995R101.xml': ['Sony Ericsson', 'W995', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/W995aR101.xml': ['Sony Ericsson', 'W995a', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/WT18iR101.xml': ['Sony Ericsson', 'Walkman', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/IS11SR301.xml': ['Sony Ericsson', 'Xperia Acro', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/IS11SR402.xml': ['Sony Ericsson', 'Xperia Acro', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SO-02CR301.xml': [
    'Sony Ericsson',
    'Xperia Acro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SO-02CR402.xml': [
    'Sony Ericsson',
    'Xperia Acro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.sonymobile.com/SO-03DR621.xml': ['Sony Ericsson', 'Xperia Acro HD', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/IS12SR601.xml': [
    'Sony Ericsson',
    'Xperia Acro HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/IS12SR611.xml': [
    'Sony Ericsson',
    'Xperia Acro HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SO-03DR601.xml': [
    'Sony Ericsson',
    'Xperia Acro HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SO-03DR611.xml': [
    'Sony Ericsson',
    'Xperia Acro HD',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.sonymobile.com/ST17iR402.xml': ['Sony Ericsson', 'Xperia Active', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST17aR402.xml': [
    'Sony Ericsson',
    'Xperia Active',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/ST17aR411.xml': [
    'Sony Ericsson',
    'Xperia Active',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/ST17iR402.xml': [
    'Sony Ericsson',
    'Xperia Active',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/ST17iR411.xml': [
    'Sony Ericsson',
    'Xperia Active',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.sonymobile.com/LT15iR1002.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT15iR1401.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15aR301.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15aR401.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15aR402.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15aR411.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15iR202.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15iR301.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15iR401.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15iR402.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15iR411.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15R301.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT15R411.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SO-01CR301.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SO-01CR402.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SO-01CR411.xml': ['Sony Ericsson', 'Xperia Arc', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT18iR1002.xml': ['Sony Ericsson', 'Xperia Arc S', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/LT18iR1401.xml': ['Sony Ericsson', 'Xperia Arc S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT18aR402.xml': [
    'Sony Ericsson',
    'Xperia Arc S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/LT18aR411.xml': [
    'Sony Ericsson',
    'Xperia Arc S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/LT18iR402.xml': [
    'Sony Ericsson',
    'Xperia Arc S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/LT18iR411.xml': [
    'Sony Ericsson',
    'Xperia Arc S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/LT18iR601.xml': [
    'Sony Ericsson',
    'Xperia Arc S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/LT18R402.xml': ['Sony Ericsson', 'Xperia Arc S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/LT18R411.xml': ['Sony Ericsson', 'Xperia Arc S', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Xperia Arc SR411.xml': [
    'Sony Ericsson',
    'Xperia Arc S',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/S51SER402.xml': ['Sony Ericsson', 'Xperia Mini', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST15aR401.xml': ['Sony Ericsson', 'Xperia Mini', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST15aR402.xml': ['Sony Ericsson', 'Xperia Mini', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST15aR411.xml': ['Sony Ericsson', 'Xperia Mini', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST15iR301.xml': ['Sony Ericsson', 'Xperia Mini', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST15iR401.xml': ['Sony Ericsson', 'Xperia Mini', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST15iR402.xml': ['Sony Ericsson', 'Xperia Mini', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST15iR411.xml': ['Sony Ericsson', 'Xperia Mini', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SK17aR401.xml': [
    'Sony Ericsson',
    'Xperia Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SK17aR402.xml': [
    'Sony Ericsson',
    'Xperia Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SK17aR411.xml': [
    'Sony Ericsson',
    'Xperia Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SK17iR401.xml': [
    'Sony Ericsson',
    'Xperia Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SK17iR402.xml': [
    'Sony Ericsson',
    'Xperia Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SK17iR411.xml': [
    'Sony Ericsson',
    'Xperia Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.sonymobile.com/MT15iR1002.xml': ['Sony Ericsson', 'Xperia Neo', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT15aR402.xml': ['Sony Ericsson', 'Xperia Neo', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT15aR411.xml': ['Sony Ericsson', 'Xperia Neo', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT15iR301.xml': ['Sony Ericsson', 'Xperia Neo', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT15iR401.xml': ['Sony Ericsson', 'Xperia Neo', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT15iR402.xml': ['Sony Ericsson', 'Xperia Neo', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT15iR411.xml': ['Sony Ericsson', 'Xperia Neo', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/XPERIA NEOR402.xml': [
    'Sony Ericsson',
    'Xperia Neo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.sonymobile.com/MT11iR1002.xml': ['Sony Ericsson', 'Xperia Neo V', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MT11aR402.xml': [
    'Sony Ericsson',
    'Xperia Neo V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/MT11aR411.xml': [
    'Sony Ericsson',
    'Xperia Neo V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/MT11iR402.xml': [
    'Sony Ericsson',
    'Xperia Neo V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/MT11iR411.xml': [
    'Sony Ericsson',
    'Xperia Neo V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SO-02DR601.xml': ['Sony Ericsson', 'Xperia NX', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SO-02DR611.xml': ['Sony Ericsson', 'Xperia NX', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/R800iR1401.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/R800aR301.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/R800aR401.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/R800aR402.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/R800atR301.xml': [
    'Sony Ericsson',
    'Xperia Play',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/R800iR301.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/R800iR401.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/R800iR402.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/R800iR411.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SO-01DR402.xml': [
    'Sony Ericsson',
    'Xperia Play',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/Z1iR301.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z1iR402.xml': ['Sony Ericsson', 'Xperia Play', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MK16aR401.xml': ['Sony Ericsson', 'Xperia Pro', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MK16aR402.xml': ['Sony Ericsson', 'Xperia Pro', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MK16aR411.xml': ['Sony Ericsson', 'Xperia Pro', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MK16iR301.xml': ['Sony Ericsson', 'Xperia Pro', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MK16iR402.xml': ['Sony Ericsson', 'Xperia Pro', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/MK16iR411.xml': ['Sony Ericsson', 'Xperia Pro', 'Android', DeviceType.MOBILE],
  'http://uaprof.sonymobile.com/ST18iR1002.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SO-03CR401.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SO-03CR402.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST18aR401.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST18aR402.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST18aR411.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST18i PremiumR402.xml': [
    'Sony Ericsson',
    'Xperia Ray',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/ST18iR401.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST18iR402.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST18iR411.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/ST18R411.xml': ['Sony Ericsson', 'Xperia Ray', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X1iR101.xml': [
    'Sony Ericsson',
    'Xperia X1',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/SO-01BR101.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/SO-01BR201.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10aR101.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10aR201.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10aR202.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10aR301.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10iR101.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10iR201.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10iR202.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10iR301.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10iR601.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10R301.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10R601.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10SR301.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/X10SR601.xml': ['Sony Ericsson', 'Xperia X10', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Xperia X10R301.xml': [
    'Sony Ericsson',
    'Xperia X10',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/E10aR102.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/E10aR201.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/E10aR202.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/E10iR102.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/E10iR201.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/E10iR202.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/U20aR102.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/U20aR201.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/U20aR202.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/U20iR102.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/U20iR201.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/U20iR202.xml': [
    'Sony Ericsson',
    'Xperia X10 Mini Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/X2R301.xml': [
    'Sony Ericsson',
    'Xperia X2',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap.sonyericsson.com/UAprof/E15aR102.xml': ['Sony Ericsson', 'Xperia X8', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/E15aR201.xml': ['Sony Ericsson', 'Xperia X8', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/E15aR202.xml': ['Sony Ericsson', 'Xperia X8', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/E15iR102.xml': ['Sony Ericsson', 'Xperia X8', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/E15iR201.xml': ['Sony Ericsson', 'Xperia X8', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/E15iR202.xml': ['Sony Ericsson', 'Xperia X8', 'Android', DeviceType.MOBILE],
  'http://wap.sonyericsson.com/uaprof/W150iR101.xml': ['Sony Ericsson', 'Yendo', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z1010R101.xml': ['Sony Ericsson', 'Z1010', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z200R101.xml': ['Sony Ericsson', 'Z200', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z320iR101.xml': ['Sony Ericsson', 'Z320i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z558cR301.xml': ['Sony Ericsson', 'Z558c', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z600R301.xml': ['Sony Ericsson', 'Z600', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z600R401.xml': ['Sony Ericsson', 'Z600', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z608R301.xml': ['Sony Ericsson', 'Z608', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z608R401.xml': ['Sony Ericsson', 'Z608', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z750iR101.xml': ['Sony Ericsson', 'Z750i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z770iR101.xml': ['Sony Ericsson', 'Z770i', null, DeviceType.MOBILE],
  'http://wap.sonyericsson.com/UAprof/Z780iR101.xml': ['Sony Ericsson', 'Z780i', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Soshphone_4G.xml': ['SoshPhone', '4G', 'Android', DeviceType.MOBILE],
  'http://wap.spicegang.in/uaprofile/SPICE-C-810.xml': ['Spice', 'C-810', null, DeviceType.MOBILE],
  'http://msai.in/uaprof/spice/M5455.xml': ['Spice', 'M-5455 Flo', null, DeviceType.MOBILE],
  'http://msai.in/uaprof/spice/M5885.xml': ['Spice', 'M-5885 Cappuccino II', 'MTK', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/spice/SPICE_M6700.xml': ['Spice', 'M-6700', null, DeviceType.MOBILE],
  'http://www.msai.in/uaprof/spice/SPICE_M-6800.xml': ['Spice', 'M-6800', 'MTK', DeviceType.MOBILE],
  'http://msai.in/uaprof/spice/M6868n.xml': ['Spice', 'M-6868 Flo', 'MTK', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/Spice/Mi-315.xml': ['Spice', 'Mi-315', 'Android', DeviceType.MOBILE],
  'http://www.commtiva.com/uaprof/E500/UAProf_E500_Froyo.xml': ['Spice', 'Mi-350', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/Spice_Mi350_UAProfile.xml': [
    'Spice',
    'Mi-350',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/Kyocera/KYE4255/1306SP.rdf': ['Sprint', 'E4255', 'Brew', DeviceType.MOBILE],
  'http://device.sprintpcs.com/KYOCERA/S2151/1.000SP.rdf': ['Sprint', 'S2151', 'Brew', DeviceType.MOBILE],
  'http://uap.cellon.com/Starmobile_KNIGHT.xml': ['Starmobile', 'Knight', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/starmobile/starmobile.xml': ['Starmobile', 'Roar', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/tmo/ameo-1.0.xml': ['T-Mobile', 'Ameo', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/tmo/ameo-1.1.xml': ['T-Mobile', 'Ameo', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Rogers/DreamR/ua-profile-htc-dream-Rogers.xml': [
    'T-Mobile',
    'G1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/G2/ua-profile.xml': ['T-Mobile', 'G2', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/TMO/Hero/ua-profile.xml': ['T-Mobile', 'G2', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/LG-L95G.xml': ['T-Mobile', 'G2x', 'Android', DeviceType.MOBILE],
  'http://gsm.lge.com/html/gsm/P999-M10-D1.xml': ['T-Mobile', 'G2x', 'Android', DeviceType.MOBILE],
  'http://static.garmincdn.com/uaprof/T-Mobile_Garminfone_1_0.xml': [
    'T-Mobile',
    'Garminfone',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/tmo/mdacp-1.0.xml': ['T-Mobile', 'MDA Compact', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/tmo/mdacp-3.0.xml': ['T-Mobile', 'MDA Compact III', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/tmo/mdapro-1.0.xml': ['T-Mobile', 'MDA Pro', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/tmo/mdatouch-1.0.xml': ['T-Mobile', 'MDA Touch', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/tmo/mdavario-2.0.xml': ['T-Mobile', 'MDA Vario II', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/tmo/mdavario-3.0.xml': [
    'T-Mobile',
    'MDA Vario III',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8600WCDMA-T-Mobile.xml': [
    'T-Mobile',
    'Move Balance',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://gsm.lge.com/html/gsm/E739-M10-D1.xml': ['T-Mobile', 'myTouch', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8680GPRS-TMO.xml': ['T-Mobile', 'myTouch', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8680WCDMA-TMO.xml': ['T-Mobile', 'myTouch', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/Android/Common/myTouch3G/ua-profile.xml': [
    'T-Mobile',
    'myTouch 3G Slide',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/myTouch4G/ua-profile.xml': [
    'T-Mobile',
    'myTouch 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/PD15/ua-profile.xml': [
    'T-Mobile',
    'myTouch 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/Android/Common/myTouch_4G_Slide/ua-profile.xml': [
    'T-Mobile',
    'myTouch 4G Slide',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://gsm.lge.com/html/gsm/C800-M10-D1.xml': ['T-Mobile', 'myTouch Q', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8730GPRS-TMO.xml': ['T-Mobile', 'myTouch Q', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8730WCDMA-TMO.xml': ['T-Mobile', 'myTouch Q', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8651GPRS-TMO.xml': ['T-Mobile', 'Prism', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8651SWCDMA-TMO.xml': ['T-Mobile', 'Prism', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8651WCDMA-TMO.xml': ['T-Mobile', 'Prism', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8686GPRS-Normal.xml': ['T-Mobile', 'Prism II', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8220v100GPRSEclair.xml': ['T-Mobile', 'Pulse', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8220v100WCDMAEclair.xml': [
    'T-Mobile',
    'Pulse',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8220_6v100WCDMA.xml': ['T-Mobile', 'Pulse', 'Android', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/tmo/sda-1.0.xml': ['T-Mobile', 'SDA', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/T-Mobile_Vivacity.xml': [
    'T-Mobile',
    'Vivacity',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/TCL_TCL_309T.xml': ['TCL', '309T', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_A890_2SIM.xml': ['TCL', 'A890', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL-A909.xml': ['TCL', 'A909', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_A919.xml': ['TCL', 'A919', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_A980.xml': ['TCL', 'A980', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL A986.xml': ['TCL', 'A986', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_A990.xml': ['TCL', 'A990', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL A998.xml': ['TCL', 'A998', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_H900M.xml': ['TCL', 'H900M', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_Y910T.xml': ['TCL', 'Hero N3', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_i708U.xml': ['TCL', 'i708U', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_i709M.xml': ['TCL', 'i709M', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_i718M.xml': ['TCL', 'i718M', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_i800.xml': ['TCL', 'i800', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/i806.xml': ['TCL', 'i806', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_i806.xml': ['TCL', 'i806', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCT_J320T.xml': ['TCL', 'J320', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCT_J600T.xml': ['TCL', 'J600T', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCT_J630T.xml': ['TCL', 'J630T', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_J720.xml': ['TCL', 'J720', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_J726T.xml': ['TCL', 'J726T', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL-J736L.xml': ['TCL', 'J736', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_J738M.xml': ['TCL', 'J738', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S838M.xml': ['TCL', 'J738M', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_J926T.xml': ['TCL', 'J926T', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_J928.xml': ['TCL', 'J928', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_M2M.xml': ['TCL', 'M2M', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_M2U.xml': ['TCL', 'M2U', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_P301M.xml': ['TCL', 'P301M', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_P331M.xml': ['TCL', 'P331M', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_P600.xml': ['TCL', 'P600', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_P606.xml': ['TCL', 'P606', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_P606T.xml': ['TCL', 'P606T', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_P620M_UA.xml': ['TCL', 'P620M', 'Android', DeviceType.MOBILE],
  'http://114.242.213.43:8080/ThundersoftMDMWeb/resources/mochagw01.xml': [
    'TCL',
    'P650',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/TCL-P688L.xml': ['TCL', 'P688L', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_P728M.xml': ['TCL', 'P728', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL-S700T.xml': ['TCL', 'S700', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S720.xml': ['TCL', 'S720', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S720T.xml': ['TCL', 'S720', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S725T.xml': ['TCL', 'S725', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S820.xml': ['TCL', 'S820', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S826L.xml': ['TCL', 'S826', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S830U.xml': ['TCL', 'S830U', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S850.xml': ['TCL', 'S850', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S860.xml': ['TCL', 'S860', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S950.xml': ['TCL', 'S950', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S950T.xml': ['TCL', 'S950', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOTCL S950.xml': ['TCL', 'S950', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/ALCATEL_ONE_TOUCH_6043D.xml': ['TCL', 'S960', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S960.xml': ['TCL', 'S960', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_S960T.xml': ['TCL', 'S960', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_W939.xml': ['TCL', 'W939', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_W969.xml': ['TCL', 'W969', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_Y710.xml': ['TCL', 'Y710', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_Y900.xml': ['TCL', 'Y900', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/TCL_Y910.xml': ['TCL', 'Y910', 'Android', DeviceType.MOBILE],
  'Mozilla/5.0 (Linux; U; Android 4.4; zh-cn;TECNO L7 Build/ AppleWebKit/534.30 (KHTML, like Gecko) Version/4.4 Mobile Safari/534.30': [
    'Tecno',
    'L6',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.1066.cn/uaprof/prof/Tecno/Tecno_N7.xml': ['TECNO', 'N7', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/file/ALCATEL_one_touch_7018.xml': ['Tecno', 'P3', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Preo_Teknosa_P1.xml': ['Teknosa', 'Preo P1', 'Android', DeviceType.MOBILE],
  'http://wap.purplelabs.com/UAprofile/UAprofileTelme_T919.xml': ['Tel.Me', 'T919', null, DeviceType.MOBILE],
  'http://www.teleepoch.com/PMI920.xml': ['TeleEpoch', 'PMI920', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ Telenor Touch Plus.xml': [
    'Telenor',
    'Touch Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://download.telme.at/wap/UAprofileTelme_T919.xml': ['TelMe', 'T919', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T20.xml': ['Telstra', 'FLIP', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/T3020.xml': ['Telstra', 'Smart Touch', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/tmn_smart_a18.xml': ['TMN', 'Smart A18', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V9800.xml': ['TMN', 'Smart A60', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/tmn_smart_a7.xml': ['TMN', 'Smart A7', 'Android', DeviceType.MOBILE],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/EUR1/G500-1.0.xml': [
    'Toshiba',
    'Portégé G500',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/EUR1/G810-1.0.xml': [
    'Toshiba',
    'Portégé G810',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/EUR1/G910_G920-1.0.xml': [
    'Toshiba',
    'Portégé G910',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.fmworld.net/product/phone/is04/uapro/IS04-1.0.xml': [
    'Toshiba',
    'Regza IS04',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.fmworld.net/product/phone/t-01c/uapro/T-01C-1.0.xml': [
    'Toshiba',
    'Regza T-01C',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/GPRS/Toshiba_TS605.xml': [
    'Toshiba',
    'TS605',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/GPRS/Toshiba_GS20.xml': [
    'Toshiba',
    'TS608',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/EUR1/Toshiba_808_r100_3G.xml': [
    'Toshiba',
    'TS808',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/EUR1/Toshiba_808_r100_GPRS.xml': [
    'Toshiba',
    'TS808',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/EUR1/TS_921_r100.xml': [
    'Toshiba',
    'TS921',
    null,
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8860-rGPRS-Turkcell.xml': [
    'Turkcell',
    'MaxiPRO5',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiU8650GPRS-Turkcell.xml': ['Turkcell', 'T20', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiU8650WCDMA-Turkcell.xml': ['Turkcell', 'T20', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/TURKCELL T40.xml': ['Turkcell', 'T40', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/TURKCELL_T50.xml': ['Turkcell', 'T50', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Amazing_A5S.xml': ['TWM', 'Amazing A5S', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/A6.xml': ['TWM', 'Amazing A6', 'Android', DeviceType.MOBILE],
  'http://www.c2dms.com/UAProfile/TWM/A6S.xml': ['TWM', 'Amazing A6S', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T88.xml': ['TWM', 'Amazing X2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Amazing_X5.xml': ['TWM', 'Amazing X5', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/myPad_P3.xml': ['TWM', 'myPad P3', 'Android', DeviceType.MOBILE],
  'http://gsm.unc.com/html/gsm/GL8-M10-D1.xml': ['Ucan', 'MJ Michael Jackson Reborn', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/UMI_eMAX_mini.xml': ['UMI', 'eMAX mini', 'Android', DeviceType.MOBILE],
  'http://pix.cspire.com/UA/profile/unimax/u680/u680.xml': ['UMX', 'U680C', 'Android', DeviceType.MOBILE],
  'http://www.uniscope.com.cn/wapup/unipu2.xml': ['Uniscope', 'PU2', null, DeviceType.MOBILE],
  'http://uriver.co.kr/UAprof/UAprof_SP770.xml': ['Uriver', 'SP770', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/Utec_S800.xml': ['Utec', 'S800', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/UTStarcom/TXT8010/TXT8010.xml': ['UTStarcom', 'Blitz TXT8010', null, DeviceType.MOBILE],
  'http://uaprof.vtext.com/utstar/7075/7075v1.xml': ['UTStarcom', 'CDM-7075', null, DeviceType.MOBILE],
  'http://uaprof.vmobl.com/UTSTARCOM/cdma8074/VMU_cdma8074_UAProf.xml': [
    'UTStarcom',
    'CDM-8074',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.vmobl.com/AUDIOVOX/CDM-8915/VMU_Audiovox-CDM-8915.xml': [
    'UTStarcom',
    'CDM-8915',
    null,
    DeviceType.MOBILE,
  ],
  'http://user.chol.com/~budelgaji/uaprof/CDM8935.xml': ['UTStarcom', 'CDM-8935', null, DeviceType.MOBILE],
  'http://pix.cellularsouth.com/UA/profile/utstarcom/cdm8955/cdm8955.xml': [
    'UTstarcom',
    'CDM-8955',
    null,
    DeviceType.MOBILE,
  ],
  'https://servicios.iusacell.com.mx/uts/CDM8960_wap.xml': ['UTStarcom', 'CDM-8960', null, DeviceType.MOBILE],
  'http://uaprof.vmobl.com/utstarcom/cdma8964/VMU_utstarcom-CDM-8964VM_UAProf.xml': [
    'UTStarcom',
    'CDM-8964',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.vtext.com/utstar/gz1s/gz1sv1.xml': ['UTStarcom', 'G\'zOne Type-S', null, DeviceType.MOBILE],
  'http://www.bellwave.co.uk/uaprof/UAProfile_GPRS778.xml': ['UTStarcom', 'GPRS778', null, DeviceType.MOBILE],
  'http://pcdgsmlab.com/gpt380/GPT380.xml': ['UTstarcom', 'GPT380', null, DeviceType.MOBILE],
  'http://uaprof.utstar.co.kr/uaprof/gsm/UTSTARCOM-GTX75.xml': ['UTStarcom', 'GTX75', null, DeviceType.MOBILE],
  'http://uaprof.vmobl.com/UTSTARCOM/pcs1450/VMU_SliceII_UAProf.xml': [
    'UTStarcom',
    'PCS-1450',
    null,
    DeviceType.MOBILE,
  ],
  'https://servicios.iusacell.com.mx/vacom/vt820/vt820prof.rdf': ['Vacom', 'VT820', null, DeviceType.MOBILE],
  'http://www.velocitymobile.com/resource/UAProf-103.xml': ['Velicity', '103 VGA', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NVAscentr200.xml': ['Vertu', 'Ascent', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NVAscentTir100.xml': ['Vertu', 'Ascent Ti', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NVAscentTir100_3G.xml': ['Vertu', 'Ascent Ti', null, DeviceType.MOBILE],
  'http://nds.nokia.com/uaprof/NVConstellationr100.xml': ['Vertu', 'Constellation', 'Series60', DeviceType.MOBILE],
  'http://nds1.nds.nokia.com/uaprof/NVConstellationQuestr100.xml': [
    'Vertu',
    'Constellation Quest',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/NVConstellationTr100.xml': [
    'Vertu',
    'Constellation T',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds1.nds.nokia.com/uaprof/NVConstellationTr200.xml': [
    'Vertu',
    'Constellation T',
    'Series60',
    DeviceType.MOBILE,
  ],
  'http://nds.nokia.com/uaprof/NVSignaturer100.xml': ['Vertu', 'Signature', null, DeviceType.MOBILE],
  'http://www.verykool.net/Profiles/s5017Q/s5017Q.xml': ['verykool', 'Dorado s5017', 'Android', DeviceType.MOBILE],
  'http://www.verykool.net/Profiles/s352/s352.xml': ['verykool', 's352', 'Android', DeviceType.MOBILE],
  'http://www.verykool.net/Profiles/s354/s354.xml': ['verykool', 's354', 'Android', DeviceType.MOBILE],
  'http://www.verykool.net/Profiles/s400T/s400T.xml': ['verykool', 's400', 'Android', DeviceType.MOBILE],
  'http://www.verykool.net/Profiles/s401/s401.xml': ['verykool', 's401', 'Android', DeviceType.MOBILE],
  'http://www.verykool.net/Profiles/S4510/S4510.xml': ['verykool', 's4510u', 'Android', DeviceType.MOBILE],
  'http://www.verykool.net/Profiles/s505/s505.xml': ['verykool', 's505', 'Android', DeviceType.MOBILE],
  'http://www.verykool.net/Profiles/S732/S732.xml': ['verykool', 's732', 'Android', DeviceType.MOBILE],
  'http://www.verykool.net/Profiles/S758/S758.xml': ['Verykool', 'S758', 'Android', DeviceType.MOBILE],
  'http://www.verzioworld.com/Duplii.xml': ['Verzio', 'Duplii', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Viettel-N8303.xml': ['Viettel', 'N8303', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Viettel-V8403.xml': ['Viettel', 'V8403', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/VIETTEL_V8404GPRS-NORMAL.xml': ['Viettel', 'V8404', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/VIETTEL_V8404WCDMA-NORMAL.xml': ['Viettel', 'V8404', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V8501.xml': ['Viettel', 'V8501', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/VIETTELV8506.xml': ['Viettel', 'V8506', 'Android', DeviceType.MOBILE],
  'http://ap.viewsonic.com/uaprofile/V350/UAProf_V350_Gingerbread.xml': [
    'ViewSonic',
    'V350',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://ap.viewsonic.com/uaprofile/ViewPhone3/UAProf_ViewPhone3_Gingerbread.xml': [
    'ViewSonic',
    'ViewPhone 3',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.purplelabs.com/UAprofile/UAprofile_VitelcomTSM100.xml': [
    'Vitelcom',
    'TSM-100',
    null,
    DeviceType.MOBILE,
  ],
  'http://uaprof.purplelabs.com/UAprofile/UAprofile_VitelcomTSM30.xml': [
    'Vitelcom',
    'TSM-30',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.vitelcom.es/uaprof/UAprofile_VitelcomTSM340_01.xml': ['Vitelcom', 'TSM-340', null, DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_V1.xml': ['Vivo', 'V1', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_V3.xml': ['Vivo', 'V3', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_V3Max.xml': ['Vivo', 'V3 Max', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_V3Max.xml': ['Vivo', 'V3 Max', 'Linux'],
  'http://www.msai.in/uaprof/vivo/vivo_V1Max.xml': ['Vivo', 'vivo V1Max', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_X3S.xml': ['Vivo', 'X3S', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo-X3S.xml': ['Vivo', 'X3S', 'Android', DeviceType.MOBILE],
  'http://download0.inner.bbk.com/pro/BBG_vivo_X3V_1_20140703.xml': ['Vivo', 'X3V', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_X5.xml': ['Vivo', 'X5', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_X5Max.xml': ['Vivo', 'X5 Max', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_X5Max.xml': ['Vivo', 'X5 Max', 'Android', DeviceType.MOBILE],
  'http://download0.inner.bbk.com/pro/VIV_vivo_X5MaxV_1_20141118.xml': [
    'Vivo',
    'X5 Max V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://download.api.vivoglobal.com/pro/UA/vivo_X5Pro.xml': ['Vivo', 'X5 Pro', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_X5Pro.xml': ['Vivo', 'X5 Pro', 'Android', DeviceType.MOBILE],
  'http://download0.vivo.com.cn/pro/browser/VIV_vivo_X5Pro_V_1_20150427.xml': [
    'Vivo',
    'X5 Pro V',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://download0.inner.bbk.com/pro/BBG_vivo_X5V_1_20140922.xml': ['Vivo', 'X5V', 'Android', DeviceType.MOBILE],
  'http://download0.inner.bbk.com/pro/VIV_vivo_X5V_1_20140922.xml': ['Vivo', 'X5V', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_UA.xml': ['Vivo', 'Xshot', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_X710.xml': ['Vivo', 'Xshot', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y11.xml': ['Vivo', 'Y11', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y15.xml': ['Vivo', 'Y15', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo-Y15.xml': ['Vivo', 'Y15', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y15S.xml': ['Vivo', 'Y15S', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y21.xml': ['Vivo', 'Y21', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y21.xml': ['Vivo', 'Y21', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y21L.xml': ['Vivo', 'Y21L', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y22.xml': ['Vivo', 'Y22', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo-Y22.xml': ['Vivo', 'Y22', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y27.xml': ['Vivo', 'Y27', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y27L.xml': ['Vivo', 'Y27L', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y28.xml': ['Vivo', 'Y28', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y28.xml': ['Vivo', 'Y28', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y31.xml': ['Vivo', 'Y31', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y31.xml': ['Vivo', 'Y31', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y31L.xml': ['Vivo', 'Y31L', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y31L.xml': ['Vivo', 'Y31L', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y35.xml': ['Vivo', 'Y35', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y37.xml': ['Vivo', 'Y37', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y51.xml': ['Vivo', 'Y51', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y51L.xml': ['Vivo', 'Y51L', 'Android', DeviceType.MOBILE],
  'http://download.api.vivoglobal.com/pro/UA/vivo_Y55L.xml': ['Vivo', 'Y55L', 'Android', DeviceType.MOBILE],
  'http://www.msai.in/uaprof/vivo/vivo_Y55L.xml': ['Vivo', 'Y55L', 'Android', DeviceType.MOBILE],
  'http://wap1.mtk.com.tw/MTK_Phone_JB_UAprofile.xml': ['Vivo', 'Y613', 'Android', DeviceType.MOBILE],
  'http://download0.inner.bbk.com/pro/VIV_vivo_Y913_1_20140922.xml': ['Vivo', 'Y913', 'Android', DeviceType.MOBILE],
  'http://download0.vivo.com.cn/pro/browser/VIV_vivo_Y923_1_20150319.xml': [
    'Vivo',
    'Y923',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://download0.inner.bbk.com/pro/VIV_vivo_Y928_1_20141008.xml': ['Vivo', 'Y928', 'Android', DeviceType.MOBILE],
  'http://download0.vivo.com.cn/pro/browser/VIV_vivo_Y937_1_20150701.xml': [
    'Vivo',
    'Y937',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap.vkmobile.com/uaprof/vk5000.xml': ['VK Mobile', 'VK5000', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Vodafone-1231.xml': ['Vodafone', '1231', null, DeviceType.MOBILE],
  'http://uaprofile.asus.com/uaprof/Vodafone1520-1.0.xml': ['Vodafone', '1520', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com./files/Vodafone-331.rdf': ['Vodafone', '331', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_355.rdf': ['Vodafone', '355', null, DeviceType.MOBILE],
  'http://wap.samsungmobile.com/uaprof/I6410UAProf2G.rdf': ['Vodafone', '360 M1', 'LiMo', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/VODAFONE-455.rdf': ['Vodafone', '455', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Vodafone550.xml': ['Vodafone', '550', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_575.rdf': ['Vodafone', '575', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_655.rdf': ['Vodafone', '655', null, DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_655W.rdf': ['Vodafone', '655W', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/703SH_G001_base.xml': ['Vodafone', '703SH', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/V703SHf_SHJ001_3g.xml': ['Vodafone', '703SH', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/V705SH_SHJ001_3g.xml': ['Vodafone', '705SH', null, DeviceType.MOBILE],
  'http://wap.huawei.com/uaprof/HuaweiV735v100WCDMA.xml': ['Vodafone', '735', null, DeviceType.MOBILE],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/VFKK/Vodafone_803T_r100_3G.xml': [
    'Vodafone',
    '803T',
    null,
    DeviceType.MOBILE,
  ],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/VFKK/Vodafone_803T_r100_GPRS.xml': [
    'Vodafone',
    '803T',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.sharp-mobile.com/UAProf/V804SH_SHJ001_3g.xml': ['Vodafone', '804SH', null, DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Vodafone845v100GPRS.xml': ['Vodafone', '845 Nova', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/Vodafone845v100WCDMA.xml': ['Vodafone', '845 Nova', 'Android', DeviceType.MOBILE],
  'http://wap1.huawei.com/uaprof/HuaweiV858GPRS-Vodafone.xml': [
    'Vodafone',
    '858 Smart',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://wap1.huawei.com/uaprof/HuaweiV858WCDMA-Vodafone.xml': [
    'Vodafone',
    '858 Smart',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_861.xml': ['Vodafone', '861', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_875.xml': ['Vodafone', '875', 'Android', DeviceType.MOBILE],
  'http://config.51coolpad.com/UAProfile/vodafone/Vodafone-890N.xml': [
    'Vodafone',
    '890',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.sharp-mobile.com/UAProf/902SH_G001_base.xml': ['Vodafone', '902SH', null, DeviceType.MOBILE],
  'http://www.sharp-mobile.com/UAProf/V902SH_J001_3g.xml': ['Vodafone', '902SH', null, DeviceType.MOBILE],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/VFKK/Vodafone_902T_r100_3G.xml': [
    'Vodafone',
    '902T',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.sharp-mobile.com/UAProf/903SH_G001_base.xml': ['Vodafone', '903SH', null, DeviceType.MOBILE],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/VFKK/Vodafone_903T_r100_3G.xml': [
    'Vodafone',
    '903T',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.sharp-mobile.com/UAProf/V904SH_SHJ001_3g.xml': ['Vodafone', '904SH', null, DeviceType.MOBILE],
  'http://gphone.toshiba.co.jp/tech/profiles/UAPROF/VFKK/Vodafone_904T_r100_3G.xml': [
    'Vodafone',
    '904T',
    null,
    DeviceType.MOBILE,
  ],
  'http://www.sharp-mobile.com/UAProf/V905SH_SHJ001_3g.xml': ['Vodafone', '905SH', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/VF945.xml': ['Vodafone', '945', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone 958.xml': ['Vodafone', '958', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_975.xml': ['Vodafone', '975', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_975N.xml': ['Vodafone', '975', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_Chat_655W.rdf': ['Vodafone', 'Chat 655', null, DeviceType.MOBILE],
  'http://config.51coolpad.com/UAProfile/vodafone/Smart-4-baloo.xml': [
    'Vodafone',
    'Smart 4',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_785.xml': ['Vodafone', 'Smart 4 Mini', 'Android', DeviceType.MOBILE],
  'http://vodafone.51coolpad.com/UAProfile/vodafone/Smart-4G.xml': [
    'Vodafone',
    'Smart 4G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-SmartQ-WCDMA.xml': [
    'Vodafone',
    'Smart Chat',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-SmartQ.xml': ['Vodafone', 'Smart Chat', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_Smart_II.xml': ['Vodafone', 'Smart II', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_Smart_II_3G.xml': [
    'Vodafone',
    'Smart II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_Smart_Tab_3G.xml': [
    'Vodafone',
    'Smart Tab 3G',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www-ccpp.tcl-ta.com/files/Vodafone_Smart_Tab_4.xml': [
    'Vodafone',
    'Smart Tab 4',
    'Android',
    DeviceType.TABLET,
  ],
  'http://s3.lenovomm.com/Obelix_Profile.xml': ['Vodafone', 'Smart Tab III 10', 'Android', DeviceType.MOBILE],
  'http://s3.lenovomm.com/Asterix_Profile.xml': ['Vodafone', 'Smart Tab III 7', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/VodafoneSmartTab10.xml': [
    'Vodafone',
    'SmartTab 10',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.zte.com.cn/mobile/uaprof/VodafoneSmartTab7.xml': [
    'Vodafone',
    'SmartTab 7',
    'Android',
    DeviceType.TABLET,
  ],
  'https://s3-us-west-1.amazonaws.com/lenovo-ota/Clara_Profile.xml': [
    'Vodafone',
    'SmartTab II 7',
    'Android',
    DeviceType.TABLET,
  ],
  'http://www.htcmms.com.tw/voda/v1415-1.0.xml': ['Vodafone', 'v1415', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/voda/v1510-1.0.xml': ['Vodafone', 'v1510', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/voda/v1640-2.0.xml': ['Vodafone', 'v1640', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/voda/V7505-1.0.xml': ['Vodafone', 'v7505', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.htcmms.com.tw/voda/VPACompactIV-1.0.xml': [
    'Vodafone',
    'VPA Compact IV',
    'Windows Mobile',
    DeviceType.MOBILE,
  ],
  'http://www.htcmms.com.tw/voda/VPA_Touch-1.0.xml': ['Vodafone', 'VPA Touch', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/W1.xml': ['Vodafone', 'W1', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_BD40.xml': ['Voxtel', 'BD40', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_RX100_UAProf.xml': ['Voxtel', 'RX100', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_RX200_UAProf.xml': ['Voxtel', 'RX200', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_rx600.xml': ['Voxtel', 'RX600', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_rx800.xml': ['Voxtel', 'RX800', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_v100.xml': ['Voxtel', 'V100', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_v300.xml': ['Voxtel', 'V300', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_V310.xml': ['Voxtel', 'V310', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_v350.xml': ['Voxtel', 'V350', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_v50.xml': ['Voxtel', 'V50', null, DeviceType.MOBILE],
  'http://www.voxtel.ru/UAProf/Voxtel_vs400.xml': ['Voxtel', 'VS400', null, DeviceType.MOBILE],
  'http://www.ngm-mobile.com/UserAgentProfiles/ngmwilcojb.xml': ['Walton', 'Primo G1', 'Android', DeviceType.MOBILE],
  'http://go.acer.com/?id=84687': ['Walton', 'Primo H5', 'Android', DeviceType.MOBILE],
  'http://www.fly-phone.ru/UAP/Fly_IQ4501_Quad.xml': ['Walton', 'Primo HM', 'Android', DeviceType.MOBILE],
  'http://whaminfocom.com/profiles/WG40.xml': ['Wham', 'WG40', 'Android', DeviceType.MOBILE],
  'http://www.wonutel.co.kr/UAProfile/WonuS1.xml': ['Wonu', 'S1', null, DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOMI 5s.xml': ['Xiaomi', 'Mi 5S', 'Android', DeviceType.MOBILE],
  'http://apkupdate.miui.com/other/HM2LTE-BR_H2X_2014819_UAProfile.xml': [
    'Xiaomi',
    'Redmi 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://apkupdate.miui.com/other/HM2LTE-IN_H2X_2014818_UAProfile.xml': [
    'Xiaomi',
    'Redmi 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://apkupdate.miui.com/other/HM2LTE-SA_H2X_2014817_UAProfile.xml': [
    'Xiaomi',
    'Redmi 2',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.oppo.com/resource/UA-PROF/OPPOHM Note 1S.xml': [
    'Xiaomi',
    'Redmi Note 1',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://apkupdate.miui.com/other/HM2013023_UAprofile.xml': [
    'Xiaomi',
    'Redmi Red Rice',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://apkupdate.miui.com/other/HM2014011_UAprofile.xml': [
    'Xiaomi',
    'Redmi Red Rice',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://apkupdate.miui.com/other/HM2014501_UAprofile.xml': [
    'Xiaomi',
    'Redmi Red Rice',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.msai.in/uaprof/XOLO/Q1020.xml': ['XOLO', 'Q1020', 'Android', DeviceType.MOBILE],
  'http://nmsc.ctvap.cn/uaprof/YCT/YCT_TE600_1_20101228.xml': ['YCT', 'TE600', 'Android', DeviceType.MOBILE],
  'http://www.ddmbrands.com/uaprof/yezz/andy_3.5EI2.xml': ['Yezz', 'Andy 3.5EI2', 'Android', DeviceType.MOBILE],
  'http://www.ddmbrands.com/uaprof/yezz/andy_5EI.xml': ['Yezz', 'Andy 5EI', 'Android', DeviceType.MOBILE],
  'http://www.ddmbrands.com/uaprof/yezz/andy_5EL.xml': ['Yezz', 'Andy 5EL', 'Android', DeviceType.MOBILE],
  'http://www.ddmbrands.com/uaprof/yezz/andy_AC5EL.xml': ['Yezz', 'Andy 5EL', 'Android', DeviceType.MOBILE],
  'http://www.ddmbrands.com/uaprof/yezz/andy_C5EL.xml': ['Yezz', 'Andy 5EL', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_Q491.xml': ['Yu', 'Yuphoria', 'Android', DeviceType.MOBILE],
  'http://www.1066.cn/uaprof/prof/Micromax/Micromax_YU5200.xml': ['Yu', 'Yureka S', 'Android', DeviceType.MOBILE],
  'http://www.lenovomobile.com/admin/module/product/DownFile/YUSUN LA2-T_UAprofile.xml': [
    'YUSUN',
    'LA2-T',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.zebra.com/mc36.xml': ['Zebra', 'MC36', 'Android', DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/ZMEM1070.xml': ['Zonda', 'ZMEM1070', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/ZMEM1075.xml': ['Zonda', 'ZMEM1075', null, DeviceType.MOBILE],
  'http://211.42.201.70/ua_profile/ZMEM1085.xml': ['Zonda', 'ZMEM1085', null, DeviceType.MOBILE],
  'http://profile.aiko.com.br/aiko70w.xml': ['ZTE', '70W', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE A2015.xml': ['ZTE', 'A2015', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/A3.xml': ['ZTE', 'A3', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTEA37.xml': ['ZTE', 'A37', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/A4.xml': ['ZTE', 'A4', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Acqua.xml': ['ZTE', 'Acqua', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ARIZONA.xml': ['ZTE', 'Arizona', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE%20A2017U.xml': ['ZTE', 'Axon 7', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/Joy Smart AXS II.xml': [
    'ZTE',
    'BGH Joy Smart AXS II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.ztemt.com/mobile/uaprof/ZTE Blade V320.xml': [
    'ZTE',
    'BGH Joy Smart AXS II D',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://ua.musn-mobile.com/TWN/A5.xml': ['ZTE', 'Blade', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/a5.xml': ['ZTE', 'Blade', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_A430.xml': ['ZTE', 'Blade A430', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_A450.xml': ['ZTE', 'Blade A450', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_BLADE_A510.xml': ['ZTE', 'Blade A510', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_BLADE_A612.xml': ['ZTE', 'Blade A612', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Apex.xml': ['ZTE', 'Blade Apex', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Apex2.xml': ['ZTE', 'Blade Apex2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_C2_Plus.xml': [
    'ZTE',
    'Blade C2 Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Blade C370.xml': ['ZTE', 'Blade C370', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_G_Lux.xml': ['ZTE', 'Blade G Lux', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V830W.xml': ['ZTE', 'Blade G Lux', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_G2.xml': ['ZTE', 'Blade G2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Blade III Pro.xml': [
    'ZTE',
    'Blade III Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_L2.xml': ['ZTE', 'Blade L2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_L2_4.4.xml': ['ZTE', 'Blade L2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Blade L2 Plus.xml': ['ZTE', 'Blade L2 Plus', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Blade_L3.xml': ['ZTE', 'Blade L3', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_L3.xml': ['ZTE', 'Blade L3', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Blade L3 Apex.xml': [
    'ZTE',
    'Blade L3 Apex',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/Blade L3 PLUS.xml': ['ZTE', 'Blade L3 Plus', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Q.xml': ['ZTE', 'Blade Q', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Q_Lux.xml': ['ZTE', 'Blade Q Lux', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Q_Mini.xml': ['ZTE', 'Blade Q Mini', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Q1.xml': ['ZTE', 'Blade Q1', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Blade S.xml': ['ZTE', 'Blade S', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Blade_Super.xml': ['ZTE', 'Blade Super', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_V2.xml': ['ZTE', 'Blade V2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_V220.xml': ['ZTE', 'Blade V220', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_V6.xml': ['ZTE', 'Blade V6', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z978.xml': ['ZTE', 'Blade V8 Pro', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Vec.xml': ['ZTE', 'Blade Vec', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Vec_4G.xml': ['ZTE', 'Blade Vec', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Blade_Vec_Pro.xml': [
    'ZTE',
    'Blade Vec Pro',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Crescent.xml': ['ZTE', 'Crescent', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T126.xml': ['ZTE', 'Cruise T126', null, DeviceType.MOBILE],
  'http://device.telusmobility.com/zte/ZTED90-0.rdf': ['ZTE', 'D90', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_N72_20090709.xml': ['ZTE', 'E N72', 'Windows Mobile', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_E10T.xml': ['ZTE', 'e-Learning PAD E10T', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-U-E850(Movilnet).xml': ['ZTE', 'E850', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F101(RDS).xml': ['ZTE', 'F101', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F107(3UK).xml': ['ZTE', 'F107', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F150.xml': ['ZTE', 'F150', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F151.xml': ['ZTE', 'F151', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F152.xml': ['ZTE', 'F152', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F153.xml': ['ZTE', 'F153', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F156.xml': ['ZTE', 'F156', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F158.xml': ['ZTE', 'F158', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F159.xml': ['ZTE', 'F159', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F160(Orange-RO).xml': ['ZTE', 'F160', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F160-BH-Telecom.xml': ['ZTE', 'F160', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F160-Free.xml': ['ZTE', 'F160', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F165.xml': ['ZTE', 'F165', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F230.xml': ['ZTE', 'F230', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F256.xml': ['ZTE', 'F256', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F260.xml': ['ZTE', 'F260', null, DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/F310.xml': ['ZTE', 'F310', 'MRE', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F852.xml': ['ZTE', 'F852', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F858.xml': ['ZTE', 'F858', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F880.xml': ['ZTE', 'F880', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-F912.xml': ['ZTE', 'F912', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Fit_4G_Smart.xml': ['ZTE', 'Fit 4G Smart', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9100-2012083001/N9100V1.0.0B11.rdf': [
    'ZTE',
    'Force',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9100-Chameleon/latest': ['ZTE', 'Force', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T81.xml': ['ZTE', 'Fronteer 4G', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-G X760.xml': ['ZTE', 'G X760', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/G717C.xml': ['ZTE', 'G717', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/G718C.xml': ['ZTE', 'G718', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/G719C.xml': ['ZTE', 'G719', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/G720C.xml': ['ZTE', 'G720', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE G720C.xml': ['ZTE', 'G720', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE G721C.xml': ['ZTE', 'G721 Star 3', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE S2003.xml': ['ZTE', 'Geek II', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Grand Memo.xml': ['ZTE', 'Grand Memo', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-V5S.xml': ['ZTE', 'Grand Memo Lite', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Grand S Flex.xml': ['ZTE', 'Grand S Flex', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Grand_S_Flex.xml': ['ZTE', 'Grand S Flex', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/ZTE-Grand S II.xml': ['ZTE', 'Grand S II', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Grand S Lite.xml': ['ZTE', 'Grand S Lite', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Grand_X_Quad_Lite.xml': [
    'ZTE',
    'Grand X Quad Lite',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Grand X2.xml': ['ZTE', 'Grand X2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-A7.xml': ['ZTE', 'Grand X2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Jack-3G(Orange).xml': ['ZTE', 'Jack', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Kis II Max.xml': ['ZTE', 'Kis 2 Max', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Kis_II_Max.xml': ['ZTE', 'Kis 2 Max', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V815W.xml': ['ZTE', 'Kis 2 Max', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Kis_II_Max_plus.xml': [
    'ZTE',
    'Kis 2 Max Plus',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Kis_3.xml': ['ZTE', 'Kis 3', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Kis3_max.xml': ['ZTE', 'Kis 3 Max', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE KIS LITE.xml': ['ZTE', 'Kis Lite', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-KisPro.xml': ['ZTE', 'Kis Pro', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Kis_Q.xml': ['ZTE', 'Kis Q', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/ZTE_LEO_M1.xml': ['ZTE', 'LEO M1', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V765M.xml': ['ZTE', 'LEO Q1', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/V769M.xml': ['ZTE', 'LEO Q2', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/ZTE V769M.xml': ['ZTE', 'LEO Q2', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/ZTE_LEO_S1.xml': ['ZTE', 'LEO S1', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Light.xml': ['ZTE', 'Light Tab', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/V9.xml': ['ZTE', 'Light Tab', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/V9_VIVO.xml': ['ZTE', 'Light Tab', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/Light-Tab-2.xml': ['ZTE', 'Light Tab 2', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/V9A.xml': ['ZTE', 'Light Tab 2', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V9A.xml': ['ZTE', 'Light Tab 2', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/V9S.xml': ['ZTE', 'Light Tab 3', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/V9C.xml': ['ZTE', 'Light Tab Pro', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/TNZ_V9.xml': ['ZTE', 'Light Tab V9', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V9A(Telcel).xml': ['ZTE', 'Light Tab V9', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/M901C.xml': ['ZTE', 'M901', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/MEM02.xml': ['ZTE', 'M901 Grand Memo 2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z831.xml': ['ZTE', 'Maven 2', 'Android', DeviceType.MOBILE],
  'http://mms.mycricket.com/A415_Uaprof.xml': ['ZTE', 'Memo', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/zte-N295.xml': ['ZTE', 'N295', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N5.xml': ['ZTE', 'N5 Grand Memo', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE N5.xml': ['ZTE', 'N5 Grand Memo', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N5S.xml': ['ZTE', 'N5S', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N606.xml': ['ZTE', 'N600', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N700.xml': ['ZTE', 'N700', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com.cn/mobile/uaprof/ZTE-U-N720-Froyo.xml': ['ZTE', 'N720', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N760.xml': ['ZTE', 'N760', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE N762.xml': ['ZTE', 'N762', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-N780.xml': ['ZTE', 'N780', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N788.xml': ['ZTE', 'N788', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/ZTE N789.xml': ['ZTE', 'N789', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/ZTE-N790.xml': ['ZTE', 'N790', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N790.xml': ['ZTE', 'N790', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N790S.xml': ['ZTE', 'N790S', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N795.xml': ['ZTE', 'N795', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N799D.xml': ['ZTE', 'N799', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N800-Chameleon/latest': ['ZTE', 'N800 Awe', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N800-Chameleon/N800V1.0.0B06.rdf': [
    'ZTE',
    'N800 Awe',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N800-VIRGIN/AWE_Inspired_Moonshine_White_V2.9.rdf': [
    'ZTE',
    'N800 Awe',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N800-VIRGIN/N800V1.0.0B04.rdf': ['ZTE', 'N800 Awe', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N800-VIRGIN/N800V1.0.0B05.rdf': ['ZTE', 'N800 Awe', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N800-VIRGIN/N800V1.0.0B06.rdf': ['ZTE', 'N800 Awe', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N800-VIRGIN/N800V1.0.0B07.rdf': ['ZTE', 'N800 Awe', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N810-VIRGIN/N810V1.0.0B06.rdf': [
    'ZTE',
    'N810 Reef',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.qma.com.tw/ZTE-N818.xml': ['ZTE', 'N818', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-N850PMI.xml': ['ZTE', 'N850', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/ZTEN850KT/N850V1.0.0B14.rdf': ['ZTE', 'N850 Fury', 'Android', DeviceType.MOBILE],
  'http://mms.revol.us/uaprofs/ZTE_N850.xml': ['ZTE', 'N850 Fury', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N855D.xml': ['ZTE', 'N855D', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N860/N860_MVNOV1.0.0B05.rdf': ['ZTE', 'N860 Warp', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/CTMod 3.68.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/CTMod 3.80.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/HaloBean 6.12 ROM.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/HaloBean Nine by Skinny.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/n00b VIII.II by MrBobo.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/N860V1.0.0B06.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/N860V1.0.0B08.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/N860V1.0.0B08c.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/N860V1.0.0B10.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/ZTEN860ABC-BST/SimpleROM 0.2.0.rdf': [
    'ZTE',
    'N860 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-N860PMI.xml': ['ZTE', 'N860 Warp', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N861-BOOST/N861V1.0.0B07.rdf': [
    'ZTE',
    'N861 Warp II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N861-BOOST/N861V1.0.0B07.WARP2CCP.rdf': [
    'ZTE',
    'N861 Warp II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N861-BOOST/N861V1.0.0B09.rdf': [
    'ZTE',
    'N861 Warp II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N861-BOOST/N861V1.0.0B12.rdf': [
    'ZTE',
    'N861 Warp II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N861-BOOST/N861V1.0.0B13.rdf': [
    'ZTE',
    'N861 Warp II',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N861-Chameleon/latest': ['ZTE', 'N861 Warp II', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-N861PMI.xml': ['ZTE', 'N861 Warp II', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N880.xml': ['ZTE', 'N880 Blade', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_C_N600PLUS_1_20101223.xml': [
    'ZTE',
    'N880 Blade',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://uaprof.qma.com.tw/ZTE N880E.xml': ['ZTE', 'N880E', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N880E.xml': ['ZTE', 'N880E', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N900.xml': ['ZTE', 'N900', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/ZTE-N909.xml': ['ZTE', 'N909', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N909.xml': ['ZTE', 'N909', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/ZTE-N910.xml': ['ZTE', 'N910 Anthem', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9100-2012083001/N9100V1.0.0B09.rdf': [
    'ZTE',
    'N9100 Force',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9100-BOOST/DroidSmith_Force_0.6_Beta.rdf': [
    'ZTE',
    'N9100 Force',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9100-BOOST/N9100V1.0.0B09.rdf': [
    'ZTE',
    'N9100 Force',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9100-BOOST/N9100V1.0.0B11.rdf': [
    'ZTE',
    'N9100 Force',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9100-BOOST/N9100V1.0.0B13.rdf': [
    'ZTE',
    'N9100 Force',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/N9101.xml': ['ZTE', 'N9101 Imperial', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9130-BOOST/N9130V1.0.0B05.rdf': [
    'ZTE',
    'N9130 Speed',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9130-BOOST/N9130V1.0.0B06.rdf': [
    'ZTE',
    'N9130 Speed',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9130-BOOST/N9130V1.0.0B08.rdf': [
    'ZTE',
    'N9130 Speed',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9130-BOOST/N9130V1.0.0B09.rdf': [
    'ZTE',
    'N9130 Speed',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9130-Chameleon/N9130V1.0.0B09.rdf': [
    'ZTE',
    'N9130 Speed',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9500-6105573748/N9500V1.0.0B18.rdf': [
    'ZTE',
    'N9500 Flash',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9500-BOOST/N9500V1.0.0B14.rdf': [
    'ZTE',
    'N9500 Flash',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9500-BOOST/N9500V1.0.0B18.rdf': [
    'ZTE',
    'N9500 Flash',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9500-BOOST/PV_ZTE_N9500V1.0.0B07.rdf': [
    'ZTE',
    'N9500 Flash',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9500-SPRINT/N9500V1.0.0B11.rdf': [
    'ZTE',
    'N9500 Flash',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9500-SPRINT/N9500V1.0.0B13.rdf': [
    'ZTE',
    'N9500 Flash',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9500-SPRINT/N9500V1.0.0B14.rdf': [
    'ZTE',
    'N9500 Flash',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9500-SPRINT/N9500V1.0.0B18.rdf': [
    'ZTE',
    'N9500 Flash',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/N9510V1.0.0B12.rdf': ['ZTE', 'N9510 Warp', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9510-BOOST/N9510V1.0.0B07.rdf': [
    'ZTE',
    'N9510 Warp',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9510-Chameleon/latest': ['ZTE', 'N9510 Warp', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_N9511.xml': ['ZTE', 'N9511', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9515-BOOST/N9515V1.0.0B05.rdf': ['ZTE', 'N9515', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9515-BOOST/N9515V1.0.0B06.rdf': ['ZTE', 'N9515', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9515-BOOST/N9515V1.0.0B07.rdf': ['ZTE', 'N9515', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9515-Chameleon/latest': ['ZTE', 'N9515', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9515-Chameleon/N9515V1.0.0B05.rdf': [
    'ZTE',
    'N9515',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/N9520V1.0.0B05.rdf': ['ZTE', 'N9520 Stormer', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9520-BOOST/latest': ['ZTE', 'N9520 Stormer', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9520-BOOST/N9520V1.0.0B05.rdf': [
    'ZTE',
    'N9520 Stormer',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9520-BOOST/N9520V1.0.0B06.rdf': [
    'ZTE',
    'N9520 Stormer',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9520-BOOST/N9520V1.0.0B07.rdf': [
    'ZTE',
    'N9520 Stormer',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9520-Chameleon/latest': ['ZTE', 'N9520 Stormer', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE N901.xml': ['ZTE', 'N960', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE N970.xml': ['ZTE', 'N970 Grand X', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9810-Chameleon/latest': ['ZTE', 'N9810 Vital', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9810-SPRINT/N9810V1.0.0B02.rdf': [
    'ZTE',
    'N9810 Vital',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9810-SPRINT/N9810V1.0.0B06.rdf': [
    'ZTE',
    'N9810 Vital',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9810-SPRINT/N9810V1.0.0B09.rdf': [
    'ZTE',
    'N9810 Vital',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://device.sprintpcs.com/ZTE/N9810-VIRGIN/N9810V1.0.0B09.rdf': [
    'ZTE',
    'N9810 Vital',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/N983.xml': ['ZTE', 'N983', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N986.xml': ['ZTE', 'N986', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com.cn/mobile/uaprof/nubia_NX501_Z72.xml': ['ZTE', 'Nubia Z5', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/nubia-NX40X.xml': ['ZTE', 'Nubia Z5 mini', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com.cn/mobile/uaprof/nubia_NX402_Z64.xml': [
    'ZTE',
    'Nubia Z5 mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.ztemt.com/mobile/uaprof/NX406E.xml': ['ZTE', 'Nubia Z5s mini', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/NX512J_CT.xml': ['ZTE', 'Nubia Z9 Max', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com.cn/mobile/uaprof/ZTE_NX501_VE.xml': ['ZTE', 'NX501', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/OPEN.xml': ['ZTE', 'Open', 'Firefox OS', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/OPENC.xml': ['ZTE', 'Open C', 'Firefox OS', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/OPENC2.xml': ['ZTE', 'Open C2', 'Firefox OS', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/OPEN2.xml': ['ZTE', 'Open II', 'Firefox OS', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/ZTESV55TAB/B03.rdf': ['ZTE', 'Optik', 'Android', DeviceType.TABLET],
  'http://device.sprintpcs.com/ZTE/ZTESV55TAB/B12.rdf': ['ZTE', 'Optik', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Q2S-C.xml': ['ZTE', 'Q2S-C', 'Android', DeviceType.MOBILE],
  'http://uaprof.qma.com.tw/ZTE-Q301C.xml': ['ZTE', 'Q301C', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Q802C.xml': ['ZTE', 'Q802C', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_C_R750_3_20100725.xml': ['ZTE', 'R750', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/RacerII.xml': ['ZTE', 'Racer II', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/SKATE-KIS.xml': ['ZTE', 'Skate', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-SKATE.xml': ['ZTE', 'Skate', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-SKATE.xml, http://www.zte.com.cn/mobile/uaprof/ ZTE-SKATE.xml': [
    'ZTE',
    'Skate',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Skate4.3.xml': ['ZTE', 'Skate', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Skate_TME.xml': ['ZTE', 'Skate', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Skate-Pro.xml': ['ZTE', 'Skate Pro', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T816.xml': ['ZTE', 'Smart Plus', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z832.xml': ['ZTE', 'Sonata 3', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9130-BOOST/N9130V1.0.0B11.rdf': ['ZTE', 'Speed', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9130-BOOST/N9130V1.0.0B14.rdf': ['ZTE', 'Speed', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9130-BOOST/N9130V1.0.0B15.rdf': ['ZTE', 'Speed', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/ZTE/N9130-Chameleon/N9130V1.0.0B08.rdf': [
    'ZTE',
    'Speed',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE S2002.xml': ['ZTE', 'Star 1', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Star_1.xml': ['ZTE', 'Star 1', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE S2005.xml': ['ZTE', 'Star 2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_Switch_X1.xml': ['ZTE', 'Switch X1', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_T12.xml': ['ZTE', 'T12', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T165i.xml': ['ZTE', 'T165i', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_T760.xml': ['ZTE', 'T760', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T82.xml': ['ZTE', 'T82', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T83.xml': ['ZTE', 'T83', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE T86.xml': ['ZTE', 'T86', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_T815.xml': ['ZTE', 'Tempo', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE S2004.xml': ['ZTE', 'Tianji 3', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE S291.xml': ['ZTE', 'Tianji 3', 'Android', DeviceType.MOBILE],
  'http://uaprofile.zte.com/uaprof/ZTE-T-U830-1.0.xml': ['ZTE', 'TU830', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-TUIRES.xml': ['ZTE', 'Tuires', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T60.xml': ['ZTE', 'Tureis', 'Android', DeviceType.MOBILE],
  'http://www.access.co.jp/uaprof/NF3Prof.rdf': ['ZTE', 'U236', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTEU790.xml': ['ZTE', 'U790', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_U791.xml': ['ZTE', 'U791', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T U802.xml': ['ZTE', 'U802', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE U808.xml': ['ZTE', 'U808', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE U879.xml': ['ZTE', 'U879', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-T U880.xml': ['ZTE', 'U880 Blade', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_U887_UAProfile.xml': ['ZTE', 'U887', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Grand X 4.2.xml': ['ZTE', 'U930 Grand X', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Grand X In.xml': ['ZTE', 'U930 Grand X IN', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOZTE U956.xml': ['ZTE', 'U956', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/F1310.xml': ['ZTE', 'Unite F1310', 'MTK', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V72.xml': ['ZTE', 'V72', 'Android', DeviceType.TABLET],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-UV760.xml': ['ZTE', 'V760', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-V768.xml': ['ZTE', 'V768 Concord', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Kis.xml': ['ZTE', 'V788 Kis', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V788D.xml': ['ZTE', 'V788 Kis', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/V790.xml': ['ZTE', 'V790', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V790.xml': ['ZTE', 'V790', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V791.xml': ['ZTE', 'V791', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V793.xml': ['ZTE', 'V793', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V795_2.3.xml': ['ZTE', 'V795', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V795_2.3_Skinny.xml': ['ZTE', 'V795', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V795_4.2.xml': ['ZTE', 'V795', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V797.xml': ['ZTE', 'V797', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V807.xml': ['ZTE', 'V807 Blade C', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V809.xml': ['ZTE', 'V809 Blade C2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V811W.xml': ['ZTE', 'V811', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/ZTE V8110.xml': ['ZTE', 'V8110', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V816W.xml': ['ZTE', 'V816W', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V818.xml': ['ZTE', 'V818', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-GV821.xml': ['ZTE', 'V821', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/V852.xml': ['ZTE', 'V852', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_U_V856_V3_3.xml': [
    'ZTE',
    'V856 Mimosa Mini',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/zte_u_v857_v3.xml': ['ZTE', 'V857', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-UV859.xml': ['ZTE', 'V859', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/ZTE-V865M.xml': ['ZTE', 'V865', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V880.xml': ['ZTE', 'V880 Blade', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V880E.xml': ['ZTE', 'V880 Blade', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V880H.xml': ['ZTE', 'V880 Blade', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-BLADE.xml': ['ZTE', 'V880 Blade', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-U V880E.xml': ['ZTE', 'V880 Blade', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Blade G.xml': ['ZTE', 'V880 Blade G', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/V881.xml': ['ZTE', 'V881 Blade II', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-U V881.xml': ['ZTE', 'V881 Blade II', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V887.xml': ['ZTE', 'V887', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V889D.xml': ['ZTE', 'V889', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V889M.xml': ['ZTE', 'V889', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V889S.xml': ['ZTE', 'V889', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/V9+.xml': ['ZTE', 'V9+', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V965.xml': ['ZTE', 'V965', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V967S.xml': ['ZTE', 'V967', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V969.xml': ['ZTE', 'V969', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-V96A.xml': ['ZTE', 'V96A', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/ZTE V972M.xml': ['ZTE', 'V972M', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V975.xml': ['ZTE', 'V975 Geek', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Grand Memo LTE.xml': [
    'ZTE',
    'V9815 Grand Memo',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V9820.xml': ['ZTE', 'V9820', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Grand X Pro.xml': ['ZTE', 'V983 Grand X Pro', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V983.xml': ['ZTE', 'V983 Grand X Pro', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V985.xml': ['ZTE', 'V985 Grand Era', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOZTE V 987.xml': ['ZTE', 'V987', 'Android', DeviceType.MOBILE],
  'http://www.oppo.com/resource/UA-PROF/OPPOZTE V987.xml': ['ZTE', 'V987', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V987.xml': ['ZTE', 'V987', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V987_4.2.xml': ['ZTE', 'V987', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE V988.xml': ['ZTE', 'V988', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/N988.xml': ['ZTE', 'V988 Grand S', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE Grand S.xml': ['ZTE', 'V988 Grand S', 'Android', DeviceType.MOBILE],
  'http://device.sprintpcs.com/N9510V1.0.0B13.rdf': ['ZTE', 'Warp', 'Android', DeviceType.MOBILE],
  'http://mmslab.mycricket.com/zte-x500.xml': ['ZTE', 'X500 Score', 'Android', DeviceType.MOBILE],
  'http://uaprof.metropcs.net/UAProf/ZTE-X500.xml': ['ZTE', 'X500 Score', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE X850.xml': ['ZTE', 'X850 Racer', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-RACER.xml': ['ZTE', 'X850 Racer', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-U X850.xml': ['ZTE', 'X850 Racer', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_U X850.xml': ['ZTE', 'X850 Racer', 'Android', DeviceType.MOBILE],
  'http://www.ztemt.com/mobile/uaprof/X990_V2_Z10.xml': ['ZTE', 'X990', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE A880.xml': ['ZTE', 'Xiaoxian', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z221.xml': ['ZTE', 'Z221', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z222.xml': ['ZTE', 'Z222', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z223.xml': ['ZTE', 'Z223', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z431.xml': ['ZTE', 'Z431', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z432.xml': ['ZTE', 'Z432', null, DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z660G.xml': ['ZTE', 'Z660', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/zte/wsz665c/wsz665c.xml': ['ZTE', 'Z665 Valet', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z667.xml': ['ZTE', 'Z667 Prelude 2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z740.xml': ['ZTE', 'Z740 Radiant', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z740G.xml': ['ZTE', 'Z740G Sonata 4G', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/zte/zte752c/zte752c.xml': ['ZTE', 'Z752 Zephyr', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z753G.xml': ['ZTE', 'Z753 Paragon', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z755.xml': ['ZTE', 'Z755', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z768G.xml': ['ZTE', 'Z768', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z787.xml': ['ZTE', 'Z787', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z788G.xml': ['ZTE', 'Z788', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z791G.xml': ['ZTE', 'Z791G', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z792.xml': ['ZTE', 'Z792', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/zte/wsz793c/wsz793c.xml': ['ZTE', 'Z793C', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z795G.xml': ['ZTE', 'Z795 Solar', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z812.xml': ['ZTE', 'Z812 Maven', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z813.xml': ['ZTE', 'Z813', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z818L.xml': ['ZTE', 'Z818 Allstar', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/zte/wsz819l/wsz819l.xml': ['ZTE', 'Z819L', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z830.xml': ['ZTE', 'Z830', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z930L.xml': ['ZTE', 'Z930 Unico', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/zte/wsz932l/wsz932l.xml': ['ZTE', 'Z932', 'Android', DeviceType.MOBILE],
  'http://uaprof.vtext.com/zte/wsz936l/wsz936l.xml': ['ZTE', 'Z936 Lever', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z955L.xml': ['ZTE', 'Z955L', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z958.xml': ['ZTE', 'Z958 Zmax 2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z970.xml': ['ZTE', 'Z970', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V970.xml': ['ZTE', 'Z970 Grand X', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V970M.xml': ['ZTE', 'Z970 Grand X', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE_V970M_JB.xml': ['ZTE', 'Z970 Grand X', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z987.xml': ['ZTE', 'Z987', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z990.xml': ['ZTE', 'Z990 Roamer', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z990G.xml': ['ZTE', 'Z990 Roamer', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/ZTE-Z992.xml': ['ZTE', 'Z992 Avail 2', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z993.xml': ['ZTE', 'Z993 Prelude', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z995.xml': ['ZTE', 'Z995 Overture', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/Z998.xml': ['ZTE', 'Z998', 'Android', DeviceType.MOBILE],
  'http://www.zte.com.cn/mobile/uaprof/MS4A.xml': ['Мегафон', '4G Turbo', 'Android', DeviceType.MOBILE],
  'http://www-ccpp.tcl-ta.com/files/MS3B.xml': ['Мегафон', 'Optima', 'Android', DeviceType.MOBILE],
  'http://downloadmirror.intel.com/20932/eng/SP-A20i_UA_Profile.xml': [
    'Мегафон',
    'SP-A20i Mint',
    'Android',
    DeviceType.MOBILE,
  ],
  'http://www.zte.com.cn/mobile/uaprof/MegaFon_SP-A5.xml': ['Мегафон', 'SP-A5', 'Android', DeviceType.MOBILE],
};

/* eslint-enable max-len */

/* This file is automatically generated, do not edit manually! */
